(() => {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2790"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2790"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aXNcS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "PureComponent", () => $7fb5957c885311b6$export$221d75b3f55bb0bd);
$parcel$export(module.exports, "memo", () => $7fb5957c885311b6$export$7c73462e0d25e514);
$parcel$export(module.exports, "forwardRef", () => $7fb5957c885311b6$export$257a8862b851cb5b);
$parcel$export(module.exports, "Children", () => $7fb5957c885311b6$export$dca3b0875bd9a954);
$parcel$export(module.exports, "Suspense", () => $7fb5957c885311b6$export$74bf444e3cd11ea5);
$parcel$export(module.exports, "lazy", () => $7fb5957c885311b6$export$488013bae63b21da);
$parcel$export(module.exports, "SuspenseList", () => $7fb5957c885311b6$export$998bcd577473dd93);
$parcel$export(module.exports, "createPortal", () => $7fb5957c885311b6$export$d39a5bbd09211389);
$parcel$export(module.exports, "render", () => $7fb5957c885311b6$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "hydrate", () => $7fb5957c885311b6$export$fa8d919ba61d84db);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $7fb5957c885311b6$export$ae55be85d98224ed);
$parcel$export(module.exports, "version", () => $7fb5957c885311b6$export$83d89fbfd8236492);
$parcel$export(module.exports, "createFactory", () => $7fb5957c885311b6$export$d38cd72104c1f0e9);
$parcel$export(module.exports, "isValidElement", () => $7fb5957c885311b6$export$a8257692ac88316c);
$parcel$export(module.exports, "cloneElement", () => $7fb5957c885311b6$export$e530037191fcd5d7);
$parcel$export(module.exports, "unmountComponentAtNode", () => $7fb5957c885311b6$export$502457920280e6be);
$parcel$export(module.exports, "findDOMNode", () => $7fb5957c885311b6$export$466bfc07425424d5);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $7fb5957c885311b6$export$c78a37762a8d58e1);
$parcel$export(module.exports, "flushSync", () => $7fb5957c885311b6$export$cd75ccfd720a3cd4);
$parcel$export(module.exports, "StrictMode", () => $7fb5957c885311b6$export$5f8d39834fd61797);
$parcel$export(module.exports, "default", () => $7fb5957c885311b6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "createElement", () => (parcelRequire("fUX2S")).createElement);
$parcel$export(module.exports, "createContext", () => (parcelRequire("fUX2S")).createContext);
$parcel$export(module.exports, "createRef", () => (parcelRequire("fUX2S")).createRef);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("fUX2S")).Fragment);
$parcel$export(module.exports, "Component", () => (parcelRequire("fUX2S")).Component);

var $fqaWh = parcelRequire("fqaWh");

var $fUX2S = parcelRequire("fUX2S");
function $7fb5957c885311b6$var$C(n, t) {
    for(var e in t)n[e] = t[e];
    return n;
}
function $7fb5957c885311b6$var$S(n, t) {
    for(var e in n)if ("__source" !== e && !(e in t)) return !0;
    for(var r in t)if ("__source" !== r && n[r] !== t[r]) return !0;
    return !1;
}
function $7fb5957c885311b6$export$221d75b3f55bb0bd(n) {
    this.props = n;
}
function $7fb5957c885311b6$export$7c73462e0d25e514(n, t) {
    function e(n) {
        var e = this.props.ref, r = e == n.ref;
        return !r && e && (e.call ? e(null) : e.current = null), t ? !t(this.props, n) || !r : $7fb5957c885311b6$var$S(this.props, n);
    }
    function r(t) {
        return this.shouldComponentUpdate = e, (0, $fUX2S.createElement)(n, t);
    }
    return r.displayName = "Memo(" + (n.displayName || n.name) + ")", r.prototype.isReactComponent = !0, r.__f = !0, r;
}
($7fb5957c885311b6$export$221d75b3f55bb0bd.prototype = new (0, $fUX2S.Component)).isPureReactComponent = !0, $7fb5957c885311b6$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $7fb5957c885311b6$var$S(this.props, n) || $7fb5957c885311b6$var$S(this.state, t);
};
var $7fb5957c885311b6$var$w = (0, $fUX2S.options).__b;
(0, $fUX2S.options).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $7fb5957c885311b6$var$w && $7fb5957c885311b6$var$w(n);
};
var $7fb5957c885311b6$var$R = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $7fb5957c885311b6$export$257a8862b851cb5b(n) {
    function t(t) {
        var e = $7fb5957c885311b6$var$C({}, t);
        return delete e.ref, n(e, t.ref || null);
    }
    return t.$$typeof = $7fb5957c885311b6$var$R, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $7fb5957c885311b6$var$N = function(n, t) {
    return null == n ? null : (0, $fUX2S.toChildArray)((0, $fUX2S.toChildArray)(n).map(t));
}, $7fb5957c885311b6$export$dca3b0875bd9a954 = {
    map: $7fb5957c885311b6$var$N,
    forEach: $7fb5957c885311b6$var$N,
    count: function(n) {
        return n ? (0, $fUX2S.toChildArray)(n).length : 0;
    },
    only: function(n) {
        var t = (0, $fUX2S.toChildArray)(n);
        if (1 !== t.length) throw "Children.only";
        return t[0];
    },
    toArray: (0, $fUX2S.toChildArray)
}, $7fb5957c885311b6$var$A = (0, $fUX2S.options).__e;
(0, $fUX2S.options).__e = function(n, t, e, r) {
    if (n.then) {
        for(var u, o = t; o = o.__;)if ((u = o.__c) && u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), u.__c(n, t);
    }
    $7fb5957c885311b6$var$A(n, t, e, r);
};
var $7fb5957c885311b6$var$O = (0, $fUX2S.options).unmount;
function $7fb5957c885311b6$export$74bf444e3cd11ea5() {
    this.__u = 0, this.t = null, this.__b = null;
}
function $7fb5957c885311b6$var$U(n) {
    var t = n.__.__c;
    return t && t.__e && t.__e(n);
}
function $7fb5957c885311b6$export$488013bae63b21da(n) {
    var t, e, r;
    function u(u) {
        if (t || (t = n()).then(function(n) {
            e = n.default || n;
        }, function(n) {
            r = n;
        }), r) throw r;
        if (!e) throw t;
        return (0, $fUX2S.createElement)(e, u);
    }
    return u.displayName = "Lazy", u.__f = !0, u;
}
function $7fb5957c885311b6$export$998bcd577473dd93() {
    this.u = null, this.o = null;
}
(0, $fUX2S.options).unmount = function(n) {
    var t = n.__c;
    t && t.__R && t.__R(), t && !0 === n.__h && (n.type = null), $7fb5957c885311b6$var$O && $7fb5957c885311b6$var$O(n);
}, ($7fb5957c885311b6$export$74bf444e3cd11ea5.prototype = new (0, $fUX2S.Component)).__c = function(n, t) {
    var e = t.__c, r = this;
    null == r.t && (r.t = []), r.t.push(e);
    var u = $7fb5957c885311b6$var$U(r.__v), o = !1, i = function() {
        o || (o = !0, e.__R = null, u ? u(l) : l());
    };
    e.__R = i;
    var l = function() {
        if (!--r.__u) {
            if (r.state.__e) {
                var n = r.state.__e;
                r.__v.__k[0] = function n(t, e, r) {
                    return t && (t.__v = null, t.__k = t.__k && t.__k.map(function(t) {
                        return n(t, e, r);
                    }), t.__c && t.__c.__P === e && (t.__e && r.insertBefore(t.__e, t.__d), t.__c.__e = !0, t.__c.__P = r)), t;
                }(n, n.__c.__P, n.__c.__O);
            }
            var t;
            for(r.setState({
                __e: r.__b = null
            }); t = r.t.pop();)t.forceUpdate();
        }
    }, f = !0 === t.__h;
    r.__u++ || f || r.setState({
        __e: r.__b = r.__v.__k[0]
    }), n.then(i, i);
}, $7fb5957c885311b6$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.t = [];
}, $7fb5957c885311b6$export$74bf444e3cd11ea5.prototype.render = function(n, t) {
    if (this.__b) {
        if (this.__v.__k) {
            var e = document.createElement("div"), r = this.__v.__k[0].__c;
            this.__v.__k[0] = function n(t, e, r) {
                return t && (t.__c && t.__c.__H && (t.__c.__H.__.forEach(function(n) {
                    "function" == typeof n.__c && n.__c();
                }), t.__c.__H = null), null != (t = $7fb5957c885311b6$var$C({}, t)).__c && (t.__c.__P === r && (t.__c.__P = e), t.__c = null), t.__k = t.__k && t.__k.map(function(t) {
                    return n(t, e, r);
                })), t;
            }(this.__b, e, r.__O = r.__P);
        }
        this.__b = null;
    }
    var u = t.__e && (0, $fUX2S.createElement)((0, $fUX2S.Fragment), null, n.fallback);
    return u && (u.__h = null), [
        (0, $fUX2S.createElement)((0, $fUX2S.Fragment), null, t.__e ? null : n.children),
        u
    ];
};
var $7fb5957c885311b6$var$T = function(n, t, e) {
    if (++e[1] === e[0] && n.o.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.o.size)) for(e = n.u; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.u = e = e[2];
    }
};
function $7fb5957c885311b6$var$D(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $7fb5957c885311b6$var$I(n) {
    var t = this, e = n.i;
    t.componentWillUnmount = function() {
        (0, $fUX2S.render)(null, t.l), t.l = null, t.i = null;
    }, t.i && t.i !== e && t.componentWillUnmount(), n.__v ? (t.l || (t.i = e, t.l = {
        nodeType: 1,
        parentNode: e,
        childNodes: [],
        appendChild: function(n) {
            this.childNodes.push(n), t.i.appendChild(n);
        },
        insertBefore: function(n, e) {
            this.childNodes.push(n), t.i.appendChild(n);
        },
        removeChild: function(n) {
            this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), t.i.removeChild(n);
        }
    }), (0, $fUX2S.render)((0, $fUX2S.createElement)($7fb5957c885311b6$var$D, {
        context: t.context
    }, n.__v), t.l)) : t.l && t.componentWillUnmount();
}
function $7fb5957c885311b6$export$d39a5bbd09211389(n, t) {
    var e = (0, $fUX2S.createElement)($7fb5957c885311b6$var$I, {
        __v: n,
        i: t
    });
    return e.containerInfo = t, e;
}
($7fb5957c885311b6$export$998bcd577473dd93.prototype = new (0, $fUX2S.Component)).__e = function(n) {
    var t = this, e = $7fb5957c885311b6$var$U(t.__v), r = t.o.get(n);
    return r[0]++, function(u) {
        var o = function() {
            t.props.revealOrder ? (r.push(u), $7fb5957c885311b6$var$T(t, n, r)) : u();
        };
        e ? e(o) : o();
    };
}, $7fb5957c885311b6$export$998bcd577473dd93.prototype.render = function(n) {
    this.u = null, this.o = new Map;
    var t = (0, $fUX2S.toChildArray)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && t.reverse();
    for(var e = t.length; e--;)this.o.set(t[e], this.u = [
        1,
        0,
        this.u
    ]);
    return n.children;
}, $7fb5957c885311b6$export$998bcd577473dd93.prototype.componentDidUpdate = $7fb5957c885311b6$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var n = this;
    this.o.forEach(function(t, e) {
        $7fb5957c885311b6$var$T(n, e, t);
    });
};
var $7fb5957c885311b6$var$P = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $7fb5957c885311b6$var$V = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|marker(?!H|W|U)|overline|paint|shape|stop|strikethrough|stroke|text(?!L)|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $7fb5957c885311b6$var$$ = "undefined" != typeof document, $7fb5957c885311b6$var$j = function(n) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/i : /fil|che|ra/i).test(n);
};
function $7fb5957c885311b6$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $fUX2S.render)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $7fb5957c885311b6$export$fa8d919ba61d84db(n, t, e) {
    return (0, $fUX2S.hydrate)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $fUX2S.Component).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(n) {
    Object.defineProperty((0, $fUX2S.Component).prototype, n, {
        configurable: !0,
        get: function() {
            return this["UNSAFE_" + n];
        },
        set: function(t) {
            Object.defineProperty(this, n, {
                configurable: !0,
                writable: !0,
                value: t
            });
        }
    });
});
var $7fb5957c885311b6$var$H = (0, $fUX2S.options).event;
function $7fb5957c885311b6$var$Z() {}
function $7fb5957c885311b6$var$Y() {
    return this.cancelBubble;
}
function $7fb5957c885311b6$var$q() {
    return this.defaultPrevented;
}
(0, $fUX2S.options).event = function(n) {
    return $7fb5957c885311b6$var$H && (n = $7fb5957c885311b6$var$H(n)), n.persist = $7fb5957c885311b6$var$Z, n.isPropagationStopped = $7fb5957c885311b6$var$Y, n.isDefaultPrevented = $7fb5957c885311b6$var$q, n.nativeEvent = n;
};
var $7fb5957c885311b6$var$G, $7fb5957c885311b6$var$J = {
    configurable: !0,
    get: function() {
        return this.class;
    }
}, $7fb5957c885311b6$var$K = (0, $fUX2S.options).vnode;
(0, $fUX2S.options).vnode = function(n) {
    var t = n.type, e = n.props, r = e;
    if ("string" == typeof t) {
        var u = -1 === t.indexOf("-");
        for(var o in r = {}, e){
            var i = e[o];
            $7fb5957c885311b6$var$$ && "children" === o && "noscript" === t || "value" === o && "defaultValue" in e && null == i || ("defaultValue" === o && "value" in e && null == e.value ? o = "value" : "download" === o && !0 === i ? i = "" : /ondoubleclick/i.test(o) ? o = "ondblclick" : /^onchange(textarea|input)/i.test(o + t) && !$7fb5957c885311b6$var$j(e.type) ? o = "oninput" : /^onfocus$/i.test(o) ? o = "onfocusin" : /^onblur$/i.test(o) ? o = "onfocusout" : /^on(Ani|Tra|Tou|BeforeInp|Compo)/.test(o) ? o = o.toLowerCase() : u && $7fb5957c885311b6$var$V.test(o) ? o = o.replace(/[A-Z0-9]/, "-$&").toLowerCase() : null === i && (i = void 0), /^oninput$/i.test(o) && (o = o.toLowerCase(), r[o] && (o = "oninputCapture")), r[o] = i);
        }
        "select" == t && r.multiple && Array.isArray(r.value) && (r.value = (0, $fUX2S.toChildArray)(e.children).forEach(function(n) {
            n.props.selected = -1 != r.value.indexOf(n.props.value);
        })), "select" == t && null != r.defaultValue && (r.value = (0, $fUX2S.toChildArray)(e.children).forEach(function(n) {
            n.props.selected = r.multiple ? -1 != r.defaultValue.indexOf(n.props.value) : r.defaultValue == n.props.value;
        })), n.props = r, e.class != e.className && ($7fb5957c885311b6$var$J.enumerable = "className" in e, null != e.className && (r.class = e.className), Object.defineProperty(r, "className", $7fb5957c885311b6$var$J));
    }
    n.$$typeof = $7fb5957c885311b6$var$P, $7fb5957c885311b6$var$K && $7fb5957c885311b6$var$K(n);
};
var $7fb5957c885311b6$var$Q = (0, $fUX2S.options).__r;
(0, $fUX2S.options).__r = function(n) {
    $7fb5957c885311b6$var$Q && $7fb5957c885311b6$var$Q(n), $7fb5957c885311b6$var$G = n.__c;
};
var $7fb5957c885311b6$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function(n) {
                return $7fb5957c885311b6$var$G.__n[n.__c].props.value;
            }
        }
    }
}, $7fb5957c885311b6$export$83d89fbfd8236492 = "17.0.2";
function $7fb5957c885311b6$export$d38cd72104c1f0e9(n) {
    return (0, $fUX2S.createElement).bind(null, n);
}
function $7fb5957c885311b6$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $7fb5957c885311b6$var$P;
}
function $7fb5957c885311b6$export$e530037191fcd5d7(n) {
    return $7fb5957c885311b6$export$a8257692ac88316c(n) ? (0, $fUX2S.cloneElement).apply(null, arguments) : n;
}
function $7fb5957c885311b6$export$502457920280e6be(n) {
    return !!n.__k && ((0, $fUX2S.render)(null, n), !0);
}
function $7fb5957c885311b6$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $7fb5957c885311b6$export$c78a37762a8d58e1 = function(n, t) {
    return n(t);
}, $7fb5957c885311b6$export$cd75ccfd720a3cd4 = function(n, t) {
    return n(t);
}, $7fb5957c885311b6$export$5f8d39834fd61797 = (0, $fUX2S.Fragment);
var $7fb5957c885311b6$export$2e2bcd8739ae039 = {
    useState: (0, $fqaWh.useState),
    useReducer: (0, $fqaWh.useReducer),
    useEffect: (0, $fqaWh.useEffect),
    useLayoutEffect: (0, $fqaWh.useLayoutEffect),
    useRef: (0, $fqaWh.useRef),
    useImperativeHandle: (0, $fqaWh.useImperativeHandle),
    useMemo: (0, $fqaWh.useMemo),
    useCallback: (0, $fqaWh.useCallback),
    useContext: (0, $fqaWh.useContext),
    useDebugValue: (0, $fqaWh.useDebugValue),
    version: "17.0.2",
    Children: $7fb5957c885311b6$export$dca3b0875bd9a954,
    render: $7fb5957c885311b6$export$b3890eb0ae9dca99,
    hydrate: $7fb5957c885311b6$export$fa8d919ba61d84db,
    unmountComponentAtNode: $7fb5957c885311b6$export$502457920280e6be,
    createPortal: $7fb5957c885311b6$export$d39a5bbd09211389,
    createElement: (0, $fUX2S.createElement),
    createContext: (0, $fUX2S.createContext),
    createFactory: $7fb5957c885311b6$export$d38cd72104c1f0e9,
    cloneElement: $7fb5957c885311b6$export$e530037191fcd5d7,
    createRef: (0, $fUX2S.createRef),
    Fragment: (0, $fUX2S.Fragment),
    isValidElement: $7fb5957c885311b6$export$a8257692ac88316c,
    findDOMNode: $7fb5957c885311b6$export$466bfc07425424d5,
    Component: (0, $fUX2S.Component),
    PureComponent: $7fb5957c885311b6$export$221d75b3f55bb0bd,
    memo: $7fb5957c885311b6$export$7c73462e0d25e514,
    forwardRef: $7fb5957c885311b6$export$257a8862b851cb5b,
    flushSync: $7fb5957c885311b6$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $7fb5957c885311b6$export$c78a37762a8d58e1,
    StrictMode: (0, $fUX2S.Fragment),
    Suspense: $7fb5957c885311b6$export$74bf444e3cd11ea5,
    SuspenseList: $7fb5957c885311b6$export$998bcd577473dd93,
    lazy: $7fb5957c885311b6$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $7fb5957c885311b6$export$ae55be85d98224ed
};
$parcel$exportWildcard(module.exports, $fqaWh);

});
parcelRegister("fqaWh", function(module, exports) {

$parcel$export(module.exports, "useState", () => $b3a1c4f5a8bf6334$export$60241385465d0a34);
$parcel$export(module.exports, "useReducer", () => $b3a1c4f5a8bf6334$export$13e3392192263954);
$parcel$export(module.exports, "useEffect", () => $b3a1c4f5a8bf6334$export$6d9c69b0de29b591);
$parcel$export(module.exports, "useLayoutEffect", () => $b3a1c4f5a8bf6334$export$e5c5a5f917a5871c);
$parcel$export(module.exports, "useRef", () => $b3a1c4f5a8bf6334$export$b8f5890fc79d6aca);
$parcel$export(module.exports, "useMemo", () => $b3a1c4f5a8bf6334$export$1538c33de8887b59);
$parcel$export(module.exports, "useImperativeHandle", () => $b3a1c4f5a8bf6334$export$d5a552a76deda3c2);
$parcel$export(module.exports, "useCallback", () => $b3a1c4f5a8bf6334$export$35808ee640e87ca7);
$parcel$export(module.exports, "useContext", () => $b3a1c4f5a8bf6334$export$fae74005e78b1a27);
$parcel$export(module.exports, "useDebugValue", () => $b3a1c4f5a8bf6334$export$dc8fbce3eb94dc1e);
$parcel$export(module.exports, "useErrorBoundary", () => $b3a1c4f5a8bf6334$export$c052f6604b7d51fe);

var $fUX2S = parcelRequire("fUX2S");
var $b3a1c4f5a8bf6334$var$t, $b3a1c4f5a8bf6334$var$u, $b3a1c4f5a8bf6334$var$r, $b3a1c4f5a8bf6334$var$o, $b3a1c4f5a8bf6334$var$i = 0, $b3a1c4f5a8bf6334$var$c = [], $b3a1c4f5a8bf6334$var$f = [], $b3a1c4f5a8bf6334$var$e = (0, $fUX2S.options).__b, $b3a1c4f5a8bf6334$var$a = (0, $fUX2S.options).__r, $b3a1c4f5a8bf6334$var$v = (0, $fUX2S.options).diffed, $b3a1c4f5a8bf6334$var$l = (0, $fUX2S.options).__c, $b3a1c4f5a8bf6334$var$m = (0, $fUX2S.options).unmount;
function $b3a1c4f5a8bf6334$var$p(t, r) {
    (0, $fUX2S.options).__h && (0, $fUX2S.options).__h($b3a1c4f5a8bf6334$var$u, t, $b3a1c4f5a8bf6334$var$i || r), $b3a1c4f5a8bf6334$var$i = 0;
    var o = $b3a1c4f5a8bf6334$var$u.__H || ($b3a1c4f5a8bf6334$var$u.__H = {
        __: [],
        __h: []
    });
    return t >= o.__.length && o.__.push({
        __V: $b3a1c4f5a8bf6334$var$f
    }), o.__[t];
}
function $b3a1c4f5a8bf6334$export$60241385465d0a34(n) {
    return $b3a1c4f5a8bf6334$var$i = 1, $b3a1c4f5a8bf6334$export$13e3392192263954($b3a1c4f5a8bf6334$var$z, n);
}
function $b3a1c4f5a8bf6334$export$13e3392192263954(n, r, o) {
    var i = $b3a1c4f5a8bf6334$var$p($b3a1c4f5a8bf6334$var$t++, 2);
    return i.t = n, i.__c || (i.__ = [
        o ? o(r) : $b3a1c4f5a8bf6334$var$z(void 0, r),
        function(n) {
            var t = i.t(i.__[0], n);
            i.__[0] !== t && (i.__ = [
                t,
                i.__[1]
            ], i.__c.setState({}));
        }
    ], i.__c = $b3a1c4f5a8bf6334$var$u), i.__;
}
function $b3a1c4f5a8bf6334$export$6d9c69b0de29b591(r, o) {
    var i = $b3a1c4f5a8bf6334$var$p($b3a1c4f5a8bf6334$var$t++, 3);
    !(0, $fUX2S.options).__s && $b3a1c4f5a8bf6334$var$w(i.__H, o) && (i.__ = r, i.u = o, $b3a1c4f5a8bf6334$var$u.__H.__h.push(i));
}
function $b3a1c4f5a8bf6334$export$e5c5a5f917a5871c(r, o) {
    var i = $b3a1c4f5a8bf6334$var$p($b3a1c4f5a8bf6334$var$t++, 4);
    !(0, $fUX2S.options).__s && $b3a1c4f5a8bf6334$var$w(i.__H, o) && (i.__ = r, i.u = o, $b3a1c4f5a8bf6334$var$u.__h.push(i));
}
function $b3a1c4f5a8bf6334$export$b8f5890fc79d6aca(n) {
    return $b3a1c4f5a8bf6334$var$i = 5, $b3a1c4f5a8bf6334$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $b3a1c4f5a8bf6334$export$d5a552a76deda3c2(n, t, u) {
    $b3a1c4f5a8bf6334$var$i = 6, $b3a1c4f5a8bf6334$export$e5c5a5f917a5871c(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == u ? u : u.concat(n));
}
function $b3a1c4f5a8bf6334$export$1538c33de8887b59(n, u) {
    var r = $b3a1c4f5a8bf6334$var$p($b3a1c4f5a8bf6334$var$t++, 7);
    return $b3a1c4f5a8bf6334$var$w(r.__H, u) ? (r.__V = n(), r.u = u, r.__h = n, r.__V) : r.__;
}
function $b3a1c4f5a8bf6334$export$35808ee640e87ca7(n, t) {
    return $b3a1c4f5a8bf6334$var$i = 8, $b3a1c4f5a8bf6334$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $b3a1c4f5a8bf6334$export$fae74005e78b1a27(n) {
    var r = $b3a1c4f5a8bf6334$var$u.context[n.__c], o = $b3a1c4f5a8bf6334$var$p($b3a1c4f5a8bf6334$var$t++, 9);
    return o.c = n, r ? (null == o.__ && (o.__ = !0, r.sub($b3a1c4f5a8bf6334$var$u)), r.props.value) : n.__;
}
function $b3a1c4f5a8bf6334$export$dc8fbce3eb94dc1e(t, u) {
    (0, $fUX2S.options).useDebugValue && (0, $fUX2S.options).useDebugValue(u ? u(t) : t);
}
function $b3a1c4f5a8bf6334$export$c052f6604b7d51fe(n) {
    var r = $b3a1c4f5a8bf6334$var$p($b3a1c4f5a8bf6334$var$t++, 10), o = $b3a1c4f5a8bf6334$export$60241385465d0a34();
    return r.__ = n, $b3a1c4f5a8bf6334$var$u.componentDidCatch || ($b3a1c4f5a8bf6334$var$u.componentDidCatch = function(n) {
        r.__ && r.__(n), o[1](n);
    }), [
        o[0],
        function() {
            o[1](void 0);
        }
    ];
}
function $b3a1c4f5a8bf6334$var$b() {
    for(var t; t = $b3a1c4f5a8bf6334$var$c.shift();)if (t.__P) try {
        t.__H.__h.forEach($b3a1c4f5a8bf6334$var$j), t.__H.__h.forEach($b3a1c4f5a8bf6334$var$k), t.__H.__h = [];
    } catch (u) {
        t.__H.__h = [], (0, $fUX2S.options).__e(u, t.__v);
    }
}
(0, $fUX2S.options).__b = function(n) {
    $b3a1c4f5a8bf6334$var$u = null, $b3a1c4f5a8bf6334$var$e && $b3a1c4f5a8bf6334$var$e(n);
}, (0, $fUX2S.options).__r = function(n) {
    $b3a1c4f5a8bf6334$var$a && $b3a1c4f5a8bf6334$var$a(n), $b3a1c4f5a8bf6334$var$t = 0;
    var o = ($b3a1c4f5a8bf6334$var$u = n.__c).__H;
    o && ($b3a1c4f5a8bf6334$var$r === $b3a1c4f5a8bf6334$var$u ? (o.__h = [], $b3a1c4f5a8bf6334$var$u.__h = [], o.__.forEach(function(n) {
        n.__V = $b3a1c4f5a8bf6334$var$f, n.u = void 0;
    })) : (o.__h.forEach($b3a1c4f5a8bf6334$var$j), o.__h.forEach($b3a1c4f5a8bf6334$var$k), o.__h = [])), $b3a1c4f5a8bf6334$var$r = $b3a1c4f5a8bf6334$var$u;
}, (0, $fUX2S.options).diffed = function(t) {
    $b3a1c4f5a8bf6334$var$v && $b3a1c4f5a8bf6334$var$v(t);
    var i = t.__c;
    i && i.__H && (i.__H.__h.length && (1 !== $b3a1c4f5a8bf6334$var$c.push(i) && $b3a1c4f5a8bf6334$var$o === (0, $fUX2S.options).requestAnimationFrame || (($b3a1c4f5a8bf6334$var$o = (0, $fUX2S.options).requestAnimationFrame) || function(n) {
        var t, u = function() {
            clearTimeout(r), $b3a1c4f5a8bf6334$var$g && cancelAnimationFrame(t), setTimeout(n);
        }, r = setTimeout(u, 100);
        $b3a1c4f5a8bf6334$var$g && (t = requestAnimationFrame(u));
    })($b3a1c4f5a8bf6334$var$b)), i.__H.__.forEach(function(n) {
        n.u && (n.__H = n.u), n.__V !== $b3a1c4f5a8bf6334$var$f && (n.__ = n.__V), n.u = void 0, n.__V = $b3a1c4f5a8bf6334$var$f;
    })), $b3a1c4f5a8bf6334$var$r = $b3a1c4f5a8bf6334$var$u = null;
}, (0, $fUX2S.options).__c = function(t, u) {
    u.some(function(t) {
        try {
            t.__h.forEach($b3a1c4f5a8bf6334$var$j), t.__h = t.__h.filter(function(n) {
                return !n.__ || $b3a1c4f5a8bf6334$var$k(n);
            });
        } catch (r) {
            u.some(function(n) {
                n.__h && (n.__h = []);
            }), u = [], (0, $fUX2S.options).__e(r, t.__v);
        }
    }), $b3a1c4f5a8bf6334$var$l && $b3a1c4f5a8bf6334$var$l(t, u);
}, (0, $fUX2S.options).unmount = function(t) {
    $b3a1c4f5a8bf6334$var$m && $b3a1c4f5a8bf6334$var$m(t);
    var u, r = t.__c;
    r && r.__H && (r.__H.__.forEach(function(n) {
        try {
            $b3a1c4f5a8bf6334$var$j(n);
        } catch (n) {
            u = n;
        }
    }), u && (0, $fUX2S.options).__e(u, r.__v));
};
var $b3a1c4f5a8bf6334$var$g = "function" == typeof requestAnimationFrame;
function $b3a1c4f5a8bf6334$var$j(n) {
    var t = $b3a1c4f5a8bf6334$var$u, r = n.__c;
    "function" == typeof r && (n.__c = void 0, r()), $b3a1c4f5a8bf6334$var$u = t;
}
function $b3a1c4f5a8bf6334$var$k(n) {
    var t = $b3a1c4f5a8bf6334$var$u;
    n.__c = n.__(), $b3a1c4f5a8bf6334$var$u = t;
}
function $b3a1c4f5a8bf6334$var$w(n, t) {
    return !n || n.length !== t.length || t.some(function(t, u) {
        return t !== n[u];
    });
}
function $b3a1c4f5a8bf6334$var$z(n, t) {
    return "function" == typeof t ? t(n) : t;
}

});
parcelRegister("fUX2S", function(module, exports) {

$parcel$export(module.exports, "options", () => $b969e325dc3b890d$export$41c562ebe57d11e2);
$parcel$export(module.exports, "createElement", () => $b969e325dc3b890d$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "createRef", () => $b969e325dc3b890d$export$7d1e3a5e95ceca43);
$parcel$export(module.exports, "Fragment", () => $b969e325dc3b890d$export$ffb0004e005737fa);
$parcel$export(module.exports, "Component", () => $b969e325dc3b890d$export$16fa2f45be04daa8);
$parcel$export(module.exports, "toChildArray", () => $b969e325dc3b890d$export$47e4c5b300681277);
$parcel$export(module.exports, "render", () => $b969e325dc3b890d$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "hydrate", () => $b969e325dc3b890d$export$fa8d919ba61d84db);
$parcel$export(module.exports, "cloneElement", () => $b969e325dc3b890d$export$e530037191fcd5d7);
$parcel$export(module.exports, "createContext", () => $b969e325dc3b890d$export$fd42f52fd3ae1109);
$parcel$export(module.exports, "h", () => $b969e325dc3b890d$export$c8a8987d4410bf2d);
var $b969e325dc3b890d$var$n, $b969e325dc3b890d$export$41c562ebe57d11e2, $b969e325dc3b890d$var$u, $b969e325dc3b890d$export$a8257692ac88316c, $b969e325dc3b890d$var$t, $b969e325dc3b890d$var$o, $b969e325dc3b890d$var$r, $b969e325dc3b890d$var$f, $b969e325dc3b890d$var$e = {}, $b969e325dc3b890d$var$c = [], $b969e325dc3b890d$var$s = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function $b969e325dc3b890d$var$a(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $b969e325dc3b890d$var$h(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $b969e325dc3b890d$export$c8a8987d4410bf2d(l, u, i) {
    var t, o, r, f = {};
    for(r in u)"key" == r ? t = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $b969e325dc3b890d$var$n.call(arguments, 2) : i), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $b969e325dc3b890d$var$y(l, f, t, o, null);
}
function $b969e325dc3b890d$var$y(n, i, t, o, r) {
    var f = {
        type: n,
        props: i,
        key: t,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: null == r ? ++$b969e325dc3b890d$var$u : r
    };
    return null == r && null != $b969e325dc3b890d$export$41c562ebe57d11e2.vnode && $b969e325dc3b890d$export$41c562ebe57d11e2.vnode(f), f;
}
function $b969e325dc3b890d$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $b969e325dc3b890d$export$ffb0004e005737fa(n) {
    return n.children;
}
function $b969e325dc3b890d$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $b969e325dc3b890d$var$k(n, l) {
    if (null == l) return n.__ ? $b969e325dc3b890d$var$k(n.__, n.__.__k.indexOf(n) + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $b969e325dc3b890d$var$k(n) : null;
}
function $b969e325dc3b890d$var$b(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $b969e325dc3b890d$var$b(n);
    }
}
function $b969e325dc3b890d$var$m(n) {
    (!n.__d && (n.__d = !0) && $b969e325dc3b890d$var$t.push(n) && !$b969e325dc3b890d$var$g.__r++ || $b969e325dc3b890d$var$r !== $b969e325dc3b890d$export$41c562ebe57d11e2.debounceRendering) && (($b969e325dc3b890d$var$r = $b969e325dc3b890d$export$41c562ebe57d11e2.debounceRendering) || $b969e325dc3b890d$var$o)($b969e325dc3b890d$var$g);
}
function $b969e325dc3b890d$var$g() {
    for(var n; $b969e325dc3b890d$var$g.__r = $b969e325dc3b890d$var$t.length;)n = $b969e325dc3b890d$var$t.sort(function(n, l) {
        return n.__v.__b - l.__v.__b;
    }), $b969e325dc3b890d$var$t = [], n.some(function(n) {
        var l, u, i, t, o, r;
        n.__d && (o = (t = (l = n).__v).__e, (r = l.__P) && (u = [], (i = $b969e325dc3b890d$var$a({}, t)).__v = t.__v + 1, $b969e325dc3b890d$var$j(r, t, i, l.__n, void 0 !== r.ownerSVGElement, null != t.__h ? [
            o
        ] : null, u, null == o ? $b969e325dc3b890d$var$k(t) : o, t.__h), $b969e325dc3b890d$var$z(u, t), t.__e != o && $b969e325dc3b890d$var$b(t)));
    });
}
function $b969e325dc3b890d$var$w(n, l, u, i, t, o, r, f, s, a) {
    var h, v, p, _, b, m, g, w = i && i.__k || $b969e325dc3b890d$var$c, A = w.length;
    for(u.__k = [], h = 0; h < l.length; h++)if (null != (_ = u.__k[h] = null == (_ = l[h]) || "boolean" == typeof _ ? null : "string" == typeof _ || "number" == typeof _ || "bigint" == typeof _ ? $b969e325dc3b890d$var$y(null, _, null, null, _) : Array.isArray(_) ? $b969e325dc3b890d$var$y($b969e325dc3b890d$export$ffb0004e005737fa, {
        children: _
    }, null, null, null) : _.__b > 0 ? $b969e325dc3b890d$var$y(_.type, _.props, _.key, null, _.__v) : _)) {
        if (_.__ = u, _.__b = u.__b + 1, null === (p = w[h]) || p && _.key == p.key && _.type === p.type) w[h] = void 0;
        else for(v = 0; v < A; v++){
            if ((p = w[v]) && _.key == p.key && _.type === p.type) {
                w[v] = void 0;
                break;
            }
            p = null;
        }
        $b969e325dc3b890d$var$j(n, _, p = p || $b969e325dc3b890d$var$e, t, o, r, f, s, a), b = _.__e, (v = _.ref) && p.ref != v && (g || (g = []), p.ref && g.push(p.ref, null, _), g.push(v, _.__c || b, _)), null != b ? (null == m && (m = b), "function" == typeof _.type && _.__k === p.__k ? _.__d = s = $b969e325dc3b890d$var$x(_, s, n) : s = $b969e325dc3b890d$var$P(n, _, p, w, b, s), "function" == typeof u.type && (u.__d = s)) : s && p.__e == s && s.parentNode != n && (s = $b969e325dc3b890d$var$k(p));
    }
    for(u.__e = m, h = A; h--;)null != w[h] && ("function" == typeof u.type && null != w[h].__e && w[h].__e == u.__d && (u.__d = $b969e325dc3b890d$var$k(i, h + 1)), $b969e325dc3b890d$var$N(w[h], w[h]));
    if (g) for(h = 0; h < g.length; h++)$b969e325dc3b890d$var$M(g[h], g[++h], g[++h]);
}
function $b969e325dc3b890d$var$x(n, l, u) {
    for(var i, t = n.__k, o = 0; t && o < t.length; o++)(i = t[o]) && (i.__ = n, l = "function" == typeof i.type ? $b969e325dc3b890d$var$x(i, l, u) : $b969e325dc3b890d$var$P(u, i, i, t, i.__e, l));
    return l;
}
function $b969e325dc3b890d$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || (Array.isArray(n) ? n.some(function(n) {
        $b969e325dc3b890d$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $b969e325dc3b890d$var$P(n, l, u, i, t, o) {
    var r, f, e;
    if (void 0 !== l.__d) r = l.__d, l.__d = void 0;
    else if (null == u || t != o || null == t.parentNode) n: if (null == o || o.parentNode !== n) n.appendChild(t), r = null;
    else {
        for(f = o, e = 0; (f = f.nextSibling) && e < i.length; e += 2)if (f == t) break n;
        n.insertBefore(t, o), r = o;
    }
    return void 0 !== r ? r : t.nextSibling;
}
function $b969e325dc3b890d$var$C(n, l, u, i, t) {
    var o;
    for(o in u)"children" === o || "key" === o || o in l || $b969e325dc3b890d$var$H(n, o, null, u[o], i);
    for(o in l)t && "function" != typeof l[o] || "children" === o || "key" === o || "value" === o || "checked" === o || u[o] === l[o] || $b969e325dc3b890d$var$H(n, o, l[o], u[o], i);
}
function $b969e325dc3b890d$var$$(n, l, u) {
    "-" === l[0] ? n.setProperty(l, u) : n[l] = null == u ? "" : "number" != typeof u || $b969e325dc3b890d$var$s.test(l) ? u : u + "px";
}
function $b969e325dc3b890d$var$H(n, l, u, i, t) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof i && (n.style.cssText = i = ""), i) for(l in i)u && l in u || $b969e325dc3b890d$var$$(n.style, l, "");
            if (u) for(l in u)i && u[l] === i[l] || $b969e325dc3b890d$var$$(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/Capture$/, "")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? i || n.addEventListener(l, o ? $b969e325dc3b890d$var$T : $b969e325dc3b890d$var$I, o) : n.removeEventListener(l, o ? $b969e325dc3b890d$var$T : $b969e325dc3b890d$var$I, o);
    else if ("dangerouslySetInnerHTML" !== l) {
        if (t) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null != u && (!1 !== u || "a" === l[0] && "r" === l[1]) ? n.setAttribute(l, u) : n.removeAttribute(l));
    }
}
function $b969e325dc3b890d$var$I(n) {
    this.l[n.type + !1]($b969e325dc3b890d$export$41c562ebe57d11e2.event ? $b969e325dc3b890d$export$41c562ebe57d11e2.event(n) : n);
}
function $b969e325dc3b890d$var$T(n) {
    this.l[n.type + !0]($b969e325dc3b890d$export$41c562ebe57d11e2.event ? $b969e325dc3b890d$export$41c562ebe57d11e2.event(n) : n);
}
function $b969e325dc3b890d$var$j(n, u, i, t, o, r, f, e, c) {
    var s, h, v, y, p, k, b, m, g, x, A, P, C, $ = u.type;
    if (void 0 !== u.constructor) return null;
    null != i.__h && (c = i.__h, e = u.__e = i.__e, u.__h = null, r = [
        e
    ]), (s = $b969e325dc3b890d$export$41c562ebe57d11e2.__b) && s(u);
    try {
        n: if ("function" == typeof $) {
            if (m = u.props, g = (s = $.contextType) && t[s.__c], x = s ? g ? g.props.value : s.__ : t, i.__c ? b = (h = u.__c = i.__c).__ = h.__E : ("prototype" in $ && $.prototype.render ? u.__c = h = new $(m, x) : (u.__c = h = new $b969e325dc3b890d$export$16fa2f45be04daa8(m, x), h.constructor = $, h.render = $b969e325dc3b890d$var$O), g && g.sub(h), h.props = m, h.state || (h.state = {}), h.context = x, h.__n = t, v = h.__d = !0, h.__h = []), null == h.__s && (h.__s = h.state), null != $.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $b969e325dc3b890d$var$a({}, h.__s)), $b969e325dc3b890d$var$a(h.__s, $.getDerivedStateFromProps(m, h.__s))), y = h.props, p = h.state, v) null == $.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), null != h.componentDidMount && h.__h.push(h.componentDidMount);
            else {
                if (null == $.getDerivedStateFromProps && m !== y && null != h.componentWillReceiveProps && h.componentWillReceiveProps(m, x), !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(m, h.__s, x) || u.__v === i.__v) {
                    h.props = m, h.state = h.__s, u.__v !== i.__v && (h.__d = !1), h.__v = u, u.__e = i.__e, u.__k = i.__k, u.__k.forEach(function(n) {
                        n && (n.__ = u);
                    }), h.__h.length && f.push(h);
                    break n;
                }
                null != h.componentWillUpdate && h.componentWillUpdate(m, h.__s, x), null != h.componentDidUpdate && h.__h.push(function() {
                    h.componentDidUpdate(y, p, k);
                });
            }
            if (h.context = x, h.props = m, h.__v = u, h.__P = n, A = $b969e325dc3b890d$export$41c562ebe57d11e2.__r, P = 0, "prototype" in $ && $.prototype.render) h.state = h.__s, h.__d = !1, A && A(u), s = h.render(h.props, h.state, h.context);
            else do h.__d = !1, A && A(u), s = h.render(h.props, h.state, h.context), h.state = h.__s;
            while (h.__d && ++P < 25);
            h.state = h.__s, null != h.getChildContext && (t = $b969e325dc3b890d$var$a($b969e325dc3b890d$var$a({}, t), h.getChildContext())), v || null == h.getSnapshotBeforeUpdate || (k = h.getSnapshotBeforeUpdate(y, p)), C = null != s && s.type === $b969e325dc3b890d$export$ffb0004e005737fa && null == s.key ? s.props.children : s, $b969e325dc3b890d$var$w(n, Array.isArray(C) ? C : [
                C
            ], u, i, t, o, r, f, e, c), h.base = u.__e, u.__h = null, h.__h.length && f.push(h), b && (h.__E = h.__ = null), h.__e = !1;
        } else null == r && u.__v === i.__v ? (u.__k = i.__k, u.__e = i.__e) : u.__e = $b969e325dc3b890d$var$L(i.__e, u, i, t, o, r, f, c);
        (s = $b969e325dc3b890d$export$41c562ebe57d11e2.diffed) && s(u);
    } catch (n) {
        u.__v = null, (c || null != r) && (u.__e = e, u.__h = !!c, r[r.indexOf(e)] = null), $b969e325dc3b890d$export$41c562ebe57d11e2.__e(n, u, i);
    }
}
function $b969e325dc3b890d$var$z(n, u) {
    $b969e325dc3b890d$export$41c562ebe57d11e2.__c && $b969e325dc3b890d$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $b969e325dc3b890d$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $b969e325dc3b890d$var$L(l, u, i, t, o, r, f, c) {
    var s, a, v, y = i.props, p = u.props, d = u.type, _ = 0;
    if ("svg" === d && (o = !0), null != r) {
        for(; _ < r.length; _++)if ((s = r[_]) && "setAttribute" in s == !!d && (d ? s.localName === d : 3 === s.nodeType)) {
            l = s, r[_] = null;
            break;
        }
    }
    if (null == l) {
        if (null === d) return document.createTextNode(p);
        l = o ? document.createElementNS("http://www.w3.org/2000/svg", d) : document.createElement(d, p.is && p), r = null, c = !1;
    }
    if (null === d) y === p || c && l.data === p || (l.data = p);
    else {
        if (r = r && $b969e325dc3b890d$var$n.call(l.childNodes), a = (y = i.props || $b969e325dc3b890d$var$e).dangerouslySetInnerHTML, v = p.dangerouslySetInnerHTML, !c) {
            if (null != r) for(y = {}, _ = 0; _ < l.attributes.length; _++)y[l.attributes[_].name] = l.attributes[_].value;
            (v || a) && (v && (a && v.__html == a.__html || v.__html === l.innerHTML) || (l.innerHTML = v && v.__html || ""));
        }
        if ($b969e325dc3b890d$var$C(l, p, y, o, c), v) u.__k = [];
        else if (_ = u.props.children, $b969e325dc3b890d$var$w(l, Array.isArray(_) ? _ : [
            _
        ], u, i, t, o && "foreignObject" !== d, r, f, r ? r[0] : i.__k && $b969e325dc3b890d$var$k(i, 0), c), null != r) for(_ = r.length; _--;)null != r[_] && $b969e325dc3b890d$var$h(r[_]);
        c || ("value" in p && void 0 !== (_ = p.value) && (_ !== l.value || "progress" === d && !_ || "option" === d && _ !== y.value) && $b969e325dc3b890d$var$H(l, "value", _, y.value, !1), "checked" in p && void 0 !== (_ = p.checked) && _ !== l.checked && $b969e325dc3b890d$var$H(l, "checked", _, y.checked, !1));
    }
    return l;
}
function $b969e325dc3b890d$var$M(n, u, i) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $b969e325dc3b890d$export$41c562ebe57d11e2.__e(n, i);
    }
}
function $b969e325dc3b890d$var$N(n, u, i) {
    var t, o;
    if ($b969e325dc3b890d$export$41c562ebe57d11e2.unmount && $b969e325dc3b890d$export$41c562ebe57d11e2.unmount(n), (t = n.ref) && (t.current && t.current !== n.__e || $b969e325dc3b890d$var$M(t, null, u)), null != (t = n.__c)) {
        if (t.componentWillUnmount) try {
            t.componentWillUnmount();
        } catch (n) {
            $b969e325dc3b890d$export$41c562ebe57d11e2.__e(n, u);
        }
        t.base = t.__P = null;
    }
    if (t = n.__k) for(o = 0; o < t.length; o++)t[o] && $b969e325dc3b890d$var$N(t[o], u, "function" != typeof n.type);
    i || null == n.__e || $b969e325dc3b890d$var$h(n.__e), n.__e = n.__d = void 0;
}
function $b969e325dc3b890d$var$O(n, l, u) {
    return this.constructor(n, u);
}
function $b969e325dc3b890d$export$b3890eb0ae9dca99(u, i, t) {
    var o, r, f;
    $b969e325dc3b890d$export$41c562ebe57d11e2.__ && $b969e325dc3b890d$export$41c562ebe57d11e2.__(u, i), r = (o = "function" == typeof t) ? null : t && t.__k || i.__k, f = [], $b969e325dc3b890d$var$j(i, u = (!o && t || i).__k = $b969e325dc3b890d$export$c8a8987d4410bf2d($b969e325dc3b890d$export$ffb0004e005737fa, null, [
        u
    ]), r || $b969e325dc3b890d$var$e, $b969e325dc3b890d$var$e, void 0 !== i.ownerSVGElement, !o && t ? [
        t
    ] : r ? null : i.firstChild ? $b969e325dc3b890d$var$n.call(i.childNodes) : null, f, !o && t ? t : r ? r.__e : i.firstChild, o), $b969e325dc3b890d$var$z(f, u);
}
function $b969e325dc3b890d$export$fa8d919ba61d84db(n, l) {
    $b969e325dc3b890d$export$b3890eb0ae9dca99(n, l, $b969e325dc3b890d$export$fa8d919ba61d84db);
}
function $b969e325dc3b890d$export$e530037191fcd5d7(l, u, i) {
    var t, o, r, f = $b969e325dc3b890d$var$a({}, l.props);
    for(r in u)"key" == r ? t = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $b969e325dc3b890d$var$n.call(arguments, 2) : i), $b969e325dc3b890d$var$y(l.type, f, t || l.key, o || l.ref, null);
}
function $b969e325dc3b890d$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $b969e325dc3b890d$var$f++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, i;
            return this.getChildContext || (u = [], (i = {})[l] = this, this.getChildContext = function() {
                return i;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some($b969e325dc3b890d$var$m);
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$b969e325dc3b890d$var$n = $b969e325dc3b890d$var$c.slice, $b969e325dc3b890d$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, i) {
        for(var t, o, r; l = l.__;)if ((t = l.__c) && !t.__) try {
            if ((o = t.constructor) && null != o.getDerivedStateFromError && (t.setState(o.getDerivedStateFromError(n)), r = t.__d), null != t.componentDidCatch && (t.componentDidCatch(n, i || {}), r = t.__d), r) return t.__E = t;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $b969e325dc3b890d$var$u = 0, $b969e325dc3b890d$export$a8257692ac88316c = function(n) {
    return null != n && void 0 === n.constructor;
}, $b969e325dc3b890d$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $b969e325dc3b890d$var$a({}, this.state), "function" == typeof n && (n = n($b969e325dc3b890d$var$a({}, u), this.props)), n && $b969e325dc3b890d$var$a(u, n), null != n && this.__v && (l && this.__h.push(l), $b969e325dc3b890d$var$m(this));
}, $b969e325dc3b890d$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $b969e325dc3b890d$var$m(this));
}, $b969e325dc3b890d$export$16fa2f45be04daa8.prototype.render = $b969e325dc3b890d$export$ffb0004e005737fa, $b969e325dc3b890d$var$t = [], $b969e325dc3b890d$var$o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $b969e325dc3b890d$var$g.__r = 0, $b969e325dc3b890d$var$f = 0;

});



parcelRegister("jyjGF", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $e3c076c4c9e1aa83$export$a7c73072b1a182ae, (v) => $e3c076c4c9e1aa83$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $e3c076c4c9e1aa83$export$9f27bc3417b4524d, (v) => $e3c076c4c9e1aa83$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $e3c076c4c9e1aa83$export$db77ccec0bb4ccac, (v) => $e3c076c4c9e1aa83$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $e3c076c4c9e1aa83$export$8392c0c9d3dcbd35, (v) => $e3c076c4c9e1aa83$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $e3c076c4c9e1aa83$export$ffb0004e005737fa, (v) => $e3c076c4c9e1aa83$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $e3c076c4c9e1aa83$export$b624eff549462981, (v) => $e3c076c4c9e1aa83$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $e3c076c4c9e1aa83$export$7897aa7841a5380c, (v) => $e3c076c4c9e1aa83$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $e3c076c4c9e1aa83$export$602eac185826482c, (v) => $e3c076c4c9e1aa83$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $e3c076c4c9e1aa83$export$e2c29f18771995cb, (v) => $e3c076c4c9e1aa83$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $e3c076c4c9e1aa83$export$5f8d39834fd61797, (v) => $e3c076c4c9e1aa83$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $e3c076c4c9e1aa83$export$74bf444e3cd11ea5, (v) => $e3c076c4c9e1aa83$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $e3c076c4c9e1aa83$export$998bcd577473dd93, (v) => $e3c076c4c9e1aa83$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $e3c076c4c9e1aa83$export$92387174baf9b227, (v) => $e3c076c4c9e1aa83$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $e3c076c4c9e1aa83$export$ec112efeb987d9c6, (v) => $e3c076c4c9e1aa83$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $e3c076c4c9e1aa83$export$b706b080d889d2c9, (v) => $e3c076c4c9e1aa83$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $e3c076c4c9e1aa83$export$5be5a87408f70ddc, (v) => $e3c076c4c9e1aa83$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $e3c076c4c9e1aa83$export$45a5e7f76e0caa8d, (v) => $e3c076c4c9e1aa83$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $e3c076c4c9e1aa83$export$455c2e768291efa6, (v) => $e3c076c4c9e1aa83$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $e3c076c4c9e1aa83$export$9522e17588c12572, (v) => $e3c076c4c9e1aa83$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $e3c076c4c9e1aa83$export$2110ac352bb060b9, (v) => $e3c076c4c9e1aa83$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $e3c076c4c9e1aa83$export$56885ab8b9c456ab, (v) => $e3c076c4c9e1aa83$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $e3c076c4c9e1aa83$export$d927fcb6adf8f9de, (v) => $e3c076c4c9e1aa83$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $e3c076c4c9e1aa83$export$b82d16f27459e05a, (v) => $e3c076c4c9e1aa83$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $e3c076c4c9e1aa83$export$522c17b4f5e123e8, (v) => $e3c076c4c9e1aa83$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $e3c076c4c9e1aa83$export$1aabd8a0274ecfd6, (v) => $e3c076c4c9e1aa83$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $e3c076c4c9e1aa83$export$3d6c20d97e46b957, (v) => $e3c076c4c9e1aa83$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $e3c076c4c9e1aa83$export$9b621391a187a31a, (v) => $e3c076c4c9e1aa83$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $e3c076c4c9e1aa83$export$f5bbd400c2f4426f, (v) => $e3c076c4c9e1aa83$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e3c076c4c9e1aa83$export$a7c73072b1a182ae;
var $e3c076c4c9e1aa83$export$9f27bc3417b4524d;
var $e3c076c4c9e1aa83$export$db77ccec0bb4ccac;
var $e3c076c4c9e1aa83$export$8392c0c9d3dcbd35;
var $e3c076c4c9e1aa83$export$ffb0004e005737fa;
var $e3c076c4c9e1aa83$export$b624eff549462981;
var $e3c076c4c9e1aa83$export$7897aa7841a5380c;
var $e3c076c4c9e1aa83$export$602eac185826482c;
var $e3c076c4c9e1aa83$export$e2c29f18771995cb;
var $e3c076c4c9e1aa83$export$5f8d39834fd61797;
var $e3c076c4c9e1aa83$export$74bf444e3cd11ea5;
var $e3c076c4c9e1aa83$export$998bcd577473dd93;
var $e3c076c4c9e1aa83$export$92387174baf9b227;
var $e3c076c4c9e1aa83$export$ec112efeb987d9c6;
var $e3c076c4c9e1aa83$export$b706b080d889d2c9;
var $e3c076c4c9e1aa83$export$5be5a87408f70ddc;
var $e3c076c4c9e1aa83$export$45a5e7f76e0caa8d;
var $e3c076c4c9e1aa83$export$455c2e768291efa6;
var $e3c076c4c9e1aa83$export$9522e17588c12572;
var $e3c076c4c9e1aa83$export$2110ac352bb060b9;
var $e3c076c4c9e1aa83$export$56885ab8b9c456ab;
var $e3c076c4c9e1aa83$export$d927fcb6adf8f9de;
var $e3c076c4c9e1aa83$export$b82d16f27459e05a;
var $e3c076c4c9e1aa83$export$522c17b4f5e123e8;
var $e3c076c4c9e1aa83$export$1aabd8a0274ecfd6;
var $e3c076c4c9e1aa83$export$3d6c20d97e46b957;
var $e3c076c4c9e1aa83$export$9b621391a187a31a;
var $e3c076c4c9e1aa83$export$f5bbd400c2f4426f;
'use strict';
var $e3c076c4c9e1aa83$var$b = Symbol.for("react.element"), $e3c076c4c9e1aa83$var$c = Symbol.for("react.portal"), $e3c076c4c9e1aa83$var$d = Symbol.for("react.fragment"), $e3c076c4c9e1aa83$var$e = Symbol.for("react.strict_mode"), $e3c076c4c9e1aa83$var$f = Symbol.for("react.profiler"), $e3c076c4c9e1aa83$var$g = Symbol.for("react.provider"), $e3c076c4c9e1aa83$var$h = Symbol.for("react.context"), $e3c076c4c9e1aa83$var$k = Symbol.for("react.server_context"), $e3c076c4c9e1aa83$var$l = Symbol.for("react.forward_ref"), $e3c076c4c9e1aa83$var$m = Symbol.for("react.suspense"), $e3c076c4c9e1aa83$var$n = Symbol.for("react.suspense_list"), $e3c076c4c9e1aa83$var$p = Symbol.for("react.memo"), $e3c076c4c9e1aa83$var$q = Symbol.for("react.lazy"), $e3c076c4c9e1aa83$var$t = Symbol.for("react.offscreen"), $e3c076c4c9e1aa83$var$u;
$e3c076c4c9e1aa83$var$u = Symbol.for("react.module.reference");
function $e3c076c4c9e1aa83$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $e3c076c4c9e1aa83$var$b:
                switch(a = a.type, a){
                    case $e3c076c4c9e1aa83$var$d:
                    case $e3c076c4c9e1aa83$var$f:
                    case $e3c076c4c9e1aa83$var$e:
                    case $e3c076c4c9e1aa83$var$m:
                    case $e3c076c4c9e1aa83$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $e3c076c4c9e1aa83$var$k:
                            case $e3c076c4c9e1aa83$var$h:
                            case $e3c076c4c9e1aa83$var$l:
                            case $e3c076c4c9e1aa83$var$q:
                            case $e3c076c4c9e1aa83$var$p:
                            case $e3c076c4c9e1aa83$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $e3c076c4c9e1aa83$var$c:
                return r;
        }
    }
}
$e3c076c4c9e1aa83$export$a7c73072b1a182ae = $e3c076c4c9e1aa83$var$h;
$e3c076c4c9e1aa83$export$9f27bc3417b4524d = $e3c076c4c9e1aa83$var$g;
$e3c076c4c9e1aa83$export$db77ccec0bb4ccac = $e3c076c4c9e1aa83$var$b;
$e3c076c4c9e1aa83$export$8392c0c9d3dcbd35 = $e3c076c4c9e1aa83$var$l;
$e3c076c4c9e1aa83$export$ffb0004e005737fa = $e3c076c4c9e1aa83$var$d;
$e3c076c4c9e1aa83$export$b624eff549462981 = $e3c076c4c9e1aa83$var$q;
$e3c076c4c9e1aa83$export$7897aa7841a5380c = $e3c076c4c9e1aa83$var$p;
$e3c076c4c9e1aa83$export$602eac185826482c = $e3c076c4c9e1aa83$var$c;
$e3c076c4c9e1aa83$export$e2c29f18771995cb = $e3c076c4c9e1aa83$var$f;
$e3c076c4c9e1aa83$export$5f8d39834fd61797 = $e3c076c4c9e1aa83$var$e;
$e3c076c4c9e1aa83$export$74bf444e3cd11ea5 = $e3c076c4c9e1aa83$var$m;
$e3c076c4c9e1aa83$export$998bcd577473dd93 = $e3c076c4c9e1aa83$var$n;
$e3c076c4c9e1aa83$export$92387174baf9b227 = function() {
    return !1;
};
$e3c076c4c9e1aa83$export$ec112efeb987d9c6 = function() {
    return !1;
};
$e3c076c4c9e1aa83$export$b706b080d889d2c9 = function(a) {
    return $e3c076c4c9e1aa83$var$v(a) === $e3c076c4c9e1aa83$var$h;
};
$e3c076c4c9e1aa83$export$5be5a87408f70ddc = function(a) {
    return $e3c076c4c9e1aa83$var$v(a) === $e3c076c4c9e1aa83$var$g;
};
$e3c076c4c9e1aa83$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $e3c076c4c9e1aa83$var$b;
};
$e3c076c4c9e1aa83$export$455c2e768291efa6 = function(a) {
    return $e3c076c4c9e1aa83$var$v(a) === $e3c076c4c9e1aa83$var$l;
};
$e3c076c4c9e1aa83$export$9522e17588c12572 = function(a) {
    return $e3c076c4c9e1aa83$var$v(a) === $e3c076c4c9e1aa83$var$d;
};
$e3c076c4c9e1aa83$export$2110ac352bb060b9 = function(a) {
    return $e3c076c4c9e1aa83$var$v(a) === $e3c076c4c9e1aa83$var$q;
};
$e3c076c4c9e1aa83$export$56885ab8b9c456ab = function(a) {
    return $e3c076c4c9e1aa83$var$v(a) === $e3c076c4c9e1aa83$var$p;
};
$e3c076c4c9e1aa83$export$d927fcb6adf8f9de = function(a) {
    return $e3c076c4c9e1aa83$var$v(a) === $e3c076c4c9e1aa83$var$c;
};
$e3c076c4c9e1aa83$export$b82d16f27459e05a = function(a) {
    return $e3c076c4c9e1aa83$var$v(a) === $e3c076c4c9e1aa83$var$f;
};
$e3c076c4c9e1aa83$export$522c17b4f5e123e8 = function(a) {
    return $e3c076c4c9e1aa83$var$v(a) === $e3c076c4c9e1aa83$var$e;
};
$e3c076c4c9e1aa83$export$1aabd8a0274ecfd6 = function(a) {
    return $e3c076c4c9e1aa83$var$v(a) === $e3c076c4c9e1aa83$var$m;
};
$e3c076c4c9e1aa83$export$3d6c20d97e46b957 = function(a) {
    return $e3c076c4c9e1aa83$var$v(a) === $e3c076c4c9e1aa83$var$n;
};
$e3c076c4c9e1aa83$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $e3c076c4c9e1aa83$var$d || a === $e3c076c4c9e1aa83$var$f || a === $e3c076c4c9e1aa83$var$e || a === $e3c076c4c9e1aa83$var$m || a === $e3c076c4c9e1aa83$var$n || a === $e3c076c4c9e1aa83$var$t || "object" === typeof a && null !== a && (a.$$typeof === $e3c076c4c9e1aa83$var$q || a.$$typeof === $e3c076c4c9e1aa83$var$p || a.$$typeof === $e3c076c4c9e1aa83$var$g || a.$$typeof === $e3c076c4c9e1aa83$var$h || a.$$typeof === $e3c076c4c9e1aa83$var$l || a.$$typeof === $e3c076c4c9e1aa83$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$e3c076c4c9e1aa83$export$f5bbd400c2f4426f = $e3c076c4c9e1aa83$var$v;

});

parcelRegister("kCZtx", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $f0470afe3a72c66a$export$2b8d127b894957b9, (v) => $f0470afe3a72c66a$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $f0470afe3a72c66a$export$cea3a54a6425200c, (v) => $f0470afe3a72c66a$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $f0470afe3a72c66a$export$a7c73072b1a182ae, (v) => $f0470afe3a72c66a$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $f0470afe3a72c66a$export$9f27bc3417b4524d, (v) => $f0470afe3a72c66a$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $f0470afe3a72c66a$export$db77ccec0bb4ccac, (v) => $f0470afe3a72c66a$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $f0470afe3a72c66a$export$8392c0c9d3dcbd35, (v) => $f0470afe3a72c66a$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $f0470afe3a72c66a$export$ffb0004e005737fa, (v) => $f0470afe3a72c66a$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $f0470afe3a72c66a$export$b624eff549462981, (v) => $f0470afe3a72c66a$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $f0470afe3a72c66a$export$7897aa7841a5380c, (v) => $f0470afe3a72c66a$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $f0470afe3a72c66a$export$602eac185826482c, (v) => $f0470afe3a72c66a$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $f0470afe3a72c66a$export$e2c29f18771995cb, (v) => $f0470afe3a72c66a$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $f0470afe3a72c66a$export$5f8d39834fd61797, (v) => $f0470afe3a72c66a$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $f0470afe3a72c66a$export$74bf444e3cd11ea5, (v) => $f0470afe3a72c66a$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $f0470afe3a72c66a$export$92387174baf9b227, (v) => $f0470afe3a72c66a$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $f0470afe3a72c66a$export$ec112efeb987d9c6, (v) => $f0470afe3a72c66a$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $f0470afe3a72c66a$export$b706b080d889d2c9, (v) => $f0470afe3a72c66a$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $f0470afe3a72c66a$export$5be5a87408f70ddc, (v) => $f0470afe3a72c66a$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $f0470afe3a72c66a$export$45a5e7f76e0caa8d, (v) => $f0470afe3a72c66a$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $f0470afe3a72c66a$export$455c2e768291efa6, (v) => $f0470afe3a72c66a$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $f0470afe3a72c66a$export$9522e17588c12572, (v) => $f0470afe3a72c66a$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $f0470afe3a72c66a$export$2110ac352bb060b9, (v) => $f0470afe3a72c66a$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $f0470afe3a72c66a$export$56885ab8b9c456ab, (v) => $f0470afe3a72c66a$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $f0470afe3a72c66a$export$d927fcb6adf8f9de, (v) => $f0470afe3a72c66a$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $f0470afe3a72c66a$export$b82d16f27459e05a, (v) => $f0470afe3a72c66a$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $f0470afe3a72c66a$export$522c17b4f5e123e8, (v) => $f0470afe3a72c66a$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $f0470afe3a72c66a$export$1aabd8a0274ecfd6, (v) => $f0470afe3a72c66a$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $f0470afe3a72c66a$export$9b621391a187a31a, (v) => $f0470afe3a72c66a$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $f0470afe3a72c66a$export$f5bbd400c2f4426f, (v) => $f0470afe3a72c66a$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f0470afe3a72c66a$export$2b8d127b894957b9;
var $f0470afe3a72c66a$export$cea3a54a6425200c;
var $f0470afe3a72c66a$export$a7c73072b1a182ae;
var $f0470afe3a72c66a$export$9f27bc3417b4524d;
var $f0470afe3a72c66a$export$db77ccec0bb4ccac;
var $f0470afe3a72c66a$export$8392c0c9d3dcbd35;
var $f0470afe3a72c66a$export$ffb0004e005737fa;
var $f0470afe3a72c66a$export$b624eff549462981;
var $f0470afe3a72c66a$export$7897aa7841a5380c;
var $f0470afe3a72c66a$export$602eac185826482c;
var $f0470afe3a72c66a$export$e2c29f18771995cb;
var $f0470afe3a72c66a$export$5f8d39834fd61797;
var $f0470afe3a72c66a$export$74bf444e3cd11ea5;
var $f0470afe3a72c66a$export$92387174baf9b227;
var $f0470afe3a72c66a$export$ec112efeb987d9c6;
var $f0470afe3a72c66a$export$b706b080d889d2c9;
var $f0470afe3a72c66a$export$5be5a87408f70ddc;
var $f0470afe3a72c66a$export$45a5e7f76e0caa8d;
var $f0470afe3a72c66a$export$455c2e768291efa6;
var $f0470afe3a72c66a$export$9522e17588c12572;
var $f0470afe3a72c66a$export$2110ac352bb060b9;
var $f0470afe3a72c66a$export$56885ab8b9c456ab;
var $f0470afe3a72c66a$export$d927fcb6adf8f9de;
var $f0470afe3a72c66a$export$b82d16f27459e05a;
var $f0470afe3a72c66a$export$522c17b4f5e123e8;
var $f0470afe3a72c66a$export$1aabd8a0274ecfd6;
var $f0470afe3a72c66a$export$9b621391a187a31a;
var $f0470afe3a72c66a$export$f5bbd400c2f4426f;
'use strict';
var $f0470afe3a72c66a$var$b = "function" === typeof Symbol && Symbol.for, $f0470afe3a72c66a$var$c = $f0470afe3a72c66a$var$b ? Symbol.for("react.element") : 60103, $f0470afe3a72c66a$var$d = $f0470afe3a72c66a$var$b ? Symbol.for("react.portal") : 60106, $f0470afe3a72c66a$var$e = $f0470afe3a72c66a$var$b ? Symbol.for("react.fragment") : 60107, $f0470afe3a72c66a$var$f = $f0470afe3a72c66a$var$b ? Symbol.for("react.strict_mode") : 60108, $f0470afe3a72c66a$var$g = $f0470afe3a72c66a$var$b ? Symbol.for("react.profiler") : 60114, $f0470afe3a72c66a$var$h = $f0470afe3a72c66a$var$b ? Symbol.for("react.provider") : 60109, $f0470afe3a72c66a$var$k = $f0470afe3a72c66a$var$b ? Symbol.for("react.context") : 60110, $f0470afe3a72c66a$var$l = $f0470afe3a72c66a$var$b ? Symbol.for("react.async_mode") : 60111, $f0470afe3a72c66a$var$m = $f0470afe3a72c66a$var$b ? Symbol.for("react.concurrent_mode") : 60111, $f0470afe3a72c66a$var$n = $f0470afe3a72c66a$var$b ? Symbol.for("react.forward_ref") : 60112, $f0470afe3a72c66a$var$p = $f0470afe3a72c66a$var$b ? Symbol.for("react.suspense") : 60113, $f0470afe3a72c66a$var$q = $f0470afe3a72c66a$var$b ? Symbol.for("react.suspense_list") : 60120, $f0470afe3a72c66a$var$r = $f0470afe3a72c66a$var$b ? Symbol.for("react.memo") : 60115, $f0470afe3a72c66a$var$t = $f0470afe3a72c66a$var$b ? Symbol.for("react.lazy") : 60116, $f0470afe3a72c66a$var$v = $f0470afe3a72c66a$var$b ? Symbol.for("react.block") : 60121, $f0470afe3a72c66a$var$w = $f0470afe3a72c66a$var$b ? Symbol.for("react.fundamental") : 60117, $f0470afe3a72c66a$var$x = $f0470afe3a72c66a$var$b ? Symbol.for("react.responder") : 60118, $f0470afe3a72c66a$var$y = $f0470afe3a72c66a$var$b ? Symbol.for("react.scope") : 60119;
function $f0470afe3a72c66a$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $f0470afe3a72c66a$var$c:
                switch(a = a.type, a){
                    case $f0470afe3a72c66a$var$l:
                    case $f0470afe3a72c66a$var$m:
                    case $f0470afe3a72c66a$var$e:
                    case $f0470afe3a72c66a$var$g:
                    case $f0470afe3a72c66a$var$f:
                    case $f0470afe3a72c66a$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $f0470afe3a72c66a$var$k:
                            case $f0470afe3a72c66a$var$n:
                            case $f0470afe3a72c66a$var$t:
                            case $f0470afe3a72c66a$var$r:
                            case $f0470afe3a72c66a$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $f0470afe3a72c66a$var$d:
                return u;
        }
    }
}
function $f0470afe3a72c66a$var$A(a) {
    return $f0470afe3a72c66a$var$z(a) === $f0470afe3a72c66a$var$m;
}
$f0470afe3a72c66a$export$2b8d127b894957b9 = $f0470afe3a72c66a$var$l;
$f0470afe3a72c66a$export$cea3a54a6425200c = $f0470afe3a72c66a$var$m;
$f0470afe3a72c66a$export$a7c73072b1a182ae = $f0470afe3a72c66a$var$k;
$f0470afe3a72c66a$export$9f27bc3417b4524d = $f0470afe3a72c66a$var$h;
$f0470afe3a72c66a$export$db77ccec0bb4ccac = $f0470afe3a72c66a$var$c;
$f0470afe3a72c66a$export$8392c0c9d3dcbd35 = $f0470afe3a72c66a$var$n;
$f0470afe3a72c66a$export$ffb0004e005737fa = $f0470afe3a72c66a$var$e;
$f0470afe3a72c66a$export$b624eff549462981 = $f0470afe3a72c66a$var$t;
$f0470afe3a72c66a$export$7897aa7841a5380c = $f0470afe3a72c66a$var$r;
$f0470afe3a72c66a$export$602eac185826482c = $f0470afe3a72c66a$var$d;
$f0470afe3a72c66a$export$e2c29f18771995cb = $f0470afe3a72c66a$var$g;
$f0470afe3a72c66a$export$5f8d39834fd61797 = $f0470afe3a72c66a$var$f;
$f0470afe3a72c66a$export$74bf444e3cd11ea5 = $f0470afe3a72c66a$var$p;
$f0470afe3a72c66a$export$92387174baf9b227 = function(a) {
    return $f0470afe3a72c66a$var$A(a) || $f0470afe3a72c66a$var$z(a) === $f0470afe3a72c66a$var$l;
};
$f0470afe3a72c66a$export$ec112efeb987d9c6 = $f0470afe3a72c66a$var$A;
$f0470afe3a72c66a$export$b706b080d889d2c9 = function(a) {
    return $f0470afe3a72c66a$var$z(a) === $f0470afe3a72c66a$var$k;
};
$f0470afe3a72c66a$export$5be5a87408f70ddc = function(a) {
    return $f0470afe3a72c66a$var$z(a) === $f0470afe3a72c66a$var$h;
};
$f0470afe3a72c66a$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $f0470afe3a72c66a$var$c;
};
$f0470afe3a72c66a$export$455c2e768291efa6 = function(a) {
    return $f0470afe3a72c66a$var$z(a) === $f0470afe3a72c66a$var$n;
};
$f0470afe3a72c66a$export$9522e17588c12572 = function(a) {
    return $f0470afe3a72c66a$var$z(a) === $f0470afe3a72c66a$var$e;
};
$f0470afe3a72c66a$export$2110ac352bb060b9 = function(a) {
    return $f0470afe3a72c66a$var$z(a) === $f0470afe3a72c66a$var$t;
};
$f0470afe3a72c66a$export$56885ab8b9c456ab = function(a) {
    return $f0470afe3a72c66a$var$z(a) === $f0470afe3a72c66a$var$r;
};
$f0470afe3a72c66a$export$d927fcb6adf8f9de = function(a) {
    return $f0470afe3a72c66a$var$z(a) === $f0470afe3a72c66a$var$d;
};
$f0470afe3a72c66a$export$b82d16f27459e05a = function(a) {
    return $f0470afe3a72c66a$var$z(a) === $f0470afe3a72c66a$var$g;
};
$f0470afe3a72c66a$export$522c17b4f5e123e8 = function(a) {
    return $f0470afe3a72c66a$var$z(a) === $f0470afe3a72c66a$var$f;
};
$f0470afe3a72c66a$export$1aabd8a0274ecfd6 = function(a) {
    return $f0470afe3a72c66a$var$z(a) === $f0470afe3a72c66a$var$p;
};
$f0470afe3a72c66a$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $f0470afe3a72c66a$var$e || a === $f0470afe3a72c66a$var$m || a === $f0470afe3a72c66a$var$g || a === $f0470afe3a72c66a$var$f || a === $f0470afe3a72c66a$var$p || a === $f0470afe3a72c66a$var$q || "object" === typeof a && null !== a && (a.$$typeof === $f0470afe3a72c66a$var$t || a.$$typeof === $f0470afe3a72c66a$var$r || a.$$typeof === $f0470afe3a72c66a$var$h || a.$$typeof === $f0470afe3a72c66a$var$k || a.$$typeof === $f0470afe3a72c66a$var$n || a.$$typeof === $f0470afe3a72c66a$var$w || a.$$typeof === $f0470afe3a72c66a$var$x || a.$$typeof === $f0470afe3a72c66a$var$y || a.$$typeof === $f0470afe3a72c66a$var$v);
};
$f0470afe3a72c66a$export$f5bbd400c2f4426f = $f0470afe3a72c66a$var$z;

});

parcelRegister("bvWtN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $861ff3c65b4a3165$var$_react = $861ff3c65b4a3165$var$_interopRequireDefault((parcelRequire("aXNcS")));

var $861ff3c65b4a3165$var$_classnames = $861ff3c65b4a3165$var$_interopRequireDefault((parcelRequire("3LGzW")));


var $861ff3c65b4a3165$var$_aspectRatioBox = $861ff3c65b4a3165$var$_interopRequireDefault((parcelRequire("jZHNk")));

var $861ff3c65b4a3165$var$_image = $861ff3c65b4a3165$var$_interopRequireDefault((parcelRequire("9X97d")));

var $861ff3c65b4a3165$var$_ssrIcon = $861ff3c65b4a3165$var$_interopRequireDefault((parcelRequire("kqNiS")));

var $861ff3c65b4a3165$var$_arrowRight = $861ff3c65b4a3165$var$_interopRequireDefault((parcelRequire("4hkUl")));
function $861ff3c65b4a3165$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $861ff3c65b4a3165$var$_extends() {
    $861ff3c65b4a3165$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $861ff3c65b4a3165$var$_extends.apply(this, arguments);
}
const $861ff3c65b4a3165$var$Card = (_ref)=>{
    let { prefix: prefix = '', className: className, title: title, label: label, body: body, ctaLabel: ctaLabel, children: children, href: href, backgroundColor: backgroundColor, imageProps: imageProps, textColor: textColor, titleHeadingTag: titleHeadingTag = 'h2', emphasised: emphasised, compact: compact, imagePosition: imagePosition = 'trailing', buttonVariant: buttonVariant = 'primary', large: large, ...other } = _ref;
    const backgroundColorStyle = backgroundColor ? {
        backgroundColor: backgroundColor
    } : null;
    const textColorStyle = textColor ? {
        color: textColor
    } : null;
    const cardClasses = (0, $861ff3c65b4a3165$var$_classnames.default)(`${prefix}card`, !imageProps && `${prefix}card--without-image`, emphasised && `${prefix}card--emphasised`, large && `${prefix}card--large`, compact && `${prefix}card--compact`, imagePosition === 'trailing' && `${prefix}card--trailing-image`, className);
    const cardInfoClasses = (0, $861ff3c65b4a3165$var$_classnames.default)(`${prefix}card__info`);
    const HeadingTag = titleHeadingTag;
    const textContent = $861ff3c65b4a3165$var$_react.default.createElement("div", {
        className: `${prefix}card__text-wrapper`
    }, label && $861ff3c65b4a3165$var$_react.default.createElement("span", {
        style: textColorStyle,
        className: `${prefix}card__label`
    }, label), title && $861ff3c65b4a3165$var$_react.default.createElement(HeadingTag, {
        style: textColorStyle,
        className: `${prefix}card__title`
    }, title), body && $861ff3c65b4a3165$var$_react.default.createElement("p", {
        style: textColorStyle,
        className: `${prefix}card__body`
    }, body), children);
    return $861ff3c65b4a3165$var$_react.default.createElement("a", $861ff3c65b4a3165$var$_extends({
        className: cardClasses,
        href: href,
        style: backgroundColorStyle
    }, other), imageProps && $861ff3c65b4a3165$var$_react.default.createElement("div", {
        className: `${prefix}card__image`
    }, $861ff3c65b4a3165$var$_react.default.createElement($861ff3c65b4a3165$var$_aspectRatioBox.default, {
        ratio: "wide",
        prefix: prefix,
        className: `${prefix}card__image-aspect-ratio`
    }, $861ff3c65b4a3165$var$_react.default.createElement($861ff3c65b4a3165$var$_image.default, $861ff3c65b4a3165$var$_extends({
        prefix: prefix
    }, imageProps)))), $861ff3c65b4a3165$var$_react.default.createElement("div", {
        className: cardInfoClasses
    }, textContent, $861ff3c65b4a3165$var$_react.default.createElement("span", {
        style: textColorStyle,
        className: (0, $861ff3c65b4a3165$var$_classnames.default)(`${prefix}card__cta`, ctaLabel && `${prefix}card__cta--with-button`)
    }, ctaLabel || emphasised ? $861ff3c65b4a3165$var$_react.default.createElement("span", {
        className: `${prefix}card__btn ${prefix}btn ${prefix}btn--${buttonVariant} ${prefix}btn--small`
    }, $861ff3c65b4a3165$var$_react.default.createElement("span", {
        className: `${prefix}btn__inner`
    }, emphasised && buttonVariant.indexOf('icon') !== -1 && $861ff3c65b4a3165$var$_react.default.createElement($861ff3c65b4a3165$var$_ssrIcon.default, {
        className: `${prefix}card__icon`,
        prefix: prefix,
        paths: $861ff3c65b4a3165$var$_arrowRight.default
    }), ctaLabel && $861ff3c65b4a3165$var$_react.default.createElement("span", {
        className: `${prefix}btn__label`
    }, ctaLabel))) : $861ff3c65b4a3165$var$_react.default.createElement($861ff3c65b4a3165$var$_ssrIcon.default, {
        className: `${prefix}card__icon`,
        prefix: prefix,
        paths: $861ff3c65b4a3165$var$_arrowRight.default
    }))));
};
var $861ff3c65b4a3165$var$_default = $861ff3c65b4a3165$var$Card;
module.exports.default = $861ff3c65b4a3165$var$_default;

});
parcelRegister("3LGzW", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = '[native code]';
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === 'string' || argType === 'number') classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === 'object') {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(' ');
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("jZHNk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e8e5af85beda4a9b$var$_AspectRatioBox = $e8e5af85beda4a9b$var$_interopRequireDefault((parcelRequire("8409y")));
function $e8e5af85beda4a9b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e8e5af85beda4a9b$var$_default = $e8e5af85beda4a9b$var$_AspectRatioBox.default;
module.exports.default = $e8e5af85beda4a9b$var$_default;

});
parcelRegister("8409y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5deed0d72f6a2a35$var$_react = $5deed0d72f6a2a35$var$_interopRequireDefault((parcelRequire("aXNcS")));


var $5deed0d72f6a2a35$var$_classnames = $5deed0d72f6a2a35$var$_interopRequireDefault((parcelRequire("3LGzW")));
function $5deed0d72f6a2a35$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5deed0d72f6a2a35$var$_extends() {
    $5deed0d72f6a2a35$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5deed0d72f6a2a35$var$_extends.apply(this, arguments);
}
const $5deed0d72f6a2a35$var$AspectRatioBox = (_ref)=>{
    let { tagType: tagType, prefix: prefix, className: className, ratio: ratio, children: children, ...others } = _ref;
    const classes = (0, $5deed0d72f6a2a35$var$_classnames.default)(`${prefix}aspect-ratio-box`, ratio && `${prefix}aspect-ratio-box--${ratio}`, className);
    const SpanOrDiv = tagType;
    return $5deed0d72f6a2a35$var$_react.default.createElement(SpanOrDiv, $5deed0d72f6a2a35$var$_extends({
        className: `${classes}`
    }, others), children);
};
$5deed0d72f6a2a35$var$AspectRatioBox.defaultProps = {
    prefix: '',
    tagType: 'span',
    ratio: 'standard'
};
var $5deed0d72f6a2a35$var$_default = $5deed0d72f6a2a35$var$AspectRatioBox;
module.exports.default = $5deed0d72f6a2a35$var$_default;

});


parcelRegister("9X97d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $73f0b1e19780b4b9$var$_Image = $73f0b1e19780b4b9$var$_interopRequireDefault((parcelRequire("vnoW4")));
function $73f0b1e19780b4b9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $73f0b1e19780b4b9$var$_default = $73f0b1e19780b4b9$var$_Image.default;
module.exports.default = $73f0b1e19780b4b9$var$_default;

});
parcelRegister("vnoW4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $05e50c5a90b72f1b$var$_react = $05e50c5a90b72f1b$var$_interopRequireWildcard((parcelRequire("aXNcS")));


var $05e50c5a90b72f1b$var$_ssrIcon = $05e50c5a90b72f1b$var$_interopRequireDefault((parcelRequire("kqNiS")));

var $05e50c5a90b72f1b$var$_imageStrikethrough = $05e50c5a90b72f1b$var$_interopRequireDefault((parcelRequire("4wysS")));

var $05e50c5a90b72f1b$var$_image = $05e50c5a90b72f1b$var$_interopRequireDefault((parcelRequire("04aMk")));

var $05e50c5a90b72f1b$var$_classnames = $05e50c5a90b72f1b$var$_interopRequireDefault((parcelRequire("3LGzW")));
function $05e50c5a90b72f1b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $05e50c5a90b72f1b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($05e50c5a90b72f1b$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $05e50c5a90b72f1b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $05e50c5a90b72f1b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $05e50c5a90b72f1b$var$_extends() {
    $05e50c5a90b72f1b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $05e50c5a90b72f1b$var$_extends.apply(this, arguments);
}
const $05e50c5a90b72f1b$var$Image = (_ref)=>{
    let { src: src, alt: alt, className: className, prefix: prefix, srcSet: srcSet, sizes: sizes, loading: loading, fallback: fallback, ...otherProps } = _ref;
    const [error, setError] = (0, $05e50c5a90b72f1b$var$_react.useState)(false);
    const classes = (0, $05e50c5a90b72f1b$var$_classnames.default)(`${prefix}image`, (error || fallback) && `${prefix}image--fallback`, className);
    const onError = ()=>{
        setError(true);
    };
    (0, $05e50c5a90b72f1b$var$_react.useEffect)(()=>{
        if (src) setError(false);
    }, [
        src
    ]);
    let paths = $05e50c5a90b72f1b$var$_image.default;
    if (error) paths = $05e50c5a90b72f1b$var$_imageStrikethrough.default;
    const image = $05e50c5a90b72f1b$var$_react.default.createElement("img", $05e50c5a90b72f1b$var$_extends({
        className: !error && !fallback ? classes : undefined,
        onError: onError,
        alt: alt,
        src: src,
        srcSet: srcSet,
        sizes: sizes,
        loading: loading
    }, otherProps));
    return error || fallback ? $05e50c5a90b72f1b$var$_react.default.createElement("span", {
        className: classes
    }, $05e50c5a90b72f1b$var$_react.default.createElement($05e50c5a90b72f1b$var$_ssrIcon.default, {
        paths: paths,
        className: `${prefix}image__icon`,
        prefix: prefix
    }), image) : image;
};
$05e50c5a90b72f1b$var$Image.defaultProps = {
    prefix: '',
    loading: 'lazy'
};
var $05e50c5a90b72f1b$var$_default = $05e50c5a90b72f1b$var$Image;
module.exports.default = $05e50c5a90b72f1b$var$_default;

});
parcelRegister("kqNiS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $edfc7aff1416a0c3$var$_SSRIcon = $edfc7aff1416a0c3$var$_interopRequireDefault((parcelRequire("WIlth")));
function $edfc7aff1416a0c3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $edfc7aff1416a0c3$var$_default = $edfc7aff1416a0c3$var$_SSRIcon.default;
module.exports.default = $edfc7aff1416a0c3$var$_default;

});
parcelRegister("WIlth", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b07d0f2ed5b429b$var$_react = $0b07d0f2ed5b429b$var$_interopRequireDefault((parcelRequire("aXNcS")));


var $0b07d0f2ed5b429b$var$_classnames = $0b07d0f2ed5b429b$var$_interopRequireDefault((parcelRequire("3LGzW")));
function $0b07d0f2ed5b429b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0b07d0f2ed5b429b$var$_extends() {
    $0b07d0f2ed5b429b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0b07d0f2ed5b429b$var$_extends.apply(this, arguments);
}
const $0b07d0f2ed5b429b$var$SSRIcon = (props)=>{
    const { prefix: prefix = '', viewBox: viewBox = '0 0 24 24', paths: paths, className: className, modifier: modifier, ariaHidden: ariaHidden = true, ...otherProps } = props;
    const cssStyles = (0, $0b07d0f2ed5b429b$var$_classnames.default)(`${prefix}svg-icon`, className, modifier && `${prefix}svg-icon--${modifier}`);
    return paths ? $0b07d0f2ed5b429b$var$_react.default.createElement("svg", $0b07d0f2ed5b429b$var$_extends({
        focusable: "false",
        viewBox: viewBox,
        width: '24',
        height: '24'
    }, otherProps, {
        className: cssStyles,
        "aria-hidden": ariaHidden
    }), paths().map((path, id)=>{
        return $0b07d0f2ed5b429b$var$_react.default.cloneElement(path, {
            key: id
        });
    })) : null;
};
var $0b07d0f2ed5b429b$var$_default = $0b07d0f2ed5b429b$var$SSRIcon;
module.exports.default = $0b07d0f2ed5b429b$var$_default;

});


parcelRegister("4wysS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $34b4e2916725220a$var$_react = $34b4e2916725220a$var$_interopRequireDefault((parcelRequire("aXNcS")));
function $34b4e2916725220a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $34b4e2916725220a$var$_default = function _default() {
    let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return [
        $34b4e2916725220a$var$_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "m2.3979 2.414 19.1846 19.1907-1.3978 1.3965-3.0002-3.0011H3V5.8113L1 3.8106l1.3979-1.3965zM15.185 18.0002l-1.9994-2H6.5l2.6748-4.0122L5 7.8119V18h10.1851z"
        }),
        $34b4e2916725220a$var$_react.default.createElement("path", {
            d: "m6.8114 4.0001 1.9994 2H19v10.1924l2 2.0006V4.0001H6.8114z"
        }),
        $34b4e2916725220a$var$_react.default.createElement("path", {
            d: "M14 9.5001c0 .8284.6716 1.5 1.5 1.5s1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5-1.5.6716-1.5 1.5z"
        })
    ];
};
module.exports.default = $34b4e2916725220a$var$_default;

});

parcelRegister("04aMk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $00c8bc393ca2e318$var$_react = $00c8bc393ca2e318$var$_interopRequireDefault((parcelRequire("aXNcS")));
function $00c8bc393ca2e318$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $00c8bc393ca2e318$var$_default = function _default() {
    let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return [
        $00c8bc393ca2e318$var$_react.default.createElement("path", {
            d: "M15.5 11c-.8284 0-1.5-.6716-1.5-1.5S14.6716 8 15.5 8s1.5.6716 1.5 1.5-.6716 1.5-1.5 1.5zM13 15.25l-3-4.5L6.5 16h11L15 12.25l-2 3z"
        }),
        $00c8bc393ca2e318$var$_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3 4v16h18V4H3zm2 14V6h14v12H5z"
        })
    ];
};
module.exports.default = $00c8bc393ca2e318$var$_default;

});



parcelRegister("4hkUl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $31d8f7c9449de931$var$_react = $31d8f7c9449de931$var$_interopRequireDefault((parcelRequire("aXNcS")));
function $31d8f7c9449de931$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $31d8f7c9449de931$var$_default = function _default() {
    let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return [
        $31d8f7c9449de931$var$_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "m20.0008 12.0001-8-8.001-1.4143 1.414L16.1727 11H4v2h12.1723l-5.5868 5.5866 1.4141 1.4142 8.0012-8.0007z"
        })
    ];
};
module.exports.default = $31d8f7c9449de931$var$_default;

});


parcelRegister("c96eS", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kYrH1 = parcelRequire("kYrH1");
function $8d7b2a35fb23d198$var$emptyFunction() {}
function $8d7b2a35fb23d198$var$emptyFunctionWithReset() {}
$8d7b2a35fb23d198$var$emptyFunctionWithReset.resetWarningCache = $8d7b2a35fb23d198$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kYrH1) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $8d7b2a35fb23d198$var$emptyFunctionWithReset,
        resetWarningCache: $8d7b2a35fb23d198$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kYrH1", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f44ee4807c657d43$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f44ee4807c657d43$var$ReactPropTypesSecret;

});


parcelRegister("9MLuw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $71fd6f82fcb43ec7$var$_react = $71fd6f82fcb43ec7$var$_interopRequireWildcard((parcelRequire("aXNcS")));

var $71fd6f82fcb43ec7$var$_button = $71fd6f82fcb43ec7$var$_interopRequireDefault((parcelRequire("1m4gm")));


var $71fd6f82fcb43ec7$var$_classnames = $71fd6f82fcb43ec7$var$_interopRequireDefault((parcelRequire("3LGzW")));

var $4iisx = parcelRequire("4iisx");
function $71fd6f82fcb43ec7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $71fd6f82fcb43ec7$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($71fd6f82fcb43ec7$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $71fd6f82fcb43ec7$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $71fd6f82fcb43ec7$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $71fd6f82fcb43ec7$var$_extends() {
    $71fd6f82fcb43ec7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $71fd6f82fcb43ec7$var$_extends.apply(this, arguments);
}
const $71fd6f82fcb43ec7$var$ModalFooter = (_ref)=>{
    let { prefix: prefix, children: children, closeBtnClick: closeBtnClick, renderBorder: renderBorder, className: className, ...other } = _ref;
    let childrenArr = $71fd6f82fcb43ec7$var$_react.Children.toArray(children);
    if (childrenArr.length && childrenArr[0].type === $71fd6f82fcb43ec7$var$_react.Fragment) childrenArr = $71fd6f82fcb43ec7$var$_react.Children.toArray(children.props.children);
    const breakpoint = (0, $4iisx.useBreakpoint)('sm', 'md');
    const classes = (0, $71fd6f82fcb43ec7$var$_classnames.default)(`${prefix}modal-footer`, !renderBorder && `${prefix}modal-footer--borderless`, childrenArr.length === 2 && `${prefix}modal-footer--dual-action`, className);
    const buttons = childrenArr.map((item, i)=>{
        const clickHandlerWrapper = item.props.onClick ? (ev)=>item.props.onClick(ev, closeBtnClick) : ()=>closeBtnClick();
        return $71fd6f82fcb43ec7$var$_react.default.cloneElement(item, {
            prefix: prefix,
            small: breakpoint === 'sm',
            key: i,
            onClick: clickHandlerWrapper
        });
    });
    return $71fd6f82fcb43ec7$var$_react.default.createElement("div", $71fd6f82fcb43ec7$var$_extends({
        className: classes
    }, other), buttons);
};
$71fd6f82fcb43ec7$var$ModalFooter.defaultProps = {
    prefix: '',
    renderBorder: false
};
var $71fd6f82fcb43ec7$var$_default = $71fd6f82fcb43ec7$var$ModalFooter;
module.exports.default = $71fd6f82fcb43ec7$var$_default;

});
parcelRegister("1m4gm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0fcb270c22523416$var$_Button = $0fcb270c22523416$var$_interopRequireDefault((parcelRequire("bCEVk")));
function $0fcb270c22523416$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0fcb270c22523416$var$_default = $0fcb270c22523416$var$_Button.default;
module.exports.default = $0fcb270c22523416$var$_default;

});
parcelRegister("bCEVk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ldsZ1 = parcelRequire("ldsZ1");

var $8762fce90945ed14$var$_react = $8762fce90945ed14$var$_interopRequireWildcard((parcelRequire("aXNcS")));

var $8762fce90945ed14$var$_ssrIcon = $8762fce90945ed14$var$_interopRequireDefault((parcelRequire("bAnv2")));

var $8762fce90945ed14$var$_classnames = $8762fce90945ed14$var$_interopRequireDefault((parcelRequire("3LGzW")));

var $8762fce90945ed14$var$_warningTriangle = $8762fce90945ed14$var$_interopRequireDefault((parcelRequire("8GDHy")));
function $8762fce90945ed14$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8762fce90945ed14$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8762fce90945ed14$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8762fce90945ed14$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8762fce90945ed14$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $8762fce90945ed14$var$_extends() {
    $8762fce90945ed14$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8762fce90945ed14$var$_extends.apply(this, arguments);
}
const $8762fce90945ed14$var$inverseTypes = [
    'primary',
    'emphasised',
    'secondary',
    'tertiary'
];
const $8762fce90945ed14$var$propTypes = {
    children: (0, $ldsZ1.oneOfType)([
        (0, $ldsZ1.arrayOf)($ldsZ1.node),
        $ldsZ1.node
    ]),
    className: $ldsZ1.string,
    disabled: $ldsZ1.bool,
    expanding: $ldsZ1.bool,
    fluid: $ldsZ1.bool,
    href: $ldsZ1.string,
    htmlType: $ldsZ1.string,
    iconOnly: $ldsZ1.bool,
    iconPosition: (0, $ldsZ1.oneOf)([
        'leading',
        'trailing'
    ]),
    inverseTheme: (props, propName, componentName)=>{
        if ($8762fce90945ed14$var$inverseTypes.indexOf(props.type) === -1 && props.inverseTheme) return new Error(`The property: \'inverseTheme\' provided to Button is not applicable to the Button of the type \'${props.type}\'. Please remove it or set it to false`);
        return (0, $ldsZ1.checkPropTypes)({
            inverseTheme: $ldsZ1.bool
        }, props, 'prop', componentName);
    },
    loading: $ldsZ1.bool,
    loadingSrText: (0, $ldsZ1.oneOfType)([
        $ldsZ1.string,
        $ldsZ1.element
    ]),
    newWindow: $ldsZ1.bool,
    onClick: $ldsZ1.func,
    prefix: $ldsZ1.string,
    small: $ldsZ1.bool,
    ssrIcon: $ldsZ1.func,
    text: (0, $ldsZ1.oneOfType)([
        $ldsZ1.string,
        $ldsZ1.element
    ]),
    type: (0, $ldsZ1.oneOf)([
        'primary',
        'emphasised',
        'secondary',
        'tertiary',
        'danger',
        'plain',
        'image-overlay'
    ]),
    xsmallIconOnly: $ldsZ1.bool,
    expandedOnTouchDevice: $ldsZ1.bool
};
const $8762fce90945ed14$var$Button = (0, $8762fce90945ed14$var$_react.forwardRef)((props, ref)=>{
    const { small: small, xsmallIconOnly: xsmallIconOnly, href: href, newWindow: newWindow, loadingSrText: loadingSrText = "Loading\u2026", ssrIcon: ssrIcon, iconOnly: iconOnly = false, prefix: prefix = '', htmlType: htmlType = 'button', disabled: disabled = false, className: className, onClick: onClick, text: text, type: type = 'secondary', expanding: expanding, loading: loading, iconPosition: iconPosition = 'leading', fluid: fluid, inverseTheme: inverseTheme, children: children, expandedOnTouchDevice: expandedOnTouchDevice, ...others } = props;
    function onKeyUpHandler(e) {
        if (disabled || loading || e.key !== ' ') return true;
        e.target.click();
    }
    let btnType = type ? type : 'secondary';
    if (iconOnly && ssrIcon) btnType = `icon-${btnType}`;
    if (inverseTheme && $8762fce90945ed14$var$inverseTypes.indexOf(type) > -1) btnType = `${btnType}-inverse`;
    const innerClasses = (0, $8762fce90945ed14$var$_classnames.default)(`${prefix}btn__inner`);
    let iconTag;
    const iconClass = `${prefix}btn__icon`;
    const icon = type === 'danger' ? $8762fce90945ed14$var$_warningTriangle.default : ssrIcon;
    if (icon) iconTag = $8762fce90945ed14$var$_react.default.createElement($8762fce90945ed14$var$_ssrIcon.default, {
        className: iconClass,
        prefix: prefix,
        paths: icon
    });
    const classes = (0, $8762fce90945ed14$var$_classnames.default)(`${prefix}btn`, loading && `${prefix}btn--loading`, small && `${prefix}btn--small`, iconOnly && xsmallIconOnly && `${prefix}btn--xsmall`, !iconOnly && icon && iconPosition && `${prefix}${iconPosition}-icon`, type && `${prefix}btn--${btnType}`, fluid && !iconOnly && `${prefix}btn--fluid`, expanding && `${prefix}btn--expanding`, expanding && expandedOnTouchDevice && `${prefix}btn--touch-device-expanded`, className);
    const handleClick = (ev)=>{
        if (loading || disabled) {
            ev.stopPropagation();
            return;
        }
        if (onClick && typeof onClick === 'function') onClick(ev);
    };
    const ButtonTag = href ? 'a' : 'button';
    const onKeyUp = ButtonTag === 'a' ? onKeyUpHandler : null;
    const role = href ? 'button' : null;
    const linkProps = {
        ...!disabled && {
            href: href
        },
        ...newWindow && {
            target: '_blank'
        }
    };
    const button = $8762fce90945ed14$var$_react.default.createElement(ButtonTag, $8762fce90945ed14$var$_extends({
        ref: ref,
        "aria-disabled": loading,
        type: !href ? htmlType : null,
        role: role,
        disabled: href ? null : disabled,
        className: classes,
        onClick: handleClick,
        onKeyUp: onKeyUp
    }, linkProps, others), $8762fce90945ed14$var$_react.default.createElement("span", {
        className: innerClasses
    }, iconTag, text && $8762fce90945ed14$var$_react.default.createElement("span", {
        className: `${prefix}btn__label`
    }, text), !loading && children, loading && $8762fce90945ed14$var$_react.default.createElement("span", {
        className: `${prefix}btn__loader`
    }, loadingSrText)));
    return button;
});
$8762fce90945ed14$var$Button.propTypes = $8762fce90945ed14$var$propTypes;
$8762fce90945ed14$var$Button.displayName = 'Button';
var $8762fce90945ed14$var$_default = $8762fce90945ed14$var$Button;
module.exports.default = $8762fce90945ed14$var$_default;

});
parcelRegister("ldsZ1", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $03fc6870e0f980f9$var$ReactIs, $03fc6870e0f980f9$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("c96eS"))();

});

parcelRegister("bAnv2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $86f5490c0bfcba5b$var$_SSRIcon = $86f5490c0bfcba5b$var$_interopRequireDefault((parcelRequire("hEVo5")));
function $86f5490c0bfcba5b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $86f5490c0bfcba5b$var$_default = $86f5490c0bfcba5b$var$_SSRIcon.default;
module.exports.default = $86f5490c0bfcba5b$var$_default;

});
parcelRegister("hEVo5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cdb2b00fc98bb2fa$var$_react = $cdb2b00fc98bb2fa$var$_interopRequireDefault((parcelRequire("aXNcS")));


var $cdb2b00fc98bb2fa$var$_classnames = $cdb2b00fc98bb2fa$var$_interopRequireDefault((parcelRequire("3LGzW")));
function $cdb2b00fc98bb2fa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cdb2b00fc98bb2fa$var$_extends() {
    $cdb2b00fc98bb2fa$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cdb2b00fc98bb2fa$var$_extends.apply(this, arguments);
}
const $cdb2b00fc98bb2fa$var$SSRIcon = (props)=>{
    const { prefix: prefix = '', viewBox: viewBox = '0 0 24 24', paths: paths, className: className, modifier: modifier, ariaHidden: ariaHidden = true, ...otherProps } = props;
    const cssStyles = (0, $cdb2b00fc98bb2fa$var$_classnames.default)(`${prefix}svg-icon`, className, modifier && `${prefix}svg-icon--${modifier}`);
    return paths ? $cdb2b00fc98bb2fa$var$_react.default.createElement("svg", $cdb2b00fc98bb2fa$var$_extends({
        focusable: "false",
        viewBox: viewBox,
        width: '24',
        height: '24'
    }, otherProps, {
        className: cssStyles,
        "aria-hidden": ariaHidden
    }), paths().map((path, id)=>{
        return $cdb2b00fc98bb2fa$var$_react.default.cloneElement(path, {
            key: id
        });
    })) : null;
};
var $cdb2b00fc98bb2fa$var$_default = $cdb2b00fc98bb2fa$var$SSRIcon;
module.exports.default = $cdb2b00fc98bb2fa$var$_default;

});


parcelRegister("8GDHy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65310ade38212e34$var$_react = $65310ade38212e34$var$_interopRequireDefault((parcelRequire("aXNcS")));
function $65310ade38212e34$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $65310ade38212e34$var$_default = function _default() {
    let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return [
        $65310ade38212e34$var$_react.default.createElement("path", {
            d: "M11.0036 14.1337h2v-6h-2v6zm1 1.5c-.6904 0-1.25.5597-1.25 1.25 0 .6904.5596 1.25 1.25 1.25.6903 0 1.25-.5596 1.25-1.25 0-.6903-.5597-1.25-1.25-1.25z"
        }),
        $65310ade38212e34$var$_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "m1.1152 20.418 10-19h1.7699l10 19-.8849 1.4657h-20l-.885-1.4657zm2.5413-.5343h16.6873L12.0002 4.0308 3.6565 19.8837z"
        })
    ];
};
module.exports.default = $65310ade38212e34$var$_default;

});



parcelRegister("4iisx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "useBreakpoint", {
    enumerable: true,
    get: function() {
        return $3207298438bd07dc$var$_useBreakpoints.default;
    }
});
Object.defineProperty(module.exports, "useWindowSize", {
    enumerable: true,
    get: function() {
        return $3207298438bd07dc$var$_useWindowSize.default;
    }
});

var $3207298438bd07dc$var$_useBreakpoints = $3207298438bd07dc$var$_interopRequireDefault((parcelRequire("9Z6uI")));

var $3207298438bd07dc$var$_useWindowSize = $3207298438bd07dc$var$_interopRequireDefault((parcelRequire("as4BG")));
function $3207298438bd07dc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("9Z6uI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mediaWidth = module.exports.default = void 0;

var $744ed93be5296b86$var$_react = $744ed93be5296b86$var$_interopRequireDefault((parcelRequire("aXNcS")));

var $iXMJh = parcelRequire("iXMJh");
function $744ed93be5296b86$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
if (!$iXMJh.breakpointM || !$iXMJh.breakpointL || !$iXMJh.breakpointXl) throw Error('Undefined essential design tokens! Check breakpoint references at @ingka/variables');
const $744ed93be5296b86$var$mediaRules = {};
const $744ed93be5296b86$var$createRules = ()=>{
    if ($744ed93be5296b86$var$mediaRules.small) return;
    $744ed93be5296b86$var$mediaRules.small = window.matchMedia(`(min-width: ${$iXMJh.breakpointM})`);
    $744ed93be5296b86$var$mediaRules.medium = window.matchMedia(`(min-width: ${$iXMJh.breakpointL})`);
    $744ed93be5296b86$var$mediaRules.large = window.matchMedia(`(min-width: ${$iXMJh.breakpointXl})`);
    $744ed93be5296b86$var$mediaRules.all = [
        $744ed93be5296b86$var$mediaRules.small,
        $744ed93be5296b86$var$mediaRules.medium,
        $744ed93be5296b86$var$mediaRules.large
    ];
};
const $744ed93be5296b86$var$cleanUpOnDestroy = ()=>{
    $744ed93be5296b86$var$mediaRules.all.length = 0;
    delete $744ed93be5296b86$var$mediaRules.all;
    Object.keys($744ed93be5296b86$var$mediaRules).map((key)=>delete $744ed93be5296b86$var$mediaRules[key]);
};
const $744ed93be5296b86$var$stateSetters = [];
const $744ed93be5296b86$var$getMediaWidth = ()=>{
    let breakpoint;
    if ($744ed93be5296b86$var$mediaRules.large.matches) breakpoint = $744ed93be5296b86$var$mediaWidth.XLARGE;
    else if ($744ed93be5296b86$var$mediaRules.medium.matches) breakpoint = $744ed93be5296b86$var$mediaWidth.LARGE;
    else if ($744ed93be5296b86$var$mediaRules.small.matches) breakpoint = $744ed93be5296b86$var$mediaWidth.MEDIUM;
    else breakpoint = $744ed93be5296b86$var$mediaWidth.SMALL;
    return breakpoint;
};
const $744ed93be5296b86$var$bpIndex = (bp)=>$744ed93be5296b86$var$breakpointsOrder.indexOf(bp);
const $744ed93be5296b86$var$signalBreakpointChange = ()=>{
    let breakpoint = $744ed93be5296b86$var$getMediaWidth();
    $744ed93be5296b86$var$stateSetters.forEach((_ref)=>{
        let { current: { breakpointStateSetter: breakpointStateSetter, triggerPoints: triggerPoints } } = _ref;
        return breakpointStateSetter((previousBreakpoint)=>{
            if (triggerPoints.find((triggerpoint)=>$744ed93be5296b86$var$bpIndex(previousBreakpoint) < $744ed93be5296b86$var$bpIndex(triggerpoint) !== $744ed93be5296b86$var$bpIndex(breakpoint) < $744ed93be5296b86$var$bpIndex(triggerpoint))) return breakpoint;
            return previousBreakpoint;
        });
    });
};
const $744ed93be5296b86$var$addBreakpointListeners = ()=>{
    $744ed93be5296b86$var$mediaRules.all.forEach((rule)=>$744ed93be5296b86$var$mediaRules.small.addEventListener ? rule.addEventListener('change', $744ed93be5296b86$var$signalBreakpointChange) : rule.addListener($744ed93be5296b86$var$signalBreakpointChange));
};
const $744ed93be5296b86$var$removeBreakpointListeners = ()=>{
    $744ed93be5296b86$var$mediaRules.all.forEach((rule)=>$744ed93be5296b86$var$mediaRules.small.removeEventListener ? rule.removeEventListener('change', $744ed93be5296b86$var$signalBreakpointChange) : rule.removeListener($744ed93be5296b86$var$signalBreakpointChange));
};
const $744ed93be5296b86$var$useBreakpoint = function() {
    for(var _len = arguments.length, triggerPoints = new Array(_len), _key = 0; _key < _len; _key++)triggerPoints[_key] = arguments[_key];
    const [currentBreakpoint, setCurrentBreakpoint] = $744ed93be5296b86$var$_react.default.useState();
    const config = $744ed93be5296b86$var$_react.default.useRef();
    $744ed93be5296b86$var$_react.default.useEffect(()=>{
        config.current = {
            breakpointStateSetter: setCurrentBreakpoint,
            triggerPoints: triggerPoints
        };
        if (triggerPoints.length) {
            $744ed93be5296b86$var$stateSetters.push(config);
            if ($744ed93be5296b86$var$stateSetters.length === 1) {
                $744ed93be5296b86$var$createRules();
                $744ed93be5296b86$var$addBreakpointListeners();
            }
            setCurrentBreakpoint($744ed93be5296b86$var$getMediaWidth());
        }
        return ()=>{
            if ($744ed93be5296b86$var$stateSetters.indexOf(config) > -1) $744ed93be5296b86$var$stateSetters.splice($744ed93be5296b86$var$stateSetters.indexOf(config), 1);
            if ($744ed93be5296b86$var$stateSetters.length === 0) {
                $744ed93be5296b86$var$removeBreakpointListeners();
                $744ed93be5296b86$var$cleanUpOnDestroy();
            }
        };
    }, triggerPoints);
    return currentBreakpoint;
};
const $744ed93be5296b86$var$mediaWidth = {
    SMALL: 'sm',
    MEDIUM: 'md',
    LARGE: 'lg',
    XLARGE: 'xl'
};
module.exports.mediaWidth = $744ed93be5296b86$var$mediaWidth;
const $744ed93be5296b86$var$breakpointsOrder = [
    $744ed93be5296b86$var$mediaWidth.SMALL,
    $744ed93be5296b86$var$mediaWidth.MEDIUM,
    $744ed93be5296b86$var$mediaWidth.LARGE,
    $744ed93be5296b86$var$mediaWidth.XLARGE
];
var $744ed93be5296b86$var$_default = $744ed93be5296b86$var$useBreakpoint;
module.exports.default = $744ed93be5296b86$var$_default;

});
parcelRegister("iXMJh", function(module, exports) {

$parcel$export(module.exports, "breakpointXl", () => $dce3894a979838ec$export$a1871aeaef241475);
$parcel$export(module.exports, "breakpointL", () => $dce3894a979838ec$export$cc0d07b5ce8f1a0f);
$parcel$export(module.exports, "breakpointM", () => $dce3894a979838ec$export$504b14171daac591);
// Do not make edits in this file!
// This file is automatically generated and any changes will be overwritten.
// To fetch new design tokens check the design-system/README.md
/**
  * 0.625rem
  */ const $dce3894a979838ec$export$2ee03700355519fa = '0.625rem';
const $dce3894a979838ec$export$e43eb1146692dbbd = '0.6875rem';
const $dce3894a979838ec$export$94aebaea4fb047db = '0.75rem';
const $dce3894a979838ec$export$143f3afd583c7e66 = '0.875rem';
const $dce3894a979838ec$export$be81731d829ada72 = '1rem';
const $dce3894a979838ec$export$dad37c4064481a23 = '1.125rem';
const $dce3894a979838ec$export$2310711877b15a13 = '1.25rem';
const $dce3894a979838ec$export$16d93b84ab0fd6af = '1.375rem';
const $dce3894a979838ec$export$c34ba906d3da8f27 = '1.5rem';
const $dce3894a979838ec$export$d9e3a79e4465d1f9 = '1.75rem';
const $dce3894a979838ec$export$e765e0acbbf3897 = '2rem';
const $dce3894a979838ec$export$a9ea6d3097f62ed1 = '2.25rem';
const $dce3894a979838ec$export$136ee1ac2d6ff3f1 = '2.5rem';
const $dce3894a979838ec$export$ee1f01a2186c5986 = '3rem';
const $dce3894a979838ec$export$1cd7dbc564582521 = '3.25rem';
const $dce3894a979838ec$export$7d39dea31f76b14e = '3.5rem';
const $dce3894a979838ec$export$1ea6000041e8400d = '4rem';
const $dce3894a979838ec$export$281669aa21b2bf87 = '4.4375rem';
const $dce3894a979838ec$export$1517d1e73ae0dac0 = '5rem';
const $dce3894a979838ec$export$6dcbc1746e26eb2d = '6rem';
const $dce3894a979838ec$export$c46df79513126abf = 700;
const $dce3894a979838ec$export$a9ac43da6e214480 = 400;
const $dce3894a979838ec$export$4302b5044559543e = '1px';
const $dce3894a979838ec$export$48073435ecd5df18 = '2px';
const $dce3894a979838ec$export$f0fea226b14d0e20 = '0px';
const $dce3894a979838ec$export$81d8122f53ebd34b = '4px';
const $dce3894a979838ec$export$2e6fa7320bd4b2b9 = '8px';
const $dce3894a979838ec$export$2f3c39780d157365 = '12px';
const $dce3894a979838ec$export$16fc2e49cd0cccef = '20px';
const $dce3894a979838ec$export$25106c99e7472a2a = '64px';
const $dce3894a979838ec$export$11c1a522262fbe56 = '0.25rem';
const $dce3894a979838ec$export$53a7898de828e9eb = '0.5rem';
const $dce3894a979838ec$export$9b8d3cbb719f80ca = '0.75rem';
const $dce3894a979838ec$export$2b2ae4911f53c2af = '1rem';
const $dce3894a979838ec$export$dbc96ebec57e5b2e = '1.25rem';
const $dce3894a979838ec$export$cd0210c732c60394 = '1.5rem';
const $dce3894a979838ec$export$c1b36e318bc8b98f = '2rem';
const $dce3894a979838ec$export$12fc8bf165e419f5 = '2.5rem';
const $dce3894a979838ec$export$e0ce3f501d0b56a7 = '3rem';
const $dce3894a979838ec$export$d882d6acaa09bc81 = '4rem';
const $dce3894a979838ec$export$853fe8b65b3c9d3e = '5.5rem';
const $dce3894a979838ec$export$63c8594bc24ba2fc = '7.5rem';
const $dce3894a979838ec$export$8f30f9ccae80857e = '10rem';
const $dce3894a979838ec$export$5a020f1540525bc3 = '13.5rem';
const $dce3894a979838ec$export$dabe941b842ede4b = '0px 4px 16px rgba(0, 0, 0, 0.1)';
const $dce3894a979838ec$export$330c04f0c6cb53da = '800ms';
const $dce3894a979838ec$export$a9394c1e93a3ae94 = '400ms';
const $dce3894a979838ec$export$ee67cfc7433a2119 = '250ms';
const $dce3894a979838ec$export$babf96970656270 = '600ms';
const $dce3894a979838ec$export$4397c6cd8fdaceda = '300ms';
const $dce3894a979838ec$export$43f82c63d8ff0eda = '200ms';
const $dce3894a979838ec$export$16f814752097846d = '300ms';
const $dce3894a979838ec$export$5162ae3a74d2cef8 = '150ms';
const $dce3894a979838ec$export$f0354e5dcbedb391 = '100ms';
const $dce3894a979838ec$export$794972db2a5ac913 = 0;
const $dce3894a979838ec$export$11df69698a3bdb0d = 0;
const $dce3894a979838ec$export$521677aedfc08152 = 0;
const $dce3894a979838ec$export$5d6e1e4631108fd5 = 'cubic-bezier(0,0,1,1)';
const $dce3894a979838ec$export$8015f00874380ec4 = 'cubic-bezier(0.45, 1.45, 0.65, 1.0)';
const $dce3894a979838ec$export$ef4a0043fd391d19 = 'cubic-bezier(0.9, 0.0, 1.0, 1.0)';
const $dce3894a979838ec$export$526aeb31f17d55b = 'cubic-bezier(0.0, 0.0, 0.1, 1.0)';
const $dce3894a979838ec$export$898027d0522bc825 = 'cubic-bezier(0.8, 0.0, 0.0, 1.0)';
const $dce3894a979838ec$export$3d0b46cfbaff30ad = 'cubic-bezier(0.4, 0.0, 0.4, 1.0)';
const $dce3894a979838ec$export$5ccaa61f19dc72a8 = '150ms';
const $dce3894a979838ec$export$c9b30f35e04d7e19 = '100ms';
const $dce3894a979838ec$export$530853c3ed0e1def = '33ms';
const $dce3894a979838ec$export$a1871aeaef241475 = '75em';
const $dce3894a979838ec$export$cc0d07b5ce8f1a0f = '56.25em';
const $dce3894a979838ec$export$504b14171daac591 = '37.5em';
const $dce3894a979838ec$export$b566b8a446d689b4 = '1.400';
const $dce3894a979838ec$export$608e12cd8aeed704 = '1.400';
const $dce3894a979838ec$export$88dfda805ba2a1d = '1.450';
const $dce3894a979838ec$export$3a22007be3a15a4b = '1.450';
const $dce3894a979838ec$export$5966a9086a8b9185 = '1.500';
const $dce3894a979838ec$export$ac71030b78c8521e = '1.500';
const $dce3894a979838ec$export$aa59fc54eab145a9 = '1.571';
const $dce3894a979838ec$export$6cd4c9a3016d5014 = '1.571';
const $dce3894a979838ec$export$bd38e8da8fed1db0 = '1.500';
const $dce3894a979838ec$export$5ef1b419efd96175 = '1.625';
const $dce3894a979838ec$export$3bafb04a47d34f47 = '1.444';
const $dce3894a979838ec$export$e977ed8e787a209b = '1.555';
const $dce3894a979838ec$export$cb4c1b9fe89bac53 = '1.400';
const $dce3894a979838ec$export$7bbd5462b2a93eaf = '1.600';
const $dce3894a979838ec$export$763a7df8e5edbf69 = '1.364';
const $dce3894a979838ec$export$593f5d9745f27d22 = '1.545';
const $dce3894a979838ec$export$112d97fcd4e6b5c0 = '1.450';
const $dce3894a979838ec$export$7ea996d67885a728 = '1.670';
const $dce3894a979838ec$export$c4627bec6a185292 = '1.357';
const $dce3894a979838ec$export$95fb505e5cf274f7 = '1.570';
const $dce3894a979838ec$export$b9ebc7efd1c1217e = '1.375';
const $dce3894a979838ec$export$20439145e468b5dd = '1.500';
const $dce3894a979838ec$export$9d82797c239f130 = '1.333';
const $dce3894a979838ec$export$1e82e2294596f62c = '1.500';
const $dce3894a979838ec$export$bf2e39d3235a17b7 = '1.300';
const $dce3894a979838ec$export$292f78108f186754 = '1.500';
const $dce3894a979838ec$export$7fca3d2cfdb0aace = '1.300';
const $dce3894a979838ec$export$e424384fab9a743c = '1.460';
const $dce3894a979838ec$export$5abbb37a1381fd2 = '1.320';
const $dce3894a979838ec$export$ace75daf1dcfcc35 = '1.520';
const $dce3894a979838ec$export$122088941748d4c6 = '1.357';
const $dce3894a979838ec$export$236a5474fee07847 = '1.500';
const $dce3894a979838ec$export$cd8129ec5f6baea9 = '1.300';
const $dce3894a979838ec$export$e75281d7fc50b108 = '1.500';
const $dce3894a979838ec$export$961c3da499ef8efb = '1.280';
const $dce3894a979838ec$export$56a53497585c2f53 = '1.500';
const $dce3894a979838ec$export$5bfe3a53df9f4353 = '1.300';
const $dce3894a979838ec$export$89a6eecd6bc28e3f = '1.500';
const $dce3894a979838ec$export$5232b007519cba14 = '1.290';
const $dce3894a979838ec$export$6e6f46ebed3f076c = '1.500';
const $dce3894a979838ec$export$f4b847a3158c43be = '0em';
const $dce3894a979838ec$export$90e88555b0fa38ab = '0em';
const $dce3894a979838ec$export$167d22651d8f12e9 = '0em';
const $dce3894a979838ec$export$65ca168570ddf476 = '0em';
const $dce3894a979838ec$export$90cb8cd3d1caea89 = '0em';
const $dce3894a979838ec$export$56b8287d82e8e821 = '0em';
const $dce3894a979838ec$export$3006cf4064795d9a = '0em';
const $dce3894a979838ec$export$7d468ce6d08618d9 = '-0.0039em';
const $dce3894a979838ec$export$bf290ac0b0f3d46b = '-0.0042em';
const $dce3894a979838ec$export$32c58dc6c39e60b9 = '-0.0049em';
const $dce3894a979838ec$export$ca3bf8abfa9876ed = '-0.0056em';
const $dce3894a979838ec$export$1b38016a9cf77110 = '-0.0063em';
const $dce3894a979838ec$export$188510324fec16bd = '-0.007em';
const $dce3894a979838ec$export$aea07f9e40db6c4e = '-0.0084em';
const $dce3894a979838ec$export$f63eb8b1947e1861 = '-0.0091em';
const $dce3894a979838ec$export$db42c175df675108 = '-0.0098em';
const $dce3894a979838ec$export$7edf1af4c16ef12b = '-0.011em';
const $dce3894a979838ec$export$8868456ca76ded7f = '-0.0124em';
const $dce3894a979838ec$export$cae7d44884e62e48 = '-0.014em';
const $dce3894a979838ec$export$3f9af2b6b7a91ebb = '-0.0168em';
var $dce3894a979838ec$export$2e2bcd8739ae039 = {
    fontSize20: $dce3894a979838ec$export$2ee03700355519fa,
    fontSize25: $dce3894a979838ec$export$e43eb1146692dbbd,
    fontSize50: $dce3894a979838ec$export$94aebaea4fb047db,
    fontSize75: $dce3894a979838ec$export$143f3afd583c7e66,
    fontSize100: $dce3894a979838ec$export$be81731d829ada72,
    fontSize200: $dce3894a979838ec$export$dad37c4064481a23,
    fontSize300: $dce3894a979838ec$export$2310711877b15a13,
    fontSize400: $dce3894a979838ec$export$16d93b84ab0fd6af,
    fontSize500: $dce3894a979838ec$export$c34ba906d3da8f27,
    fontSize600: $dce3894a979838ec$export$d9e3a79e4465d1f9,
    fontSize700: $dce3894a979838ec$export$e765e0acbbf3897,
    fontSize800: $dce3894a979838ec$export$a9ea6d3097f62ed1,
    fontSize900: $dce3894a979838ec$export$136ee1ac2d6ff3f1,
    fontSize1000: $dce3894a979838ec$export$ee1f01a2186c5986,
    fontSize1100: $dce3894a979838ec$export$1cd7dbc564582521,
    fontSize1200: $dce3894a979838ec$export$7d39dea31f76b14e,
    fontSize1300: $dce3894a979838ec$export$1ea6000041e8400d,
    fontSize1400: $dce3894a979838ec$export$281669aa21b2bf87,
    fontSize1500: $dce3894a979838ec$export$1517d1e73ae0dac0,
    fontSize1600: $dce3894a979838ec$export$6dcbc1746e26eb2d,
    fontWeightBold: $dce3894a979838ec$export$c46df79513126abf,
    fontWeightRegular: $dce3894a979838ec$export$a9ac43da6e214480,
    thicknessThin: $dce3894a979838ec$export$4302b5044559543e,
    thicknessThick: $dce3894a979838ec$export$48073435ecd5df18,
    radiusNone: $dce3894a979838ec$export$f0fea226b14d0e20,
    radiusS: $dce3894a979838ec$export$81d8122f53ebd34b,
    radiusM: $dce3894a979838ec$export$2e6fa7320bd4b2b9,
    radiusL: $dce3894a979838ec$export$2f3c39780d157365,
    radiusXl: $dce3894a979838ec$export$16fc2e49cd0cccef,
    radiusCap: $dce3894a979838ec$export$25106c99e7472a2a,
    space25: $dce3894a979838ec$export$11c1a522262fbe56,
    space50: $dce3894a979838ec$export$53a7898de828e9eb,
    space75: $dce3894a979838ec$export$9b8d3cbb719f80ca,
    space100: $dce3894a979838ec$export$2b2ae4911f53c2af,
    space125: $dce3894a979838ec$export$dbc96ebec57e5b2e,
    space150: $dce3894a979838ec$export$cd0210c732c60394,
    space200: $dce3894a979838ec$export$c1b36e318bc8b98f,
    space250: $dce3894a979838ec$export$12fc8bf165e419f5,
    space300: $dce3894a979838ec$export$e0ce3f501d0b56a7,
    space400: $dce3894a979838ec$export$d882d6acaa09bc81,
    space550: $dce3894a979838ec$export$853fe8b65b3c9d3e,
    space750: $dce3894a979838ec$export$63c8594bc24ba2fc,
    space1000: $dce3894a979838ec$export$8f30f9ccae80857e,
    space1350: $dce3894a979838ec$export$5a020f1540525bc3,
    shadowSizeDefault: $dce3894a979838ec$export$dabe941b842ede4b,
    durationSlowXlScreen: $dce3894a979838ec$export$330c04f0c6cb53da,
    durationSlowMobileNative: $dce3894a979838ec$export$a9394c1e93a3ae94,
    durationSlowWeb: $dce3894a979838ec$export$ee67cfc7433a2119,
    durationStandardXlScreen: $dce3894a979838ec$export$babf96970656270,
    durationStandardMobileNative: $dce3894a979838ec$export$4397c6cd8fdaceda,
    durationStandardWeb: $dce3894a979838ec$export$43f82c63d8ff0eda,
    durationQuickXlScreen: $dce3894a979838ec$export$16f814752097846d,
    durationQuickMobileNative: $dce3894a979838ec$export$5162ae3a74d2cef8,
    durationQuickWeb: $dce3894a979838ec$export$f0354e5dcbedb391,
    durationInstantXlScreen: $dce3894a979838ec$export$794972db2a5ac913,
    durationInstantMobileNative: $dce3894a979838ec$export$11df69698a3bdb0d,
    durationInstantWeb: $dce3894a979838ec$export$521677aedfc08152,
    easeLinear: $dce3894a979838ec$export$5d6e1e4631108fd5,
    easeBob: $dce3894a979838ec$export$8015f00874380ec4,
    easeExit: $dce3894a979838ec$export$ef4a0043fd391d19,
    easeEnter: $dce3894a979838ec$export$526aeb31f17d55b,
    easeExpressive: $dce3894a979838ec$export$898027d0522bc825,
    easeEasy: $dce3894a979838ec$export$3d0b46cfbaff30ad,
    delayEmphasised: $dce3894a979838ec$export$5ccaa61f19dc72a8,
    delayStandard: $dce3894a979838ec$export$c9b30f35e04d7e19,
    delayTight: $dce3894a979838ec$export$530853c3ed0e1def,
    breakpointXl: $dce3894a979838ec$export$a1871aeaef241475,
    breakpointL: $dce3894a979838ec$export$cc0d07b5ce8f1a0f,
    breakpointM: $dce3894a979838ec$export$504b14171daac591,
    lineHeight20Short: $dce3894a979838ec$export$b566b8a446d689b4,
    lineHeight20Long: $dce3894a979838ec$export$608e12cd8aeed704,
    lineHeight25Short: $dce3894a979838ec$export$88dfda805ba2a1d,
    lineHeight25Long: $dce3894a979838ec$export$3a22007be3a15a4b,
    lineHeight50Short: $dce3894a979838ec$export$5966a9086a8b9185,
    lineHeight50Long: $dce3894a979838ec$export$ac71030b78c8521e,
    lineHeight75Short: $dce3894a979838ec$export$aa59fc54eab145a9,
    lineHeight75Long: $dce3894a979838ec$export$6cd4c9a3016d5014,
    lineHeight100Short: $dce3894a979838ec$export$bd38e8da8fed1db0,
    lineHeight100Long: $dce3894a979838ec$export$5ef1b419efd96175,
    lineHeight200Short: $dce3894a979838ec$export$3bafb04a47d34f47,
    lineHeight200Long: $dce3894a979838ec$export$e977ed8e787a209b,
    lineHeight300Short: $dce3894a979838ec$export$cb4c1b9fe89bac53,
    lineHeight300Long: $dce3894a979838ec$export$7bbd5462b2a93eaf,
    lineHeight400Short: $dce3894a979838ec$export$763a7df8e5edbf69,
    lineHeight400Long: $dce3894a979838ec$export$593f5d9745f27d22,
    lineHeight500Short: $dce3894a979838ec$export$112d97fcd4e6b5c0,
    lineHeight500Long: $dce3894a979838ec$export$7ea996d67885a728,
    lineHeight600Short: $dce3894a979838ec$export$c4627bec6a185292,
    lineHeight600Long: $dce3894a979838ec$export$95fb505e5cf274f7,
    lineHeight700Short: $dce3894a979838ec$export$b9ebc7efd1c1217e,
    lineHeight700Long: $dce3894a979838ec$export$20439145e468b5dd,
    lineHeight800Short: $dce3894a979838ec$export$9d82797c239f130,
    lineHeight800Long: $dce3894a979838ec$export$1e82e2294596f62c,
    lineHeight900Short: $dce3894a979838ec$export$bf2e39d3235a17b7,
    lineHeight900Long: $dce3894a979838ec$export$292f78108f186754,
    lineHeight1000Short: $dce3894a979838ec$export$7fca3d2cfdb0aace,
    lineHeight1000Long: $dce3894a979838ec$export$e424384fab9a743c,
    lineHeight1100Short: $dce3894a979838ec$export$5abbb37a1381fd2,
    lineHeight1100Long: $dce3894a979838ec$export$ace75daf1dcfcc35,
    lineHeight1200Short: $dce3894a979838ec$export$122088941748d4c6,
    lineHeight1200Long: $dce3894a979838ec$export$236a5474fee07847,
    lineHeight1300Short: $dce3894a979838ec$export$cd8129ec5f6baea9,
    lineHeight1300Long: $dce3894a979838ec$export$e75281d7fc50b108,
    lineHeight1400Short: $dce3894a979838ec$export$961c3da499ef8efb,
    lineHeight1400Long: $dce3894a979838ec$export$56a53497585c2f53,
    lineHeight1500Short: $dce3894a979838ec$export$5bfe3a53df9f4353,
    lineHeight1500Long: $dce3894a979838ec$export$89a6eecd6bc28e3f,
    lineHeight1600Short: $dce3894a979838ec$export$5232b007519cba14,
    lineHeight1600Long: $dce3894a979838ec$export$6e6f46ebed3f076c,
    letterSpacing20: $dce3894a979838ec$export$f4b847a3158c43be,
    letterSpacing25: $dce3894a979838ec$export$90e88555b0fa38ab,
    letterSpacing50: $dce3894a979838ec$export$167d22651d8f12e9,
    letterSpacing75: $dce3894a979838ec$export$65ca168570ddf476,
    letterSpacing100: $dce3894a979838ec$export$90cb8cd3d1caea89,
    letterSpacing200: $dce3894a979838ec$export$56b8287d82e8e821,
    letterSpacing300: $dce3894a979838ec$export$3006cf4064795d9a,
    letterSpacing400: $dce3894a979838ec$export$7d468ce6d08618d9,
    letterSpacing500: $dce3894a979838ec$export$bf290ac0b0f3d46b,
    letterSpacing600: $dce3894a979838ec$export$32c58dc6c39e60b9,
    letterSpacing700: $dce3894a979838ec$export$ca3bf8abfa9876ed,
    letterSpacing800: $dce3894a979838ec$export$1b38016a9cf77110,
    letterSpacing900: $dce3894a979838ec$export$188510324fec16bd,
    letterSpacing1000: $dce3894a979838ec$export$aea07f9e40db6c4e,
    letterSpacing1100: $dce3894a979838ec$export$f63eb8b1947e1861,
    letterSpacing1200: $dce3894a979838ec$export$db42c175df675108,
    letterSpacing1300: $dce3894a979838ec$export$7edf1af4c16ef12b,
    letterSpacing1400: $dce3894a979838ec$export$8868456ca76ded7f,
    letterSpacing1500: $dce3894a979838ec$export$cae7d44884e62e48,
    letterSpacing1600: $dce3894a979838ec$export$3f9af2b6b7a91ebb
};

});


parcelRegister("as4BG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $79c017b7103ae34e$var$_react = $79c017b7103ae34e$var$_interopRequireDefault((parcelRequire("aXNcS")));
function $79c017b7103ae34e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $79c017b7103ae34e$var$getClientSize = ()=>({
        w: window.innerWidth,
        h: window.innerHeight
    });
const $79c017b7103ae34e$var$resizeListeners = [];
let $79c017b7103ae34e$var$debounceID;
const $79c017b7103ae34e$var$debouncedUpdate = ()=>{
    clearTimeout($79c017b7103ae34e$var$debounceID);
    $79c017b7103ae34e$var$debounceID = setTimeout(()=>{
        const clientSize = $79c017b7103ae34e$var$getClientSize();
        $79c017b7103ae34e$var$resizeListeners.forEach((setter)=>setter(clientSize));
    }, 40);
};
const $79c017b7103ae34e$var$addResizeListener = ()=>{
    $79c017b7103ae34e$var$removeResizeListener();
    window.addEventListener('resize', $79c017b7103ae34e$var$debouncedUpdate);
};
const $79c017b7103ae34e$var$removeResizeListener = ()=>{
    clearTimeout($79c017b7103ae34e$var$debouncedUpdate);
    window.removeEventListener('resize', $79c017b7103ae34e$var$debouncedUpdate);
};
const $79c017b7103ae34e$var$useWindowSize = (listen)=>{
    const [clientSize, setClientSize] = $79c017b7103ae34e$var$_react.default.useState(listen && typeof window !== 'undefined' && $79c017b7103ae34e$var$getClientSize());
    $79c017b7103ae34e$var$_react.default.useEffect(()=>{
        if (listen) {
            $79c017b7103ae34e$var$resizeListeners.push(setClientSize);
            if ($79c017b7103ae34e$var$resizeListeners.length === 1) $79c017b7103ae34e$var$addResizeListener();
        }
        return ()=>{
            let index = $79c017b7103ae34e$var$resizeListeners.indexOf(setClientSize);
            if (index > -1) $79c017b7103ae34e$var$resizeListeners.splice(index, 1);
            if ($79c017b7103ae34e$var$resizeListeners.length === 0) $79c017b7103ae34e$var$removeResizeListener();
        };
    }, [
        listen
    ]);
    return clientSize;
};
var $79c017b7103ae34e$var$_default = $79c017b7103ae34e$var$useWindowSize;
module.exports.default = $79c017b7103ae34e$var$_default;

});



parcelRegister("2LRUv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2049ca0f3fc10f16$var$_react = $2049ca0f3fc10f16$var$_interopRequireDefault((parcelRequire("aXNcS")));


var $2049ca0f3fc10f16$var$_classnames = $2049ca0f3fc10f16$var$_interopRequireDefault((parcelRequire("3LGzW")));

var $2049ca0f3fc10f16$var$_button = $2049ca0f3fc10f16$var$_interopRequireDefault((parcelRequire("1m4gm")));

var $2049ca0f3fc10f16$var$_cross = $2049ca0f3fc10f16$var$_interopRequireDefault((parcelRequire("4SQij")));

var $2049ca0f3fc10f16$var$_arrowLeft = $2049ca0f3fc10f16$var$_interopRequireDefault((parcelRequire("9SuT2")));
function $2049ca0f3fc10f16$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2049ca0f3fc10f16$var$_extends() {
    $2049ca0f3fc10f16$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2049ca0f3fc10f16$var$_extends.apply(this, arguments);
}
const $2049ca0f3fc10f16$var$ModalHeader = (props)=>{
    const { title: title, titleId: titleId, prefix: prefix, className: className, closeBtnClick: closeBtnClick, ariaCloseTxt: ariaCloseTxt, backBtnClick: backBtnClick, ariaBackBtnTxt: ariaBackBtnTxt, floating: floating, ...other } = props;
    const wrapperClasses = (0, $2049ca0f3fc10f16$var$_classnames.default)(`${prefix}modal-header__title-wrapper`, !backBtnClick && `${prefix}modal-header__title-wrapper--padded`);
    const headerClasses = (0, $2049ca0f3fc10f16$var$_classnames.default)(`${prefix}modal-header`, floating && `${prefix}modal-header--floating-header`, className);
    return $2049ca0f3fc10f16$var$_react.default.createElement("div", $2049ca0f3fc10f16$var$_extends({
        className: headerClasses
    }, other), $2049ca0f3fc10f16$var$_react.default.createElement($2049ca0f3fc10f16$var$_button.default, {
        prefix: prefix,
        type: "primary",
        inverseTheme: true,
        small: true,
        iconOnly: true,
        ssrIcon: $2049ca0f3fc10f16$var$_cross.default,
        onClick: closeBtnClick,
        className: `${prefix}modal-header__close`,
        "aria-label": ariaCloseTxt
    }), !floating && title && $2049ca0f3fc10f16$var$_react.default.createElement("div", {
        className: wrapperClasses
    }, $2049ca0f3fc10f16$var$_react.default.createElement("span", {
        id: titleId,
        className: `${prefix}modal-header__title`
    }, title)), backBtnClick && $2049ca0f3fc10f16$var$_react.default.createElement($2049ca0f3fc10f16$var$_button.default, {
        prefix: prefix,
        type: "primary",
        inverseTheme: true,
        small: true,
        iconOnly: true,
        ssrIcon: $2049ca0f3fc10f16$var$_arrowLeft.default,
        onClick: backBtnClick,
        className: `${prefix}modal-header__back-button`,
        "aria-label": ariaBackBtnTxt
    }));
};
$2049ca0f3fc10f16$var$ModalHeader.defaultProps = {
    prefix: '',
    floating: false,
    ariaBackBtnTxt: 'Back',
    ariaCloseTxt: 'Close'
};
var $2049ca0f3fc10f16$var$_default = $2049ca0f3fc10f16$var$ModalHeader;
module.exports.default = $2049ca0f3fc10f16$var$_default;

});
parcelRegister("4SQij", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $38e4c523a068fa42$var$_react = $38e4c523a068fa42$var$_interopRequireDefault((parcelRequire("aXNcS")));
function $38e4c523a068fa42$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $38e4c523a068fa42$var$_default = function _default() {
    let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return [
        $38e4c523a068fa42$var$_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "m11.9997 13.4149 4.9498 4.9497 1.4142-1.4142-4.9498-4.9497 4.9498-4.9498-1.4142-1.4142-4.9498 4.9498L7.05 5.6367 5.6357 7.051l4.9498 4.9498-4.9497 4.9497L7.05 18.3646l4.9497-4.9497z"
        })
    ];
};
module.exports.default = $38e4c523a068fa42$var$_default;

});

parcelRegister("9SuT2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $73111daa22541cc9$var$_react = $73111daa22541cc9$var$_interopRequireDefault((parcelRequire("aXNcS")));
function $73111daa22541cc9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $73111daa22541cc9$var$_default = function _default() {
    let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return [
        $73111daa22541cc9$var$_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "m3.999 11.9997 8 8.0011 1.4143-1.4141-5.5859-5.5866H20v-2H7.8273l5.5871-5.5868-1.4142-1.4143-8.0012 8.0007z"
        })
    ];
};
module.exports.default = $73111daa22541cc9$var$_default;

});


parcelRegister("gRLCy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c476891c100745c9$var$_react = $c476891c100745c9$var$_interopRequireDefault((parcelRequire("aXNcS")));


var $c476891c100745c9$var$_classnames = $c476891c100745c9$var$_interopRequireDefault((parcelRequire("3LGzW")));
function $c476891c100745c9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c476891c100745c9$var$_extends() {
    $c476891c100745c9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c476891c100745c9$var$_extends.apply(this, arguments);
}
const $c476891c100745c9$var$ModalBody = (_ref)=>{
    let { prefix: prefix, children: children, className: className, ...other } = _ref;
    return $c476891c100745c9$var$_react.default.createElement("div", $c476891c100745c9$var$_extends({}, other, {
        className: (0, $c476891c100745c9$var$_classnames.default)(`${prefix}modal-body`, className)
    }), children);
};
$c476891c100745c9$var$ModalBody.defaultProps = {
    prefix: ''
};
var $c476891c100745c9$var$_default = $c476891c100745c9$var$ModalBody;
module.exports.default = $c476891c100745c9$var$_default;

});

parcelRegister("arrri", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;


var $79a1b5e036f0f963$var$_react = $79a1b5e036f0f963$var$_interopRequireDefault((parcelRequire("aXNcS")));

var $79a1b5e036f0f963$var$_classnames = $79a1b5e036f0f963$var$_interopRequireDefault((parcelRequire("3LGzW")));

var $79a1b5e036f0f963$var$_headerPropTypeValidation = $79a1b5e036f0f963$var$_interopRequireDefault((parcelRequire("hXFHD")));

var $79a1b5e036f0f963$var$_AutoFocusOnMount = $79a1b5e036f0f963$var$_interopRequireDefault((parcelRequire("kwBzk")));
function $79a1b5e036f0f963$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $79a1b5e036f0f963$var$_extends() {
    $79a1b5e036f0f963$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $79a1b5e036f0f963$var$_extends.apply(this, arguments);
}
const $79a1b5e036f0f963$var$Sheets = (_ref)=>{
    let { className: className, fullSize: fullSize, prefix: prefix, children: children, open: open, closeBtnClick: closeBtnClick, header: header, alignment: alignment, preserveAlignment: preserveAlignment, footer: footer, size: size, describedById: describedById, labelledById: labelledById, ariaLabel: ariaLabel, ...other } = _ref;
    const classes = (0, $79a1b5e036f0f963$var$_classnames.default)(`${prefix}sheets`, `${prefix}sheets--${size}`, fullSize && `${prefix}sheets--mobile-full-size`, alignment === 'left' && `${prefix}sheets--mirrored`, preserveAlignment && `${prefix}sheets--preserve-alignment`, open ? `${prefix}sheets--enter` : `${prefix}sheets--close`, className);
    const hookedHeader = header ? $79a1b5e036f0f963$var$_react.default.cloneElement(header, {
        closeBtnClick: closeBtnClick,
        prefix: prefix
    }) : null;
    const hookedFooter = footer && $79a1b5e036f0f963$var$_react.default.cloneElement(footer, {
        prefix: prefix,
        closeBtnClick: closeBtnClick
    }) || null;
    const hookedBody = $79a1b5e036f0f963$var$_react.default.Children.map(children, (child)=>child.props ? $79a1b5e036f0f963$var$_react.default.cloneElement(child, {
            prefix: prefix
        }) : child);
    const [wrapperFocus, contentRef] = (0, $79a1b5e036f0f963$var$_AutoFocusOnMount.default)();
    return $79a1b5e036f0f963$var$_react.default.createElement("div", $79a1b5e036f0f963$var$_extends({
        "aria-describedby": describedById,
        "aria-labelledby": labelledById,
        "aria-label": ariaLabel
    }, other, {
        className: classes,
        "aria-modal": "true",
        role: "dialog",
        tabIndex: "-1"
    }), hookedHeader && !hookedHeader.props.floating && hookedHeader, $79a1b5e036f0f963$var$_react.default.createElement("div", {
        className: `${prefix}sheets__content-wrapper`,
        role: "document",
        tabIndex: "0",
        ref: contentRef,
        "data-autofocus": wrapperFocus
    }, $79a1b5e036f0f963$var$_react.default.createElement("div", null, " ", hookedHeader && hookedHeader.props.floating && hookedHeader, hookedBody)), hookedFooter);
};
$79a1b5e036f0f963$var$Sheets.defaultProps = {
    open: false,
    prefix: '',
    size: 'small',
    alignment: 'right',
    preserveAlignment: false
};
var $79a1b5e036f0f963$var$_default = $79a1b5e036f0f963$var$Sheets;
module.exports.default = $79a1b5e036f0f963$var$_default;

});
parcelRegister("hXFHD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ldsZ1 = parcelRequire("ldsZ1");

var $bOlkA = parcelRequire("bOlkA");
const $d1384ba35f751720$var$headerPropTypeValidation = (props, propName, componentName)=>{
    if (props[propName] !== null && [
        $bOlkA.ModalHeader
    ].indexOf(props[propName]?.type) < 0) return new Error('header propType only accepts ModalHeader component instance or null. If null is provided, additional CSS must be added to ensure a minimum top-padding for the content.');
    return (0, $ldsZ1.checkPropTypes)({
        header: (0, $ldsZ1.oneOfType)([
            (0, $ldsZ1.oneOf)([
                null
            ]).isRequired,
            $ldsZ1.node
        ])
    }, props, 'prop', componentName);
};
var $d1384ba35f751720$var$_default = $d1384ba35f751720$var$headerPropTypeValidation;
module.exports.default = $d1384ba35f751720$var$_default;

});
parcelRegister("bOlkA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "ModalBody", {
    enumerable: true,
    get: function() {
        return $e0BOD.ModalBody;
    }
});
Object.defineProperty(module.exports, "ModalFooter", {
    enumerable: true,
    get: function() {
        return $e0BOD.ModalFooter;
    }
});
Object.defineProperty(module.exports, "ModalHeader", {
    enumerable: true,
    get: function() {
        return $e0BOD.ModalHeader;
    }
});
Object.defineProperty(module.exports, "Prompt", {
    enumerable: true,
    get: function() {
        return $kukgP.Prompt;
    }
});
Object.defineProperty(module.exports, "Sheets", {
    enumerable: true,
    get: function() {
        return $kukgP.Sheets;
    }
});
Object.defineProperty(module.exports, "Theatre", {
    enumerable: true,
    get: function() {
        return $kukgP.Theatre;
    }
});
module.exports.default = void 0;

var $e0BOD = parcelRequire("e0BOD");

var $kukgP = parcelRequire("kukgP");

var $8994e91ad205a7dd$var$_Modal = $8994e91ad205a7dd$var$_interopRequireDefault((parcelRequire("jYY9U")));
function $8994e91ad205a7dd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8994e91ad205a7dd$var$_default = $8994e91ad205a7dd$var$_Modal.default;
module.exports.default = $8994e91ad205a7dd$var$_default;

});
parcelRegister("e0BOD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "ModalBody", {
    enumerable: true,
    get: function() {
        return $a32e662caf8ef40d$var$_ModalBody.default;
    }
});
Object.defineProperty(module.exports, "ModalFooter", {
    enumerable: true,
    get: function() {
        return $a32e662caf8ef40d$var$_Footer.default;
    }
});
Object.defineProperty(module.exports, "ModalHeader", {
    enumerable: true,
    get: function() {
        return $a32e662caf8ef40d$var$_Header.default;
    }
});

var $a32e662caf8ef40d$var$_Footer = $a32e662caf8ef40d$var$_interopRequireDefault((parcelRequire("9MLuw")));

var $a32e662caf8ef40d$var$_Header = $a32e662caf8ef40d$var$_interopRequireDefault((parcelRequire("2LRUv")));

var $a32e662caf8ef40d$var$_ModalBody = $a32e662caf8ef40d$var$_interopRequireDefault((parcelRequire("gRLCy")));
function $a32e662caf8ef40d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});

parcelRegister("kukgP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Prompt", {
    enumerable: true,
    get: function() {
        return $eea65545d96c2e19$var$_Prompt.default;
    }
});
Object.defineProperty(module.exports, "Sheets", {
    enumerable: true,
    get: function() {
        return $eea65545d96c2e19$var$_Sheets.default;
    }
});
Object.defineProperty(module.exports, "Theatre", {
    enumerable: true,
    get: function() {
        return $eea65545d96c2e19$var$_Theatre.default;
    }
});

var $eea65545d96c2e19$var$_Sheets = $eea65545d96c2e19$var$_interopRequireDefault((parcelRequire("arrri")));

var $eea65545d96c2e19$var$_Prompt = $eea65545d96c2e19$var$_interopRequireDefault((parcelRequire("fsVVN")));

var $eea65545d96c2e19$var$_Theatre = $eea65545d96c2e19$var$_interopRequireDefault((parcelRequire("1WXdK")));
function $eea65545d96c2e19$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("fsVVN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;


var $b426687b163ccf4b$var$_react = $b426687b163ccf4b$var$_interopRequireDefault((parcelRequire("aXNcS")));

var $b426687b163ccf4b$var$_classnames = $b426687b163ccf4b$var$_interopRequireDefault((parcelRequire("3LGzW")));

var $b426687b163ccf4b$var$_headerPropTypeValidation = $b426687b163ccf4b$var$_interopRequireDefault((parcelRequire("hXFHD")));

var $b426687b163ccf4b$var$_AutoFocusOnMount = $b426687b163ccf4b$var$_interopRequireDefault((parcelRequire("kwBzk")));
function $b426687b163ccf4b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b426687b163ccf4b$var$_extends() {
    $b426687b163ccf4b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b426687b163ccf4b$var$_extends.apply(this, arguments);
}
const $b426687b163ccf4b$var$Prompt = (_ref)=>{
    let { className: className, titleId: titleId, header: header, prefix: prefix, children: children, open: open, closeBtnClick: closeBtnClick, title: title, footer: footer, describedById: describedById, ...other } = _ref;
    const classes = (0, $b426687b163ccf4b$var$_classnames.default)(`${prefix}prompt`, open ? `${prefix}prompt--enter` : `${prefix}prompt--close`, className);
    const hookedHeader = header ? $b426687b163ccf4b$var$_react.default.cloneElement(header, {
        closeBtnClick: closeBtnClick,
        prefix: prefix,
        backBtnClick: null
    }) : null;
    const hookedFooter = footer && $b426687b163ccf4b$var$_react.default.cloneElement(footer, {
        prefix: prefix,
        closeBtnClick: closeBtnClick
    }) || null;
    const [wrapperFocus, contentRef] = (0, $b426687b163ccf4b$var$_AutoFocusOnMount.default)();
    return $b426687b163ccf4b$var$_react.default.createElement("div", $b426687b163ccf4b$var$_extends({
        "aria-describedby": describedById,
        "aria-labelledby": titleId
    }, other, {
        className: classes,
        "aria-modal": "true",
        role: "dialog",
        tabIndex: "-1"
    }), hookedHeader, $b426687b163ccf4b$var$_react.default.createElement("div", {
        className: `${prefix}prompt__content-wrapper`
    }, $b426687b163ccf4b$var$_react.default.createElement("div", {
        ref: contentRef,
        "data-autofocus": wrapperFocus,
        tabIndex: "0",
        role: "document",
        className: `${prefix}prompt__content`
    }, $b426687b163ccf4b$var$_react.default.createElement("h2", {
        id: titleId,
        className: `${prefix}prompt__heading`
    }, title), children), hookedFooter));
};
$b426687b163ccf4b$var$Prompt.defaultProps = {
    open: false,
    prefix: ''
};
var $b426687b163ccf4b$var$_default = $b426687b163ccf4b$var$Prompt;
module.exports.default = $b426687b163ccf4b$var$_default;

});
parcelRegister("kwBzk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
parcelRequire("aXNcS");
var $fqaWh = parcelRequire("fqaWh");

var $ef13f02da6ab4a70$var$_ShouldAutoFocus = $ef13f02da6ab4a70$var$_interopRequireDefault((parcelRequire("fL4GC")));
function $ef13f02da6ab4a70$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ef13f02da6ab4a70$var$AutoFocusOnMount = ()=>{
    const contentRef = (0, $fqaWh.useRef)(null);
    const [wrapperFocus, setWrapperFocus] = (0, $fqaWh.useState)(undefined);
    (0, $fqaWh.useEffect)(()=>{
        if (contentRef.current) {
            const wrapper = contentRef.current;
            setWrapperFocus((0, $ef13f02da6ab4a70$var$_ShouldAutoFocus.default)(wrapper));
        }
    }, []);
    return [
        wrapperFocus,
        contentRef
    ];
};
var $ef13f02da6ab4a70$var$_default = $ef13f02da6ab4a70$var$AutoFocusOnMount;
module.exports.default = $ef13f02da6ab4a70$var$_default;

});
parcelRegister("fL4GC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $b78ee166290ad7e1$var$ShouldAutoFocus = (refElement)=>{
    if (!refElement) return false;
    const autoFocusSet = Boolean(refElement.querySelectorAll('*[data-autofocus],*[autofocus]').length);
    return !autoFocusSet;
};
module.exports.default = $b78ee166290ad7e1$var$ShouldAutoFocus;

});



parcelRegister("1WXdK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;


var $16b92537c206f6a0$var$_react = $16b92537c206f6a0$var$_interopRequireDefault((parcelRequire("aXNcS")));

var $16b92537c206f6a0$var$_classnames = $16b92537c206f6a0$var$_interopRequireDefault((parcelRequire("3LGzW")));

var $16b92537c206f6a0$var$_headerPropTypeValidation = $16b92537c206f6a0$var$_interopRequireDefault((parcelRequire("hXFHD")));
function $16b92537c206f6a0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $16b92537c206f6a0$var$_extends() {
    $16b92537c206f6a0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $16b92537c206f6a0$var$_extends.apply(this, arguments);
}
const $16b92537c206f6a0$var$Theatre = (_ref)=>{
    let { className: className, prefix: prefix, children: children, open: open, closeBtnClick: closeBtnClick, header: header, labelledById: labelledById, describedById: describedById, ariaLabel: ariaLabel, ...other } = _ref;
    const classes = (0, $16b92537c206f6a0$var$_classnames.default)(`${prefix}theatre`, open ? `${prefix}theatre--enter` : `${prefix}theatre--close`, className);
    const hookedHeader = header ? $16b92537c206f6a0$var$_react.default.cloneElement(header, {
        closeBtnClick: closeBtnClick,
        prefix: prefix
    }) : null;
    const hookedBody = $16b92537c206f6a0$var$_react.default.Children.map(children, (child)=>child.props ? $16b92537c206f6a0$var$_react.default.cloneElement(child, {
            prefix: prefix
        }) : child);
    return $16b92537c206f6a0$var$_react.default.createElement("div", $16b92537c206f6a0$var$_extends({
        "aria-describedby": describedById,
        "aria-labelledby": labelledById,
        "aria-label": ariaLabel
    }, other, {
        className: classes,
        "aria-modal": "true",
        role: "dialog",
        tabIndex: "-1"
    }), $16b92537c206f6a0$var$_react.default.createElement("div", {
        className: `${prefix}theatre__content-wrapper`
    }, hookedHeader, hookedBody));
};
$16b92537c206f6a0$var$Theatre.defaultProps = {
    open: false,
    prefix: ''
};
var $16b92537c206f6a0$var$_default = $16b92537c206f6a0$var$Theatre;
module.exports.default = $16b92537c206f6a0$var$_default;

});


parcelRegister("jYY9U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;


var $e8c249335c6dac6c$var$_react = $e8c249335c6dac6c$var$_interopRequireWildcard((parcelRequire("aXNcS")));

var $e8c249335c6dac6c$var$_reactFocusLock = $e8c249335c6dac6c$var$_interopRequireDefault((parcelRequire("7V1h9")));

var $e8c249335c6dac6c$var$_classnames = $e8c249335c6dac6c$var$_interopRequireDefault((parcelRequire("3LGzW")));

var $aMoT9 = parcelRequire("aMoT9");
function $e8c249335c6dac6c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e8c249335c6dac6c$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($e8c249335c6dac6c$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $e8c249335c6dac6c$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $e8c249335c6dac6c$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $e8c249335c6dac6c$var$_extends() {
    $e8c249335c6dac6c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e8c249335c6dac6c$var$_extends.apply(this, arguments);
}
const $e8c249335c6dac6c$var$modalTypes = [
    'Sheets',
    'Prompt',
    'Theatre'
];
const $e8c249335c6dac6c$var$elx = function() {
    for(var _len = arguments.length, listeners = new Array(_len), _key = 0; _key < _len; _key++)listeners[_key] = arguments[_key];
    return function() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return listeners.map((l)=>l && l(...args));
    };
};
const $e8c249335c6dac6c$var$Modal = (_ref)=>{
    let { className: className, visible: visible, prefix: prefix, children: children, handleCloseBtn: handleCloseBtn, focusLockProps: focusLockProps, keepContentMounted: keepContentMounted, escapable: escapable, onModalClosed: onModalClosed, onModalOpened: onModalOpened, scrollLock: scrollLock, ...other } = _ref;
    const [isOpen, setIsOpen] = $e8c249335c6dac6c$var$_react.default.useState(visible);
    const [animationMountHelper, setAnimationMountHelper] = $e8c249335c6dac6c$var$_react.default.useState(false);
    const animationFrameRef = $e8c249335c6dac6c$var$_react.default.useRef(-1);
    const baseClass = `${prefix}modal-wrapper`;
    (0, $e8c249335c6dac6c$var$_react.useEffect)(()=>{
        (0, $aMoT9.onVisibleChanged)(prefix, visible, scrollLock, isOpen, setIsOpen, setAnimationMountHelper);
    }, [
        visible
    ]);
    (0, $e8c249335c6dac6c$var$_react.useEffect)(()=>{
        if (visible) (0, $aMoT9.enter)(setIsOpen, scrollLock, prefix);
        return ()=>{
            if (scrollLock) (0, $aMoT9.releaseBody)(prefix);
            cancelAnimationFrame(animationFrameRef.current);
        };
    }, []);
    const overlayStyle = (0, $e8c249335c6dac6c$var$_classnames.default)(baseClass, isOpen ? `${baseClass}--open` : `${baseClass}--close`, className);
    const backdropStyle = (0, $e8c249335c6dac6c$var$_classnames.default)(`${baseClass}__backdrop`, `${baseClass}__backdrop--dark`);
    const hookedModal = $e8c249335c6dac6c$var$_react.default.Children.map(children, (child)=>$e8c249335c6dac6c$var$_react.default.cloneElement(child, {
            open: isOpen,
            closeBtnClick: handleCloseBtn,
            prefix: prefix
        }));
    return $e8c249335c6dac6c$var$_react.default.createElement("div", $e8c249335c6dac6c$var$_extends({}, other, {
        onKeyDown: (e)=>{
            $e8c249335c6dac6c$var$elx(other.onKeyDown, (0, $aMoT9.escFunction)(e, baseClass, escapable, handleCloseBtn, setIsOpen, setAnimationMountHelper));
        },
        className: overlayStyle,
        tabIndex: "-1"
    }), $e8c249335c6dac6c$var$_react.default.createElement("div", {
        className: backdropStyle,
        onMouseDown: (e)=>{
            (0, $aMoT9.onBackdropClick)(e, escapable, handleCloseBtn);
        },
        onAnimationEnd: (e)=>{
            (0, $aMoT9.handleAnimationEnd)(e, animationFrameRef.current, isOpen, onModalOpened, onModalClosed, scrollLock, animationMountHelper, setAnimationMountHelper, prefix);
        }
    }), (keepContentMounted || isOpen || animationMountHelper) && $e8c249335c6dac6c$var$_react.default.createElement($e8c249335c6dac6c$var$_reactFocusLock.default, $e8c249335c6dac6c$var$_extends({
        returnFocus: true,
        autoFocus: true
    }, focusLockProps, {
        children: hookedModal
    })));
};
$e8c249335c6dac6c$var$Modal.defaultProps = {
    prefix: '',
    focusLockProps: {},
    keepContentMounted: false,
    escapable: true,
    scrollLock: true
};
var $e8c249335c6dac6c$var$_default = $e8c249335c6dac6c$var$Modal;
module.exports.default = $e8c249335c6dac6c$var$_default;

});
parcelRegister("7V1h9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5c3ed897384b7f5b$export$2e2bcd8739ae039);

var $jRxZ1 = parcelRequire("jRxZ1");

var $fQrA1 = parcelRequire("fQrA1");
var $5c3ed897384b7f5b$export$2e2bcd8739ae039 = (0, $jRxZ1.default);
$parcel$exportWildcard(module.exports, $fQrA1);

});
parcelRegister("jRxZ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e75d53e9e38d4555$export$2e2bcd8739ae039);

var $7zHIQ = parcelRequire("7zHIQ");

var $iuyZt = parcelRequire("iuyZt");
parcelRequire("aXNcS");
var $fUX2S = parcelRequire("fUX2S");
var $aXNcS = parcelRequire("aXNcS");

var $b8kzx = parcelRequire("b8kzx");

var $77AKQ = parcelRequire("77AKQ");
/* that would be a BREAKING CHANGE!
// delaying sidecar execution till the first usage
const RequireSideCar = (props) => {
  // eslint-disable-next-line global-require
  const SideCar = require('./Trap').default;
  return <SideCar {...props} />;
};
*/ var $e75d53e9e38d4555$var$FocusLockCombination = /*#__PURE__*/ $aXNcS.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $fUX2S.createElement((0, $b8kzx.default), (0, $iuyZt.default)({
        sideCar: (0, $77AKQ.default),
        ref: ref
    }, props));
});
var $e75d53e9e38d4555$var$_ref = (0, $b8kzx.default).propTypes || {}, $e75d53e9e38d4555$var$sideCar = $e75d53e9e38d4555$var$_ref.sideCar, $e75d53e9e38d4555$var$propTypes = (0, $7zHIQ.default)($e75d53e9e38d4555$var$_ref, [
    "sideCar"
]);
$e75d53e9e38d4555$var$FocusLockCombination.propTypes = {};
var $e75d53e9e38d4555$export$2e2bcd8739ae039 = $e75d53e9e38d4555$var$FocusLockCombination;

});
parcelRegister("7zHIQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $583db79f6ce5b1a7$export$2e2bcd8739ae039);
function $583db79f6ce5b1a7$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("iuyZt", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7662bb5d7999c7e$export$2e2bcd8739ae039);
function $d7662bb5d7999c7e$export$2e2bcd8739ae039() {
    return $d7662bb5d7999c7e$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d7662bb5d7999c7e$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("b8kzx", function(module, exports) {

$parcel$export(module.exports, "default", () => $81b06649bdd06cbc$export$2e2bcd8739ae039);

var $iuyZt = parcelRequire("iuyZt");
parcelRequire("aXNcS");
var $fUX2S = parcelRequire("fUX2S");
var $aXNcS = parcelRequire("aXNcS");
var $fqaWh = parcelRequire("fqaWh");


var $897GZ = parcelRequire("897GZ");

var $3YCh4 = parcelRequire("3YCh4");

var $017Eu = parcelRequire("017Eu");

var $2q98l = parcelRequire("2q98l");
var $81b06649bdd06cbc$var$emptyArray = [];
var $81b06649bdd06cbc$var$FocusLock = /*#__PURE__*/ $aXNcS.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $fqaWh.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $fqaWh.useRef();
    var isActive = $fqaWh.useRef(false);
    var originalFocusedElement = $fqaWh.useRef(null);
    var children = props.children, disabled = props.disabled, noFocusGuards = props.noFocusGuards, persistentFocus = props.persistentFocus, crossFrame = props.crossFrame, autoFocus = props.autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $81b06649bdd06cbc$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, shouldReturnFocus = props.returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState2 = $fqaWh.useState({}), id = _React$useState2[0]; // SIDE EFFECT CALLBACKS
    var onActivation = $fqaWh.useCallback(function() {
        originalFocusedElement.current = originalFocusedElement.current || document && document.activeElement;
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $fqaWh.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
    }, [
        onDeactivationCallback
    ]);
    (0, $fqaWh.useEffect)(function() {
        if (!disabled) // cleanup return focus on trap deactivation
        // sideEffect/returnFocus should happen by this time
        originalFocusedElement.current = null;
    }, []);
    var returnFocus = $fqaWh.useCallback(function(allowDefer) {
        var returnFocusTo = originalFocusedElement.current;
        if (returnFocusTo && returnFocusTo.focus) {
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) // React might return focus after update
                // it's safer to defer the action
                Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]); // MEDIUM CALLBACKS
    var onFocus = $fqaWh.useCallback(function(event) {
        if (isActive.current) (0, $2q98l.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $2q98l.mediumBlur).useMedium; // REF PROPAGATION
    // not using real refs due to race conditions
    var setObserveNode = $fqaWh.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $iuyZt.default)((_extends2 = {}, _extends2[$897GZ.FOCUS_DISABLED] = disabled && 'disabled', _extends2[$897GZ.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $3YCh4.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    return /*#__PURE__*/ $fUX2S.createElement($fUX2S.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ // nearest focus guard
        $fUX2S.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $017Eu.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ $fUX2S.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $017Eu.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ $fUX2S.createElement(SideCar, {
        id: id,
        sideCar: (0, $2q98l.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions
    }), /*#__PURE__*/ $fUX2S.createElement(Container, (0, $iuyZt.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), children), hasTailingGuards && /*#__PURE__*/ $fUX2S.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $017Eu.hiddenGuard)
    }));
});
$81b06649bdd06cbc$var$FocusLock.propTypes = {};
$81b06649bdd06cbc$var$FocusLock.defaultProps = {
    children: undefined,
    disabled: false,
    returnFocus: false,
    focusOptions: undefined,
    noFocusGuards: false,
    autoFocus: true,
    persistentFocus: false,
    crossFrame: true,
    hasPositiveIndices: undefined,
    allowTextSelection: undefined,
    group: undefined,
    className: undefined,
    whiteList: undefined,
    shards: undefined,
    as: 'div',
    lockProps: {},
    onActivation: undefined,
    onDeactivation: undefined
};
var $81b06649bdd06cbc$export$2e2bcd8739ae039 = $81b06649bdd06cbc$var$FocusLock;

});
parcelRegister("897GZ", function(module, exports) {

$parcel$export(module.exports, "FOCUS_GROUP", () => $5ee5218793669681$export$4f9a06cb7441a087);
$parcel$export(module.exports, "FOCUS_DISABLED", () => $5ee5218793669681$export$aeda8252e54b50f7);
$parcel$export(module.exports, "FOCUS_ALLOW", () => $5ee5218793669681$export$54ecf528c58f9ef6);
$parcel$export(module.exports, "FOCUS_AUTO", () => $5ee5218793669681$export$70e9b4a1820af101);
$parcel$export(module.exports, "FOCUS_NO_AUTOFOCUS", () => $5ee5218793669681$export$134ebef29fd94853);
/**
 * defines a focus group
 */ var $5ee5218793669681$export$4f9a06cb7441a087 = 'data-focus-lock';
var $5ee5218793669681$export$aeda8252e54b50f7 = 'data-focus-lock-disabled';
var $5ee5218793669681$export$54ecf528c58f9ef6 = 'data-no-focus-lock';
var $5ee5218793669681$export$70e9b4a1820af101 = 'data-autofocus-inside';
var $5ee5218793669681$export$134ebef29fd94853 = 'data-no-autofocus';

});

parcelRegister("3YCh4", function(module, exports) {

$parcel$export(module.exports, "useMergeRefs", () => $2e54aa2e6de6b063$export$74665b213cb5c4cf);

var $bxuy4 = parcelRequire("bxuy4");

var $5yaqM = parcelRequire("5yaqM");
function $2e54aa2e6de6b063$export$74665b213cb5c4cf(refs, defaultValue) {
    return (0, $5yaqM.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $bxuy4.assignRef)(ref, newValue);
        });
    });
}

});
parcelRegister("bxuy4", function(module, exports) {

$parcel$export(module.exports, "assignRef", () => $866a7915f3189524$export$d734136a7b018efe);
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $866a7915f3189524$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("5yaqM", function(module, exports) {

$parcel$export(module.exports, "useCallbackRef", () => $40a8381d6d1e03ed$export$25bec8c6f54ee79a);
parcelRequire("aXNcS");
var $fqaWh = parcelRequire("fqaWh");
function $40a8381d6d1e03ed$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $fqaWh.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("017Eu", function(module, exports) {

$parcel$export(module.exports, "hiddenGuard", () => $003607abbafefe8e$export$b8c7b07253306600);
$parcel$export(module.exports, "default", () => $003607abbafefe8e$export$2e2bcd8739ae039);
parcelRequire("aXNcS");
var $fUX2S = parcelRequire("fUX2S");

var $003607abbafefe8e$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $003607abbafefe8e$var$InFocusGuard = function InFocusGuard(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $fUX2S.createElement($fUX2S.Fragment, null, /*#__PURE__*/ $fUX2S.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $003607abbafefe8e$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $fUX2S.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $003607abbafefe8e$export$b8c7b07253306600
    }));
};
$003607abbafefe8e$var$InFocusGuard.propTypes = {};
$003607abbafefe8e$var$InFocusGuard.defaultProps = {
    children: null
};
var $003607abbafefe8e$export$2e2bcd8739ae039 = $003607abbafefe8e$var$InFocusGuard;

});

parcelRegister("2q98l", function(module, exports) {

$parcel$export(module.exports, "mediumFocus", () => $1c35183eee5d2f30$export$5733e022b1d538cb);
$parcel$export(module.exports, "mediumBlur", () => $1c35183eee5d2f30$export$b3e9a9312f73723c);
$parcel$export(module.exports, "mediumEffect", () => $1c35183eee5d2f30$export$3a1d52767cbc07b8);
$parcel$export(module.exports, "mediumSidecar", () => $1c35183eee5d2f30$export$892cbf28e5518020);

var $dq6Pl = parcelRequire("dq6Pl");
var $1c35183eee5d2f30$export$5733e022b1d538cb = (0, $dq6Pl.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $1c35183eee5d2f30$export$b3e9a9312f73723c = (0, $dq6Pl.createMedium)();
var $1c35183eee5d2f30$export$3a1d52767cbc07b8 = (0, $dq6Pl.createMedium)();
var $1c35183eee5d2f30$export$892cbf28e5518020 = (0, $dq6Pl.createSidecarMedium)({
    async: true // focus-lock sidecar is not required on the server
});

});
parcelRegister("dq6Pl", function(module, exports) {

$parcel$export(module.exports, "createMedium", () => $9c52ffcf9eb42084$export$9ffbfcaf067b02c6);
$parcel$export(module.exports, "createSidecarMedium", () => $9c52ffcf9eb42084$export$e13ec7dd7a14088d);

var $dFPm2 = parcelRequire("dFPm2");
function $9c52ffcf9eb42084$var$ItoI(a) {
    return a;
}
function $9c52ffcf9eb42084$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $9c52ffcf9eb42084$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $9c52ffcf9eb42084$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $9c52ffcf9eb42084$var$ItoI;
    return $9c52ffcf9eb42084$var$innerCreateMedium(defaults, middleware);
}
function $9c52ffcf9eb42084$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $9c52ffcf9eb42084$var$innerCreateMedium(null);
    medium.options = (0, $dFPm2.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

});
parcelRegister("dFPm2", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $9f46f0a004d2c357$export$18ce0697a983be9b);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $9f46f0a004d2c357$var$extendStatics = function(d, b) {
    $9f46f0a004d2c357$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $9f46f0a004d2c357$var$extendStatics(d, b);
};
function $9f46f0a004d2c357$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $9f46f0a004d2c357$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $9f46f0a004d2c357$export$18ce0697a983be9b = function() {
    $9f46f0a004d2c357$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9f46f0a004d2c357$export$18ce0697a983be9b.apply(this, arguments);
};
function $9f46f0a004d2c357$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $9f46f0a004d2c357$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $9f46f0a004d2c357$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $9f46f0a004d2c357$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $9f46f0a004d2c357$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $9f46f0a004d2c357$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $9f46f0a004d2c357$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $9f46f0a004d2c357$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $9f46f0a004d2c357$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $9f46f0a004d2c357$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $9f46f0a004d2c357$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $9f46f0a004d2c357$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $9f46f0a004d2c357$export$45d3717a4c69092e(o, m, p);
}
function $9f46f0a004d2c357$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $9f46f0a004d2c357$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $9f46f0a004d2c357$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($9f46f0a004d2c357$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $9f46f0a004d2c357$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $9f46f0a004d2c357$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $9f46f0a004d2c357$export$10c90e4f7922046c(v) {
    return this instanceof $9f46f0a004d2c357$export$10c90e4f7922046c ? (this.v = v, this) : new $9f46f0a004d2c357$export$10c90e4f7922046c(v);
}
function $9f46f0a004d2c357$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $9f46f0a004d2c357$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $9f46f0a004d2c357$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $9f46f0a004d2c357$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $9f46f0a004d2c357$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $9f46f0a004d2c357$export$19a8beecd37a4c45 === "function" ? $9f46f0a004d2c357$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $9f46f0a004d2c357$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $9f46f0a004d2c357$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $9f46f0a004d2c357$var$ownKeys = function(o) {
    $9f46f0a004d2c357$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $9f46f0a004d2c357$var$ownKeys(o);
};
function $9f46f0a004d2c357$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $9f46f0a004d2c357$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $9f46f0a004d2c357$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $9f46f0a004d2c357$var$__setModuleDefault(result, mod);
    return result;
}
function $9f46f0a004d2c357$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $9f46f0a004d2c357$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $9f46f0a004d2c357$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $9f46f0a004d2c357$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $9f46f0a004d2c357$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $9f46f0a004d2c357$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $9f46f0a004d2c357$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $9f46f0a004d2c357$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $9f46f0a004d2c357$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $9f46f0a004d2c357$export$2e2bcd8739ae039 = {
    __extends: $9f46f0a004d2c357$export$a8ba968b8961cb8a,
    __assign: $9f46f0a004d2c357$export$18ce0697a983be9b,
    __rest: $9f46f0a004d2c357$export$3c9a16f847548506,
    __decorate: $9f46f0a004d2c357$export$29e00dfd3077644b,
    __param: $9f46f0a004d2c357$export$d5ad3fd78186038f,
    __esDecorate: $9f46f0a004d2c357$export$3a84e1ae4e97e9b0,
    __runInitializers: $9f46f0a004d2c357$export$d831c04e792af3d,
    __propKey: $9f46f0a004d2c357$export$6a2a36740a146cb8,
    __setFunctionName: $9f46f0a004d2c357$export$d1a06452d3489bc7,
    __metadata: $9f46f0a004d2c357$export$f1db080c865becb9,
    __awaiter: $9f46f0a004d2c357$export$1050f835b63b671e,
    __generator: $9f46f0a004d2c357$export$67ebef60e6f28a6,
    __createBinding: $9f46f0a004d2c357$export$45d3717a4c69092e,
    __exportStar: $9f46f0a004d2c357$export$f33643c0debef087,
    __values: $9f46f0a004d2c357$export$19a8beecd37a4c45,
    __read: $9f46f0a004d2c357$export$8d051b38c9118094,
    __spread: $9f46f0a004d2c357$export$afc72e2116322959,
    __spreadArrays: $9f46f0a004d2c357$export$6388937ca91ccae8,
    __spreadArray: $9f46f0a004d2c357$export$1216008129fb82ed,
    __await: $9f46f0a004d2c357$export$10c90e4f7922046c,
    __asyncGenerator: $9f46f0a004d2c357$export$e427f37a30a4de9b,
    __asyncDelegator: $9f46f0a004d2c357$export$bbd80228419bb833,
    __asyncValues: $9f46f0a004d2c357$export$e3b29a3d6162315f,
    __makeTemplateObject: $9f46f0a004d2c357$export$4fb47efe1390b86f,
    __importStar: $9f46f0a004d2c357$export$c21735bcef00d192,
    __importDefault: $9f46f0a004d2c357$export$da59b14a69baef04,
    __classPrivateFieldGet: $9f46f0a004d2c357$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $9f46f0a004d2c357$export$d40a35129aaff81f,
    __classPrivateFieldIn: $9f46f0a004d2c357$export$81fdc39f203e4e04,
    __addDisposableResource: $9f46f0a004d2c357$export$88ac25d8e944e405,
    __disposeResources: $9f46f0a004d2c357$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $9f46f0a004d2c357$export$889dfb5d17574b0b
};

});




parcelRegister("77AKQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $52f5b288a18ed00f$export$2e2bcd8739ae039);
/* eslint-disable no-mixed-operators */ parcelRequire("aXNcS");
var $fUX2S = parcelRequire("fUX2S");


var $8uCU2 = parcelRequire("8uCU2");

var $9qpsu = parcelRequire("9qpsu");
var $ghsgK = parcelRequire("ghsgK");
var $hD0Wz = parcelRequire("hD0Wz");
var $eY2Ln = parcelRequire("eY2Ln");

var $7QlzK = parcelRequire("7QlzK");

var $2q98l = parcelRequire("2q98l");
var $52f5b288a18ed00f$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $52f5b288a18ed00f$var$isFreeFocus = function isFreeFocus() {
    return $52f5b288a18ed00f$var$focusOnBody() || (0, $hD0Wz.focusIsHidden)();
};
var $52f5b288a18ed00f$var$lastActiveTrap = null;
var $52f5b288a18ed00f$var$lastActiveFocus = null;
var $52f5b288a18ed00f$var$lastPortaledElement = null;
var $52f5b288a18ed00f$var$focusWasOutsideWindow = false;
var $52f5b288a18ed00f$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $52f5b288a18ed00f$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($52f5b288a18ed00f$var$lastActiveTrap.whiteList || $52f5b288a18ed00f$var$defaultWhitelist)(activeElement);
};
var $52f5b288a18ed00f$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $52f5b288a18ed00f$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $52f5b288a18ed00f$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $52f5b288a18ed00f$var$lastPortaledElement && $52f5b288a18ed00f$var$lastPortaledElement.portaledElement === element;
};
function $52f5b288a18ed00f$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) // we will tab to the next element
            return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $52f5b288a18ed00f$var$extractRef = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var $52f5b288a18ed00f$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) // with cross frame return true for any value
    return Boolean($52f5b288a18ed00f$var$focusWasOutsideWindow);
     // in other case return only of focus went a while aho
    return $52f5b288a18ed00f$var$focusWasOutsideWindow === 'meanwhile';
};
var $52f5b288a18ed00f$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement) // dive up
    ) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $52f5b288a18ed00f$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $52f5b288a18ed00f$var$checkInHost(activeElement, area, area);
    });
};
var $52f5b288a18ed00f$var$activateTrap = function activateTrap() {
    var result = false;
    if ($52f5b288a18ed00f$var$lastActiveTrap) {
        var _lastActiveTrap = $52f5b288a18ed00f$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
        var workingNode = observed || $52f5b288a18ed00f$var$lastPortaledElement && $52f5b288a18ed00f$var$lastPortaledElement.portaledElement;
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map($52f5b288a18ed00f$var$extractRef).filter(Boolean));
            if (!activeElement || $52f5b288a18ed00f$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || $52f5b288a18ed00f$var$focusWasOutside(crossFrame) || !$52f5b288a18ed00f$var$isFreeFocus() || !$52f5b288a18ed00f$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $ghsgK.focusInside)(workingArea) || // check for shadow-dom contained elements
                    activeElement && $52f5b288a18ed00f$var$withinHost(activeElement, workingArea) || $52f5b288a18ed00f$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$52f5b288a18ed00f$var$lastActiveFocus && activeElement && !autoFocus) {
                            // Check if blur() exists, which is missing on certain elements on IE
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $9qpsu.default)(workingArea, $52f5b288a18ed00f$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $52f5b288a18ed00f$var$lastPortaledElement = {};
                        }
                    }
                    $52f5b288a18ed00f$var$focusWasOutsideWindow = false;
                    $52f5b288a18ed00f$var$lastActiveFocus = document && document.activeElement;
                }
            }
            if (document) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $eY2Ln.getFocusabledIn)(workingArea);
                var focusedIndex = allNodes.map(function(_ref) {
                    var node = _ref.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    // remove old focus
                    allNodes.filter(function(_ref2) {
                        var guard = _ref2.guard, node = _ref2.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref3) {
                        var node = _ref3.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $52f5b288a18ed00f$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $52f5b288a18ed00f$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $52f5b288a18ed00f$var$onTrap = function onTrap(event) {
    if ($52f5b288a18ed00f$var$activateTrap() && event) {
        // prevent scroll jump
        event.stopPropagation();
        event.preventDefault();
    }
};
var $52f5b288a18ed00f$var$onBlur = function onBlur() {
    return (0, $7QlzK.deferAction)($52f5b288a18ed00f$var$activateTrap);
};
var $52f5b288a18ed00f$var$onFocus = function onFocus(event) {
    // detect portal
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $52f5b288a18ed00f$var$recordPortal(currentNode, source);
};
var $52f5b288a18ed00f$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $52f5b288a18ed00f$var$FocusTrap = function FocusTrap(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ $fUX2S.createElement("div", {
        onBlur: $52f5b288a18ed00f$var$onBlur,
        onFocus: $52f5b288a18ed00f$var$onFocus
    }, children);
};
$52f5b288a18ed00f$var$FocusTrap.propTypes = {};
var $52f5b288a18ed00f$var$onWindowBlur = function onWindowBlur() {
    $52f5b288a18ed00f$var$focusWasOutsideWindow = 'just'; // using setTimeout to set  this variable after React/sidecar reaction
    setTimeout(function() {
        $52f5b288a18ed00f$var$focusWasOutsideWindow = 'meanwhile';
    }, 0);
};
var $52f5b288a18ed00f$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $52f5b288a18ed00f$var$onTrap);
    document.addEventListener('focusout', $52f5b288a18ed00f$var$onBlur);
    window.addEventListener('blur', $52f5b288a18ed00f$var$onWindowBlur);
};
var $52f5b288a18ed00f$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $52f5b288a18ed00f$var$onTrap);
    document.removeEventListener('focusout', $52f5b288a18ed00f$var$onBlur);
    window.removeEventListener('blur', $52f5b288a18ed00f$var$onWindowBlur);
};
function $52f5b288a18ed00f$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref5) {
        var disabled = _ref5.disabled;
        return !disabled;
    });
}
function $52f5b288a18ed00f$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$52f5b288a18ed00f$var$lastActiveTrap) $52f5b288a18ed00f$var$attachHandler();
    var lastTrap = $52f5b288a18ed00f$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $52f5b288a18ed00f$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation(); // return focus only of last trap was removed
        if (!traps.filter(function(_ref6) {
            var id = _ref6.id;
            return id === lastTrap.id;
        }).length) // allow defer is no other trap is awaiting restore
        lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $52f5b288a18ed00f$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation();
        $52f5b288a18ed00f$var$activateTrap(true);
        (0, $7QlzK.deferAction)($52f5b288a18ed00f$var$activateTrap);
    } else {
        $52f5b288a18ed00f$var$detachHandler();
        $52f5b288a18ed00f$var$lastActiveFocus = null;
    }
} // bind medium
(0, $2q98l.mediumFocus).assignSyncMedium($52f5b288a18ed00f$var$onFocus);
(0, $2q98l.mediumBlur).assignMedium($52f5b288a18ed00f$var$onBlur);
(0, $2q98l.mediumEffect).assignMedium(function(cb) {
    return cb({
        moveFocusInside: (0, $9qpsu.default),
        focusInside: (0, $ghsgK.focusInside)
    });
});
var $52f5b288a18ed00f$export$2e2bcd8739ae039 = (0, $8uCU2.default)($52f5b288a18ed00f$var$reducePropsToState, $52f5b288a18ed00f$var$handleStateChangeOnClient)($52f5b288a18ed00f$var$FocusWatcher);

});
parcelRegister("8uCU2", function(module, exports) {

$parcel$export(module.exports, "default", () => $62ef4d5e251e7c69$export$2e2bcd8739ae039);

var $gfzaL = parcelRequire("gfzaL");

var $7QZoe = parcelRequire("7QZoe");

var $aXNcS = parcelRequire("aXNcS");
function $62ef4d5e251e7c69$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $gfzaL.default)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, $aXNcS.default).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $aXNcS.PureComponent));
        (0, $7QZoe.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $62ef4d5e251e7c69$export$2e2bcd8739ae039 = $62ef4d5e251e7c69$var$withSideEffect;

});
parcelRegister("gfzaL", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd49549ce5d0c350$export$2e2bcd8739ae039);

var $e5t8D = parcelRequire("e5t8D");
function $bd49549ce5d0c350$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $e5t8D.default)(t, o);
}

});
parcelRegister("e5t8D", function(module, exports) {

$parcel$export(module.exports, "default", () => $a418228d9a0b2578$export$2e2bcd8739ae039);
function $a418228d9a0b2578$export$2e2bcd8739ae039(t, e) {
    return $a418228d9a0b2578$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $a418228d9a0b2578$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("7QZoe", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b7d0275f5d80ab8$export$2e2bcd8739ae039);

var $d2O01 = parcelRequire("d2O01");
function $5b7d0275f5d80ab8$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $d2O01.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("d2O01", function(module, exports) {

$parcel$export(module.exports, "default", () => $97f23f14820d9c27$export$2e2bcd8739ae039);

var $lo7DV = parcelRequire("lo7DV");

var $cqBJH = parcelRequire("cqBJH");
function $97f23f14820d9c27$export$2e2bcd8739ae039(t) {
    var i = (0, $cqBJH.default)(t, "string");
    return "symbol" == (0, $lo7DV.default)(i) ? i : i + "";
}

});
parcelRegister("lo7DV", function(module, exports) {

$parcel$export(module.exports, "default", () => $f921c49a61c43640$export$2e2bcd8739ae039);
function $f921c49a61c43640$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $f921c49a61c43640$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f921c49a61c43640$export$2e2bcd8739ae039(o);
}

});

parcelRegister("cqBJH", function(module, exports) {

$parcel$export(module.exports, "default", () => $90c52f5c5e6c1261$export$2e2bcd8739ae039);

var $lo7DV = parcelRequire("lo7DV");
function $90c52f5c5e6c1261$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $lo7DV.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $lo7DV.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("9qpsu", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dca4a4a3b2382b5$export$2e2bcd8739ae039);


var $ghsgK = parcelRequire("ghsgK");

var $hD0Wz = parcelRequire("hD0Wz");


var $eY2Ln = parcelRequire("eY2Ln");

var $iVQm7 = parcelRequire("iVQm7");




var $6dca4a4a3b2382b5$export$2e2bcd8739ae039 //
 = (0, $iVQm7.setFocus);

});
parcelRegister("ghsgK", function(module, exports) {

$parcel$export(module.exports, "focusInside", () => $bda42986f697aa02$export$20115f8da7baa6fa);

var $dGwLO = parcelRequire("dGwLO");

var $kaqq0 = parcelRequire("kaqq0");

var $3dZfm = parcelRequire("3dZfm");

var $cJGR3 = parcelRequire("cJGR3");
var $bda42986f697aa02$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $bda42986f697aa02$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $3dZfm.toArray)(topNode.querySelectorAll('iframe')).some(function(node) {
        return $bda42986f697aa02$var$focusInFrame(node, activeElement);
    }));
};
var $bda42986f697aa02$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $cJGR3.getActiveElement)((0, $3dZfm.getFirst)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $kaqq0.getAllAffectedNodes)(topNode).some(function(node) {
        return (0, $dGwLO.contains)(node, activeElement) || $bda42986f697aa02$var$focusInsideIframe(node, activeElement);
    });
};

});
parcelRegister("dGwLO", function(module, exports) {

$parcel$export(module.exports, "filterAutoFocusable", () => $9f689e0f269a4f6a$export$2f70373d403a5d2b);
$parcel$export(module.exports, "getTabbableNodes", () => $9f689e0f269a4f6a$export$3738e313571e2ad2);
$parcel$export(module.exports, "getAllTabbableNodes", () => $9f689e0f269a4f6a$export$23c79be8286a3b0c);
$parcel$export(module.exports, "parentAutofocusables", () => $9f689e0f269a4f6a$export$dc26309a71d1ce47);
$parcel$export(module.exports, "contains", () => $9f689e0f269a4f6a$export$2344b14b097df817);

var $3dZfm = parcelRequire("3dZfm");

var $cAvow = parcelRequire("cAvow");

var $1QIcG = parcelRequire("1QIcG");

var $deDjw = parcelRequire("deDjw");
var $9f689e0f269a4f6a$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $3dZfm.toArray)(nodes).filter(function(node) {
        return (0, $cAvow.isVisibleCached)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $cAvow.notHiddenInput)(node);
    });
};
var $9f689e0f269a4f6a$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $3dZfm.toArray)(nodes).filter(function(node) {
        return (0, $cAvow.isAutoFocusAllowedCached)(cache, node);
    });
};
var $9f689e0f269a4f6a$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $1QIcG.orderByTabIndex)($9f689e0f269a4f6a$export$6266a5cd5915dc33((0, $deDjw.getFocusables)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $9f689e0f269a4f6a$export$23c79be8286a3b0c = function(topNodes, visibilityCache) {
    return (0, $1QIcG.orderByTabIndex)($9f689e0f269a4f6a$export$6266a5cd5915dc33((0, $deDjw.getFocusables)(topNodes), visibilityCache), false);
};
var $9f689e0f269a4f6a$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $9f689e0f269a4f6a$export$6266a5cd5915dc33((0, $deDjw.getParentAutofocusables)(topNode), visibilityCache);
};
var $9f689e0f269a4f6a$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $9f689e0f269a4f6a$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $3dZfm.toArray)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $9f689e0f269a4f6a$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $9f689e0f269a4f6a$export$2344b14b097df817(child, element);
        });
    }
};

});
parcelRegister("3dZfm", function(module, exports) {

$parcel$export(module.exports, "toArray", () => $259218580a656da5$export$45b10814cc054894);
$parcel$export(module.exports, "asArray", () => $259218580a656da5$export$75093a47a9fa838d);
$parcel$export(module.exports, "getFirst", () => $259218580a656da5$export$bcd7afcd904dce14);
/*
IE11 support
 */ var $259218580a656da5$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $259218580a656da5$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $259218580a656da5$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};

});

parcelRegister("cAvow", function(module, exports) {

$parcel$export(module.exports, "isVisibleCached", () => $92a13320778b6a5f$export$3c9dc299685ad160);
$parcel$export(module.exports, "isAutoFocusAllowedCached", () => $92a13320778b6a5f$export$bcaa50628f6a736e);
$parcel$export(module.exports, "getDataset", () => $92a13320778b6a5f$export$698b339b0c8edae3);
$parcel$export(module.exports, "isRadioElement", () => $92a13320778b6a5f$export$9d74f6fbc6f469d0);
$parcel$export(module.exports, "notHiddenInput", () => $92a13320778b6a5f$export$8197b0ea56b3b055);
$parcel$export(module.exports, "isGuard", () => $92a13320778b6a5f$export$d94b8b58ec2f30eb);
$parcel$export(module.exports, "isNotAGuard", () => $92a13320778b6a5f$export$602e5a0d338d7750);
$parcel$export(module.exports, "isDefined", () => $92a13320778b6a5f$export$4e62c701997796c1);

var $897GZ = parcelRequire("897GZ");
var $92a13320778b6a5f$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};
var $92a13320778b6a5f$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $92a13320778b6a5f$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $92a13320778b6a5f$var$isVisibleUncached = function(node, checkParent) {
    return !node || $92a13320778b6a5f$var$isTopNode(node) || !$92a13320778b6a5f$var$isElementHidden(node) && checkParent($92a13320778b6a5f$var$getParentNode(node));
};
var $92a13320778b6a5f$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $92a13320778b6a5f$var$isVisibleUncached(node, $92a13320778b6a5f$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $92a13320778b6a5f$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$92a13320778b6a5f$var$isTopNode(node) ? $92a13320778b6a5f$export$b8550e27de209d85(node) ? checkParent($92a13320778b6a5f$var$getParentNode(node)) : false : true;
};
var $92a13320778b6a5f$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $92a13320778b6a5f$var$isAutoFocusAllowedUncached(node, $92a13320778b6a5f$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $92a13320778b6a5f$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $92a13320778b6a5f$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === 'BUTTON';
};
var $92a13320778b6a5f$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === 'INPUT';
};
var $92a13320778b6a5f$export$9d74f6fbc6f469d0 = function(node) {
    return $92a13320778b6a5f$export$88a6ceeed5737ba3(node) && node.type === 'radio';
};
var $92a13320778b6a5f$export$8197b0ea56b3b055 = function(node) {
    return !(($92a13320778b6a5f$export$88a6ceeed5737ba3(node) || $92a13320778b6a5f$export$65aad1b6bc934b11(node)) && (node.type === 'hidden' || node.disabled));
};
var $92a13320778b6a5f$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $897GZ.FOCUS_NO_AUTOFOCUS));
    return ![
        true,
        'true',
        ''
    ].includes(attribute);
};
var $92a13320778b6a5f$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $92a13320778b6a5f$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $92a13320778b6a5f$export$602e5a0d338d7750 = function(node) {
    return !$92a13320778b6a5f$export$d94b8b58ec2f30eb(node);
};
var $92a13320778b6a5f$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};

});

parcelRegister("1QIcG", function(module, exports) {

$parcel$export(module.exports, "orderByTabIndex", () => $158cefabc5ebaf7c$export$cb40ee071f0d5226);

var $3dZfm = parcelRequire("3dZfm");
var $158cefabc5ebaf7c$export$350ee6c095d98996 = function(a, b) {
    var tabDiff = a.tabIndex - b.tabIndex;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!a.tabIndex) return 1;
        if (!b.tabIndex) return -1;
    }
    return tabDiff || indexDiff;
};
var $158cefabc5ebaf7c$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $3dZfm.toArray)(nodes).map(function(node, index) {
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && node.tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : node.tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($158cefabc5ebaf7c$export$350ee6c095d98996);
};

});

parcelRegister("deDjw", function(module, exports) {

$parcel$export(module.exports, "getFocusables", () => $9a2b141a89269652$export$f6768025e418420e);
$parcel$export(module.exports, "getParentAutofocusables", () => $9a2b141a89269652$export$853fa94d922e78b9);

var $897GZ = parcelRequire("897GZ");

var $3dZfm = parcelRequire("3dZfm");

var $9aCi4 = parcelRequire("9aCi4");
var $9a2b141a89269652$var$queryTabbables = (0, $9aCi4.tabbables).join(',');
var $9a2b141a89269652$var$queryGuardTabbables = "".concat($9a2b141a89269652$var$queryTabbables, ", [data-focus-guard]");
var $9a2b141a89269652$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $3dZfm.toArray)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $9a2b141a89269652$var$queryGuardTabbables : $9a2b141a89269652$var$queryTabbables) ? [
            child
        ] : [], $9a2b141a89269652$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $9a2b141a89269652$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $9a2b141a89269652$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $9a2b141a89269652$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $9a2b141a89269652$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $9a2b141a89269652$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $3dZfm.toArray)(parent.parentNode.querySelectorAll($9a2b141a89269652$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $9a2b141a89269652$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $897GZ.FOCUS_AUTO), "]"));
    return (0, $3dZfm.toArray)(parentFocus).map(function(node) {
        return $9a2b141a89269652$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};

});
parcelRegister("9aCi4", function(module, exports) {

$parcel$export(module.exports, "tabbables", () => $6ad2bfed75f1a9d0$export$8555f4622e95784);
/**
 * list of the object to be considered as focusable
 */ var $6ad2bfed75f1a9d0$export$8555f4622e95784 = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]'
];

});



parcelRegister("kaqq0", function(module, exports) {

$parcel$export(module.exports, "getAllAffectedNodes", () => $eae93bff7b42320d$export$7e87c4720b9b279b);

var $897GZ = parcelRequire("897GZ");

var $3dZfm = parcelRequire("3dZfm");
/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $eae93bff7b42320d$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $eae93bff7b42320d$var$getTopParent = function(node) {
    return node.parentNode ? $eae93bff7b42320d$var$getTopParent(node.parentNode) : node;
};
var $eae93bff7b42320d$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $3dZfm.asArray)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $897GZ.FOCUS_GROUP));
        acc.push.apply(acc, group ? $eae93bff7b42320d$var$filterNested((0, $3dZfm.toArray)($eae93bff7b42320d$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $897GZ.FOCUS_GROUP), "=\"").concat(group, "\"]:not([").concat((0, $897GZ.FOCUS_DISABLED), "=\"disabled\"])")))) : [
            currentNode
        ]);
        return acc;
    }, []);
};

});

parcelRegister("cJGR3", function(module, exports) {

$parcel$export(module.exports, "getActiveElement", () => $945aee118bee4986$export$cd4e5573fbe2b576);
/**
 * returns active element from document or from nested shadowdoms
 */ 
var $1lhcA = parcelRequire("1lhcA");
var $945aee118bee4986$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $945aee118bee4986$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $1lhcA.safeProbe)(function() {
        return activeElement.contentWindow.document;
    }) ? $945aee118bee4986$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};

});
parcelRegister("1lhcA", function(module, exports) {

$parcel$export(module.exports, "safeProbe", () => $0fa51892c6efaee4$export$78d20aae35adef88);
var $0fa51892c6efaee4$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};

});



parcelRegister("hD0Wz", function(module, exports) {

$parcel$export(module.exports, "focusIsHidden", () => $cd56cf9acc91bbdc$export$be6b21806d3fd485);

var $897GZ = parcelRequire("897GZ");

var $dGwLO = parcelRequire("dGwLO");

var $3dZfm = parcelRequire("3dZfm");

var $cJGR3 = parcelRequire("cJGR3");
var $cd56cf9acc91bbdc$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $cJGR3.getActiveElement)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $3dZfm.toArray)(inDocument.querySelectorAll("[".concat((0, $897GZ.FOCUS_ALLOW), "]"))).some(function(node) {
        return (0, $dGwLO.contains)(node, activeElement);
    });
};

});

parcelRegister("eY2Ln", function(module, exports) {

$parcel$export(module.exports, "getFocusabledIn", () => $ae58cff6e95fbf8f$export$30d9c643899a8835);

var $dGwLO = parcelRequire("dGwLO");

var $kaqq0 = parcelRequire("kaqq0");

var $cAvow = parcelRequire("cAvow");

var $ekDa9 = parcelRequire("ekDa9");
var $ae58cff6e95fbf8f$export$30d9c643899a8835 = function(topNode) {
    var entries = (0, $kaqq0.getAllAffectedNodes)(topNode).filter((0, $cAvow.isNotAGuard));
    var commonParent = (0, $ekDa9.getTopCommonParent)(topNode, topNode, entries);
    var visibilityCache = new Map();
    var outerNodes = (0, $dGwLO.getTabbableNodes)([
        commonParent
    ], visibilityCache, true);
    var innerElements = (0, $dGwLO.getTabbableNodes)(entries, visibilityCache).filter(function(_a) {
        var node = _a.node;
        return (0, $cAvow.isNotAGuard)(node);
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $cAvow.isGuard)(node)
        };
    });
};
var $ae58cff6e95fbf8f$export$5f246425711134ac = $ae58cff6e95fbf8f$export$30d9c643899a8835;

});
parcelRegister("ekDa9", function(module, exports) {

$parcel$export(module.exports, "getTopCommonParent", () => $a6f14fdf90f745fd$export$a9a7252b5f2e280e);
$parcel$export(module.exports, "allParentAutofocusables", () => $a6f14fdf90f745fd$export$8f99714c70a37db1);

var $dGwLO = parcelRequire("dGwLO");

var $3dZfm = parcelRequire("3dZfm");
var $a6f14fdf90f745fd$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $a6f14fdf90f745fd$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $a6f14fdf90f745fd$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $a6f14fdf90f745fd$var$getParents(nodeA);
    var parentsB = $a6f14fdf90f745fd$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $a6f14fdf90f745fd$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $3dZfm.asArray)(baseActiveElement);
    var leftEntries = (0, $3dZfm.asArray)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $a6f14fdf90f745fd$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $a6f14fdf90f745fd$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $dGwLO.contains)(common, topCommon)) topCommon = common;
                else topCommon = $a6f14fdf90f745fd$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $a6f14fdf90f745fd$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $dGwLO.parentAutofocusables)(node, visibilityCache));
    }, []);
};

});


parcelRegister("iVQm7", function(module, exports) {

$parcel$export(module.exports, "setFocus", () => $038e8d0ee2a083a5$export$f06c444b0336b5d5);

var $k8ijt = parcelRequire("k8ijt");
var $038e8d0ee2a083a5$export$c12b3da842c43a8 = function(target, focusOptions) {
    if ('focus' in target) target.focus(focusOptions);
    if ('contentWindow' in target && target.contentWindow) target.contentWindow.focus();
};
var $038e8d0ee2a083a5$var$guardCount = 0;
var $038e8d0ee2a083a5$var$lockDisabled = false;
var $038e8d0ee2a083a5$export$f06c444b0336b5d5 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $k8ijt.getFocusMerge)(topNode, lastNode);
    if ($038e8d0ee2a083a5$var$lockDisabled) return;
    if (focusable) {
        if ($038e8d0ee2a083a5$var$guardCount > 2) {
            // tslint:disable-next-line:no-console
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $038e8d0ee2a083a5$var$lockDisabled = true;
            setTimeout(function() {
                $038e8d0ee2a083a5$var$lockDisabled = false;
            }, 1);
            return;
        }
        $038e8d0ee2a083a5$var$guardCount++;
        $038e8d0ee2a083a5$export$c12b3da842c43a8(focusable.node, options.focusOptions);
        $038e8d0ee2a083a5$var$guardCount--;
    }
};

});
parcelRegister("k8ijt", function(module, exports) {

$parcel$export(module.exports, "getFocusMerge", () => $ea82c2993f8eb3d2$export$82d3f62e3f171d1d);

var $hvL3M = parcelRequire("hvL3M");

var $dGwLO = parcelRequire("dGwLO");

var $kaqq0 = parcelRequire("kaqq0");

var $3dZfm = parcelRequire("3dZfm");

var $lgDTl = parcelRequire("lgDTl");

var $cJGR3 = parcelRequire("cJGR3");

var $cAvow = parcelRequire("cAvow");

var $ekDa9 = parcelRequire("ekDa9");
var $ea82c2993f8eb3d2$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $cAvow.isDefined));
};
var $ea82c2993f8eb3d2$export$82d3f62e3f171d1d = function(topNode, lastNode) {
    var activeElement = (0, $cJGR3.getActiveElement)((0, $3dZfm.asArray)(topNode).length > 0 ? document : (0, $3dZfm.getFirst)(topNode).ownerDocument);
    var entries = (0, $kaqq0.getAllAffectedNodes)(topNode).filter((0, $cAvow.isNotAGuard));
    var commonParent = (0, $ekDa9.getTopCommonParent)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $dGwLO.getAllTabbableNodes)(entries, visibilityCache);
    var innerElements = (0, $dGwLO.getTabbableNodes)(entries, visibilityCache).filter(function(_a) {
        var node = _a.node;
        return (0, $cAvow.isNotAGuard)(node);
    });
    if (!innerElements[0]) {
        innerElements = anyFocusable;
        if (!innerElements[0]) return undefined;
    }
    var outerNodes = (0, $dGwLO.getAllTabbableNodes)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $ea82c2993f8eb3d2$var$reorderNodes(outerNodes, innerElements);
    var innerNodes = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $hvL3M.newFocus)(innerNodes, outerNodes, activeElement, lastNode);
    if (newId === (0, $hvL3M.NEW_FOCUS)) {
        var focusNode = (0, $lgDTl.pickAutofocus)(anyFocusable, innerNodes, (0, $ekDa9.allParentAutofocusables)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};

});
parcelRegister("hvL3M", function(module, exports) {

$parcel$export(module.exports, "NEW_FOCUS", () => $cbf9d60d37c55158$export$85710b12cf912438);
$parcel$export(module.exports, "newFocus", () => $cbf9d60d37c55158$export$65842178e9bb4205);

var $ftArt = parcelRequire("ftArt");

var $1vYa3 = parcelRequire("1vYa3");

var $cAvow = parcelRequire("cAvow");
var $cbf9d60d37c55158$export$85710b12cf912438 = 'NEW_FOCUS';
var $cbf9d60d37c55158$export$65842178e9bb4205 = function(innerNodes, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $cAvow.isGuard)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $ftArt.correctNodes)(outerNodes);
    var correctedIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var correctedIndexDiff = correctedIndex - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
    var returnFirstNode = (0, $1vYa3.pickFocusable)(innerNodes, 0);
    var returnLastNode = (0, $1vYa3.pickFocusable)(innerNodes, cnt - 1);
    // new focus
    if (activeIndex === -1 || lastNodeInside === -1) return $cbf9d60d37c55158$export$85710b12cf912438;
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(correctedIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

});
parcelRegister("ftArt", function(module, exports) {

$parcel$export(module.exports, "correctNode", () => $b445d518e018c082$export$5261662167ad7ced);
$parcel$export(module.exports, "correctNodes", () => $b445d518e018c082$export$4a5a72a7124e45f9);

var $cAvow = parcelRequire("cAvow");
var $b445d518e018c082$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $cAvow.isRadioElement)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $b445d518e018c082$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $cAvow.isRadioElement)(node) && node.name) return $b445d518e018c082$var$findSelectedRadio(node, nodes);
    return node;
};
var $b445d518e018c082$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($b445d518e018c082$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};

});

parcelRegister("1vYa3", function(module, exports) {

$parcel$export(module.exports, "pickFirstFocus", () => $11a75a6dd55eec13$export$f4e86cfa0679b9cc);
$parcel$export(module.exports, "pickFocusable", () => $11a75a6dd55eec13$export$e06728ee87c96122);

var $ftArt = parcelRequire("ftArt");
var $11a75a6dd55eec13$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $ftArt.correctNode)(nodes[0], nodes);
    return nodes[0];
};
var $11a75a6dd55eec13$export$e06728ee87c96122 = function(nodes, index) {
    if (nodes.length > 1) return nodes.indexOf((0, $ftArt.correctNode)(nodes[index], nodes));
    return index;
};

});


parcelRegister("lgDTl", function(module, exports) {

$parcel$export(module.exports, "pickAutofocus", () => $f7ba0940ea29fab8$export$cfb742983e257555);

var $dGwLO = parcelRequire("dGwLO");

var $1vYa3 = parcelRequire("1vYa3");

var $cAvow = parcelRequire("cAvow");
var $f7ba0940ea29fab8$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $cAvow.getDataset)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== 'false' || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $f7ba0940ea29fab8$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $dGwLO.filterAutoFocusable)(nodes.filter($f7ba0940ea29fab8$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $1vYa3.pickFirstFocus)(autoFocusable);
    return (0, $1vYa3.pickFirstFocus)((0, $dGwLO.filterAutoFocusable)(orderedNodes));
};

});




parcelRegister("7QlzK", function(module, exports) {

$parcel$export(module.exports, "deferAction", () => $5b5e202efb99a9c0$export$6523025722806278);
$parcel$export(module.exports, "inlineProp", () => $5b5e202efb99a9c0$export$db10c343af3f20fa);
function $5b5e202efb99a9c0$export$6523025722806278(action) {
    // Hidding setImmediate from Webpack to avoid inserting polyfill
    var _window = window, setImmediate = _window.setImmediate;
    if (typeof setImmediate !== 'undefined') setImmediate(action);
    else setTimeout(action, 1);
}
var $5b5e202efb99a9c0$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};

});



parcelRegister("fQrA1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b8911b2750c62102$export$2e2bcd8739ae039);
$parcel$export(module.exports, "AutoFocusInside", () => (parcelRequire("4iOVL")).default);
$parcel$export(module.exports, "MoveFocusInside", () => (parcelRequire("2JORg")).default);
$parcel$export(module.exports, "FreeFocusInside", () => (parcelRequire("eH7KK")).default);
$parcel$export(module.exports, "InFocusGuard", () => (parcelRequire("017Eu")).default);
$parcel$export(module.exports, "FocusLockUI", () => (parcelRequire("b8kzx")).default);
$parcel$export(module.exports, "useFocusInside", () => (parcelRequire("2JORg")).useFocusInside);

var $b8kzx = parcelRequire("b8kzx");

var $4iOVL = parcelRequire("4iOVL");

var $2JORg = parcelRequire("2JORg");

var $eH7KK = parcelRequire("eH7KK");

var $017Eu = parcelRequire("017Eu");
var $b8911b2750c62102$export$2e2bcd8739ae039 = (0, $b8kzx.default);

});
parcelRegister("4iOVL", function(module, exports) {

$parcel$export(module.exports, "default", () => $3220599f1fb371c4$export$2e2bcd8739ae039);

var $iuyZt = parcelRequire("iuyZt");
parcelRequire("aXNcS");
var $fUX2S = parcelRequire("fUX2S");


var $897GZ = parcelRequire("897GZ");

var $7QlzK = parcelRequire("7QlzK");
var $3220599f1fb371c4$var$AutoFocusInside = function AutoFocusInside(_ref) {
    var _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, children = _ref.children, _ref$className = _ref.className, className = _ref$className === void 0 ? undefined : _ref$className;
    return /*#__PURE__*/ $fUX2S.createElement("div", (0, $iuyZt.default)({}, (0, $7QlzK.inlineProp)($897GZ.FOCUS_AUTO, !disabled), {
        className: className
    }), children);
};
$3220599f1fb371c4$var$AutoFocusInside.propTypes = {};
var $3220599f1fb371c4$export$2e2bcd8739ae039 = $3220599f1fb371c4$var$AutoFocusInside;

});

parcelRegister("2JORg", function(module, exports) {

$parcel$export(module.exports, "useFocusInside", () => $1fe73c18fff135e1$export$729dec1d3bf84074);
$parcel$export(module.exports, "default", () => $1fe73c18fff135e1$export$2e2bcd8739ae039);

var $iuyZt = parcelRequire("iuyZt");
parcelRequire("aXNcS");
var $fUX2S = parcelRequire("fUX2S");
var $fqaWh = parcelRequire("fqaWh");


var $897GZ = parcelRequire("897GZ");

var $7QlzK = parcelRequire("7QlzK");

var $2q98l = parcelRequire("2q98l");
var $1fe73c18fff135e1$export$729dec1d3bf84074 = function useFocusInside(observedRef) {
    $fqaWh.useEffect(function() {
        var enabled = true;
        (0, $2q98l.mediumEffect).useMedium(function(car) {
            var observed = observedRef && observedRef.current;
            if (enabled && observed) {
                if (!car.focusInside(observed)) car.moveFocusInside(observed, null);
            }
        });
        return function() {
            enabled = false;
        };
    }, [
        observedRef
    ]);
};
function $1fe73c18fff135e1$var$MoveFocusInside(_ref) {
    var isDisabled = _ref.disabled, className = _ref.className, children = _ref.children;
    var ref = $fqaWh.useRef(null);
    $1fe73c18fff135e1$export$729dec1d3bf84074(isDisabled ? undefined : ref);
    return /*#__PURE__*/ $fUX2S.createElement("div", (0, $iuyZt.default)({}, (0, $7QlzK.inlineProp)($897GZ.FOCUS_AUTO, !isDisabled), {
        ref: ref,
        className: className
    }), children);
}
$1fe73c18fff135e1$var$MoveFocusInside.propTypes = {};
$1fe73c18fff135e1$var$MoveFocusInside.defaultProps = {
    disabled: false,
    className: undefined
};
var $1fe73c18fff135e1$export$2e2bcd8739ae039 = $1fe73c18fff135e1$var$MoveFocusInside;

});

parcelRegister("eH7KK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab2b1870c0a21764$export$2e2bcd8739ae039);

var $iuyZt = parcelRequire("iuyZt");
parcelRequire("aXNcS");
var $fUX2S = parcelRequire("fUX2S");


var $897GZ = parcelRequire("897GZ");

var $7QlzK = parcelRequire("7QlzK");
var $ab2b1870c0a21764$var$FreeFocusInside = function FreeFocusInside(_ref) {
    var children = _ref.children, className = _ref.className;
    return /*#__PURE__*/ $fUX2S.createElement("div", (0, $iuyZt.default)({}, (0, $7QlzK.inlineProp)($897GZ.FOCUS_ALLOW, true), {
        className: className
    }), children);
};
$ab2b1870c0a21764$var$FreeFocusInside.propTypes = {};
$ab2b1870c0a21764$var$FreeFocusInside.defaultProps = {
    className: undefined
};
var $ab2b1870c0a21764$export$2e2bcd8739ae039 = $ab2b1870c0a21764$var$FreeFocusInside;

});



parcelRegister("aMoT9", function(module, exports) {

$parcel$export(module.exports, "releaseBody", () => $7d91b17014f49117$export$80f0e0a114f823d0);
$parcel$export(module.exports, "enter", () => $7d91b17014f49117$export$e668df1bcd81e4d2);
$parcel$export(module.exports, "escFunction", () => $7d91b17014f49117$export$8956bc22b4d5fb67);
$parcel$export(module.exports, "onBackdropClick", () => $7d91b17014f49117$export$21e7b9f4635e7aa6);
$parcel$export(module.exports, "handleAnimationEnd", () => $7d91b17014f49117$export$3373caf2c90f72f5);
$parcel$export(module.exports, "onVisibleChanged", () => $7d91b17014f49117$export$3f093399b9ae7cee);

var $l63gs = parcelRequire("l63gs");

var $5GEDS = parcelRequire("5GEDS");
const $7d91b17014f49117$export$18583d4255708396 = (prefix)=>{
    const body = document.body;
    (0, $l63gs.default).push(true);
    if (body.classList.toString().indexOf(`${prefix}prevent-scroll-y`) === -1) {
        const scrollCache = window.pageYOffset || window.scrollY;
        body.setAttribute('data-skapa--scroll', scrollCache.toString());
        const paddingCache = body.style.paddingRight;
        body.setAttribute('data-skapa--pad', paddingCache);
        let scrollbarWidth = body.clientWidth;
        body.classList.add(`${prefix}prevent-scroll-y`);
        scrollbarWidth = body.clientWidth - scrollbarWidth;
        body.style.top = `-${scrollCache}px`;
        if (scrollbarWidth) body.style.paddingRight = `calc(${paddingCache || '0px'} + ${scrollbarWidth}px)`;
        window.scrollTo(0, 0);
    }
};
const $7d91b17014f49117$export$80f0e0a114f823d0 = (prefix)=>{
    const body = document.body;
    (0, $l63gs.default).pop();
    if ((0, $l63gs.default).length === 0 && body.classList.toString().indexOf(`${prefix}prevent-scroll-y`) > -1) {
        const scrollCache = Number(body.getAttribute('data-skapa--scroll'));
        const paddingCache = body.getAttribute('data-skapa--pad');
        body.classList.remove(`${prefix}prevent-scroll-y`);
        body.style.paddingRight = paddingCache;
        window.scrollTo(0, scrollCache);
        body.style.top = '';
        body.removeAttribute('data-skapa--scroll');
        body.removeAttribute('data-skapa--pad');
        if (!body.style.length) body.removeAttribute('style');
    }
    return true;
};
const $7d91b17014f49117$export$33993f1ec7a2167a = (setIsOpen, setAnimationMountHelper)=>{
    setIsOpen(false);
    setAnimationMountHelper(true);
};
const $7d91b17014f49117$export$e668df1bcd81e4d2 = (setIsOpen, scrollLock, prefix)=>{
    setIsOpen(true);
    if (scrollLock) $7d91b17014f49117$export$18583d4255708396(prefix);
};
const $7d91b17014f49117$export$8956bc22b4d5fb67 = (e, baseClass, escapable, handleCloseBtn, setIsOpen, setAnimationMountHelper)=>{
    const escapeCalledOnThisModal = !e.target.closest || e.target.closest(`.${baseClass}`) === e.currentTarget;
    if (escapeCalledOnThisModal && escapable && e.key === 'Escape') {
        if (handleCloseBtn) handleCloseBtn(e);
        $7d91b17014f49117$export$33993f1ec7a2167a(setIsOpen, setAnimationMountHelper);
    }
};
const $7d91b17014f49117$export$21e7b9f4635e7aa6 = (event, escapable, handleCloseBtn)=>{
    if (escapable && event.target === event.currentTarget) handleCloseBtn(event);
};
const $7d91b17014f49117$export$3373caf2c90f72f5 = (event, animationFrameRef, isOpen, onModalOpened, onModalClosed, scrollLock, animationMountHelper, setAnimationMountHelper, prefix)=>{
    cancelAnimationFrame(animationFrameRef);
    if (isOpen) // Modal opening animation is finished
    {
        if (onModalOpened) animationFrameRef = requestAnimationFrame(()=>{
            onModalOpened(event);
        }); // animationFrame prevents multiple triggers
    } else if (animationMountHelper) {
        // Modal closing animation is finished
        if (scrollLock) $7d91b17014f49117$export$80f0e0a114f823d0(prefix);
        setAnimationMountHelper(false);
        if (onModalClosed) animationFrameRef = requestAnimationFrame(()=>{
            onModalClosed(event);
        }); // animationFrame prevents multiple triggers
    }
};
const $7d91b17014f49117$export$3f093399b9ae7cee = (prefix, visible, scrollLock, isOpen, setIsOpen, setAnimationMountHelper)=>{
    if (visible !== isOpen) {
        if (visible) $7d91b17014f49117$export$e668df1bcd81e4d2(setIsOpen, scrollLock, prefix);
        else $7d91b17014f49117$export$33993f1ec7a2167a(setIsOpen, setAnimationMountHelper);
    }
};

});
parcelRegister("l63gs", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5bcb0be719b515b$export$2e2bcd8739ae039);
const $f5bcb0be719b515b$var$openModals = [];
var $f5bcb0be719b515b$export$2e2bcd8739ae039 = $f5bcb0be719b515b$var$openModals;

});

parcelRegister("5GEDS", function(module, exports) {
const $424066abcbd27871$var$ShouldAutoFocus = (refElement)=>{
    if (!refElement) return false;
    const autoFocusSet = Boolean(refElement.querySelectorAll('*[data-autofocus],*[autofocus]').length);
    return !autoFocusSet;
};
var $424066abcbd27871$export$2e2bcd8739ae039 = $424066abcbd27871$var$ShouldAutoFocus;

});






parcelRegister("fg7Qi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.warningTriangle = module.exports.iconName = module.exports.paths = void 0;
module.exports.paths = [
    {
        "tag": "path",
        "att": {
            "d": "M11.0036 14.2509h2v-6h-2v6zm1 1.5c-.6904 0-1.25.5596-1.25 1.25 0 .6903.5596 1.25 1.25 1.25.6903 0 1.25-.5597 1.25-1.25 0-.6904-.5597-1.25-1.25-1.25z"
        }
    },
    {
        "tag": "path",
        "att": {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            "d": "m1.1152 20.5351 10-19h1.7699l10 19-.8849 1.4658h-20l-.885-1.4658zm2.5413-.5342h16.6873l-8.3436-15.853-8.3437 15.853z"
        }
    }
];
module.exports.iconName = 'warning-triangle';
module.exports.warningTriangle = {
    iconName: module.exports.iconName,
    paths: module.exports.paths
};
module.exports.default = module.exports.paths;

});

parcelRegister("ipMmU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d68014c7519ec794$var$_react = $d68014c7519ec794$var$_interopRequireWildcard((parcelRequire("aXNcS")));


var $d68014c7519ec794$var$_classnames = $d68014c7519ec794$var$_interopRequireDefault((parcelRequire("3LGzW")));
function $d68014c7519ec794$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d68014c7519ec794$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($d68014c7519ec794$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $d68014c7519ec794$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $d68014c7519ec794$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $d68014c7519ec794$var$_extends() {
    $d68014c7519ec794$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d68014c7519ec794$var$_extends.apply(this, arguments);
}
const $d68014c7519ec794$var$Loading = (_ref)=>{
    let { className: className, prefix: prefix, children: child, text: text, labelTransitions: labelTransitions, labelPosition: labelPosition, ...otherProps } = _ref;
    const baseClass = `${prefix}loading`;
    const [displayText, setDisplayText] = (0, $d68014c7519ec794$var$_react.useState)(text);
    const [fadeOut, setFadeOut] = (0, $d68014c7519ec794$var$_react.useState)(false);
    const [fadeIn, setFadeIn] = (0, $d68014c7519ec794$var$_react.useState)(false);
    (0, $d68014c7519ec794$var$_react.useEffect)(()=>{
        let fadeOutTimer = 0;
        let fadeInTimer = 0;
        if (labelTransitions && text !== displayText) {
            setFadeIn(false);
            setFadeOut(true);
            fadeOutTimer = setTimeout(()=>{
                setFadeOut(false);
                fadeInTimer = setTimeout(()=>{
                    setFadeIn(true);
                    setDisplayText(text);
                }, 100);
            }, 100);
        } else {
            setFadeIn(true);
            setDisplayText(text);
        }
        return ()=>{
            clearTimeout(fadeOutTimer);
            clearTimeout(fadeInTimer);
        };
    }, [
        text
    ]);
    const loadingClass = (0, $d68014c7519ec794$var$_classnames.default)(baseClass, `${baseClass}--label-${labelPosition}`, className);
    const loadingTextClasses = (0, $d68014c7519ec794$var$_classnames.default)(`${baseClass}__text`, fadeOut && `${baseClass}__text--fade-out`, fadeIn && `${baseClass}__text--fade-in`);
    const shouldRenderLabel = child && !child.props.size || child && child.props.size === 'large';
    return $d68014c7519ec794$var$_react.default.createElement("span", $d68014c7519ec794$var$_extends({}, otherProps, {
        className: loadingClass,
        "aria-live": "polite"
    }), child && (0, $d68014c7519ec794$var$_react.cloneElement)(child, {
        prefix: prefix
    }), shouldRenderLabel && $d68014c7519ec794$var$_react.default.createElement("span", {
        "aria-hidden": true,
        className: loadingTextClasses
    }, displayText), $d68014c7519ec794$var$_react.default.createElement("span", {
        className: `${baseClass}__sr-only-text`
    }, text));
};
$d68014c7519ec794$var$Loading.defaultProps = {
    prefix: '',
    text: "Loading\u2026",
    labelTransitions: false,
    labelPosition: 'center'
};
var $d68014c7519ec794$var$_default = $d68014c7519ec794$var$Loading;
module.exports.default = $d68014c7519ec794$var$_default;

});

parcelRegister("bJ5nJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8898125df49bf5e1$var$_react = $8898125df49bf5e1$var$_interopRequireDefault((parcelRequire("aXNcS")));


var $8898125df49bf5e1$var$_classnames = $8898125df49bf5e1$var$_interopRequireDefault((parcelRequire("3LGzW")));
function $8898125df49bf5e1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8898125df49bf5e1$var$_extends() {
    $8898125df49bf5e1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8898125df49bf5e1$var$_extends.apply(this, arguments);
}
const $8898125df49bf5e1$var$LoadingBall = (_ref)=>{
    let { className: className, prefix: prefix, size: size, color: color, ...otherProps } = _ref;
    const baseClass = `${prefix}loading__ball`;
    const loadingBallClass = (0, $8898125df49bf5e1$var$_classnames.default)(baseClass, `${baseClass}--${size}`, `${baseClass}--${color}`);
    return $8898125df49bf5e1$var$_react.default.createElement("span", $8898125df49bf5e1$var$_extends({}, otherProps, {
        className: loadingBallClass,
        "aria-hidden": true
    }));
};
$8898125df49bf5e1$var$LoadingBall.defaultProps = {
    prefix: '',
    size: 'large',
    color: 'emphasised'
};
var $8898125df49bf5e1$var$_default = $8898125df49bf5e1$var$LoadingBall;
module.exports.default = $8898125df49bf5e1$var$_default;

});

parcelRegister("8afao", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5f1b05ad4b4e2a5e$var$_react = $5f1b05ad4b4e2a5e$var$_interopRequireDefault((parcelRequire("aXNcS")));


var $5f1b05ad4b4e2a5e$var$_classnames = $5f1b05ad4b4e2a5e$var$_interopRequireDefault((parcelRequire("3LGzW")));
function $5f1b05ad4b4e2a5e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5f1b05ad4b4e2a5e$var$_extends() {
    $5f1b05ad4b4e2a5e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5f1b05ad4b4e2a5e$var$_extends.apply(this, arguments);
}
const $5f1b05ad4b4e2a5e$var$LoadingLinear = (_ref)=>{
    let { className: className, prefix: prefix, loadingValue: loadingValue, loadingMax: loadingMax, loadingLabel: loadingLabel, ...otherProps } = _ref;
    const baseClass = `${prefix}loading__linear`;
    const linearWrapperClasses = (0, $5f1b05ad4b4e2a5e$var$_classnames.default)(`${baseClass}-wrapper`, className);
    const currentValue = loadingValue > loadingMax ? loadingMax : loadingValue;
    return $5f1b05ad4b4e2a5e$var$_react.default.createElement("span", $5f1b05ad4b4e2a5e$var$_extends({}, otherProps, {
        className: linearWrapperClasses
    }), $5f1b05ad4b4e2a5e$var$_react.default.createElement("label", {
        className: `${baseClass}-label`
    }, loadingLabel), $5f1b05ad4b4e2a5e$var$_react.default.createElement("progress", {
        className: `${baseClass}-progress`,
        value: currentValue,
        max: loadingMax,
        "aria-valuemin": "0",
        "aria-valuenow": currentValue,
        "aria-valuemax": loadingMax
    }));
};
$5f1b05ad4b4e2a5e$var$LoadingLinear.defaultProps = {
    prefix: '',
    loadingValue: 0,
    loadingMax: 100
};
var $5f1b05ad4b4e2a5e$var$_default = $5f1b05ad4b4e2a5e$var$LoadingLinear;
module.exports.default = $5f1b05ad4b4e2a5e$var$_default;

});

parcelRegister("5DXRG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;


var $41bf0830843b5577$var$_react = $41bf0830843b5577$var$_interopRequireWildcard((parcelRequire("aXNcS")));

var $41bf0830843b5577$var$_classnames = $41bf0830843b5577$var$_interopRequireDefault((parcelRequire("3LGzW")));

var $41bf0830843b5577$var$_ssrIcon = $41bf0830843b5577$var$_interopRequireDefault((parcelRequire("cq75f")));

var $41bf0830843b5577$var$_button = $41bf0830843b5577$var$_interopRequireDefault((parcelRequire("7f6T6")));

var $41bf0830843b5577$var$_magnifyingGlass = $41bf0830843b5577$var$_interopRequireDefault((parcelRequire("2W44H")));

var $41bf0830843b5577$var$_crossSmall = $41bf0830843b5577$var$_interopRequireDefault((parcelRequire("cLbVg")));

var $41bf0830843b5577$var$_chevronDownSmall = $41bf0830843b5577$var$_interopRequireDefault((parcelRequire("jRd3E")));
function $41bf0830843b5577$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $41bf0830843b5577$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($41bf0830843b5577$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $41bf0830843b5577$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $41bf0830843b5577$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $41bf0830843b5577$var$_extends() {
    $41bf0830843b5577$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $41bf0830843b5577$var$_extends.apply(this, arguments);
}
const $41bf0830843b5577$var$Search = (0, $41bf0830843b5577$var$_react.forwardRef)((props, ref)=>{
    const { actions: actions, ariaLabel: ariaLabel, className: className, clearBtnText: clearBtnText, submitBtnText: submitBtnText, describedById: describedById, disabled: disabled, id: id, onSearch: onSearch, onClear: onClear, onChange: onChange, onFocus: onFocus, onBlur: onBlur, onKeyUp: onKeyUp, prefix: prefix = '', placeholder: placeholder = 'Search', scope: scope, scopeSelectProps: scopeSelectProps, ...other } = props;
    const { defaultValue: defaultValue, value: value } = other;
    const [isActive, setIsActive] = (0, $41bf0830843b5577$var$_react.useState)(false);
    const [isFilled, setIsFilled] = (0, $41bf0830843b5577$var$_react.useState)(Boolean(defaultValue || value));
    const inputRef = ref || (0, $41bf0830843b5577$var$_react.useRef)(null);
    const selectRef = (0, $41bf0830843b5577$var$_react.useRef)(null);
    const getState = ()=>({
            scope: selectRef.current && selectRef.current.value,
            value: inputRef.current.value
        });
    const handleFocus = (e)=>{
        setIsActive(true);
        if (onFocus) onFocus(e);
    };
    const handleBlur = (e)=>{
        setIsActive(false);
        if (onBlur) onBlur(e);
    };
    const handleValueChange = (e)=>{
        setIsFilled(Boolean(e.target.value.length));
        if (onChange) onChange(e, getState());
    };
    const handleClearValue = (e)=>{
        inputRef.current.value = '';
        inputRef.current.focus();
        setIsFilled(false);
        if (onClear) onClear(e);
    };
    const handleSearch = (e)=>{
        if (onSearch) onSearch(e, getState());
    };
    const handleKeyUp = (e)=>{
        if (onKeyUp) onKeyUp(e, getState());
        else if (e.key === 'Enter') handleSearch(e);
    };
    const baseClass = `${prefix}search`;
    const searchClasses = (0, $41bf0830843b5577$var$_classnames.default)(`${baseClass}`, isActive && `${baseClass}--active`, isFilled && `${baseClass}--filled`, disabled && `${baseClass}--disabled`, className);
    return $41bf0830843b5577$var$_react.default.createElement("div", {
        className: searchClasses
    }, $41bf0830843b5577$var$_react.default.createElement("label", {
        htmlFor: id,
        className: `${baseClass}__icon`
    }, $41bf0830843b5577$var$_react.default.createElement($41bf0830843b5577$var$_ssrIcon.default, {
        prefix: prefix,
        paths: $41bf0830843b5577$var$_magnifyingGlass.default
    })), $41bf0830843b5577$var$_react.default.createElement("div", {
        className: `${baseClass}__input-wrapper`
    }, $41bf0830843b5577$var$_react.default.createElement("input", $41bf0830843b5577$var$_extends({
        id: id,
        ref: inputRef,
        type: "search",
        className: `${baseClass}__input`,
        disabled: disabled,
        onChange: handleValueChange,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onKeyUp: handleKeyUp,
        placeholder: placeholder,
        "aria-disabled": disabled,
        "aria-describedby": describedById,
        "aria-label": ariaLabel
    }, other)), isFilled && $41bf0830843b5577$var$_react.default.createElement($41bf0830843b5577$var$_button.default, {
        className: `${baseClass}__action ${baseClass}__clear`,
        prefix: prefix,
        type: "tertiary",
        small: true,
        iconOnly: true,
        ssrIcon: $41bf0830843b5577$var$_crossSmall.default,
        text: clearBtnText,
        onClick: handleClearValue
    })), !isFilled && actions && actions.length > 0 && $41bf0830843b5577$var$_react.default.createElement("div", {
        className: `${baseClass}__action-wrapper`
    }, actions.map((action, index)=>$41bf0830843b5577$var$_react.default.createElement($41bf0830843b5577$var$_button.default, {
            key: index,
            type: "tertiary",
            text: action.text,
            className: `${baseClass}__action`,
            small: true,
            iconOnly: true,
            prefix: prefix,
            ssrIcon: action.ssrIcon,
            onClick: action.onClick,
            disabled: action.disabled
        }))), scope && $41bf0830843b5577$var$_react.default.createElement("div", {
        className: `${baseClass}__scope-wrapper`
    }, $41bf0830843b5577$var$_react.default.createElement("span", {
        className: `${baseClass}__divider`,
        "aria-hidden": "true"
    }), $41bf0830843b5577$var$_react.default.createElement("select", $41bf0830843b5577$var$_extends({
        ref: selectRef,
        className: `${baseClass}__scope`
    }, scopeSelectProps), Object.keys(scope).map((scopeKey, index)=>$41bf0830843b5577$var$_react.default.createElement("option", {
            key: `${scopeKey}--${index}`,
            value: scope[scopeKey]
        }, scopeKey))), $41bf0830843b5577$var$_react.default.createElement($41bf0830843b5577$var$_ssrIcon.default, {
        className: `${baseClass}__chevron-down`,
        prefix: prefix,
        paths: $41bf0830843b5577$var$_chevronDownSmall.default
    })), isFilled && $41bf0830843b5577$var$_react.default.createElement("div", {
        className: `${baseClass}__action-wrapper`
    }, $41bf0830843b5577$var$_react.default.createElement("span", {
        className: `${baseClass}__divider`,
        "aria-hidden": "true"
    }), $41bf0830843b5577$var$_react.default.createElement($41bf0830843b5577$var$_button.default, {
        prefix: prefix,
        htmlType: "submit",
        type: "tertiary",
        className: `${baseClass}__action`,
        small: true,
        iconOnly: true,
        ssrIcon: $41bf0830843b5577$var$_magnifyingGlass.default,
        text: submitBtnText,
        onClick: handleSearch
    })));
});
$41bf0830843b5577$var$Search.displayName = 'Search';
var $41bf0830843b5577$var$_default = $41bf0830843b5577$var$Search;
module.exports.default = $41bf0830843b5577$var$_default;

});
parcelRegister("cq75f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90ad6862f5fb75b4$var$_SSRIcon = $90ad6862f5fb75b4$var$_interopRequireDefault((parcelRequire("5Pc8e")));
function $90ad6862f5fb75b4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $90ad6862f5fb75b4$var$_default = $90ad6862f5fb75b4$var$_SSRIcon.default;
module.exports.default = $90ad6862f5fb75b4$var$_default;

});
parcelRegister("5Pc8e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $43db2043d85ba0b7$var$_react = $43db2043d85ba0b7$var$_interopRequireDefault((parcelRequire("aXNcS")));


var $43db2043d85ba0b7$var$_classnames = $43db2043d85ba0b7$var$_interopRequireDefault((parcelRequire("3LGzW")));
function $43db2043d85ba0b7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $43db2043d85ba0b7$var$_extends() {
    $43db2043d85ba0b7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $43db2043d85ba0b7$var$_extends.apply(this, arguments);
}
const $43db2043d85ba0b7$var$SSRIcon = (props)=>{
    const { prefix: prefix = '', viewBox: viewBox = '0 0 24 24', paths: paths, className: className, modifier: modifier, ariaHidden: ariaHidden = true, ...otherProps } = props;
    const cssStyles = (0, $43db2043d85ba0b7$var$_classnames.default)(`${prefix}svg-icon`, className, modifier && `${prefix}svg-icon--${modifier}`);
    return paths ? $43db2043d85ba0b7$var$_react.default.createElement("svg", $43db2043d85ba0b7$var$_extends({
        focusable: "false",
        viewBox: viewBox,
        width: '24',
        height: '24'
    }, otherProps, {
        className: cssStyles,
        "aria-hidden": ariaHidden
    }), paths().map((path, id)=>{
        return $43db2043d85ba0b7$var$_react.default.cloneElement(path, {
            key: id
        });
    })) : null;
};
var $43db2043d85ba0b7$var$_default = $43db2043d85ba0b7$var$SSRIcon;
module.exports.default = $43db2043d85ba0b7$var$_default;

});


parcelRegister("7f6T6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $545f46e48caaee53$var$_Button = $545f46e48caaee53$var$_interopRequireDefault((parcelRequire("21Kxs")));
function $545f46e48caaee53$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $545f46e48caaee53$var$_default = $545f46e48caaee53$var$_Button.default;
module.exports.default = $545f46e48caaee53$var$_default;

});
parcelRegister("21Kxs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ldsZ1 = parcelRequire("ldsZ1");

var $179fc65b2351d783$var$_react = $179fc65b2351d783$var$_interopRequireWildcard((parcelRequire("aXNcS")));

var $179fc65b2351d783$var$_ssrIcon = $179fc65b2351d783$var$_interopRequireDefault((parcelRequire("cq75f")));

var $179fc65b2351d783$var$_classnames = $179fc65b2351d783$var$_interopRequireDefault((parcelRequire("3LGzW")));

var $179fc65b2351d783$var$_warningTriangle = $179fc65b2351d783$var$_interopRequireDefault((parcelRequire("jleup")));
function $179fc65b2351d783$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $179fc65b2351d783$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($179fc65b2351d783$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $179fc65b2351d783$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $179fc65b2351d783$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $179fc65b2351d783$var$_extends() {
    $179fc65b2351d783$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $179fc65b2351d783$var$_extends.apply(this, arguments);
}
const $179fc65b2351d783$var$inverseTypes = [
    'primary',
    'emphasised',
    'secondary',
    'tertiary'
];
const $179fc65b2351d783$var$propTypes = {
    children: (0, $ldsZ1.oneOfType)([
        (0, $ldsZ1.arrayOf)($ldsZ1.node),
        $ldsZ1.node
    ]),
    className: $ldsZ1.string,
    disabled: $ldsZ1.bool,
    expanding: $ldsZ1.bool,
    fluid: $ldsZ1.bool,
    href: $ldsZ1.string,
    htmlType: $ldsZ1.string,
    iconOnly: $ldsZ1.bool,
    iconPosition: (0, $ldsZ1.oneOf)([
        'leading',
        'trailing'
    ]),
    inverseTheme: (props, propName, componentName)=>{
        if ($179fc65b2351d783$var$inverseTypes.indexOf(props.type) === -1 && props.inverseTheme) return new Error(`The property: \'inverseTheme\' provided to Button is not applicable to the Button of the type \'${props.type}\'. Please remove it or set it to false`);
        return (0, $ldsZ1.checkPropTypes)({
            inverseTheme: $ldsZ1.bool
        }, props, 'prop', componentName);
    },
    loading: $ldsZ1.bool,
    loadingSrText: (0, $ldsZ1.oneOfType)([
        $ldsZ1.string,
        $ldsZ1.element
    ]),
    newWindow: $ldsZ1.bool,
    onClick: $ldsZ1.func,
    prefix: $ldsZ1.string,
    small: $ldsZ1.bool,
    ssrIcon: $ldsZ1.func,
    text: (0, $ldsZ1.oneOfType)([
        $ldsZ1.string,
        $ldsZ1.element
    ]),
    type: (0, $ldsZ1.oneOf)([
        'primary',
        'emphasised',
        'secondary',
        'tertiary',
        'danger',
        'plain',
        'image-overlay'
    ]),
    xsmallIconOnly: $ldsZ1.bool,
    expandedOnTouchDevice: $ldsZ1.bool
};
const $179fc65b2351d783$var$Button = (0, $179fc65b2351d783$var$_react.forwardRef)((props, ref)=>{
    const { small: small, xsmallIconOnly: xsmallIconOnly, href: href, newWindow: newWindow, loadingSrText: loadingSrText = "Loading\u2026", ssrIcon: ssrIcon, iconOnly: iconOnly = false, prefix: prefix = '', htmlType: htmlType = 'button', disabled: disabled = false, className: className, onClick: onClick, text: text, type: type = 'secondary', expanding: expanding, loading: loading, iconPosition: iconPosition = 'leading', fluid: fluid, inverseTheme: inverseTheme, children: children, expandedOnTouchDevice: expandedOnTouchDevice, ...others } = props;
    function onKeyUpHandler(e) {
        if (disabled || loading || e.key !== ' ') return true;
        e.target.click();
    }
    let btnType = type ? type : 'secondary';
    if (iconOnly && ssrIcon) btnType = `icon-${btnType}`;
    if (inverseTheme && $179fc65b2351d783$var$inverseTypes.indexOf(type) > -1) btnType = `${btnType}-inverse`;
    const innerClasses = (0, $179fc65b2351d783$var$_classnames.default)(`${prefix}btn__inner`);
    let iconTag;
    const iconClass = `${prefix}btn__icon`;
    const icon = type === 'danger' ? $179fc65b2351d783$var$_warningTriangle.default : ssrIcon;
    if (icon) iconTag = $179fc65b2351d783$var$_react.default.createElement($179fc65b2351d783$var$_ssrIcon.default, {
        className: iconClass,
        prefix: prefix,
        paths: icon
    });
    const classes = (0, $179fc65b2351d783$var$_classnames.default)(`${prefix}btn`, loading && `${prefix}btn--loading`, small && `${prefix}btn--small`, iconOnly && xsmallIconOnly && `${prefix}btn--xsmall`, !iconOnly && icon && iconPosition && `${prefix}${iconPosition}-icon`, type && `${prefix}btn--${btnType}`, fluid && !iconOnly && `${prefix}btn--fluid`, expanding && `${prefix}btn--expanding`, expanding && expandedOnTouchDevice && `${prefix}btn--touch-device-expanded`, className);
    const handleClick = (ev)=>{
        if (loading || disabled) {
            ev.stopPropagation();
            return;
        }
        if (onClick && typeof onClick === 'function') onClick(ev);
    };
    const ButtonTag = href ? 'a' : 'button';
    const onKeyUp = ButtonTag === 'a' ? onKeyUpHandler : null;
    const role = href ? 'button' : null;
    const linkProps = {
        ...!disabled && {
            href: href
        },
        ...newWindow && {
            target: '_blank'
        }
    };
    const button = $179fc65b2351d783$var$_react.default.createElement(ButtonTag, $179fc65b2351d783$var$_extends({
        ref: ref,
        "aria-disabled": loading,
        type: !href ? htmlType : null,
        role: role,
        disabled: href ? null : disabled,
        className: classes,
        onClick: handleClick,
        onKeyUp: onKeyUp
    }, linkProps, others), $179fc65b2351d783$var$_react.default.createElement("span", {
        className: innerClasses
    }, iconTag, text && $179fc65b2351d783$var$_react.default.createElement("span", {
        className: `${prefix}btn__label`
    }, text), !loading && children, loading && $179fc65b2351d783$var$_react.default.createElement("span", {
        className: `${prefix}btn__loader`
    }, loadingSrText)));
    return button;
});
$179fc65b2351d783$var$Button.propTypes = $179fc65b2351d783$var$propTypes;
$179fc65b2351d783$var$Button.displayName = 'Button';
var $179fc65b2351d783$var$_default = $179fc65b2351d783$var$Button;
module.exports.default = $179fc65b2351d783$var$_default;

});
parcelRegister("jleup", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e14b37c541c3556c$var$_react = $e14b37c541c3556c$var$_interopRequireDefault((parcelRequire("aXNcS")));
function $e14b37c541c3556c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e14b37c541c3556c$var$_default = function _default() {
    let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return [
        $e14b37c541c3556c$var$_react.default.createElement("path", {
            d: "M11.0036 14.1337h2v-6h-2v6zm1 1.5c-.6904 0-1.25.5597-1.25 1.25 0 .6904.5596 1.25 1.25 1.25.6903 0 1.25-.5596 1.25-1.25 0-.6903-.5597-1.25-1.25-1.25z"
        }),
        $e14b37c541c3556c$var$_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "m1.1152 20.418 10-19h1.7699l10 19-.8849 1.4657h-20l-.885-1.4657zm2.5413-.5343h16.6873L12.0002 4.0308 3.6565 19.8837z"
        })
    ];
};
module.exports.default = $e14b37c541c3556c$var$_default;

});



parcelRegister("2W44H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $223428b5b7b6242d$var$_react = $223428b5b7b6242d$var$_interopRequireDefault((parcelRequire("aXNcS")));
function $223428b5b7b6242d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $223428b5b7b6242d$var$_default = function _default() {
    let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return [
        $223428b5b7b6242d$var$_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.9804 15.3946c-1.0361.7502-2.3099 1.1925-3.6869 1.1925C6.8177 16.5871 4 13.7694 4 10.2935 4 6.8177 6.8177 4 10.2935 4c3.4759 0 6.2936 2.8177 6.2936 6.2935 0 1.377-.4423 2.6508-1.1925 3.6869l4.6016 4.6016-1.4142 1.4142-4.6016-4.6016zm.6067-5.1011c0 2.3713-1.9223 4.2936-4.2936 4.2936C7.9223 14.5871 6 12.6648 6 10.2935 6 7.9223 7.9223 6 10.2935 6c2.3713 0 4.2936 1.9223 4.2936 4.2935z"
        })
    ];
};
module.exports.default = $223428b5b7b6242d$var$_default;

});

parcelRegister("cLbVg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $94a31f6a3b56d509$var$_react = $94a31f6a3b56d509$var$_interopRequireDefault((parcelRequire("aXNcS")));
function $94a31f6a3b56d509$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $94a31f6a3b56d509$var$_default = function _default() {
    let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return [
        $94a31f6a3b56d509$var$_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "m12.0006 13.4148 2.8283 2.8283 1.4142-1.4142-2.8283-2.8283 2.8283-2.8283-1.4142-1.4142-2.8283 2.8283L9.172 7.7578 7.7578 9.172l2.8286 2.8286-2.8286 2.8285 1.4142 1.4143 2.8286-2.8286z"
        })
    ];
};
module.exports.default = $94a31f6a3b56d509$var$_default;

});

parcelRegister("jRd3E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e74d18922fa078c3$var$_react = $e74d18922fa078c3$var$_interopRequireDefault((parcelRequire("aXNcS")));
function $e74d18922fa078c3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e74d18922fa078c3$var$_default = function _default() {
    let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return [
        $e74d18922fa078c3$var$_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "m12.0003 15.5996-5.7857-5.785 1.414-1.4143 4.3717 4.3711 4.3717-4.3711 1.4141 1.4143-5.7858 5.785z"
        })
    ];
};
module.exports.default = $e74d18922fa078c3$var$_default;

});


parcelRegister("7HtFQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;


var $59b39130a4f55bbb$var$_react = $59b39130a4f55bbb$var$_interopRequireWildcard((parcelRequire("aXNcS")));

var $59b39130a4f55bbb$var$_classnames = $59b39130a4f55bbb$var$_interopRequireDefault((parcelRequire("3LGzW")));

var $59b39130a4f55bbb$var$_ssrIcon = $59b39130a4f55bbb$var$_interopRequireDefault((parcelRequire("gnvpa")));

var $59b39130a4f55bbb$var$_button = $59b39130a4f55bbb$var$_interopRequireDefault((parcelRequire("xCXDz")));

var $59b39130a4f55bbb$var$_hyperlink = $59b39130a4f55bbb$var$_interopRequireDefault((parcelRequire("eIhEO")));

var $59b39130a4f55bbb$var$_crossSmall = $59b39130a4f55bbb$var$_interopRequireDefault((parcelRequire("3sbeC")));

var $59b39130a4f55bbb$var$_incorrect = $59b39130a4f55bbb$var$_interopRequireDefault((parcelRequire("5dQ0G")));

var $59b39130a4f55bbb$var$_warningTriangle = $59b39130a4f55bbb$var$_interopRequireDefault((parcelRequire("gdk0S")));

var $59b39130a4f55bbb$var$_checkmarkCircle = $59b39130a4f55bbb$var$_interopRequireDefault((parcelRequire("lzSAL")));

var $59b39130a4f55bbb$var$_informationCircle = $59b39130a4f55bbb$var$_interopRequireDefault((parcelRequire("6P88a")));
function $59b39130a4f55bbb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $59b39130a4f55bbb$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($59b39130a4f55bbb$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $59b39130a4f55bbb$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $59b39130a4f55bbb$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $59b39130a4f55bbb$var$_extends() {
    $59b39130a4f55bbb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $59b39130a4f55bbb$var$_extends.apply(this, arguments);
}
const $59b39130a4f55bbb$var$icons = {
    informative: $59b39130a4f55bbb$var$_informationCircle.default,
    positive: $59b39130a4f55bbb$var$_checkmarkCircle.default,
    cautionary: $59b39130a4f55bbb$var$_warningTriangle.default,
    negative: $59b39130a4f55bbb$var$_incorrect.default
};
const $59b39130a4f55bbb$var$InlineMessage = (_ref)=>{
    let { className: className, headingLevel: headingLevel, actions: actions, prefix: prefix, link: link, newWindow: newWindow, linkLabel: linkLabel, body: body, ssrIcon: ssrIcon, title: title, labelCloseButton: labelCloseButton, subtle: subtle, variant: variant, dismissable: dismissable, onDismissClick: onDismissClick, collapseWhenClosed: collapseWhenClosed, ...other } = _ref;
    const wrapperRef = (0, $59b39130a4f55bbb$var$_react.useRef)(null);
    const isInformative = variant === 'informative';
    const hideIcon = isInformative && !ssrIcon;
    const [isMessageClosed, setMessageClose] = (0, $59b39130a4f55bbb$var$_react.useState)(false);
    const [wrapperHeight, setWrapperHeight] = (0, $59b39130a4f55bbb$var$_react.useState)(null);
    const [collapsed, setCollapsed] = (0, $59b39130a4f55bbb$var$_react.useState)(false);
    const closeClick = ()=>{
        requestAnimationFrame(function() {
            setWrapperHeight(wrapperRef.current.scrollHeight);
            requestAnimationFrame(function() {
                setWrapperHeight(0);
            });
        });
        setMessageClose(true);
    };
    const handleTransitionEnd = (e)=>{
        if (e.propertyName !== 'height') return;
        setCollapsed(true);
        if (onDismissClick) onDismissClick(e);
    };
    const baseClass = `${prefix}inline-message`;
    const classes = (0, $59b39130a4f55bbb$var$_classnames.default)(baseClass, `${baseClass}--${variant}`, isMessageClosed && `${baseClass}--closed`, hideIcon && `${baseClass}--icon-hidden`, subtle && `${baseClass}--subtle`, collapseWhenClosed && collapsed && `${baseClass}--collapsed`, dismissable && `${baseClass}--dismissable`, className);
    const HeadingTag = `h${headingLevel}`;
    return $59b39130a4f55bbb$var$_react.default.createElement("div", $59b39130a4f55bbb$var$_extends({
        "aria-hidden": isMessageClosed ? 'true' : 'false',
        className: classes,
        ref: wrapperRef,
        style: {
            height: wrapperHeight
        },
        onTransitionEnd: handleTransitionEnd
    }, other), !hideIcon && $59b39130a4f55bbb$var$_react.default.createElement($59b39130a4f55bbb$var$_ssrIcon.default, {
        className: `${baseClass}__icon`,
        paths: ssrIcon ? ssrIcon : $59b39130a4f55bbb$var$icons[variant],
        prefix: prefix
    }), $59b39130a4f55bbb$var$_react.default.createElement("div", {
        className: `${baseClass}__content`
    }, title && !subtle && $59b39130a4f55bbb$var$_react.default.createElement(HeadingTag, {
        className: `${baseClass}__title`
    }, title), $59b39130a4f55bbb$var$_react.default.createElement("p", {
        className: `${baseClass}__body`
    }, body, ' ', linkLabel && $59b39130a4f55bbb$var$_react.default.createElement($59b39130a4f55bbb$var$_hyperlink.default, {
        prefix: prefix,
        url: link,
        text: linkLabel,
        newWindow: newWindow
    })), !subtle && actions && $59b39130a4f55bbb$var$_react.default.createElement("div", {
        className: `${baseClass}__actions`
    }, actions.map((action, i)=>{
        return $59b39130a4f55bbb$var$_react.default.createElement($59b39130a4f55bbb$var$_button.default, $59b39130a4f55bbb$var$_extends({}, action, {
            type: "tertiary",
            small: true,
            key: i,
            prefix: prefix
        }));
    }))), dismissable && $59b39130a4f55bbb$var$_react.default.createElement($59b39130a4f55bbb$var$_button.default, {
        prefix: prefix,
        type: "tertiary",
        small: true,
        xsmallIconOnly: true,
        iconOnly: true,
        ssrIcon: $59b39130a4f55bbb$var$_crossSmall.default,
        onClick: closeClick,
        className: `${baseClass}__close-button`,
        text: labelCloseButton
    }));
};
$59b39130a4f55bbb$var$InlineMessage.defaultProps = {
    prefix: '',
    headingLevel: '6',
    variant: 'informative'
};
var $59b39130a4f55bbb$var$_default = $59b39130a4f55bbb$var$InlineMessage;
module.exports.default = $59b39130a4f55bbb$var$_default;

});
parcelRegister("gnvpa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bec727b37cf3169e$var$_SSRIcon = $bec727b37cf3169e$var$_interopRequireDefault((parcelRequire("bd5W2")));
function $bec727b37cf3169e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $bec727b37cf3169e$var$_default = $bec727b37cf3169e$var$_SSRIcon.default;
module.exports.default = $bec727b37cf3169e$var$_default;

});
parcelRegister("bd5W2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8295832b91059d93$var$_react = $8295832b91059d93$var$_interopRequireDefault((parcelRequire("aXNcS")));


var $8295832b91059d93$var$_classnames = $8295832b91059d93$var$_interopRequireDefault((parcelRequire("3LGzW")));
function $8295832b91059d93$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8295832b91059d93$var$_extends() {
    $8295832b91059d93$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8295832b91059d93$var$_extends.apply(this, arguments);
}
const $8295832b91059d93$var$SSRIcon = (props)=>{
    const { prefix: prefix = '', viewBox: viewBox = '0 0 24 24', paths: paths, className: className, modifier: modifier, ariaHidden: ariaHidden = true, ...otherProps } = props;
    const cssStyles = (0, $8295832b91059d93$var$_classnames.default)(`${prefix}svg-icon`, className, modifier && `${prefix}svg-icon--${modifier}`);
    return paths ? $8295832b91059d93$var$_react.default.createElement("svg", $8295832b91059d93$var$_extends({
        focusable: "false",
        viewBox: viewBox,
        width: '24',
        height: '24'
    }, otherProps, {
        className: cssStyles,
        "aria-hidden": ariaHidden
    }), paths().map((path, id)=>{
        return $8295832b91059d93$var$_react.default.cloneElement(path, {
            key: id
        });
    })) : null;
};
var $8295832b91059d93$var$_default = $8295832b91059d93$var$SSRIcon;
module.exports.default = $8295832b91059d93$var$_default;

});


parcelRegister("xCXDz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $06514e00f710b024$var$_Button = $06514e00f710b024$var$_interopRequireDefault((parcelRequire("hwLAf")));
function $06514e00f710b024$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $06514e00f710b024$var$_default = $06514e00f710b024$var$_Button.default;
module.exports.default = $06514e00f710b024$var$_default;

});
parcelRegister("hwLAf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ldsZ1 = parcelRequire("ldsZ1");

var $cc2a55f04c1e193f$var$_react = $cc2a55f04c1e193f$var$_interopRequireWildcard((parcelRequire("aXNcS")));

var $cc2a55f04c1e193f$var$_ssrIcon = $cc2a55f04c1e193f$var$_interopRequireDefault((parcelRequire("gnvpa")));

var $cc2a55f04c1e193f$var$_classnames = $cc2a55f04c1e193f$var$_interopRequireDefault((parcelRequire("3LGzW")));

var $cc2a55f04c1e193f$var$_warningTriangle = $cc2a55f04c1e193f$var$_interopRequireDefault((parcelRequire("gdk0S")));
function $cc2a55f04c1e193f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cc2a55f04c1e193f$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($cc2a55f04c1e193f$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $cc2a55f04c1e193f$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $cc2a55f04c1e193f$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $cc2a55f04c1e193f$var$_extends() {
    $cc2a55f04c1e193f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cc2a55f04c1e193f$var$_extends.apply(this, arguments);
}
const $cc2a55f04c1e193f$var$inverseTypes = [
    'primary',
    'emphasised',
    'secondary',
    'tertiary'
];
const $cc2a55f04c1e193f$var$propTypes = {
    children: (0, $ldsZ1.oneOfType)([
        (0, $ldsZ1.arrayOf)($ldsZ1.node),
        $ldsZ1.node
    ]),
    className: $ldsZ1.string,
    disabled: $ldsZ1.bool,
    expanding: $ldsZ1.bool,
    fluid: $ldsZ1.bool,
    href: $ldsZ1.string,
    htmlType: $ldsZ1.string,
    iconOnly: $ldsZ1.bool,
    iconPosition: (0, $ldsZ1.oneOf)([
        'leading',
        'trailing'
    ]),
    inverseTheme: (props, propName, componentName)=>{
        if ($cc2a55f04c1e193f$var$inverseTypes.indexOf(props.type) === -1 && props.inverseTheme) return new Error(`The property: \'inverseTheme\' provided to Button is not applicable to the Button of the type \'${props.type}\'. Please remove it or set it to false`);
        return (0, $ldsZ1.checkPropTypes)({
            inverseTheme: $ldsZ1.bool
        }, props, 'prop', componentName);
    },
    loading: $ldsZ1.bool,
    loadingSrText: (0, $ldsZ1.oneOfType)([
        $ldsZ1.string,
        $ldsZ1.element
    ]),
    newWindow: $ldsZ1.bool,
    onClick: $ldsZ1.func,
    prefix: $ldsZ1.string,
    small: $ldsZ1.bool,
    ssrIcon: $ldsZ1.func,
    text: (0, $ldsZ1.oneOfType)([
        $ldsZ1.string,
        $ldsZ1.element
    ]),
    type: (0, $ldsZ1.oneOf)([
        'primary',
        'emphasised',
        'secondary',
        'tertiary',
        'danger',
        'plain',
        'image-overlay'
    ]),
    xsmallIconOnly: $ldsZ1.bool,
    expandedOnTouchDevice: $ldsZ1.bool
};
const $cc2a55f04c1e193f$var$Button = (0, $cc2a55f04c1e193f$var$_react.forwardRef)((props, ref)=>{
    const { small: small, xsmallIconOnly: xsmallIconOnly, href: href, newWindow: newWindow, loadingSrText: loadingSrText = "Loading\u2026", ssrIcon: ssrIcon, iconOnly: iconOnly = false, prefix: prefix = '', htmlType: htmlType = 'button', disabled: disabled = false, className: className, onClick: onClick, text: text, type: type = 'secondary', expanding: expanding, loading: loading, iconPosition: iconPosition = 'leading', fluid: fluid, inverseTheme: inverseTheme, children: children, expandedOnTouchDevice: expandedOnTouchDevice, ...others } = props;
    function onKeyUpHandler(e) {
        if (disabled || loading || e.key !== ' ') return true;
        e.target.click();
    }
    let btnType = type ? type : 'secondary';
    if (iconOnly && ssrIcon) btnType = `icon-${btnType}`;
    if (inverseTheme && $cc2a55f04c1e193f$var$inverseTypes.indexOf(type) > -1) btnType = `${btnType}-inverse`;
    const innerClasses = (0, $cc2a55f04c1e193f$var$_classnames.default)(`${prefix}btn__inner`);
    let iconTag;
    const iconClass = `${prefix}btn__icon`;
    const icon = type === 'danger' ? $cc2a55f04c1e193f$var$_warningTriangle.default : ssrIcon;
    if (icon) iconTag = $cc2a55f04c1e193f$var$_react.default.createElement($cc2a55f04c1e193f$var$_ssrIcon.default, {
        className: iconClass,
        prefix: prefix,
        paths: icon
    });
    const classes = (0, $cc2a55f04c1e193f$var$_classnames.default)(`${prefix}btn`, loading && `${prefix}btn--loading`, small && `${prefix}btn--small`, iconOnly && xsmallIconOnly && `${prefix}btn--xsmall`, !iconOnly && icon && iconPosition && `${prefix}${iconPosition}-icon`, type && `${prefix}btn--${btnType}`, fluid && !iconOnly && `${prefix}btn--fluid`, expanding && `${prefix}btn--expanding`, expanding && expandedOnTouchDevice && `${prefix}btn--touch-device-expanded`, className);
    const handleClick = (ev)=>{
        if (loading || disabled) {
            ev.stopPropagation();
            return;
        }
        if (onClick && typeof onClick === 'function') onClick(ev);
    };
    const ButtonTag = href ? 'a' : 'button';
    const onKeyUp = ButtonTag === 'a' ? onKeyUpHandler : null;
    const role = href ? 'button' : null;
    const linkProps = {
        ...!disabled && {
            href: href
        },
        ...newWindow && {
            target: '_blank'
        }
    };
    const button = $cc2a55f04c1e193f$var$_react.default.createElement(ButtonTag, $cc2a55f04c1e193f$var$_extends({
        ref: ref,
        "aria-disabled": loading,
        type: !href ? htmlType : null,
        role: role,
        disabled: href ? null : disabled,
        className: classes,
        onClick: handleClick,
        onKeyUp: onKeyUp
    }, linkProps, others), $cc2a55f04c1e193f$var$_react.default.createElement("span", {
        className: innerClasses
    }, iconTag, text && $cc2a55f04c1e193f$var$_react.default.createElement("span", {
        className: `${prefix}btn__label`
    }, text), !loading && children, loading && $cc2a55f04c1e193f$var$_react.default.createElement("span", {
        className: `${prefix}btn__loader`
    }, loadingSrText)));
    return button;
});
$cc2a55f04c1e193f$var$Button.propTypes = $cc2a55f04c1e193f$var$propTypes;
$cc2a55f04c1e193f$var$Button.displayName = 'Button';
var $cc2a55f04c1e193f$var$_default = $cc2a55f04c1e193f$var$Button;
module.exports.default = $cc2a55f04c1e193f$var$_default;

});
parcelRegister("gdk0S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bcdd6268e2cd1c62$var$_react = $bcdd6268e2cd1c62$var$_interopRequireDefault((parcelRequire("aXNcS")));
function $bcdd6268e2cd1c62$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $bcdd6268e2cd1c62$var$_default = function _default() {
    let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return [
        $bcdd6268e2cd1c62$var$_react.default.createElement("path", {
            d: "M11.0036 14.1337h2v-6h-2v6zm1 1.5c-.6904 0-1.25.5597-1.25 1.25 0 .6904.5596 1.25 1.25 1.25.6903 0 1.25-.5596 1.25-1.25 0-.6903-.5597-1.25-1.25-1.25z"
        }),
        $bcdd6268e2cd1c62$var$_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "m1.1152 20.418 10-19h1.7699l10 19-.8849 1.4657h-20l-.885-1.4657zm2.5413-.5343h16.6873L12.0002 4.0308 3.6565 19.8837z"
        })
    ];
};
module.exports.default = $bcdd6268e2cd1c62$var$_default;

});



parcelRegister("eIhEO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab62df1785067701$var$_Hyperlink = $ab62df1785067701$var$_interopRequireDefault((parcelRequire("6QsA1")));
function $ab62df1785067701$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ab62df1785067701$var$_default = $ab62df1785067701$var$_Hyperlink.default;
module.exports.default = $ab62df1785067701$var$_default;

});
parcelRegister("6QsA1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4fbdc4d289a6290e$var$_react = $4fbdc4d289a6290e$var$_interopRequireWildcard((parcelRequire("aXNcS")));


var $4fbdc4d289a6290e$var$_classnames = $4fbdc4d289a6290e$var$_interopRequireDefault((parcelRequire("3LGzW")));
function $4fbdc4d289a6290e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4fbdc4d289a6290e$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($4fbdc4d289a6290e$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $4fbdc4d289a6290e$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $4fbdc4d289a6290e$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $4fbdc4d289a6290e$var$_extends() {
    $4fbdc4d289a6290e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4fbdc4d289a6290e$var$_extends.apply(this, arguments);
}
const $4fbdc4d289a6290e$var$Hyperlink = (0, $4fbdc4d289a6290e$var$_react.forwardRef)((props, ref)=>{
    const { prefix: prefix, children: children, text: text, url: url, subtle: subtle, disabled: disabled, button: button, colour: colour, className: className, onClick: onClick, newWindow: newWindow, ariaControls: ariaControls, ...otherProps } = props;
    function preventClick(e) {
        e.preventDefault();
    }
    const cssStyles = (0, $4fbdc4d289a6290e$var$_classnames.default)(className, `${prefix}link`, colour && `${prefix}link--${colour}`, subtle && `${prefix}link--subtle`, disabled && `${prefix}link--disabled`);
    let role = button ? 'button' : null;
    role = disabled ? 'link' : role;
    return $4fbdc4d289a6290e$var$_react.default.createElement("a", $4fbdc4d289a6290e$var$_extends({
        ref: ref,
        target: newWindow ? '_blank' : null
    }, otherProps, {
        href: !disabled ? url : null,
        className: cssStyles,
        role: role,
        "aria-disabled": disabled && `${disabled}`,
        "aria-controls": ariaControls ? ariaControls : null,
        onClick: button && disabled ? preventClick : onClick
    }), text && text.length > 0 ? text : '', text && children ? ' ' : null, children);
});
$4fbdc4d289a6290e$var$Hyperlink.defaultProps = {
    disabled: false,
    url: '#',
    button: false,
    newWindow: false,
    prefix: ''
};
$4fbdc4d289a6290e$var$Hyperlink.displayName = 'Hyperlink';
var $4fbdc4d289a6290e$var$_default = $4fbdc4d289a6290e$var$Hyperlink;
module.exports.default = $4fbdc4d289a6290e$var$_default;

});


parcelRegister("3sbeC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $283cb3a01e56fd65$var$_react = $283cb3a01e56fd65$var$_interopRequireDefault((parcelRequire("aXNcS")));
function $283cb3a01e56fd65$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $283cb3a01e56fd65$var$_default = function _default() {
    let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return [
        $283cb3a01e56fd65$var$_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "m12.0006 13.4148 2.8283 2.8283 1.4142-1.4142-2.8283-2.8283 2.8283-2.8283-1.4142-1.4142-2.8283 2.8283L9.172 7.7578 7.7578 9.172l2.8286 2.8286-2.8286 2.8285 1.4142 1.4143 2.8286-2.8286z"
        })
    ];
};
module.exports.default = $283cb3a01e56fd65$var$_default;

});

parcelRegister("5dQ0G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3cd682be18ededed$var$_react = $3cd682be18ededed$var$_interopRequireDefault((parcelRequire("aXNcS")));
function $3cd682be18ededed$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3cd682be18ededed$var$_default = function _default() {
    let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return [
        $3cd682be18ededed$var$_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20 12c0 4.4183-3.5817 8-8 8-1.8487 0-3.551-.6271-4.9056-1.6801L18.3199 7.0944C19.3729 8.449 20 10.1513 20 12zM5.6801 16.9056 16.9056 5.6801C15.551 4.6271 13.8487 4 12 4c-4.4183 0-8 3.5817-8 8 0 1.8487.627 3.551 1.6801 4.9056zM22 12c0 5.5228-4.4772 10-10 10-5.5229 0-10-4.4772-10-10C2 6.4771 6.4771 2 12 2c5.5228 0 10 4.4771 10 10z"
        })
    ];
};
module.exports.default = $3cd682be18ededed$var$_default;

});

parcelRegister("lzSAL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fb5736aa326ebdd2$var$_react = $fb5736aa326ebdd2$var$_interopRequireDefault((parcelRequire("aXNcS")));
function $fb5736aa326ebdd2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $fb5736aa326ebdd2$var$_default = function _default() {
    let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return [
        $fb5736aa326ebdd2$var$_react.default.createElement("path", {
            d: "M18 8.9608 16.5591 7.5l-5.9955 6.0784-3.1227-3.166L6 11.8732 10.5636 16.5 18 8.9608z"
        }),
        $fb5736aa326ebdd2$var$_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22c5.5228 0 10-4.4772 10-10 0-5.5229-4.4772-10-10-10C6.4771 2 2 6.4771 2 12c0 5.5228 4.4771 10 10 10zm0-2c4.4183 0 8-3.5817 8-8s-3.5817-8-8-8-8 3.5817-8 8 3.5817 8 8 8z"
        })
    ];
};
module.exports.default = $fb5736aa326ebdd2$var$_default;

});

parcelRegister("6P88a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f7dd01d89d55bf1$var$_react = $4f7dd01d89d55bf1$var$_interopRequireDefault((parcelRequire("aXNcS")));
function $4f7dd01d89d55bf1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4f7dd01d89d55bf1$var$_default = function _default() {
    let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return [
        $4f7dd01d89d55bf1$var$_react.default.createElement("path", {
            d: "M12 9.5c.6904 0 1.25-.5596 1.25-1.25S12.6904 7 12 7s-1.25.5596-1.25 1.25S11.3096 9.5 12 9.5zM11 11v6h2v-6h-2z"
        }),
        $4f7dd01d89d55bf1$var$_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 2C6.4771 2 2 6.4771 2 12c0 5.5228 4.4771 10 10 10 5.5228 0 10-4.4772 10-10 0-5.5229-4.4772-10-10-10zM4 12c0-4.4183 3.5817-8 8-8s8 3.5817 8 8-3.5817 8-8 8-8-3.5817-8-8z"
        })
    ];
};
module.exports.default = $4f7dd01d89d55bf1$var$_default;

});


parcelRequire("aXNcS");

var $fUX2S = parcelRequire("fUX2S");
var $2ae486c44b6dfbc4$var$o = 0;
function $2ae486c44b6dfbc4$export$34b9dba7ce09269b(_, e, n, t, f) {
    var l, s, u = {};
    for(s in e)"ref" == s ? l = e[s] : u[s] = e[s];
    var a = {
        type: _,
        props: u,
        key: n,
        ref: l,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: --$2ae486c44b6dfbc4$var$o,
        __source: f,
        __self: t
    };
    if ("function" == typeof _ && (l = _.defaultProps)) for(s in l)void 0 === u[s] && (u[s] = l[s]);
    return (0, $fUX2S.options).vnode && (0, $fUX2S.options).vnode(a), a;
}





var $fUX2S = parcelRequire("fUX2S");
parcelRequire("aXNcS");
var $fqaWh = parcelRequire("fqaWh");
var $98dff0c314a1cc5c$exports = {};
'use strict';

$98dff0c314a1cc5c$exports = (parcelRequire("jyjGF"));


parcelRequire("aXNcS");
var $fUX2S = parcelRequire("fUX2S");
var $aXNcS = parcelRequire("aXNcS");
var $fqaWh = parcelRequire("fqaWh");
var $b716006f8003187d$exports = {};
//
$b716006f8003187d$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


function $742f9cd93dcb593f$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ''));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + '{' + k + '}';
                                        break;
                                    case 107:
                                        f = f.replace(fa, '$1 $2');
                                        k = f + '{' + k + '}';
                                        k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ''));
                                }
                                else k = '';
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, '') : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = '';
                                    break;
                                default:
                                    32 !== g && (y = ' ');
                            }
                            break;
                        case 0:
                            y = '\\0';
                            break;
                        case 12:
                            y = '\\f';
                            break;
                        case 11:
                            y = '\\v';
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = '\f' + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += '\r');
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(',') + '{' + p + '}';
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ':-moz-$1') + p;
                        break;
                    case 112:
                        p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? '' : d[0] + ' '; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + ' ', h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, '$1' + d.trim());
            case 58:
                return d.trim() + c.replace(F, '$1' + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ';', m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(':', 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ';';
            return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return '-webkit-' + a + a;
            case 978:
                return '-webkit-' + a + '-moz-' + a + a;
            case 1019:
            case 983:
                return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
                if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
                    case 115:
                        return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
                    case 98:
                        return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
                }
                return '-webkit-' + a + '-ms-' + a + a;
            case 964:
                return '-webkit-' + a + '-ms-flex-' + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf('-') + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, 'tb');
                        break;
                    case 232:
                        b = a.replace(G, 'tb-rl');
                        break;
                    case 220:
                        b = a.replace(G, 'lr');
                        break;
                    default:
                        return a;
                }
                return '-webkit-' + a + '-ms-' + b + a;
            case 1017:
                if (-1 === a.indexOf('sticky', 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, '-webkit-' + b) + ';' + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
                }
                return a + ';';
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
                    case 115:
                        return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
                    default:
                        return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
                break;
            case 962:
                if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ':' : '{'), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ('function' === typeof d) S[A++] = d;
                else if ('object' === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && 'string' === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = '';
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $742f9cd93dcb593f$export$2e2bcd8739ae039 = $742f9cd93dcb593f$var$stylis_min;


var $c0970159dfb921fa$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $c0970159dfb921fa$export$2e2bcd8739ae039 = $c0970159dfb921fa$var$unitlessKeys;


function $da4025cf6cd50b1b$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $da4025cf6cd50b1b$export$2e2bcd8739ae039 = $da4025cf6cd50b1b$var$memoize;


var $7cd1aa6fa0dcf323$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $7cd1aa6fa0dcf323$var$index = (0, $da4025cf6cd50b1b$export$2e2bcd8739ae039)(function(prop) {
    return $7cd1aa6fa0dcf323$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $7cd1aa6fa0dcf323$export$2e2bcd8739ae039 = $7cd1aa6fa0dcf323$var$index;


var $ce431108678812c1$exports = {};
'use strict';
var $4f8995f4c5479190$exports = {};
'use strict';

$4f8995f4c5479190$exports = (parcelRequire("kCZtx"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $ce431108678812c1$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $ce431108678812c1$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $ce431108678812c1$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $ce431108678812c1$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $ce431108678812c1$var$TYPE_STATICS = {};
$ce431108678812c1$var$TYPE_STATICS[$4f8995f4c5479190$exports.ForwardRef] = $ce431108678812c1$var$FORWARD_REF_STATICS;
$ce431108678812c1$var$TYPE_STATICS[$4f8995f4c5479190$exports.Memo] = $ce431108678812c1$var$MEMO_STATICS;
function $ce431108678812c1$var$getStatics(component) {
    // React v16.11 and below
    if ($4f8995f4c5479190$exports.isMemo(component)) return $ce431108678812c1$var$MEMO_STATICS;
     // React v16.12 and above
    return $ce431108678812c1$var$TYPE_STATICS[component['$$typeof']] || $ce431108678812c1$var$REACT_STATICS;
}
var $ce431108678812c1$var$defineProperty = Object.defineProperty;
var $ce431108678812c1$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $ce431108678812c1$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $ce431108678812c1$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $ce431108678812c1$var$getPrototypeOf = Object.getPrototypeOf;
var $ce431108678812c1$var$objectPrototype = Object.prototype;
function $ce431108678812c1$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($ce431108678812c1$var$objectPrototype) {
            var inheritedComponent = $ce431108678812c1$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $ce431108678812c1$var$objectPrototype) $ce431108678812c1$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $ce431108678812c1$var$getOwnPropertyNames(sourceComponent);
        if ($ce431108678812c1$var$getOwnPropertySymbols) keys = keys.concat($ce431108678812c1$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $ce431108678812c1$var$getStatics(targetComponent);
        var sourceStatics = $ce431108678812c1$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$ce431108678812c1$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $ce431108678812c1$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $ce431108678812c1$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$ce431108678812c1$exports = $ce431108678812c1$var$hoistNonReactStatics;


function $a40bd87bc05fc082$var$_extends() {
    $a40bd87bc05fc082$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a40bd87bc05fc082$var$_extends.apply(this, arguments);
}
function $a40bd87bc05fc082$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// 
var $a40bd87bc05fc082$var$interleave = function(strings, interpolations) {
    var result = [
        strings[0]
    ];
    for(var i = 0, len = interpolations.length; i < len; i += 1)result.push(interpolations[i], strings[i + 1]);
    return result;
};
// 
var $a40bd87bc05fc082$var$isPlainObject = function(x) {
    return x !== null && typeof x === 'object' && (x.toString ? x.toString() : Object.prototype.toString.call(x)) === '[object Object]' && !(0, $98dff0c314a1cc5c$exports.typeOf)(x);
};
// 
var $a40bd87bc05fc082$var$EMPTY_ARRAY = Object.freeze([]);
var $a40bd87bc05fc082$var$EMPTY_OBJECT = Object.freeze({});
// 
function $a40bd87bc05fc082$var$isFunction(test) {
    return typeof test === 'function';
}
// 
function $a40bd87bc05fc082$var$getComponentName(target) {
    return(// $FlowFixMe
    target.displayName || // $FlowFixMe
    target.name || 'Component');
}
// 
function $a40bd87bc05fc082$var$isStatelessFunction(test) {
    return typeof test === 'function' && !(test.prototype && test.prototype.isReactComponent);
}
// 
function $a40bd87bc05fc082$export$7ba318d8d2f06c76(target) {
    return target && typeof target.styledComponentId === 'string';
}
// 
var $a40bd87bc05fc082$var$SC_ATTR = 'data-styled';
var $a40bd87bc05fc082$var$SC_ATTR_ACTIVE = 'active';
var $a40bd87bc05fc082$var$SC_ATTR_VERSION = 'data-styled-version';
var $a40bd87bc05fc082$var$SC_VERSION = "5.1.1";
var $a40bd87bc05fc082$var$SPLITTER = '/*!sc*/\n';
var $a40bd87bc05fc082$var$IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;
var $a40bd87bc05fc082$var$DISABLE_SPEEDY = typeof SC_DISABLE_SPEEDY === 'boolean' && SC_DISABLE_SPEEDY || false || false; // Shared empty execution context when generating static styles
var $a40bd87bc05fc082$var$STATIC_EXECUTION_CONTEXT = {};
// 
/* eslint-disable camelcase, no-undef */ var $a40bd87bc05fc082$var$getNonce = function getNonce() {
    return typeof __webpack_nonce__ !== 'undefined' ? __webpack_nonce__ : null;
};
var $a40bd87bc05fc082$var$errorMap = {
    "1": "Cannot create styled-component for component: %s.\n\n",
    "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",
    "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
    "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",
    "5": "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",
    "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",
    "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
    "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
    "9": "Missing document `<head>`\n\n",
    "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
    "11": "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",
    "12": "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",
    "13": "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n",
    "14": "ThemeProvider: \"theme\" prop is required.\n\n",
    "15": "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",
    "16": "Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n",
    "17": "CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n"
};
// 
var $a40bd87bc05fc082$var$ERRORS = {};
/**
 * super basic version of sprintf
 */ function $a40bd87bc05fc082$var$format() {
    var a = arguments.length <= 0 ? undefined : arguments[0];
    var b = [];
    for(var c = 1, len = arguments.length; c < len; c += 1)b.push(c < 0 || arguments.length <= c ? undefined : arguments[c]);
    b.forEach(function(d) {
        a = a.replace(/%[a-z]/, d);
    });
    return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */ function $a40bd87bc05fc082$var$throwStyledComponentsError(code) {
    for(var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)interpolations[_key - 1] = arguments[_key];
    throw new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/master/packages/styled-components/src/utils/errors.md#" + code + " for more information." + (interpolations.length > 0 ? " Additional arguments: " + interpolations.join(', ') : ''));
}
// 
var $a40bd87bc05fc082$var$ELEMENT_TYPE = 1;
/* Node.ELEMENT_TYPE */ /** Find last style element if any inside target */ var $a40bd87bc05fc082$var$findLastStyleTag = function findLastStyleTag(target) {
    var childNodes = target.childNodes;
    for(var i = childNodes.length; i >= 0; i--){
        var child = childNodes[i];
        if (child && child.nodeType === $a40bd87bc05fc082$var$ELEMENT_TYPE && child.hasAttribute($a40bd87bc05fc082$var$SC_ATTR)) return child;
    }
    return undefined;
};
/** Create a style element inside `target` or <head> after the last */ var $a40bd87bc05fc082$var$makeStyleTag = function makeStyleTag(target) {
    var head = document.head;
    var parent = target || head;
    var style = document.createElement('style');
    var prevStyle = $a40bd87bc05fc082$var$findLastStyleTag(parent);
    var nextSibling = prevStyle !== undefined ? prevStyle.nextSibling : null;
    style.setAttribute($a40bd87bc05fc082$var$SC_ATTR, $a40bd87bc05fc082$var$SC_ATTR_ACTIVE);
    style.setAttribute($a40bd87bc05fc082$var$SC_ATTR_VERSION, $a40bd87bc05fc082$var$SC_VERSION);
    var nonce = $a40bd87bc05fc082$var$getNonce();
    if (nonce) style.setAttribute('nonce', nonce);
    parent.insertBefore(style, nextSibling);
    return style;
};
/** Get the CSSStyleSheet instance for a given style element */ var $a40bd87bc05fc082$var$getSheet = function getSheet(tag) {
    if (tag.sheet) return tag.sheet;
     // Avoid Firefox quirk where the style element might not have a sheet property
    var _document = document, styleSheets = _document.styleSheets;
    for(var i = 0, l = styleSheets.length; i < l; i++){
        var sheet = styleSheets[i];
        if (sheet.ownerNode === tag) return sheet;
    }
    $a40bd87bc05fc082$var$throwStyledComponentsError(17);
    return undefined;
};
// 
/** Create a CSSStyleSheet-like tag depending on the environment */ var $a40bd87bc05fc082$var$makeTag = function makeTag(_ref) {
    var isServer = _ref.isServer, useCSSOMInjection = _ref.useCSSOMInjection, target = _ref.target;
    if (isServer) return new $a40bd87bc05fc082$var$VirtualTag(target);
    else if (useCSSOMInjection) return new $a40bd87bc05fc082$var$CSSOMTag(target);
    else return new $a40bd87bc05fc082$var$TextTag(target);
};
var $a40bd87bc05fc082$var$CSSOMTag = /*#__PURE__*/ function() {
    function CSSOMTag(target) {
        var element = this.element = $a40bd87bc05fc082$var$makeStyleTag(target); // Avoid Edge bug where empty style elements don't create sheets
        element.appendChild(document.createTextNode(''));
        this.sheet = $a40bd87bc05fc082$var$getSheet(element);
        this.length = 0;
    }
    var _proto = CSSOMTag.prototype;
    _proto.insertRule = function insertRule(index, rule) {
        try {
            this.sheet.insertRule(rule, index);
            this.length++;
            return true;
        } catch (_error) {
            return false;
        }
    };
    _proto.deleteRule = function deleteRule(index) {
        this.sheet.deleteRule(index);
        this.length--;
    };
    _proto.getRule = function getRule(index) {
        var rule = this.sheet.cssRules[index]; // Avoid IE11 quirk where cssText is inaccessible on some invalid rules
        if (rule !== undefined && typeof rule.cssText === 'string') return rule.cssText;
        else return '';
    };
    return CSSOMTag;
}();
/** A Tag that emulates the CSSStyleSheet API but uses text nodes */ var $a40bd87bc05fc082$var$TextTag = /*#__PURE__*/ function() {
    function TextTag(target) {
        var element = this.element = $a40bd87bc05fc082$var$makeStyleTag(target);
        this.nodes = element.childNodes;
        this.length = 0;
    }
    var _proto2 = TextTag.prototype;
    _proto2.insertRule = function insertRule(index, rule) {
        if (index <= this.length && index >= 0) {
            var node = document.createTextNode(rule);
            var refNode = this.nodes[index];
            this.element.insertBefore(node, refNode || null);
            this.length++;
            return true;
        } else return false;
    };
    _proto2.deleteRule = function deleteRule(index) {
        this.element.removeChild(this.nodes[index]);
        this.length--;
    };
    _proto2.getRule = function getRule(index) {
        if (index < this.length) return this.nodes[index].textContent;
        else return '';
    };
    return TextTag;
}();
/** A completely virtual (server-side) Tag that doesn't manipulate the DOM */ var $a40bd87bc05fc082$var$VirtualTag = /*#__PURE__*/ function() {
    function VirtualTag(_target) {
        this.rules = [];
        this.length = 0;
    }
    var _proto3 = VirtualTag.prototype;
    _proto3.insertRule = function insertRule(index, rule) {
        if (index <= this.length) {
            this.rules.splice(index, 0, rule);
            this.length++;
            return true;
        } else return false;
    };
    _proto3.deleteRule = function deleteRule(index) {
        this.rules.splice(index, 1);
        this.length--;
    };
    _proto3.getRule = function getRule(index) {
        if (index < this.length) return this.rules[index];
        else return '';
    };
    return VirtualTag;
}();
// 
/** Create a GroupedTag with an underlying Tag implementation */ var $a40bd87bc05fc082$var$makeGroupedTag = function makeGroupedTag(tag) {
    return new $a40bd87bc05fc082$var$DefaultGroupedTag(tag);
};
var $a40bd87bc05fc082$var$BASE_SIZE = 512;
var $a40bd87bc05fc082$var$DefaultGroupedTag = /*#__PURE__*/ function() {
    function DefaultGroupedTag(tag) {
        this.groupSizes = new Uint32Array($a40bd87bc05fc082$var$BASE_SIZE);
        this.length = $a40bd87bc05fc082$var$BASE_SIZE;
        this.tag = tag;
    }
    var _proto = DefaultGroupedTag.prototype;
    _proto.indexOfGroup = function indexOfGroup(group) {
        var index = 0;
        for(var i = 0; i < group; i++)index += this.groupSizes[i];
        return index;
    };
    _proto.insertRules = function insertRules(group, rules) {
        if (group >= this.groupSizes.length) {
            var oldBuffer = this.groupSizes;
            var oldSize = oldBuffer.length;
            var newSize = oldSize;
            while(group >= newSize){
                newSize <<= 1;
                if (newSize < 0) $a40bd87bc05fc082$var$throwStyledComponentsError(16, "" + group);
            }
            this.groupSizes = new Uint32Array(newSize);
            this.groupSizes.set(oldBuffer);
            this.length = newSize;
            for(var i = oldSize; i < newSize; i++)this.groupSizes[i] = 0;
        }
        var ruleIndex = this.indexOfGroup(group + 1);
        for(var _i = 0, l = rules.length; _i < l; _i++)if (this.tag.insertRule(ruleIndex, rules[_i])) {
            this.groupSizes[group]++;
            ruleIndex++;
        }
    };
    _proto.clearGroup = function clearGroup(group) {
        if (group < this.length) {
            var length = this.groupSizes[group];
            var startIndex = this.indexOfGroup(group);
            var endIndex = startIndex + length;
            this.groupSizes[group] = 0;
            for(var i = startIndex; i < endIndex; i++)this.tag.deleteRule(startIndex);
        }
    };
    _proto.getGroup = function getGroup(group) {
        var css = '';
        if (group >= this.length || this.groupSizes[group] === 0) return css;
        var length = this.groupSizes[group];
        var startIndex = this.indexOfGroup(group);
        var endIndex = startIndex + length;
        for(var i = startIndex; i < endIndex; i++)css += "" + this.tag.getRule(i) + $a40bd87bc05fc082$var$SPLITTER;
        return css;
    };
    return DefaultGroupedTag;
}();
// 
var $a40bd87bc05fc082$var$MAX_SMI = 1073741824;
var $a40bd87bc05fc082$var$groupIDRegister = new Map();
var $a40bd87bc05fc082$var$reverseRegister = new Map();
var $a40bd87bc05fc082$var$nextFreeGroup = 1;
var $a40bd87bc05fc082$var$getGroupForId = function getGroupForId(id) {
    if ($a40bd87bc05fc082$var$groupIDRegister.has(id)) return $a40bd87bc05fc082$var$groupIDRegister.get(id);
    var group = $a40bd87bc05fc082$var$nextFreeGroup++;
    $a40bd87bc05fc082$var$groupIDRegister.set(id, group);
    $a40bd87bc05fc082$var$reverseRegister.set(group, id);
    return group;
};
var $a40bd87bc05fc082$var$getIdForGroup = function getIdForGroup(group) {
    return $a40bd87bc05fc082$var$reverseRegister.get(group);
};
var $a40bd87bc05fc082$var$setGroupForId = function setGroupForId(id, group) {
    if (group >= $a40bd87bc05fc082$var$nextFreeGroup) $a40bd87bc05fc082$var$nextFreeGroup = group + 1;
    $a40bd87bc05fc082$var$groupIDRegister.set(id, group);
    $a40bd87bc05fc082$var$reverseRegister.set(group, id);
};
// 
var $a40bd87bc05fc082$var$SELECTOR = "style[" + $a40bd87bc05fc082$var$SC_ATTR + "][" + $a40bd87bc05fc082$var$SC_ATTR_VERSION + "=\"" + $a40bd87bc05fc082$var$SC_VERSION + "\"]";
var $a40bd87bc05fc082$var$MARKER_RE = new RegExp("^" + $a40bd87bc05fc082$var$SC_ATTR + "\\.g(\\d+)\\[id=\"([\\w\\d-]+)\"\\].*?\"([^\"]*)");
var $a40bd87bc05fc082$var$outputSheet = function outputSheet(sheet) {
    var tag = sheet.getTag();
    var length = tag.length;
    var css = '';
    for(var group = 0; group < length; group++){
        var id = $a40bd87bc05fc082$var$getIdForGroup(group);
        if (id === undefined) continue;
        var names = sheet.names.get(id);
        var rules = tag.getGroup(group);
        if (names === undefined || rules.length === 0) continue;
        var selector = $a40bd87bc05fc082$var$SC_ATTR + ".g" + group + "[id=\"" + id + "\"]";
        var content = '';
        if (names !== undefined) names.forEach(function(name) {
            if (name.length > 0) content += name + ",";
        });
         // NOTE: It's easier to collect rules and have the marker
        // after the actual rules to simplify the rehydration
        css += "" + rules + selector + "{content:\"" + content + "\"}" + $a40bd87bc05fc082$var$SPLITTER;
    }
    return css;
};
var $a40bd87bc05fc082$var$rehydrateNamesFromContent = function rehydrateNamesFromContent(sheet, id, content) {
    var names = content.split(',');
    var name;
    for(var i = 0, l = names.length; i < l; i++)// eslint-disable-next-line
    if (name = names[i]) sheet.registerName(id, name);
};
var $a40bd87bc05fc082$var$rehydrateSheetFromTag = function rehydrateSheetFromTag(sheet, style) {
    var parts = style.innerHTML.split($a40bd87bc05fc082$var$SPLITTER);
    var rules = [];
    for(var i = 0, l = parts.length; i < l; i++){
        var part = parts[i].trim();
        if (!part) continue;
        var marker = part.match($a40bd87bc05fc082$var$MARKER_RE);
        if (marker) {
            var group = parseInt(marker[1], 10) | 0;
            var id = marker[2];
            if (group !== 0) {
                // Rehydrate componentId to group index mapping
                $a40bd87bc05fc082$var$setGroupForId(id, group); // Rehydrate names and rules
                // looks like: data-styled.g11[id="idA"]{content:"nameA,"}
                $a40bd87bc05fc082$var$rehydrateNamesFromContent(sheet, id, marker[3]);
                sheet.getTag().insertRules(group, rules);
            }
            rules.length = 0;
        } else rules.push(part);
    }
};
var $a40bd87bc05fc082$var$rehydrateSheet = function rehydrateSheet(sheet) {
    var nodes = document.querySelectorAll($a40bd87bc05fc082$var$SELECTOR);
    for(var i = 0, l = nodes.length; i < l; i++){
        var node = nodes[i];
        if (node && node.getAttribute($a40bd87bc05fc082$var$SC_ATTR) !== $a40bd87bc05fc082$var$SC_ATTR_ACTIVE) {
            $a40bd87bc05fc082$var$rehydrateSheetFromTag(sheet, node);
            if (node.parentNode) node.parentNode.removeChild(node);
        }
    }
};
var $a40bd87bc05fc082$var$SHOULD_REHYDRATE = $a40bd87bc05fc082$var$IS_BROWSER;
var $a40bd87bc05fc082$var$defaultOptions = {
    isServer: !$a40bd87bc05fc082$var$IS_BROWSER,
    useCSSOMInjection: !$a40bd87bc05fc082$var$DISABLE_SPEEDY
};
/** Contains the main stylesheet logic for stringification and caching */ var $a40bd87bc05fc082$var$StyleSheet = /*#__PURE__*/ function() {
    /** Register a group ID to give it an index */ StyleSheet.registerId = function registerId(id) {
        return $a40bd87bc05fc082$var$getGroupForId(id);
    };
    function StyleSheet(options, globalStyles, names) {
        if (options === void 0) options = $a40bd87bc05fc082$var$defaultOptions;
        if (globalStyles === void 0) globalStyles = {};
        this.options = $a40bd87bc05fc082$var$_extends({}, $a40bd87bc05fc082$var$defaultOptions, {}, options);
        this.gs = globalStyles;
        this.names = new Map(names); // We rehydrate only once and use the sheet that is created first
        if (!this.options.isServer && $a40bd87bc05fc082$var$IS_BROWSER && $a40bd87bc05fc082$var$SHOULD_REHYDRATE) {
            $a40bd87bc05fc082$var$SHOULD_REHYDRATE = false;
            $a40bd87bc05fc082$var$rehydrateSheet(this);
        }
    }
    var _proto = StyleSheet.prototype;
    _proto.reconstructWithOptions = function reconstructWithOptions(options) {
        return new StyleSheet($a40bd87bc05fc082$var$_extends({}, this.options, {}, options), this.gs, this.names);
    };
    _proto.allocateGSInstance = function allocateGSInstance(id) {
        return this.gs[id] = (this.gs[id] || 0) + 1;
    };
    _proto.getTag = function getTag() {
        return this.tag || (this.tag = $a40bd87bc05fc082$var$makeGroupedTag($a40bd87bc05fc082$var$makeTag(this.options)));
    };
    _proto.hasNameForId = function hasNameForId(id, name) {
        return this.names.has(id) && this.names.get(id).has(name);
    };
    _proto.registerName = function registerName(id, name) {
        $a40bd87bc05fc082$var$getGroupForId(id);
        if (!this.names.has(id)) {
            var groupNames = new Set();
            groupNames.add(name);
            this.names.set(id, groupNames);
        } else this.names.get(id).add(name);
    };
    _proto.insertRules = function insertRules(id, name, rules) {
        this.registerName(id, name);
        this.getTag().insertRules($a40bd87bc05fc082$var$getGroupForId(id), rules);
    };
    _proto.clearNames = function clearNames(id) {
        if (this.names.has(id)) this.names.get(id).clear();
    };
    _proto.clearRules = function clearRules(id) {
        this.getTag().clearGroup($a40bd87bc05fc082$var$getGroupForId(id));
        this.clearNames(id);
    };
    _proto.clearTag = function clearTag() {
        // NOTE: This does not clear the names, since it's only used during SSR
        // so that we can continuously output only new rules
        this.tag = undefined;
    };
    _proto.toString = function toString() {
        return $a40bd87bc05fc082$var$outputSheet(this);
    };
    return StyleSheet;
}();
// 
/* eslint-disable */ var $a40bd87bc05fc082$var$SEED = 5381; // When we have separate strings it's useful to run a progressive
// version of djb2 where we pretend that we're still looping over
// the same string
var $a40bd87bc05fc082$var$phash = function phash(h, x) {
    var i = x.length;
    while(i)h = h * 33 ^ x.charCodeAt(--i);
    return h;
}; // This is a djb2 hashing function
var $a40bd87bc05fc082$var$hash = function hash(x) {
    return $a40bd87bc05fc082$var$phash($a40bd87bc05fc082$var$SEED, x);
};
/**
 * MIT License
 *
 * Copyright (c) 2016 Sultan Tarimo
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR
 * IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ /* eslint-disable */ function $a40bd87bc05fc082$var$insertRulePlugin(insertRule) {
    var delimiter = '/*|*/';
    var needle = delimiter + "}";
    function toSheet(block) {
        if (block) try {
            insertRule(block + "}");
        } catch (e) {}
    }
    return function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
        switch(context){
            // property
            case 1:
                // @import
                if (depth === 0 && content.charCodeAt(0) === 64) return insertRule(content + ";"), '';
                break;
            // selector
            case 2:
                if (ns === 0) return content + delimiter;
                break;
            // at-rule
            case 3:
                switch(ns){
                    // @font-face, @page
                    case 102:
                    case 112:
                        return insertRule(selectors[0] + content), '';
                    default:
                        return content + (at === 0 ? delimiter : '');
                }
            case -2:
                content.split(needle).forEach(toSheet);
        }
    };
}
var $a40bd87bc05fc082$var$COMMENT_REGEX = /^\s*\/\/.*$/gm;
function $a40bd87bc05fc082$var$createStylisInstance(_temp) {
    var _ref = _temp === void 0 ? $a40bd87bc05fc082$var$EMPTY_OBJECT : _temp, _ref$options = _ref.options, options = _ref$options === void 0 ? $a40bd87bc05fc082$var$EMPTY_OBJECT : _ref$options, _ref$plugins = _ref.plugins, plugins = _ref$plugins === void 0 ? $a40bd87bc05fc082$var$EMPTY_ARRAY : _ref$plugins;
    var stylis = new (0, $742f9cd93dcb593f$export$2e2bcd8739ae039)(options); // Wrap `insertRulePlugin to build a list of rules,
    // and then make our own plugin to return the rules. This
    // makes it easier to hook into the existing SSR architecture
    var parsingRules = []; // eslint-disable-next-line consistent-return
    var returnRulesPlugin = function returnRulesPlugin(context) {
        if (context === -2) {
            var parsedRules = parsingRules;
            parsingRules = [];
            return parsedRules;
        }
    };
    var parseRulesPlugin = $a40bd87bc05fc082$var$insertRulePlugin(function(rule) {
        parsingRules.push(rule);
    });
    var _componentId;
    var _selector;
    var _selectorRegexp;
    var selfReferenceReplacer = function selfReferenceReplacer(match, offset, string) {
        if (offset > 0 && // there should be at least two self-refs to do a replacement (.b > .b)
        string.slice(0, offset).indexOf(_selector) !== -1 && // no consecutive self refs (.b.b); that is a precedence boost and treated differently
        string.slice(offset - _selector.length, offset) !== _selector) return "." + _componentId;
        return match;
    };
    /**
   * When writing a style like
   *
   * & + & {
   *   color: red;
   * }
   *
   * The second ampersand should be a reference to the static component class. stylis
   * has no knowledge of static class so we have to intelligently replace the base selector.
   *
   * https://github.com/thysultan/stylis.js#plugins <- more info about the context phase values
   * "2" means this plugin is taking effect at the very end after all other processing is complete
   */ var selfReferenceReplacementPlugin = function selfReferenceReplacementPlugin(context, _, selectors) {
        if (context === 2 && selectors.length && selectors[0].lastIndexOf(_selector) > 0) // eslint-disable-next-line no-param-reassign
        selectors[0] = selectors[0].replace(_selectorRegexp, selfReferenceReplacer);
    };
    stylis.use([].concat(plugins, [
        selfReferenceReplacementPlugin,
        parseRulesPlugin,
        returnRulesPlugin
    ]));
    function stringifyRules(css, selector, prefix, componentId) {
        if (componentId === void 0) componentId = '&';
        var flatCSS = css.replace($a40bd87bc05fc082$var$COMMENT_REGEX, '');
        var cssStr = selector && prefix ? prefix + " " + selector + " { " + flatCSS + " }" : flatCSS; // stylis has no concept of state to be passed to plugins
        // but since JS is single=threaded, we can rely on that to ensure
        // these properties stay in sync with the current stylis run
        _componentId = componentId;
        _selector = selector;
        _selectorRegexp = new RegExp("\\" + _selector + "\\b", 'g');
        return stylis(prefix || !selector ? '' : selector, cssStr);
    }
    stringifyRules.hash = plugins.length ? plugins.reduce(function(acc, plugin) {
        if (!plugin.name) $a40bd87bc05fc082$var$throwStyledComponentsError(15);
        return $a40bd87bc05fc082$var$phash(acc, plugin.name);
    }, $a40bd87bc05fc082$var$SEED).toString() : '';
    return stringifyRules;
}
// 
var $a40bd87bc05fc082$export$8c190ef828af4c86 = (0, $aXNcS.default).createContext();
var $a40bd87bc05fc082$export$91317688fc694efa = $a40bd87bc05fc082$export$8c190ef828af4c86.Consumer;
var $a40bd87bc05fc082$var$StylisContext = (0, $aXNcS.default).createContext();
var $a40bd87bc05fc082$var$StylisConsumer = $a40bd87bc05fc082$var$StylisContext.Consumer;
var $a40bd87bc05fc082$var$masterSheet = new $a40bd87bc05fc082$var$StyleSheet();
var $a40bd87bc05fc082$var$masterStylis = $a40bd87bc05fc082$var$createStylisInstance();
function $a40bd87bc05fc082$var$useStyleSheet() {
    return (0, $fqaWh.useContext)($a40bd87bc05fc082$export$8c190ef828af4c86) || $a40bd87bc05fc082$var$masterSheet;
}
function $a40bd87bc05fc082$var$useStylis() {
    return (0, $fqaWh.useContext)($a40bd87bc05fc082$var$StylisContext) || $a40bd87bc05fc082$var$masterStylis;
}
function $a40bd87bc05fc082$export$a473771da2f0ff7c(props) {
    var _useState = (0, $fqaWh.useState)(props.stylisPlugins), plugins = _useState[0], setPlugins = _useState[1];
    var contextStyleSheet = $a40bd87bc05fc082$var$useStyleSheet();
    var styleSheet = (0, $fqaWh.useMemo)(function() {
        var sheet = contextStyleSheet;
        if (props.sheet) // eslint-disable-next-line prefer-destructuring
        sheet = props.sheet;
        else if (props.target) sheet = sheet.reconstructWithOptions({
            target: props.target
        });
        if (props.disableCSSOMInjection) sheet = sheet.reconstructWithOptions({
            useCSSOMInjection: false
        });
        return sheet;
    }, [
        props.disableCSSOMInjection,
        props.sheet,
        props.target
    ]);
    var stylis = (0, $fqaWh.useMemo)(function() {
        return $a40bd87bc05fc082$var$createStylisInstance({
            options: {
                prefix: !props.disableVendorPrefixes
            },
            plugins: plugins
        });
    }, [
        props.disableVendorPrefixes,
        plugins
    ]);
    (0, $fqaWh.useEffect)(function() {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($b716006f8003187d$exports)))(plugins, props.stylisPlugins)) setPlugins(props.stylisPlugins);
    }, [
        props.stylisPlugins
    ]);
    return /*#__PURE__*/ (0, $aXNcS.default).createElement($a40bd87bc05fc082$export$8c190ef828af4c86.Provider, {
        value: styleSheet
    }, /*#__PURE__*/ (0, $aXNcS.default).createElement($a40bd87bc05fc082$var$StylisContext.Provider, {
        value: stylis
    }, (0, props.children)));
}
// 
var $a40bd87bc05fc082$var$Keyframes = /*#__PURE__*/ function() {
    function Keyframes(name, stringifyArgs) {
        var _this = this;
        this.inject = function(styleSheet) {
            if (!styleSheet.hasNameForId(_this.id, _this.name)) styleSheet.insertRules(_this.id, _this.name, $a40bd87bc05fc082$var$masterStylis.apply(void 0, _this.stringifyArgs));
        };
        this.toString = function() {
            return $a40bd87bc05fc082$var$throwStyledComponentsError(12, String(_this.name));
        };
        this.name = name;
        this.id = "sc-keyframes-" + name;
        this.stringifyArgs = stringifyArgs;
    }
    var _proto = Keyframes.prototype;
    _proto.getName = function getName() {
        return this.name;
    };
    return Keyframes;
}();
// 
/**
 * inlined version of
 * https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/hyphenateStyleName.js
 */ var $a40bd87bc05fc082$var$uppercasePattern = /([A-Z])/g;
var $a40bd87bc05fc082$var$msPattern = /^ms-/;
/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */ function $a40bd87bc05fc082$var$hyphenateStyleName(string) {
    return string.replace($a40bd87bc05fc082$var$uppercasePattern, '-$1').toLowerCase().replace($a40bd87bc05fc082$var$msPattern, '-ms-');
}
// 
function $a40bd87bc05fc082$var$addUnitIfNeeded(name, value) {
    // https://github.com/amilajack/eslint-plugin-flowtype-errors/issues/133
    // $FlowFixMe
    if (value == null || typeof value === 'boolean' || value === '') return '';
    if (typeof value === 'number' && value !== 0 && !(name in (0, $c0970159dfb921fa$export$2e2bcd8739ae039))) return value + "px"; // Presumes implicit 'px' suffix for unitless numbers
    return String(value).trim();
}
// 
/**
 * It's falsish not falsy because 0 is allowed.
 */ var $a40bd87bc05fc082$var$isFalsish = function isFalsish(chunk) {
    return chunk === undefined || chunk === null || chunk === false || chunk === '';
};
var $a40bd87bc05fc082$var$objToCssArray = function objToCssArray(obj, prevKey) {
    var rules = [];
    var keys = Object.keys(obj);
    keys.forEach(function(key) {
        if (!$a40bd87bc05fc082$var$isFalsish(obj[key])) {
            if ($a40bd87bc05fc082$var$isPlainObject(obj[key])) {
                rules.push.apply(rules, objToCssArray(obj[key], key));
                return rules;
            } else if ($a40bd87bc05fc082$var$isFunction(obj[key])) {
                rules.push($a40bd87bc05fc082$var$hyphenateStyleName(key) + ":", obj[key], ';');
                return rules;
            }
            rules.push($a40bd87bc05fc082$var$hyphenateStyleName(key) + ": " + $a40bd87bc05fc082$var$addUnitIfNeeded(key, obj[key]) + ";");
        }
        return rules;
    });
    return prevKey ? [
        prevKey + " {"
    ].concat(rules, [
        '}'
    ]) : rules;
};
function $a40bd87bc05fc082$var$flatten(chunk, executionContext, styleSheet) {
    if (Array.isArray(chunk)) {
        var ruleSet = [];
        for(var i = 0, len = chunk.length, result; i < len; i += 1){
            result = $a40bd87bc05fc082$var$flatten(chunk[i], executionContext, styleSheet);
            if (result === '') continue;
            else if (Array.isArray(result)) ruleSet.push.apply(ruleSet, result);
            else ruleSet.push(result);
        }
        return ruleSet;
    }
    if ($a40bd87bc05fc082$var$isFalsish(chunk)) return '';
    /* Handle other components */ if ($a40bd87bc05fc082$export$7ba318d8d2f06c76(chunk)) return "." + chunk.styledComponentId;
    /* Either execute or defer the function */ if ($a40bd87bc05fc082$var$isFunction(chunk)) {
        if ($a40bd87bc05fc082$var$isStatelessFunction(chunk) && executionContext) {
            var _result = chunk(executionContext);
            return $a40bd87bc05fc082$var$flatten(_result, executionContext, styleSheet);
        } else return chunk;
    }
    if (chunk instanceof $a40bd87bc05fc082$var$Keyframes) {
        if (styleSheet) {
            chunk.inject(styleSheet);
            return chunk.getName();
        } else return chunk;
    }
    /* Handle objects */ return $a40bd87bc05fc082$var$isPlainObject(chunk) ? $a40bd87bc05fc082$var$objToCssArray(chunk) : chunk.toString();
}
// 
function $a40bd87bc05fc082$export$dbf350e5966cf602(styles) {
    for(var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)interpolations[_key - 1] = arguments[_key];
    if ($a40bd87bc05fc082$var$isFunction(styles) || $a40bd87bc05fc082$var$isPlainObject(styles)) // $FlowFixMe
    return $a40bd87bc05fc082$var$flatten($a40bd87bc05fc082$var$interleave($a40bd87bc05fc082$var$EMPTY_ARRAY, [
        styles
    ].concat(interpolations)));
    if (interpolations.length === 0 && styles.length === 1 && typeof styles[0] === "string") // $FlowFixMe
    return styles;
     // $FlowFixMe
    return $a40bd87bc05fc082$var$flatten($a40bd87bc05fc082$var$interleave(styles, interpolations));
}
function $a40bd87bc05fc082$var$constructWithOptions(componentConstructor, tag, options) {
    if (options === void 0) options = $a40bd87bc05fc082$var$EMPTY_OBJECT;
    if (!(0, $98dff0c314a1cc5c$exports.isValidElementType)(tag)) return $a40bd87bc05fc082$var$throwStyledComponentsError(1, String(tag));
    /* This is callable directly as a template function */ // $FlowFixMe: Not typed to avoid destructuring arguments
    var templateFunction = function templateFunction() {
        return componentConstructor(tag, options, $a40bd87bc05fc082$export$dbf350e5966cf602.apply(void 0, arguments));
    };
    /* If config methods are called, wrap up a new template function and merge options */ templateFunction.withConfig = function(config) {
        return $a40bd87bc05fc082$var$constructWithOptions(componentConstructor, tag, $a40bd87bc05fc082$var$_extends({}, options, {}, config));
    };
    /* Modify/inject new props at runtime */ templateFunction.attrs = function(attrs) {
        return $a40bd87bc05fc082$var$constructWithOptions(componentConstructor, tag, $a40bd87bc05fc082$var$_extends({}, options, {
            attrs: Array.prototype.concat(options.attrs, attrs).filter(Boolean)
        }));
    };
    return templateFunction;
}
/* eslint-disable */ /**
  mixin-deep; https://github.com/jonschlinkert/mixin-deep
  Inlined such that it will be consistently transpiled to an IE-compatible syntax.

  The MIT License (MIT)

  Copyright (c) 2014-present, Jon Schlinkert.

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/ var $a40bd87bc05fc082$var$isObject = function isObject(val) {
    return typeof val === 'function' || typeof val === 'object' && val !== null && !Array.isArray(val);
};
var $a40bd87bc05fc082$var$isValidKey = function isValidKey(key) {
    return key !== '__proto__' && key !== 'constructor' && key !== 'prototype';
};
function $a40bd87bc05fc082$var$mixin(target, val, key) {
    var obj = target[key];
    if ($a40bd87bc05fc082$var$isObject(val) && $a40bd87bc05fc082$var$isObject(obj)) $a40bd87bc05fc082$var$mixinDeep(obj, val);
    else target[key] = val;
}
function $a40bd87bc05fc082$var$mixinDeep(target) {
    for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
    for(var _i = 0, _rest = rest; _i < _rest.length; _i++){
        var obj = _rest[_i];
        if ($a40bd87bc05fc082$var$isObject(obj)) {
            for(var key in obj)if ($a40bd87bc05fc082$var$isValidKey(key)) $a40bd87bc05fc082$var$mixin(target, obj[key], key);
        }
    }
    return target;
}
// 
/* eslint-disable no-bitwise */ var $a40bd87bc05fc082$var$AD_REPLACER_R = /(a)(d)/gi;
/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */ var $a40bd87bc05fc082$var$charsLength = 52;
/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */ var $a40bd87bc05fc082$var$getAlphabeticChar = function getAlphabeticChar(code) {
    return String.fromCharCode(code + (code > 25 ? 39 : 97));
};
/* input a number, usually a hash and convert it to base-52 */ function $a40bd87bc05fc082$var$generateAlphabeticName(code) {
    var name = '';
    var x;
    /* get a char and divide by alphabet-length */ for(x = Math.abs(code); x > $a40bd87bc05fc082$var$charsLength; x = x / $a40bd87bc05fc082$var$charsLength | 0)name = $a40bd87bc05fc082$var$getAlphabeticChar(x % $a40bd87bc05fc082$var$charsLength) + name;
    return ($a40bd87bc05fc082$var$getAlphabeticChar(x % $a40bd87bc05fc082$var$charsLength) + name).replace($a40bd87bc05fc082$var$AD_REPLACER_R, '$1-$2');
}
// 
function $a40bd87bc05fc082$var$isStaticRules(rules) {
    for(var i = 0; i < rules.length; i += 1){
        var rule = rules[i];
        if ($a40bd87bc05fc082$var$isFunction(rule) && !$a40bd87bc05fc082$export$7ba318d8d2f06c76(rule)) // functions are allowed to be static if they're just being
        // used to get the classname of a nested styled component
        return false;
    }
    return true;
}
// 
/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */ var $a40bd87bc05fc082$var$ComponentStyle = /*#__PURE__*/ function() {
    function ComponentStyle(rules, componentId) {
        this.rules = rules;
        this.staticRulesId = '';
        this.isStatic = $a40bd87bc05fc082$var$isStaticRules(rules);
        this.componentId = componentId;
        this.baseHash = $a40bd87bc05fc082$var$hash(componentId); // NOTE: This registers the componentId, which ensures a consistent order
        // for this component's styles compared to others
        $a40bd87bc05fc082$var$StyleSheet.registerId(componentId);
    }
    /*
   * Flattens a rule set into valid CSS
   * Hashes it, wraps the whole chunk in a .hash1234 {}
   * Returns the hash to be injected on render()
   * */ var _proto = ComponentStyle.prototype;
    _proto.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet, stylis) {
        var componentId = this.componentId; // force dynamic classnames if user-supplied stylis plugins are in use
        if (this.isStatic && !stylis.hash) {
            if (this.staticRulesId && styleSheet.hasNameForId(componentId, this.staticRulesId)) return this.staticRulesId;
            var cssStatic = $a40bd87bc05fc082$var$flatten(this.rules, executionContext, styleSheet).join('');
            var name = $a40bd87bc05fc082$var$generateAlphabeticName($a40bd87bc05fc082$var$phash(this.baseHash, cssStatic.length) >>> 0);
            if (!styleSheet.hasNameForId(componentId, name)) {
                var cssStaticFormatted = stylis(cssStatic, "." + name, undefined, componentId);
                styleSheet.insertRules(componentId, name, cssStaticFormatted);
            }
            this.staticRulesId = name;
            return name;
        } else {
            var length = this.rules.length;
            var dynamicHash = $a40bd87bc05fc082$var$phash(this.baseHash, stylis.hash);
            var css = '';
            for(var i = 0; i < length; i++){
                var partRule = this.rules[i];
                if (typeof partRule === 'string') css += partRule;
                else {
                    var partChunk = $a40bd87bc05fc082$var$flatten(partRule, executionContext, styleSheet);
                    var partString = Array.isArray(partChunk) ? partChunk.join('') : partChunk;
                    dynamicHash = $a40bd87bc05fc082$var$phash(dynamicHash, partString + i);
                    css += partString;
                }
            }
            var _name = $a40bd87bc05fc082$var$generateAlphabeticName(dynamicHash >>> 0);
            if (!styleSheet.hasNameForId(componentId, _name)) {
                var cssFormatted = stylis(css, "." + _name, undefined, componentId);
                styleSheet.insertRules(componentId, _name, cssFormatted);
            }
            return _name;
        }
    };
    return ComponentStyle;
}();
// 
var $a40bd87bc05fc082$var$LIMIT = 200;
var $a40bd87bc05fc082$var$createWarnTooManyClasses = function(displayName, componentId) {
    var generatedClasses = {};
    var warningSeen = false;
    return function(className) {
        if (!warningSeen) {
            generatedClasses[className] = true;
            if (Object.keys(generatedClasses).length >= $a40bd87bc05fc082$var$LIMIT) {
                // Unable to find latestRule in test environment.
                /* eslint-disable no-console, prefer-template */ var parsedIdString = componentId ? " with the id of \"" + componentId + "\"" : '';
                console.warn("Over " + $a40bd87bc05fc082$var$LIMIT + " classes were generated for component " + displayName + parsedIdString + ".\n" + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs(props => ({\n' + '    style: {\n' + '      background: props.background,\n' + '    },\n' + '  }))`width: 100%;`\n\n' + '  <Component />');
                warningSeen = true;
                generatedClasses = {};
            }
        }
    };
};
// 
var $a40bd87bc05fc082$var$invalidHookCallRe = /invalid hook call/i;
var $a40bd87bc05fc082$var$seen = new Set();
var $a40bd87bc05fc082$var$checkDynamicCreation = function checkDynamicCreation(displayName, componentId) {
    var parsedIdString, message, error;
};
// 
var $a40bd87bc05fc082$var$determineTheme = function(props, providedTheme, defaultProps) {
    if (defaultProps === void 0) defaultProps = $a40bd87bc05fc082$var$EMPTY_OBJECT;
    return props.theme !== defaultProps.theme && props.theme || providedTheme || defaultProps.theme;
};
// 
// Source: https://www.w3.org/TR/cssom-1/#serialize-an-identifier
// Control characters and non-letter first symbols are not supported
var $a40bd87bc05fc082$var$escapeRegex = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g;
var $a40bd87bc05fc082$var$dashesAtEnds = /(^-|-$)/g;
/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */ function $a40bd87bc05fc082$var$escape(str) {
    return str // Replace all possible CSS selectors
    .replace($a40bd87bc05fc082$var$escapeRegex, '-') // Remove extraneous hyphens at the start and end
    .replace($a40bd87bc05fc082$var$dashesAtEnds, '');
}
// 
function $a40bd87bc05fc082$var$isTag(target) {
    return typeof target === 'string' && true;
}
// 
function $a40bd87bc05fc082$var$generateDisplayName(target) {
    // $FlowFixMe
    return $a40bd87bc05fc082$var$isTag(target) ? "styled." + target : "Styled(" + $a40bd87bc05fc082$var$getComponentName(target) + ")";
}
// 
var $a40bd87bc05fc082$var$generateComponentId = function(str) {
    return $a40bd87bc05fc082$var$generateAlphabeticName($a40bd87bc05fc082$var$hash(str) >>> 0);
};
/**
 * Convenience function for joining strings to form className chains
 */ function $a40bd87bc05fc082$var$joinStrings(a, b) {
    return a && b ? a + " " + b : a || b;
}
var $a40bd87bc05fc082$export$2c657da244d00bd6 = (0, $aXNcS.default).createContext();
var $a40bd87bc05fc082$export$b631efc24e9d5e2f = $a40bd87bc05fc082$export$2c657da244d00bd6.Consumer;
function $a40bd87bc05fc082$var$mergeTheme(theme, outerTheme) {
    if (!theme) return $a40bd87bc05fc082$var$throwStyledComponentsError(14);
    if ($a40bd87bc05fc082$var$isFunction(theme)) {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    if (Array.isArray(theme) || typeof theme !== 'object') return $a40bd87bc05fc082$var$throwStyledComponentsError(8);
    return outerTheme ? $a40bd87bc05fc082$var$_extends({}, outerTheme, {}, theme) : theme;
}
/**
 * Provide a theme to an entire react component tree via context
 */ function $a40bd87bc05fc082$export$d8964aec282183a3(props) {
    var outerTheme = (0, $fqaWh.useContext)($a40bd87bc05fc082$export$2c657da244d00bd6);
    var themeContext = (0, $fqaWh.useMemo)(function() {
        return $a40bd87bc05fc082$var$mergeTheme(props.theme, outerTheme);
    }, [
        props.theme,
        outerTheme
    ]);
    if (!props.children) return null;
    return /*#__PURE__*/ (0, $aXNcS.default).createElement($a40bd87bc05fc082$export$2c657da244d00bd6.Provider, {
        value: themeContext
    }, props.children);
}
/* global $Call */ var $a40bd87bc05fc082$var$identifiers = {};
/* We depend on components having unique IDs */ function $a40bd87bc05fc082$var$generateId(displayName, parentComponentId) {
    var name = typeof displayName !== 'string' ? 'sc' : $a40bd87bc05fc082$var$escape(displayName); // Ensure that no displayName can lead to duplicate componentIds
    $a40bd87bc05fc082$var$identifiers[name] = ($a40bd87bc05fc082$var$identifiers[name] || 0) + 1;
    var componentId = name + "-" + $a40bd87bc05fc082$var$generateComponentId(name + $a40bd87bc05fc082$var$identifiers[name]);
    return parentComponentId ? parentComponentId + "-" + componentId : componentId;
}
function $a40bd87bc05fc082$var$useResolvedAttrs(theme, props, attrs) {
    if (theme === void 0) theme = $a40bd87bc05fc082$var$EMPTY_OBJECT;
    // NOTE: can't memoize this
    // returns [context, resolvedAttrs]
    // where resolvedAttrs is only the things injected by the attrs themselves
    var context = $a40bd87bc05fc082$var$_extends({}, props, {
        theme: theme
    });
    var resolvedAttrs = {};
    attrs.forEach(function(attrDef) {
        var resolvedAttrDef = attrDef;
        var key;
        if ($a40bd87bc05fc082$var$isFunction(resolvedAttrDef)) resolvedAttrDef = resolvedAttrDef(context);
        /* eslint-disable guard-for-in */ for(key in resolvedAttrDef)context[key] = resolvedAttrs[key] = key === 'className' ? $a40bd87bc05fc082$var$joinStrings(resolvedAttrs[key], resolvedAttrDef[key]) : resolvedAttrDef[key];
    /* eslint-enable guard-for-in */ });
    return [
        context,
        resolvedAttrs
    ];
}
function $a40bd87bc05fc082$var$useInjectedStyle(componentStyle, hasAttrs, resolvedAttrs, warnTooManyClasses) {
    var styleSheet = $a40bd87bc05fc082$var$useStyleSheet();
    var stylis = $a40bd87bc05fc082$var$useStylis(); // statically styled-components don't need to build an execution context object,
    // and shouldn't be increasing the number of class names
    var isStatic = componentStyle.isStatic && !hasAttrs;
    var className = isStatic ? componentStyle.generateAndInjectStyles($a40bd87bc05fc082$var$EMPTY_OBJECT, styleSheet, stylis) : componentStyle.generateAndInjectStyles(resolvedAttrs, styleSheet, stylis);
    (0, $fqaWh.useDebugValue)(className);
    return className;
}
function $a40bd87bc05fc082$var$useStyledComponentImpl(forwardedComponent, props, forwardedRef) {
    var componentAttrs = forwardedComponent.attrs, componentStyle = forwardedComponent.componentStyle, defaultProps = forwardedComponent.defaultProps, foldedComponentIds = forwardedComponent.foldedComponentIds, shouldForwardProp = forwardedComponent.shouldForwardProp, styledComponentId = forwardedComponent.styledComponentId, target = forwardedComponent.target;
    (0, $fqaWh.useDebugValue)(styledComponentId); // NOTE: the non-hooks version only subscribes to this when !componentStyle.isStatic,
    // but that'd be against the rules-of-hooks. We could be naughty and do it anyway as it
    // should be an immutable value, but behave for now.
    var theme = $a40bd87bc05fc082$var$determineTheme(props, (0, $fqaWh.useContext)($a40bd87bc05fc082$export$2c657da244d00bd6), defaultProps);
    var _useResolvedAttrs = $a40bd87bc05fc082$var$useResolvedAttrs(theme || $a40bd87bc05fc082$var$EMPTY_OBJECT, props, componentAttrs), context = _useResolvedAttrs[0], attrs = _useResolvedAttrs[1];
    var generatedClassName = $a40bd87bc05fc082$var$useInjectedStyle(componentStyle, componentAttrs.length > 0, context, undefined);
    var refToForward = forwardedRef;
    var elementToBeCreated = attrs.$as || props.$as || attrs.as || props.as || target;
    var isTargetTag = $a40bd87bc05fc082$var$isTag(elementToBeCreated);
    var computedProps = attrs !== props ? $a40bd87bc05fc082$var$_extends({}, props, {}, attrs) : props;
    var propFilterFn = shouldForwardProp || isTargetTag && (0, $7cd1aa6fa0dcf323$export$2e2bcd8739ae039);
    var propsForElement = {}; // eslint-disable-next-line guard-for-in
    for(var key in computedProps){
        if (key[0] === '$' || key === 'as') continue;
        else if (key === 'forwardedAs') propsForElement.as = computedProps[key];
        else if (!propFilterFn || propFilterFn(key, (0, $7cd1aa6fa0dcf323$export$2e2bcd8739ae039))) // Don't pass through non HTML tags through to HTML elements
        propsForElement[key] = computedProps[key];
    }
    if (props.style && attrs.style !== props.style) propsForElement.style = $a40bd87bc05fc082$var$_extends({}, props.style, {}, attrs.style);
    propsForElement.className = Array.prototype.concat(foldedComponentIds, styledComponentId, generatedClassName !== styledComponentId ? generatedClassName : null, props.className, attrs.className).filter(Boolean).join(' ');
    propsForElement.ref = refToForward;
    return (0, $fUX2S.createElement)(elementToBeCreated, propsForElement);
}
function $a40bd87bc05fc082$var$createStyledComponent(target, options, rules) {
    var isTargetStyledComp = $a40bd87bc05fc082$export$7ba318d8d2f06c76(target);
    var isCompositeComponent = !$a40bd87bc05fc082$var$isTag(target);
    var _options$displayName = options.displayName, displayName = _options$displayName === void 0 ? $a40bd87bc05fc082$var$generateDisplayName(target) : _options$displayName, _options$componentId = options.componentId, componentId = _options$componentId === void 0 ? $a40bd87bc05fc082$var$generateId(options.displayName, options.parentComponentId) : _options$componentId, _options$attrs = options.attrs, attrs = _options$attrs === void 0 ? $a40bd87bc05fc082$var$EMPTY_ARRAY : _options$attrs;
    var styledComponentId = options.displayName && options.componentId ? $a40bd87bc05fc082$var$escape(options.displayName) + "-" + options.componentId : options.componentId || componentId; // fold the underlying StyledComponent attrs up (implicit extend)
    var finalAttrs = isTargetStyledComp && target.attrs ? Array.prototype.concat(target.attrs, attrs).filter(Boolean) : attrs; // eslint-disable-next-line prefer-destructuring
    var shouldForwardProp = options.shouldForwardProp; // $FlowFixMe
    if (isTargetStyledComp && target.shouldForwardProp) {
        if (shouldForwardProp) // compose nested shouldForwardProp calls
        shouldForwardProp = function shouldForwardProp(prop, filterFn) {
            return target.shouldForwardProp(prop, filterFn) && options.shouldForwardProp(prop, filterFn);
        };
        else // eslint-disable-next-line prefer-destructuring
        shouldForwardProp = target.shouldForwardProp;
    }
    var componentStyle = new $a40bd87bc05fc082$var$ComponentStyle(isTargetStyledComp ? // $FlowFixMe
    target.componentStyle.rules.concat(rules) : rules, styledComponentId);
    /**
   * forwardRef creates a new interim component, which we'll take advantage of
   * instead of extending ParentComponent to create _another_ interim class
   */ var WrappedStyledComponent; // eslint-disable-next-line react-hooks/rules-of-hooks
    var forwardRef = function forwardRef(props, ref) {
        return $a40bd87bc05fc082$var$useStyledComponentImpl(WrappedStyledComponent, props, ref);
    };
    forwardRef.displayName = displayName; // $FlowFixMe this is a forced cast to merge it StyledComponentWrapperProperties
    WrappedStyledComponent = (0, $aXNcS.default).forwardRef(forwardRef);
    WrappedStyledComponent.attrs = finalAttrs;
    WrappedStyledComponent.componentStyle = componentStyle;
    WrappedStyledComponent.displayName = displayName;
    WrappedStyledComponent.shouldForwardProp = shouldForwardProp; // this static is used to preserve the cascade of static classes for component selector
    // purposes; this is especially important with usage of the css prop
    WrappedStyledComponent.foldedComponentIds = isTargetStyledComp ? Array.prototype.concat(target.foldedComponentIds, target.styledComponentId) : $a40bd87bc05fc082$var$EMPTY_ARRAY;
    WrappedStyledComponent.styledComponentId = styledComponentId; // fold the underlying StyledComponent target up since we folded the styles
    WrappedStyledComponent.target = isTargetStyledComp ? target.target : target; // $FlowFixMe
    WrappedStyledComponent.withComponent = function withComponent(tag) {
        var previousComponentId = options.componentId, optionsToCopy = $a40bd87bc05fc082$var$_objectWithoutPropertiesLoose(options, [
            "componentId"
        ]);
        var newComponentId = previousComponentId && previousComponentId + "-" + ($a40bd87bc05fc082$var$isTag(tag) ? tag : $a40bd87bc05fc082$var$escape($a40bd87bc05fc082$var$getComponentName(tag)));
        var newOptions = $a40bd87bc05fc082$var$_extends({}, optionsToCopy, {
            attrs: finalAttrs,
            componentId: newComponentId
        });
        return $a40bd87bc05fc082$var$createStyledComponent(tag, newOptions, rules);
    }; // $FlowFixMe
    Object.defineProperty(WrappedStyledComponent, 'defaultProps', {
        get: function get() {
            return this._foldedDefaultProps;
        },
        set: function set(obj) {
            // $FlowFixMe
            this._foldedDefaultProps = isTargetStyledComp ? $a40bd87bc05fc082$var$mixinDeep({}, target.defaultProps, obj) : obj;
        }
    });
    WrappedStyledComponent.toString = function() {
        return "." + WrappedStyledComponent.styledComponentId;
    };
    if (isCompositeComponent) (0, (/*@__PURE__*/$parcel$interopDefault($ce431108678812c1$exports)))(WrappedStyledComponent, target, {
        // all SC-specific things should not be hoisted
        attrs: true,
        componentStyle: true,
        displayName: true,
        foldedComponentIds: true,
        shouldForwardProp: true,
        self: true,
        styledComponentId: true,
        target: true,
        withComponent: true
    });
    return WrappedStyledComponent;
}
// 
// Thanks to ReactDOMFactories for this handy list!
var $a40bd87bc05fc082$var$domElements = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'marker',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// 
var $a40bd87bc05fc082$var$styled = function styled(tag) {
    return $a40bd87bc05fc082$var$constructWithOptions($a40bd87bc05fc082$var$createStyledComponent, tag);
}; // Shorthands for all valid HTML Elements
$a40bd87bc05fc082$var$domElements.forEach(function(domElement) {
    $a40bd87bc05fc082$var$styled[domElement] = $a40bd87bc05fc082$var$styled(domElement);
});
// 
var $a40bd87bc05fc082$var$GlobalStyle = /*#__PURE__*/ function() {
    function GlobalStyle(rules, componentId) {
        this.rules = rules;
        this.componentId = componentId;
        this.isStatic = $a40bd87bc05fc082$var$isStaticRules(rules);
    }
    var _proto = GlobalStyle.prototype;
    _proto.createStyles = function createStyles(instance, executionContext, styleSheet, stylis) {
        var flatCSS = $a40bd87bc05fc082$var$flatten(this.rules, executionContext, styleSheet);
        var css = stylis(flatCSS.join(''), '');
        var id = this.componentId + instance; // NOTE: We use the id as a name as well, since these rules never change
        styleSheet.insertRules(id, id, css);
    };
    _proto.removeStyles = function removeStyles(instance, styleSheet) {
        styleSheet.clearRules(this.componentId + instance);
    };
    _proto.renderStyles = function renderStyles(instance, executionContext, styleSheet, stylis) {
        $a40bd87bc05fc082$var$StyleSheet.registerId(this.componentId + instance); // NOTE: Remove old styles, then inject the new ones
        this.removeStyles(instance, styleSheet);
        this.createStyles(instance, executionContext, styleSheet, stylis);
    };
    return GlobalStyle;
}();
function $a40bd87bc05fc082$export$f0f03736edb61697(strings) {
    for(var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)interpolations[_key - 1] = arguments[_key];
    var rules = $a40bd87bc05fc082$export$dbf350e5966cf602.apply(void 0, [
        strings
    ].concat(interpolations));
    var styledComponentId = "sc-global-" + $a40bd87bc05fc082$var$generateComponentId(JSON.stringify(rules));
    var globalStyle = new $a40bd87bc05fc082$var$GlobalStyle(rules, styledComponentId);
    function GlobalStyleComponent(props) {
        var styleSheet = $a40bd87bc05fc082$var$useStyleSheet();
        var stylis = $a40bd87bc05fc082$var$useStylis();
        var theme = (0, $fqaWh.useContext)($a40bd87bc05fc082$export$2c657da244d00bd6);
        var instanceRef = (0, $fqaWh.useRef)(null);
        if (instanceRef.current === null) instanceRef.current = styleSheet.allocateGSInstance(styledComponentId);
        var instance = instanceRef.current;
        if (globalStyle.isStatic) globalStyle.renderStyles(instance, $a40bd87bc05fc082$var$STATIC_EXECUTION_CONTEXT, styleSheet, stylis);
        else {
            var context = $a40bd87bc05fc082$var$_extends({}, props, {
                theme: $a40bd87bc05fc082$var$determineTheme(props, theme, GlobalStyleComponent.defaultProps)
            });
            globalStyle.renderStyles(instance, context, styleSheet, stylis);
        }
        (0, $fqaWh.useEffect)(function() {
            return function() {
                return globalStyle.removeStyles(instance, styleSheet);
            };
        }, $a40bd87bc05fc082$var$EMPTY_ARRAY);
        return null;
    } // $FlowFixMe
    return (0, $aXNcS.default).memo(GlobalStyleComponent);
}
// 
function $a40bd87bc05fc082$export$d25ddfdf17c3ad3e(strings) {
    for(var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)interpolations[_key - 1] = arguments[_key];
    var rules = $a40bd87bc05fc082$export$dbf350e5966cf602.apply(void 0, [
        strings
    ].concat(interpolations)).join('');
    var name = $a40bd87bc05fc082$var$generateComponentId(rules);
    return new $a40bd87bc05fc082$var$Keyframes(name, [
        rules,
        name,
        '@keyframes'
    ]);
}
var $a40bd87bc05fc082$export$ae8c7d15c8b89a20 = /*#__PURE__*/ function() {
    function ServerStyleSheet() {
        var _this = this;
        this._emitSheetCSS = function() {
            var css = _this.instance.toString();
            var nonce = $a40bd87bc05fc082$var$getNonce();
            var attrs = [
                nonce && "nonce=\"" + nonce + "\"",
                $a40bd87bc05fc082$var$SC_ATTR + "=\"true\"",
                $a40bd87bc05fc082$var$SC_ATTR_VERSION + "=\"" + $a40bd87bc05fc082$var$SC_VERSION + "\""
            ];
            var htmlAttr = attrs.filter(Boolean).join(' ');
            return "<style " + htmlAttr + ">" + css + "</style>";
        };
        this.getStyleTags = function() {
            if (_this.sealed) return $a40bd87bc05fc082$var$throwStyledComponentsError(2);
            return _this._emitSheetCSS();
        };
        this.getStyleElement = function() {
            var _props;
            if (_this.sealed) return $a40bd87bc05fc082$var$throwStyledComponentsError(2);
            var props = (_props = {}, _props[$a40bd87bc05fc082$var$SC_ATTR] = '', _props[$a40bd87bc05fc082$var$SC_ATTR_VERSION] = $a40bd87bc05fc082$var$SC_VERSION, _props.dangerouslySetInnerHTML = {
                __html: _this.instance.toString()
            }, _props);
            var nonce = $a40bd87bc05fc082$var$getNonce();
            if (nonce) props.nonce = nonce;
             // v4 returned an array for this fn, so we'll do the same for v5 for backward compat
            return [
                /*#__PURE__*/ (0, $aXNcS.default).createElement("style", $a40bd87bc05fc082$var$_extends({}, props, {
                    key: "sc-0-0"
                }))
            ];
        };
        this.seal = function() {
            _this.sealed = true;
        };
        this.instance = new $a40bd87bc05fc082$var$StyleSheet({
            isServer: true
        });
        this.sealed = false;
    }
    var _proto = ServerStyleSheet.prototype;
    _proto.collectStyles = function collectStyles(children) {
        if (this.sealed) return $a40bd87bc05fc082$var$throwStyledComponentsError(2);
        return /*#__PURE__*/ (0, $aXNcS.default).createElement($a40bd87bc05fc082$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, children);
    };
    // eslint-disable-next-line consistent-return
    _proto.interleaveWithNodeStream = function interleaveWithNodeStream(input) {
        return $a40bd87bc05fc082$var$throwStyledComponentsError(3);
    };
    return ServerStyleSheet;
}();
// export default <Config: { theme?: any }, Instance>(
//  Component: AbstractComponent<Config, Instance>
// ): AbstractComponent<$Diff<Config, { theme?: any }> & { theme?: any }, Instance>
//
// but the old build system tooling doesn't support the syntax
var $a40bd87bc05fc082$export$e8748c6a27b910dc = function(Component) {
    // $FlowFixMe This should be React.forwardRef<Config, Instance>
    var WithTheme = (0, $aXNcS.default).forwardRef(function(props, ref) {
        var theme = (0, $fqaWh.useContext)($a40bd87bc05fc082$export$2c657da244d00bd6); // $FlowFixMe defaultProps isn't declared so it can be inferrable
        var defaultProps = Component.defaultProps;
        var themeProp = $a40bd87bc05fc082$var$determineTheme(props, theme, defaultProps);
        return /*#__PURE__*/ (0, $aXNcS.default).createElement(Component, $a40bd87bc05fc082$var$_extends({}, props, {
            theme: themeProp,
            ref: ref
        }));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($ce431108678812c1$exports)))(WithTheme, Component);
    WithTheme.displayName = "WithTheme(" + $a40bd87bc05fc082$var$getComponentName(Component) + ")";
    return WithTheme;
};
// 
var $a40bd87bc05fc082$export$93d4e7f90805808f = function useTheme() {
    return (0, $fqaWh.useContext)($a40bd87bc05fc082$export$2c657da244d00bd6);
};
// 
var $a40bd87bc05fc082$export$5c87cfe6c475f500 = {
    StyleSheet: $a40bd87bc05fc082$var$StyleSheet,
    masterSheet: $a40bd87bc05fc082$var$masterSheet
};
// 
/* Define bundle version for export */ var $a40bd87bc05fc082$export$83d89fbfd8236492 = "5.1.1";
var $a40bd87bc05fc082$export$2e2bcd8739ae039 = $a40bd87bc05fc082$var$styled;



var $fUX2S = parcelRequire("fUX2S");

var $aXNcS = parcelRequire("aXNcS");

var $f094668ecc4481a4$exports = {};
"use strict";
Object.defineProperty($f094668ecc4481a4$exports, "__esModule", {
    value: true
});
$f094668ecc4481a4$exports.default = void 0;

var $f094668ecc4481a4$var$_Card = $f094668ecc4481a4$var$_interopRequireDefault((parcelRequire("bvWtN")));
function $f094668ecc4481a4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f094668ecc4481a4$var$_default = $f094668ecc4481a4$var$_Card.default;
$f094668ecc4481a4$exports.default = $f094668ecc4481a4$var$_default;


var $65e18d5b60454c7a$exports = {};
"use strict";
Object.defineProperty($65e18d5b60454c7a$exports, "__esModule", {
    value: true
});
$65e18d5b60454c7a$exports.colourInteractiveSecondaryBgHoverRgb = $65e18d5b60454c7a$exports.colourInteractiveSecondaryBgHover = $65e18d5b60454c7a$exports.colourInteractiveSecondaryBgDefaultRgb = $65e18d5b60454c7a$exports.colourInteractiveSecondaryBgDefault = $65e18d5b60454c7a$exports.colourInteractiveEmphasisedBgPressedRgb = $65e18d5b60454c7a$exports.colourInteractiveEmphasisedBgPressed = $65e18d5b60454c7a$exports.colourInteractiveEmphasisedBgHoverRgb = $65e18d5b60454c7a$exports.colourInteractiveEmphasisedBgHover = $65e18d5b60454c7a$exports.colourInteractiveEmphasisedBgDefaultRgb = $65e18d5b60454c7a$exports.colourInteractiveEmphasisedBgDefault = $65e18d5b60454c7a$exports.colourInteractivePrimaryBgPressedRgb = $65e18d5b60454c7a$exports.colourInteractivePrimaryBgPressed = $65e18d5b60454c7a$exports.colourInteractivePrimaryBgHoverRgb = $65e18d5b60454c7a$exports.colourInteractivePrimaryBgHover = $65e18d5b60454c7a$exports.colourInteractivePrimaryBgDefaultRgb = $65e18d5b60454c7a$exports.colourInteractivePrimaryBgDefault = $65e18d5b60454c7a$exports.colourSemanticNegativeRgb = $65e18d5b60454c7a$exports.colourSemanticNegative = $65e18d5b60454c7a$exports.colourSemanticCautionTextRgb = $65e18d5b60454c7a$exports.colourSemanticCautionText = $65e18d5b60454c7a$exports.colourSemanticCautionRgb = $65e18d5b60454c7a$exports.colourSemanticCaution = $65e18d5b60454c7a$exports.colourSemanticPositiveRgb = $65e18d5b60454c7a$exports.colourSemanticPositive = $65e18d5b60454c7a$exports.colourSemanticInformativeRgb = $65e18d5b60454c7a$exports.colourSemanticInformative = $65e18d5b60454c7a$exports.colourNeutral7Rgb = $65e18d5b60454c7a$exports.colourNeutral7 = $65e18d5b60454c7a$exports.colourNeutral6Rgb = $65e18d5b60454c7a$exports.colourNeutral6 = $65e18d5b60454c7a$exports.colourNeutral5Rgb = $65e18d5b60454c7a$exports.colourNeutral5 = $65e18d5b60454c7a$exports.colourNeutral4Rgb = $65e18d5b60454c7a$exports.colourNeutral4 = $65e18d5b60454c7a$exports.colourNeutral3Rgb = $65e18d5b60454c7a$exports.colourNeutral3 = $65e18d5b60454c7a$exports.colourNeutral2Rgb = $65e18d5b60454c7a$exports.colourNeutral2 = $65e18d5b60454c7a$exports.colourNeutral1Rgb = $65e18d5b60454c7a$exports.colourNeutral1 = $65e18d5b60454c7a$exports.colourTextAndIcon5Rgb = $65e18d5b60454c7a$exports.colourTextAndIcon5 = $65e18d5b60454c7a$exports.colourTextAndIcon4Rgb = $65e18d5b60454c7a$exports.colourTextAndIcon4 = $65e18d5b60454c7a$exports.colourTextAndIcon3Rgb = $65e18d5b60454c7a$exports.colourTextAndIcon3 = $65e18d5b60454c7a$exports.colourTextAndIcon2Rgb = $65e18d5b60454c7a$exports.colourTextAndIcon2 = $65e18d5b60454c7a$exports.colourTextAndIcon1Rgb = $65e18d5b60454c7a$exports.colourTextAndIcon1 = void 0;
$65e18d5b60454c7a$exports.colourStaticWhiteRgb = $65e18d5b60454c7a$exports.colourStaticWhite = $65e18d5b60454c7a$exports.colourStaticIkeaFamilyRgb = $65e18d5b60454c7a$exports.colourStaticIkeaFamily = $65e18d5b60454c7a$exports.colourStaticIkeaBrandYellowRgb = $65e18d5b60454c7a$exports.colourStaticIkeaBrandYellow = $65e18d5b60454c7a$exports.colourStaticIkeaBrandBlueRgb = $65e18d5b60454c7a$exports.colourStaticIkeaBrandBlue = $65e18d5b60454c7a$exports.colourInteractiveStaticSecondaryBgPressedRgb = $65e18d5b60454c7a$exports.colourInteractiveStaticSecondaryBgPressed = $65e18d5b60454c7a$exports.colourInteractiveStaticSecondaryBgHoverRgb = $65e18d5b60454c7a$exports.colourInteractiveStaticSecondaryBgHover = $65e18d5b60454c7a$exports.colourInteractiveStaticSecondaryBgDefaultRgb = $65e18d5b60454c7a$exports.colourInteractiveStaticSecondaryBgDefault = $65e18d5b60454c7a$exports.colourInteractiveStaticPrimaryBgPressedRgb = $65e18d5b60454c7a$exports.colourInteractiveStaticPrimaryBgPressed = $65e18d5b60454c7a$exports.colourInteractiveStaticPrimaryBgHoverRgb = $65e18d5b60454c7a$exports.colourInteractiveStaticPrimaryBgHover = $65e18d5b60454c7a$exports.colourInteractiveStaticPrimaryBgDefaultRgb = $65e18d5b60454c7a$exports.colourInteractiveStaticPrimaryBgDefault = $65e18d5b60454c7a$exports.colourInteractiveSubtleBorderPressedRgb = $65e18d5b60454c7a$exports.colourInteractiveSubtleBorderPressed = $65e18d5b60454c7a$exports.colourInteractiveSubtleBorderHoverRgb = $65e18d5b60454c7a$exports.colourInteractiveSubtleBorderHover = $65e18d5b60454c7a$exports.colourInteractiveSubtleBorderDefaultRgb = $65e18d5b60454c7a$exports.colourInteractiveSubtleBorderDefault = $65e18d5b60454c7a$exports.colourInteractiveSubtleBorderSelectedRgb = $65e18d5b60454c7a$exports.colourInteractiveSubtleBorderSelected = $65e18d5b60454c7a$exports.colourInteractiveEmphasisedBorderSelectedRgb = $65e18d5b60454c7a$exports.colourInteractiveEmphasisedBorderSelected = $65e18d5b60454c7a$exports.colourInteractiveDisabled3Rgb = $65e18d5b60454c7a$exports.colourInteractiveDisabled3 = $65e18d5b60454c7a$exports.colourInteractiveDisabled2Rgb = $65e18d5b60454c7a$exports.colourInteractiveDisabled2 = $65e18d5b60454c7a$exports.colourInteractiveDisabled1Rgb = $65e18d5b60454c7a$exports.colourInteractiveDisabled1 = $65e18d5b60454c7a$exports.colourInteractiveDestructiveBgPressedRgb = $65e18d5b60454c7a$exports.colourInteractiveDestructiveBgPressed = $65e18d5b60454c7a$exports.colourInteractiveDestructiveBgHoverRgb = $65e18d5b60454c7a$exports.colourInteractiveDestructiveBgHover = $65e18d5b60454c7a$exports.colourInteractiveDestructiveBgDefaultRgb = $65e18d5b60454c7a$exports.colourInteractiveDestructiveBgDefault = $65e18d5b60454c7a$exports.colourInteractiveSubtleBgPressedRgb = $65e18d5b60454c7a$exports.colourInteractiveSubtleBgPressed = $65e18d5b60454c7a$exports.colourInteractiveSubtleBgHoverRgb = $65e18d5b60454c7a$exports.colourInteractiveSubtleBgHover = $65e18d5b60454c7a$exports.colourInteractiveSubtleBgDefaultRgb = $65e18d5b60454c7a$exports.colourInteractiveSubtleBgDefault = $65e18d5b60454c7a$exports.colourInteractiveSecondaryBgPressedRgb = $65e18d5b60454c7a$exports.colourInteractiveSecondaryBgPressed = void 0;
$65e18d5b60454c7a$exports.colourCampaignSustainabilityRgb = $65e18d5b60454c7a$exports.colourCampaignSustainability = $65e18d5b60454c7a$exports.colourCommercialMessageBtiRedRgb = $65e18d5b60454c7a$exports.colourCommercialMessageBtiRed = $65e18d5b60454c7a$exports.colourCommercialMessageBtiYellowRgb = $65e18d5b60454c7a$exports.colourCommercialMessageBtiYellow = $65e18d5b60454c7a$exports.colourCommercialMessageIkeaFamilyRgb = $65e18d5b60454c7a$exports.colourCommercialMessageIkeaFamily = $65e18d5b60454c7a$exports.colourCommercialMessageNewLowerPriceRgb = $65e18d5b60454c7a$exports.colourCommercialMessageNewLowerPrice = $65e18d5b60454c7a$exports.colourCommercialMessageNewRgb = $65e18d5b60454c7a$exports.colourCommercialMessageNew = $65e18d5b60454c7a$exports.colourElevation2BorderRgb = $65e18d5b60454c7a$exports.colourElevation2Border = $65e18d5b60454c7a$exports.colourElevation1BorderRgb = $65e18d5b60454c7a$exports.colourElevation1Border = $65e18d5b60454c7a$exports.colourElevation3Rgb = $65e18d5b60454c7a$exports.colourElevation3 = $65e18d5b60454c7a$exports.colourElevation2Rgb = $65e18d5b60454c7a$exports.colourElevation2 = $65e18d5b60454c7a$exports.colourElevation1Rgb = $65e18d5b60454c7a$exports.colourElevation1 = $65e18d5b60454c7a$exports.colourStaticIkeaBusinessNetworkRgb = $65e18d5b60454c7a$exports.colourStaticIkeaBusinessNetwork = $65e18d5b60454c7a$exports.colourStaticLightGreyRgb = $65e18d5b60454c7a$exports.colourStaticLightGrey = $65e18d5b60454c7a$exports.colourStaticGreyRgb = $65e18d5b60454c7a$exports.colourStaticGrey = $65e18d5b60454c7a$exports.colourStaticDarkGreyRgb = $65e18d5b60454c7a$exports.colourStaticDarkGrey = $65e18d5b60454c7a$exports.colourStaticBlackRgb = $65e18d5b60454c7a$exports.colourStaticBlack = void 0;
/** css rgb function with reference to var, default value 17, 17, 17 (#111111) */ $65e18d5b60454c7a$exports.colourTextAndIcon1 = 'rgb(var(--colour-text-and-icon-1, 17, 17, 17))';
/** css var reference, default value 17, 17, 17 (#111111) */ $65e18d5b60454c7a$exports.colourTextAndIcon1Rgb = 'var(--colour-text-and-icon-1, 17, 17, 17)';
/** css rgb function with reference to var, default value 72, 72, 72 (#484848) */ $65e18d5b60454c7a$exports.colourTextAndIcon2 = 'rgb(var(--colour-text-and-icon-2, 72, 72, 72))';
/** css var reference, default value 72, 72, 72 (#484848) */ $65e18d5b60454c7a$exports.colourTextAndIcon2Rgb = 'var(--colour-text-and-icon-2, 72, 72, 72)';
/** css rgb function with reference to var, default value 118, 118, 118 (#767676) */ $65e18d5b60454c7a$exports.colourTextAndIcon3 = 'rgb(var(--colour-text-and-icon-3, 118, 118, 118))';
/** css var reference, default value 118, 118, 118 (#767676) */ $65e18d5b60454c7a$exports.colourTextAndIcon3Rgb = 'var(--colour-text-and-icon-3, 118, 118, 118)';
/** css rgb function with reference to var, default value 146, 146, 146 (#929292) */ $65e18d5b60454c7a$exports.colourTextAndIcon4 = 'rgb(var(--colour-text-and-icon-4, 146, 146, 146))';
/** css var reference, default value 146, 146, 146 (#929292) */ $65e18d5b60454c7a$exports.colourTextAndIcon4Rgb = 'var(--colour-text-and-icon-4, 146, 146, 146)';
/** css rgb function with reference to var, default value 255, 255, 255 (#ffffff) */ $65e18d5b60454c7a$exports.colourTextAndIcon5 = 'rgb(var(--colour-text-and-icon-5, 255, 255, 255))';
/** css var reference, default value 255, 255, 255 (#ffffff) */ $65e18d5b60454c7a$exports.colourTextAndIcon5Rgb = 'var(--colour-text-and-icon-5, 255, 255, 255)';
/** css rgb function with reference to var, default value 255, 255, 255 (#ffffff) */ $65e18d5b60454c7a$exports.colourNeutral1 = 'rgb(var(--colour-neutral-1, 255, 255, 255))';
/** css var reference, default value 255, 255, 255 (#ffffff) */ $65e18d5b60454c7a$exports.colourNeutral1Rgb = 'var(--colour-neutral-1, 255, 255, 255)';
/** css rgb function with reference to var, default value 245, 245, 245 (#f5f5f5) */ $65e18d5b60454c7a$exports.colourNeutral2 = 'rgb(var(--colour-neutral-2, 245, 245, 245))';
/** css var reference, default value 245, 245, 245 (#f5f5f5) */ $65e18d5b60454c7a$exports.colourNeutral2Rgb = 'var(--colour-neutral-2, 245, 245, 245)';
/** css rgb function with reference to var, default value 223, 223, 223 (#dfdfdf) */ $65e18d5b60454c7a$exports.colourNeutral3 = 'rgb(var(--colour-neutral-3, 223, 223, 223))';
/** css var reference, default value 223, 223, 223 (#dfdfdf) */ $65e18d5b60454c7a$exports.colourNeutral3Rgb = 'var(--colour-neutral-3, 223, 223, 223)';
/** css rgb function with reference to var, default value 204, 204, 204 (#cccccc) */ $65e18d5b60454c7a$exports.colourNeutral4 = 'rgb(var(--colour-neutral-4, 204, 204, 204))';
/** css var reference, default value 204, 204, 204 (#cccccc) */ $65e18d5b60454c7a$exports.colourNeutral4Rgb = 'var(--colour-neutral-4, 204, 204, 204)';
/** css rgb function with reference to var, default value 146, 146, 146 (#929292) */ $65e18d5b60454c7a$exports.colourNeutral5 = 'rgb(var(--colour-neutral-5, 146, 146, 146))';
/** css var reference, default value 146, 146, 146 (#929292) */ $65e18d5b60454c7a$exports.colourNeutral5Rgb = 'var(--colour-neutral-5, 146, 146, 146)';
/** css rgb function with reference to var, default value 72, 72, 72 (#484848) */ $65e18d5b60454c7a$exports.colourNeutral6 = 'rgb(var(--colour-neutral-6, 72, 72, 72))';
/** css var reference, default value 72, 72, 72 (#484848) */ $65e18d5b60454c7a$exports.colourNeutral6Rgb = 'var(--colour-neutral-6, 72, 72, 72)';
/** css rgb function with reference to var, default value 17, 17, 17 (#111111) */ $65e18d5b60454c7a$exports.colourNeutral7 = 'rgb(var(--colour-neutral-7, 17, 17, 17))';
/** css var reference, default value 17, 17, 17 (#111111) */ $65e18d5b60454c7a$exports.colourNeutral7Rgb = 'var(--colour-neutral-7, 17, 17, 17)';
/** css rgb function with reference to var, default value 0, 88, 163 (#0058a3) */ $65e18d5b60454c7a$exports.colourSemanticInformative = 'rgb(var(--colour-semantic-informative, 0, 88, 163))';
/** css var reference, default value 0, 88, 163 (#0058a3) */ $65e18d5b60454c7a$exports.colourSemanticInformativeRgb = 'var(--colour-semantic-informative, 0, 88, 163)';
/** css rgb function with reference to var, default value 10, 138, 0 (#0a8a00) */ $65e18d5b60454c7a$exports.colourSemanticPositive = 'rgb(var(--colour-semantic-positive, 10, 138, 0))';
/** css var reference, default value 10, 138, 0 (#0a8a00) */ $65e18d5b60454c7a$exports.colourSemanticPositiveRgb = 'var(--colour-semantic-positive, 10, 138, 0)';
/** css rgb function with reference to var, default value 242, 106, 47 (#F26A2F) */ $65e18d5b60454c7a$exports.colourSemanticCaution = 'rgb(var(--colour-semantic-caution, 242, 106, 47))';
/** css var reference, default value 242, 106, 47 (#F26A2F) */ $65e18d5b60454c7a$exports.colourSemanticCautionRgb = 'var(--colour-semantic-caution, 242, 106, 47)';
/** css rgb function with reference to var, default value 202, 80, 8 (#ca5008) */ $65e18d5b60454c7a$exports.colourSemanticCautionText = 'rgb(var(--colour-semantic-caution-text, 202, 80, 8))';
/** css var reference, default value 202, 80, 8 (#ca5008) */ $65e18d5b60454c7a$exports.colourSemanticCautionTextRgb = 'var(--colour-semantic-caution-text, 202, 80, 8)';
/** css rgb function with reference to var, default value 224, 7, 81 (#e00751) */ $65e18d5b60454c7a$exports.colourSemanticNegative = 'rgb(var(--colour-semantic-negative, 224, 7, 81))';
/** css var reference, default value 224, 7, 81 (#e00751) */ $65e18d5b60454c7a$exports.colourSemanticNegativeRgb = 'var(--colour-semantic-negative, 224, 7, 81)';
/** css rgb function with reference to var, default value 17, 17, 17 (#111111) */ $65e18d5b60454c7a$exports.colourInteractivePrimaryBgDefault = 'rgb(var(--colour-interactive-primary-bg-default, 17, 17, 17))';
/** css var reference, default value 17, 17, 17 (#111111) */ $65e18d5b60454c7a$exports.colourInteractivePrimaryBgDefaultRgb = 'var(--colour-interactive-primary-bg-default, 17, 17, 17)';
/** css rgb function with reference to var, default value 51, 51, 51 (#333333) */ $65e18d5b60454c7a$exports.colourInteractivePrimaryBgHover = 'rgb(var(--colour-interactive-primary-bg-hover, 51, 51, 51))';
/** css var reference, default value 51, 51, 51 (#333333) */ $65e18d5b60454c7a$exports.colourInteractivePrimaryBgHoverRgb = 'var(--colour-interactive-primary-bg-hover, 51, 51, 51)';
/** css rgb function with reference to var, default value 0, 0, 0 (#000000) */ $65e18d5b60454c7a$exports.colourInteractivePrimaryBgPressed = 'rgb(var(--colour-interactive-primary-bg-pressed, 0, 0, 0))';
/** css var reference, default value 0, 0, 0 (#000000) */ $65e18d5b60454c7a$exports.colourInteractivePrimaryBgPressedRgb = 'var(--colour-interactive-primary-bg-pressed, 0, 0, 0)';
/** css rgb function with reference to var, default value 0, 88, 163 (#0058a3) */ $65e18d5b60454c7a$exports.colourInteractiveEmphasisedBgDefault = 'rgb(var(--colour-interactive-emphasised-bg-default, 0, 88, 163))';
/** css var reference, default value 0, 88, 163 (#0058a3) */ $65e18d5b60454c7a$exports.colourInteractiveEmphasisedBgDefaultRgb = 'var(--colour-interactive-emphasised-bg-default, 0, 88, 163)';
/** css rgb function with reference to var, default value 0, 79, 147 (#004f93) */ $65e18d5b60454c7a$exports.colourInteractiveEmphasisedBgHover = 'rgb(var(--colour-interactive-emphasised-bg-hover, 0, 79, 147))';
/** css var reference, default value 0, 79, 147 (#004f93) */ $65e18d5b60454c7a$exports.colourInteractiveEmphasisedBgHoverRgb = 'var(--colour-interactive-emphasised-bg-hover, 0, 79, 147)';
/** css rgb function with reference to var, default value 0, 62, 114 (#003e72) */ $65e18d5b60454c7a$exports.colourInteractiveEmphasisedBgPressed = 'rgb(var(--colour-interactive-emphasised-bg-pressed, 0, 62, 114))';
/** css var reference, default value 0, 62, 114 (#003e72) */ $65e18d5b60454c7a$exports.colourInteractiveEmphasisedBgPressedRgb = 'var(--colour-interactive-emphasised-bg-pressed, 0, 62, 114)';
/** css rgb function with reference to var, default value 245, 245, 245 (#f5f5f5) */ $65e18d5b60454c7a$exports.colourInteractiveSecondaryBgDefault = 'rgb(var(--colour-interactive-secondary-bg-default, 245, 245, 245))';
/** css var reference, default value 245, 245, 245 (#f5f5f5) */ $65e18d5b60454c7a$exports.colourInteractiveSecondaryBgDefaultRgb = 'var(--colour-interactive-secondary-bg-default, 245, 245, 245)';
/** css rgb function with reference to var, default value 223, 223, 223 (#dfdfdf) */ $65e18d5b60454c7a$exports.colourInteractiveSecondaryBgHover = 'rgb(var(--colour-interactive-secondary-bg-hover, 223, 223, 223))';
/** css var reference, default value 223, 223, 223 (#dfdfdf) */ $65e18d5b60454c7a$exports.colourInteractiveSecondaryBgHoverRgb = 'var(--colour-interactive-secondary-bg-hover, 223, 223, 223)';
/** css rgb function with reference to var, default value 204, 204, 204 (#cccccc) */ $65e18d5b60454c7a$exports.colourInteractiveSecondaryBgPressed = 'rgb(var(--colour-interactive-secondary-bg-pressed, 204, 204, 204))';
/** css var reference, default value 204, 204, 204 (#cccccc) */ $65e18d5b60454c7a$exports.colourInteractiveSecondaryBgPressedRgb = 'var(--colour-interactive-secondary-bg-pressed, 204, 204, 204)';
/** css rgb function with reference to var, default value 255, 255, 255 (#ffffff) */ $65e18d5b60454c7a$exports.colourInteractiveSubtleBgDefault = 'rgb(var(--colour-interactive-subtle-bg-default, 255, 255, 255))';
/** css var reference, default value 255, 255, 255 (#ffffff) */ $65e18d5b60454c7a$exports.colourInteractiveSubtleBgDefaultRgb = 'var(--colour-interactive-subtle-bg-default, 255, 255, 255)';
/** css rgb function with reference to var, default value 245, 245, 245 (#f5f5f5) */ $65e18d5b60454c7a$exports.colourInteractiveSubtleBgHover = 'rgb(var(--colour-interactive-subtle-bg-hover, 245, 245, 245))';
/** css var reference, default value 245, 245, 245 (#f5f5f5) */ $65e18d5b60454c7a$exports.colourInteractiveSubtleBgHoverRgb = 'var(--colour-interactive-subtle-bg-hover, 245, 245, 245)';
/** css rgb function with reference to var, default value 223, 223, 223 (#dfdfdf) */ $65e18d5b60454c7a$exports.colourInteractiveSubtleBgPressed = 'rgb(var(--colour-interactive-subtle-bg-pressed, 223, 223, 223))';
/** css var reference, default value 223, 223, 223 (#dfdfdf) */ $65e18d5b60454c7a$exports.colourInteractiveSubtleBgPressedRgb = 'var(--colour-interactive-subtle-bg-pressed, 223, 223, 223)';
/** css rgb function with reference to var, default value 224, 7, 81 (#e00751) */ $65e18d5b60454c7a$exports.colourInteractiveDestructiveBgDefault = 'rgb(var(--colour-interactive-destructive-bg-default, 224, 7, 81))';
/** css var reference, default value 224, 7, 81 (#e00751) */ $65e18d5b60454c7a$exports.colourInteractiveDestructiveBgDefaultRgb = 'var(--colour-interactive-destructive-bg-default, 224, 7, 81)';
/** css rgb function with reference to var, default value 204, 0, 61 (#cc003d) */ $65e18d5b60454c7a$exports.colourInteractiveDestructiveBgHover = 'rgb(var(--colour-interactive-destructive-bg-hover, 204, 0, 61))';
/** css var reference, default value 204, 0, 61 (#cc003d) */ $65e18d5b60454c7a$exports.colourInteractiveDestructiveBgHoverRgb = 'var(--colour-interactive-destructive-bg-hover, 204, 0, 61)';
/** css rgb function with reference to var, default value 184, 0, 41 (#b80029) */ $65e18d5b60454c7a$exports.colourInteractiveDestructiveBgPressed = 'rgb(var(--colour-interactive-destructive-bg-pressed, 184, 0, 41))';
/** css var reference, default value 184, 0, 41 (#b80029) */ $65e18d5b60454c7a$exports.colourInteractiveDestructiveBgPressedRgb = 'var(--colour-interactive-destructive-bg-pressed, 184, 0, 41)';
/** css rgb function with reference to var, default value 204, 204, 204 (#cccccc) */ $65e18d5b60454c7a$exports.colourInteractiveDisabled1 = 'rgb(var(--colour-interactive-disabled-1, 204, 204, 204))';
/** css var reference, default value 204, 204, 204 (#cccccc) */ $65e18d5b60454c7a$exports.colourInteractiveDisabled1Rgb = 'var(--colour-interactive-disabled-1, 204, 204, 204)';
/** css rgb function with reference to var, default value 146, 146, 146 (#929292) */ $65e18d5b60454c7a$exports.colourInteractiveDisabled2 = 'rgb(var(--colour-interactive-disabled-2, 146, 146, 146))';
/** css var reference, default value 146, 146, 146 (#929292) */ $65e18d5b60454c7a$exports.colourInteractiveDisabled2Rgb = 'var(--colour-interactive-disabled-2, 146, 146, 146)';
/** css rgb function with reference to var, default value 255, 255, 255 (#ffffff) */ $65e18d5b60454c7a$exports.colourInteractiveDisabled3 = 'rgb(var(--colour-interactive-disabled-3, 255, 255, 255))';
/** css var reference, default value 255, 255, 255 (#ffffff) */ $65e18d5b60454c7a$exports.colourInteractiveDisabled3Rgb = 'var(--colour-interactive-disabled-3, 255, 255, 255)';
/** css rgb function with reference to var, default value 0, 88, 163 (#0058a3) */ $65e18d5b60454c7a$exports.colourInteractiveEmphasisedBorderSelected = 'rgb(var(--colour-interactive-emphasised-border-selected, 0, 88, 163))';
/** css var reference, default value 0, 88, 163 (#0058a3) */ $65e18d5b60454c7a$exports.colourInteractiveEmphasisedBorderSelectedRgb = 'var(--colour-interactive-emphasised-border-selected, 0, 88, 163)';
/** css rgb function with reference to var, default value 17, 17, 17 (#111111) */ $65e18d5b60454c7a$exports.colourInteractiveSubtleBorderSelected = 'rgb(var(--colour-interactive-subtle-border-selected, 17, 17, 17))';
/** css var reference, default value 17, 17, 17 (#111111) */ $65e18d5b60454c7a$exports.colourInteractiveSubtleBorderSelectedRgb = 'var(--colour-interactive-subtle-border-selected, 17, 17, 17)';
/** css rgb function with reference to var, default value 146, 146, 146 (#929292) */ $65e18d5b60454c7a$exports.colourInteractiveSubtleBorderDefault = 'rgb(var(--colour-interactive-subtle-border-default, 146, 146, 146))';
/** css var reference, default value 146, 146, 146 (#929292) */ $65e18d5b60454c7a$exports.colourInteractiveSubtleBorderDefaultRgb = 'var(--colour-interactive-subtle-border-default, 146, 146, 146)';
/** css rgb function with reference to var, default value 17, 17, 17 (#111111) */ $65e18d5b60454c7a$exports.colourInteractiveSubtleBorderHover = 'rgb(var(--colour-interactive-subtle-border-hover, 17, 17, 17))';
/** css var reference, default value 17, 17, 17 (#111111) */ $65e18d5b60454c7a$exports.colourInteractiveSubtleBorderHoverRgb = 'var(--colour-interactive-subtle-border-hover, 17, 17, 17)';
/** css rgb function with reference to var, default value 17, 17, 17 (#111111) */ $65e18d5b60454c7a$exports.colourInteractiveSubtleBorderPressed = 'rgb(var(--colour-interactive-subtle-border-pressed, 17, 17, 17))';
/** css var reference, default value 17, 17, 17 (#111111) */ $65e18d5b60454c7a$exports.colourInteractiveSubtleBorderPressedRgb = 'var(--colour-interactive-subtle-border-pressed, 17, 17, 17)';
/** css rgb function with reference to var, default value 17, 17, 17 (#111111) */ $65e18d5b60454c7a$exports.colourInteractiveStaticPrimaryBgDefault = 'rgb(var(--colour-interactive-static-primary-bg-default, 17, 17, 17))';
/** css var reference, default value 17, 17, 17 (#111111) */ $65e18d5b60454c7a$exports.colourInteractiveStaticPrimaryBgDefaultRgb = 'var(--colour-interactive-static-primary-bg-default, 17, 17, 17)';
/** css rgb function with reference to var, default value 51, 51, 51 (#333333) */ $65e18d5b60454c7a$exports.colourInteractiveStaticPrimaryBgHover = 'rgb(var(--colour-interactive-static-primary-bg-hover, 51, 51, 51))';
/** css var reference, default value 51, 51, 51 (#333333) */ $65e18d5b60454c7a$exports.colourInteractiveStaticPrimaryBgHoverRgb = 'var(--colour-interactive-static-primary-bg-hover, 51, 51, 51)';
/** css rgb function with reference to var, default value 0, 0, 0 (#000000) */ $65e18d5b60454c7a$exports.colourInteractiveStaticPrimaryBgPressed = 'rgb(var(--colour-interactive-static-primary-bg-pressed, 0, 0, 0))';
/** css var reference, default value 0, 0, 0 (#000000) */ $65e18d5b60454c7a$exports.colourInteractiveStaticPrimaryBgPressedRgb = 'var(--colour-interactive-static-primary-bg-pressed, 0, 0, 0)';
/** css rgb function with reference to var, default value 245, 245, 245 (#f5f5f5) */ $65e18d5b60454c7a$exports.colourInteractiveStaticSecondaryBgDefault = 'rgb(var(--colour-interactive-static-secondary-bg-default, 245, 245, 245))';
/** css var reference, default value 245, 245, 245 (#f5f5f5) */ $65e18d5b60454c7a$exports.colourInteractiveStaticSecondaryBgDefaultRgb = 'var(--colour-interactive-static-secondary-bg-default, 245, 245, 245)';
/** css rgb function with reference to var, default value 223, 223, 223 (#dfdfdf) */ $65e18d5b60454c7a$exports.colourInteractiveStaticSecondaryBgHover = 'rgb(var(--colour-interactive-static-secondary-bg-hover, 223, 223, 223))';
/** css var reference, default value 223, 223, 223 (#dfdfdf) */ $65e18d5b60454c7a$exports.colourInteractiveStaticSecondaryBgHoverRgb = 'var(--colour-interactive-static-secondary-bg-hover, 223, 223, 223)';
/** css rgb function with reference to var, default value 204, 204, 204 (#cccccc) */ $65e18d5b60454c7a$exports.colourInteractiveStaticSecondaryBgPressed = 'rgb(var(--colour-interactive-static-secondary-bg-pressed, 204, 204, 204))';
/** css var reference, default value 204, 204, 204 (#cccccc) */ $65e18d5b60454c7a$exports.colourInteractiveStaticSecondaryBgPressedRgb = 'var(--colour-interactive-static-secondary-bg-pressed, 204, 204, 204)';
/** css rgb function with reference to var, default value 0, 88, 163 (#0058a3) */ $65e18d5b60454c7a$exports.colourStaticIkeaBrandBlue = 'rgb(var(--colour-static-ikea-brand-blue, 0, 88, 163))';
/** css var reference, default value 0, 88, 163 (#0058a3) */ $65e18d5b60454c7a$exports.colourStaticIkeaBrandBlueRgb = 'var(--colour-static-ikea-brand-blue, 0, 88, 163)';
/** css rgb function with reference to var, default value 255, 219, 0 (#ffdb00) */ $65e18d5b60454c7a$exports.colourStaticIkeaBrandYellow = 'rgb(var(--colour-static-ikea-brand-yellow, 255, 219, 0))';
/** css var reference, default value 255, 219, 0 (#ffdb00) */ $65e18d5b60454c7a$exports.colourStaticIkeaBrandYellowRgb = 'var(--colour-static-ikea-brand-yellow, 255, 219, 0)';
/** css rgb function with reference to var, default value 0, 124, 193 (#007cc1) */ $65e18d5b60454c7a$exports.colourStaticIkeaFamily = 'rgb(var(--colour-static-ikea-family, 0, 124, 193))';
/** css var reference, default value 0, 124, 193 (#007cc1) */ $65e18d5b60454c7a$exports.colourStaticIkeaFamilyRgb = 'var(--colour-static-ikea-family, 0, 124, 193)';
/** css rgb function with reference to var, default value 255, 255, 255 (#ffffff) */ $65e18d5b60454c7a$exports.colourStaticWhite = 'rgb(var(--colour-static-white, 255, 255, 255))';
/** css var reference, default value 255, 255, 255 (#ffffff) */ $65e18d5b60454c7a$exports.colourStaticWhiteRgb = 'var(--colour-static-white, 255, 255, 255)';
/** css rgb function with reference to var, default value 17, 17, 17 (#111111) */ $65e18d5b60454c7a$exports.colourStaticBlack = 'rgb(var(--colour-static-black, 17, 17, 17))';
/** css var reference, default value 17, 17, 17 (#111111) */ $65e18d5b60454c7a$exports.colourStaticBlackRgb = 'var(--colour-static-black, 17, 17, 17)';
/** css rgb function with reference to var, default value 118, 118, 118 (#767676) */ $65e18d5b60454c7a$exports.colourStaticDarkGrey = 'rgb(var(--colour-static-dark-grey, 118, 118, 118))';
/** css var reference, default value 118, 118, 118 (#767676) */ $65e18d5b60454c7a$exports.colourStaticDarkGreyRgb = 'var(--colour-static-dark-grey, 118, 118, 118)';
/** css rgb function with reference to var, default value 223, 223, 223 (#dfdfdf) */ $65e18d5b60454c7a$exports.colourStaticGrey = 'rgb(var(--colour-static-grey, 223, 223, 223))';
/** css var reference, default value 223, 223, 223 (#dfdfdf) */ $65e18d5b60454c7a$exports.colourStaticGreyRgb = 'var(--colour-static-grey, 223, 223, 223)';
/** css rgb function with reference to var, default value 245, 245, 245 (#f5f5f5) */ $65e18d5b60454c7a$exports.colourStaticLightGrey = 'rgb(var(--colour-static-light-grey, 245, 245, 245))';
/** css var reference, default value 245, 245, 245 (#f5f5f5) */ $65e18d5b60454c7a$exports.colourStaticLightGreyRgb = 'var(--colour-static-light-grey, 245, 245, 245)';
/** css rgb function with reference to var, default value 222, 188, 156 (#DEBC9C) */ $65e18d5b60454c7a$exports.colourStaticIkeaBusinessNetwork = 'rgb(var(--colour-static-ikea-business-network, 222, 188, 156))';
/** css var reference, default value 222, 188, 156 (#DEBC9C) */ $65e18d5b60454c7a$exports.colourStaticIkeaBusinessNetworkRgb = 'var(--colour-static-ikea-business-network, 222, 188, 156)';
/** css rgb function with reference to var, default value 255, 255, 255 (#ffffff) */ $65e18d5b60454c7a$exports.colourElevation1 = 'rgb(var(--colour-elevation-1, 255, 255, 255))';
/** css var reference, default value 255, 255, 255 (#ffffff) */ $65e18d5b60454c7a$exports.colourElevation1Rgb = 'var(--colour-elevation-1, 255, 255, 255)';
/** css rgb function with reference to var, default value 255, 255, 255 (#ffffff) */ $65e18d5b60454c7a$exports.colourElevation2 = 'rgb(var(--colour-elevation-2, 255, 255, 255))';
/** css var reference, default value 255, 255, 255 (#ffffff) */ $65e18d5b60454c7a$exports.colourElevation2Rgb = 'var(--colour-elevation-2, 255, 255, 255)';
/** css rgb function with reference to var, default value 17, 17, 17 (#111111) */ $65e18d5b60454c7a$exports.colourElevation3 = 'rgb(var(--colour-elevation-3, 17, 17, 17))';
/** css var reference, default value 17, 17, 17 (#111111) */ $65e18d5b60454c7a$exports.colourElevation3Rgb = 'var(--colour-elevation-3, 17, 17, 17)';
/** css rgb function with reference to var, default value 223, 223, 223 (#dfdfdf) */ $65e18d5b60454c7a$exports.colourElevation1Border = 'rgb(var(--colour-elevation-1-border, 223, 223, 223))';
/** css var reference, default value 223, 223, 223 (#dfdfdf) */ $65e18d5b60454c7a$exports.colourElevation1BorderRgb = 'var(--colour-elevation-1-border, 223, 223, 223)';
/** css rgb function with reference to var, default value 72, 72, 72 (#484848) */ $65e18d5b60454c7a$exports.colourElevation2Border = 'rgb(var(--colour-elevation-2-border, 72, 72, 72))';
/** css var reference, default value 72, 72, 72 (#484848) */ $65e18d5b60454c7a$exports.colourElevation2BorderRgb = 'var(--colour-elevation-2-border, 72, 72, 72)';
/** css rgb function with reference to var, default value 202, 80, 8 (#ca5008) */ $65e18d5b60454c7a$exports.colourCommercialMessageNew = 'rgb(var(--colour-commercial-message-new, 202, 80, 8))';
/** css var reference, default value 202, 80, 8 (#ca5008) */ $65e18d5b60454c7a$exports.colourCommercialMessageNewRgb = 'var(--colour-commercial-message-new, 202, 80, 8)';
/** css rgb function with reference to var, default value 204, 0, 8 (#cc0008) */ $65e18d5b60454c7a$exports.colourCommercialMessageNewLowerPrice = 'rgb(var(--colour-commercial-message-new-lower-price, 204, 0, 8))';
/** css var reference, default value 204, 0, 8 (#cc0008) */ $65e18d5b60454c7a$exports.colourCommercialMessageNewLowerPriceRgb = 'var(--colour-commercial-message-new-lower-price, 204, 0, 8)';
/** css rgb function with reference to var, default value 0, 124, 193 (#007cc1) */ $65e18d5b60454c7a$exports.colourCommercialMessageIkeaFamily = 'rgb(var(--colour-commercial-message-ikea-family, 0, 124, 193))';
/** css var reference, default value 0, 124, 193 (#007cc1) */ $65e18d5b60454c7a$exports.colourCommercialMessageIkeaFamilyRgb = 'var(--colour-commercial-message-ikea-family, 0, 124, 193)';
/** css rgb function with reference to var, default value 255, 219, 0 (#ffdb00) */ $65e18d5b60454c7a$exports.colourCommercialMessageBtiYellow = 'rgb(var(--colour-commercial-message-bti-yellow, 255, 219, 0))';
/** css var reference, default value 255, 219, 0 (#ffdb00) */ $65e18d5b60454c7a$exports.colourCommercialMessageBtiYellowRgb = 'var(--colour-commercial-message-bti-yellow, 255, 219, 0)';
/** css rgb function with reference to var, default value 204, 0, 8 (#cc0008) */ $65e18d5b60454c7a$exports.colourCommercialMessageBtiRed = 'rgb(var(--colour-commercial-message-bti-red, 204, 0, 8))';
/** css var reference, default value 204, 0, 8 (#cc0008) */ $65e18d5b60454c7a$exports.colourCommercialMessageBtiRedRgb = 'var(--colour-commercial-message-bti-red, 204, 0, 8)';
/** css rgb function with reference to var, default value 0, 133, 62 (#00853e) */ $65e18d5b60454c7a$exports.colourCampaignSustainability = 'rgb(var(--colour-campaign-sustainability, 0, 133, 62))';
/** css var reference, default value 0, 133, 62 (#00853e) */ $65e18d5b60454c7a$exports.colourCampaignSustainabilityRgb = 'var(--colour-campaign-sustainability, 0, 133, 62)';
$65e18d5b60454c7a$exports.default = {
    colourTextAndIcon1: $65e18d5b60454c7a$exports.colourTextAndIcon1,
    colourTextAndIcon1Rgb: $65e18d5b60454c7a$exports.colourTextAndIcon1Rgb,
    colourTextAndIcon2: $65e18d5b60454c7a$exports.colourTextAndIcon2,
    colourTextAndIcon2Rgb: $65e18d5b60454c7a$exports.colourTextAndIcon2Rgb,
    colourTextAndIcon3: $65e18d5b60454c7a$exports.colourTextAndIcon3,
    colourTextAndIcon3Rgb: $65e18d5b60454c7a$exports.colourTextAndIcon3Rgb,
    colourTextAndIcon4: $65e18d5b60454c7a$exports.colourTextAndIcon4,
    colourTextAndIcon4Rgb: $65e18d5b60454c7a$exports.colourTextAndIcon4Rgb,
    colourTextAndIcon5: $65e18d5b60454c7a$exports.colourTextAndIcon5,
    colourTextAndIcon5Rgb: $65e18d5b60454c7a$exports.colourTextAndIcon5Rgb,
    colourNeutral1: $65e18d5b60454c7a$exports.colourNeutral1,
    colourNeutral1Rgb: $65e18d5b60454c7a$exports.colourNeutral1Rgb,
    colourNeutral2: $65e18d5b60454c7a$exports.colourNeutral2,
    colourNeutral2Rgb: $65e18d5b60454c7a$exports.colourNeutral2Rgb,
    colourNeutral3: $65e18d5b60454c7a$exports.colourNeutral3,
    colourNeutral3Rgb: $65e18d5b60454c7a$exports.colourNeutral3Rgb,
    colourNeutral4: $65e18d5b60454c7a$exports.colourNeutral4,
    colourNeutral4Rgb: $65e18d5b60454c7a$exports.colourNeutral4Rgb,
    colourNeutral5: $65e18d5b60454c7a$exports.colourNeutral5,
    colourNeutral5Rgb: $65e18d5b60454c7a$exports.colourNeutral5Rgb,
    colourNeutral6: $65e18d5b60454c7a$exports.colourNeutral6,
    colourNeutral6Rgb: $65e18d5b60454c7a$exports.colourNeutral6Rgb,
    colourNeutral7: $65e18d5b60454c7a$exports.colourNeutral7,
    colourNeutral7Rgb: $65e18d5b60454c7a$exports.colourNeutral7Rgb,
    colourSemanticInformative: $65e18d5b60454c7a$exports.colourSemanticInformative,
    colourSemanticInformativeRgb: $65e18d5b60454c7a$exports.colourSemanticInformativeRgb,
    colourSemanticPositive: $65e18d5b60454c7a$exports.colourSemanticPositive,
    colourSemanticPositiveRgb: $65e18d5b60454c7a$exports.colourSemanticPositiveRgb,
    colourSemanticCaution: $65e18d5b60454c7a$exports.colourSemanticCaution,
    colourSemanticCautionRgb: $65e18d5b60454c7a$exports.colourSemanticCautionRgb,
    colourSemanticCautionText: $65e18d5b60454c7a$exports.colourSemanticCautionText,
    colourSemanticCautionTextRgb: $65e18d5b60454c7a$exports.colourSemanticCautionTextRgb,
    colourSemanticNegative: $65e18d5b60454c7a$exports.colourSemanticNegative,
    colourSemanticNegativeRgb: $65e18d5b60454c7a$exports.colourSemanticNegativeRgb,
    colourInteractivePrimaryBgDefault: $65e18d5b60454c7a$exports.colourInteractivePrimaryBgDefault,
    colourInteractivePrimaryBgDefaultRgb: $65e18d5b60454c7a$exports.colourInteractivePrimaryBgDefaultRgb,
    colourInteractivePrimaryBgHover: $65e18d5b60454c7a$exports.colourInteractivePrimaryBgHover,
    colourInteractivePrimaryBgHoverRgb: $65e18d5b60454c7a$exports.colourInteractivePrimaryBgHoverRgb,
    colourInteractivePrimaryBgPressed: $65e18d5b60454c7a$exports.colourInteractivePrimaryBgPressed,
    colourInteractivePrimaryBgPressedRgb: $65e18d5b60454c7a$exports.colourInteractivePrimaryBgPressedRgb,
    colourInteractiveEmphasisedBgDefault: $65e18d5b60454c7a$exports.colourInteractiveEmphasisedBgDefault,
    colourInteractiveEmphasisedBgDefaultRgb: $65e18d5b60454c7a$exports.colourInteractiveEmphasisedBgDefaultRgb,
    colourInteractiveEmphasisedBgHover: $65e18d5b60454c7a$exports.colourInteractiveEmphasisedBgHover,
    colourInteractiveEmphasisedBgHoverRgb: $65e18d5b60454c7a$exports.colourInteractiveEmphasisedBgHoverRgb,
    colourInteractiveEmphasisedBgPressed: $65e18d5b60454c7a$exports.colourInteractiveEmphasisedBgPressed,
    colourInteractiveEmphasisedBgPressedRgb: $65e18d5b60454c7a$exports.colourInteractiveEmphasisedBgPressedRgb,
    colourInteractiveSecondaryBgDefault: $65e18d5b60454c7a$exports.colourInteractiveSecondaryBgDefault,
    colourInteractiveSecondaryBgDefaultRgb: $65e18d5b60454c7a$exports.colourInteractiveSecondaryBgDefaultRgb,
    colourInteractiveSecondaryBgHover: $65e18d5b60454c7a$exports.colourInteractiveSecondaryBgHover,
    colourInteractiveSecondaryBgHoverRgb: $65e18d5b60454c7a$exports.colourInteractiveSecondaryBgHoverRgb,
    colourInteractiveSecondaryBgPressed: $65e18d5b60454c7a$exports.colourInteractiveSecondaryBgPressed,
    colourInteractiveSecondaryBgPressedRgb: $65e18d5b60454c7a$exports.colourInteractiveSecondaryBgPressedRgb,
    colourInteractiveSubtleBgDefault: $65e18d5b60454c7a$exports.colourInteractiveSubtleBgDefault,
    colourInteractiveSubtleBgDefaultRgb: $65e18d5b60454c7a$exports.colourInteractiveSubtleBgDefaultRgb,
    colourInteractiveSubtleBgHover: $65e18d5b60454c7a$exports.colourInteractiveSubtleBgHover,
    colourInteractiveSubtleBgHoverRgb: $65e18d5b60454c7a$exports.colourInteractiveSubtleBgHoverRgb,
    colourInteractiveSubtleBgPressed: $65e18d5b60454c7a$exports.colourInteractiveSubtleBgPressed,
    colourInteractiveSubtleBgPressedRgb: $65e18d5b60454c7a$exports.colourInteractiveSubtleBgPressedRgb,
    colourInteractiveDestructiveBgDefault: $65e18d5b60454c7a$exports.colourInteractiveDestructiveBgDefault,
    colourInteractiveDestructiveBgDefaultRgb: $65e18d5b60454c7a$exports.colourInteractiveDestructiveBgDefaultRgb,
    colourInteractiveDestructiveBgHover: $65e18d5b60454c7a$exports.colourInteractiveDestructiveBgHover,
    colourInteractiveDestructiveBgHoverRgb: $65e18d5b60454c7a$exports.colourInteractiveDestructiveBgHoverRgb,
    colourInteractiveDestructiveBgPressed: $65e18d5b60454c7a$exports.colourInteractiveDestructiveBgPressed,
    colourInteractiveDestructiveBgPressedRgb: $65e18d5b60454c7a$exports.colourInteractiveDestructiveBgPressedRgb,
    colourInteractiveDisabled1: $65e18d5b60454c7a$exports.colourInteractiveDisabled1,
    colourInteractiveDisabled1Rgb: $65e18d5b60454c7a$exports.colourInteractiveDisabled1Rgb,
    colourInteractiveDisabled2: $65e18d5b60454c7a$exports.colourInteractiveDisabled2,
    colourInteractiveDisabled2Rgb: $65e18d5b60454c7a$exports.colourInteractiveDisabled2Rgb,
    colourInteractiveDisabled3: $65e18d5b60454c7a$exports.colourInteractiveDisabled3,
    colourInteractiveDisabled3Rgb: $65e18d5b60454c7a$exports.colourInteractiveDisabled3Rgb,
    colourInteractiveEmphasisedBorderSelected: $65e18d5b60454c7a$exports.colourInteractiveEmphasisedBorderSelected,
    colourInteractiveEmphasisedBorderSelectedRgb: $65e18d5b60454c7a$exports.colourInteractiveEmphasisedBorderSelectedRgb,
    colourInteractiveSubtleBorderSelected: $65e18d5b60454c7a$exports.colourInteractiveSubtleBorderSelected,
    colourInteractiveSubtleBorderSelectedRgb: $65e18d5b60454c7a$exports.colourInteractiveSubtleBorderSelectedRgb,
    colourInteractiveSubtleBorderDefault: $65e18d5b60454c7a$exports.colourInteractiveSubtleBorderDefault,
    colourInteractiveSubtleBorderDefaultRgb: $65e18d5b60454c7a$exports.colourInteractiveSubtleBorderDefaultRgb,
    colourInteractiveSubtleBorderHover: $65e18d5b60454c7a$exports.colourInteractiveSubtleBorderHover,
    colourInteractiveSubtleBorderHoverRgb: $65e18d5b60454c7a$exports.colourInteractiveSubtleBorderHoverRgb,
    colourInteractiveSubtleBorderPressed: $65e18d5b60454c7a$exports.colourInteractiveSubtleBorderPressed,
    colourInteractiveSubtleBorderPressedRgb: $65e18d5b60454c7a$exports.colourInteractiveSubtleBorderPressedRgb,
    colourInteractiveStaticPrimaryBgDefault: $65e18d5b60454c7a$exports.colourInteractiveStaticPrimaryBgDefault,
    colourInteractiveStaticPrimaryBgDefaultRgb: $65e18d5b60454c7a$exports.colourInteractiveStaticPrimaryBgDefaultRgb,
    colourInteractiveStaticPrimaryBgHover: $65e18d5b60454c7a$exports.colourInteractiveStaticPrimaryBgHover,
    colourInteractiveStaticPrimaryBgHoverRgb: $65e18d5b60454c7a$exports.colourInteractiveStaticPrimaryBgHoverRgb,
    colourInteractiveStaticPrimaryBgPressed: $65e18d5b60454c7a$exports.colourInteractiveStaticPrimaryBgPressed,
    colourInteractiveStaticPrimaryBgPressedRgb: $65e18d5b60454c7a$exports.colourInteractiveStaticPrimaryBgPressedRgb,
    colourInteractiveStaticSecondaryBgDefault: $65e18d5b60454c7a$exports.colourInteractiveStaticSecondaryBgDefault,
    colourInteractiveStaticSecondaryBgDefaultRgb: $65e18d5b60454c7a$exports.colourInteractiveStaticSecondaryBgDefaultRgb,
    colourInteractiveStaticSecondaryBgHover: $65e18d5b60454c7a$exports.colourInteractiveStaticSecondaryBgHover,
    colourInteractiveStaticSecondaryBgHoverRgb: $65e18d5b60454c7a$exports.colourInteractiveStaticSecondaryBgHoverRgb,
    colourInteractiveStaticSecondaryBgPressed: $65e18d5b60454c7a$exports.colourInteractiveStaticSecondaryBgPressed,
    colourInteractiveStaticSecondaryBgPressedRgb: $65e18d5b60454c7a$exports.colourInteractiveStaticSecondaryBgPressedRgb,
    colourStaticIkeaBrandBlue: $65e18d5b60454c7a$exports.colourStaticIkeaBrandBlue,
    colourStaticIkeaBrandBlueRgb: $65e18d5b60454c7a$exports.colourStaticIkeaBrandBlueRgb,
    colourStaticIkeaBrandYellow: $65e18d5b60454c7a$exports.colourStaticIkeaBrandYellow,
    colourStaticIkeaBrandYellowRgb: $65e18d5b60454c7a$exports.colourStaticIkeaBrandYellowRgb,
    colourStaticIkeaFamily: $65e18d5b60454c7a$exports.colourStaticIkeaFamily,
    colourStaticIkeaFamilyRgb: $65e18d5b60454c7a$exports.colourStaticIkeaFamilyRgb,
    colourStaticWhite: $65e18d5b60454c7a$exports.colourStaticWhite,
    colourStaticWhiteRgb: $65e18d5b60454c7a$exports.colourStaticWhiteRgb,
    colourStaticBlack: $65e18d5b60454c7a$exports.colourStaticBlack,
    colourStaticBlackRgb: $65e18d5b60454c7a$exports.colourStaticBlackRgb,
    colourStaticDarkGrey: $65e18d5b60454c7a$exports.colourStaticDarkGrey,
    colourStaticDarkGreyRgb: $65e18d5b60454c7a$exports.colourStaticDarkGreyRgb,
    colourStaticGrey: $65e18d5b60454c7a$exports.colourStaticGrey,
    colourStaticGreyRgb: $65e18d5b60454c7a$exports.colourStaticGreyRgb,
    colourStaticLightGrey: $65e18d5b60454c7a$exports.colourStaticLightGrey,
    colourStaticLightGreyRgb: $65e18d5b60454c7a$exports.colourStaticLightGreyRgb,
    colourStaticIkeaBusinessNetwork: $65e18d5b60454c7a$exports.colourStaticIkeaBusinessNetwork,
    colourStaticIkeaBusinessNetworkRgb: $65e18d5b60454c7a$exports.colourStaticIkeaBusinessNetworkRgb,
    colourElevation1: $65e18d5b60454c7a$exports.colourElevation1,
    colourElevation1Rgb: $65e18d5b60454c7a$exports.colourElevation1Rgb,
    colourElevation2: $65e18d5b60454c7a$exports.colourElevation2,
    colourElevation2Rgb: $65e18d5b60454c7a$exports.colourElevation2Rgb,
    colourElevation3: $65e18d5b60454c7a$exports.colourElevation3,
    colourElevation3Rgb: $65e18d5b60454c7a$exports.colourElevation3Rgb,
    colourElevation1Border: $65e18d5b60454c7a$exports.colourElevation1Border,
    colourElevation1BorderRgb: $65e18d5b60454c7a$exports.colourElevation1BorderRgb,
    colourElevation2Border: $65e18d5b60454c7a$exports.colourElevation2Border,
    colourElevation2BorderRgb: $65e18d5b60454c7a$exports.colourElevation2BorderRgb,
    colourCommercialMessageNew: $65e18d5b60454c7a$exports.colourCommercialMessageNew,
    colourCommercialMessageNewRgb: $65e18d5b60454c7a$exports.colourCommercialMessageNewRgb,
    colourCommercialMessageNewLowerPrice: $65e18d5b60454c7a$exports.colourCommercialMessageNewLowerPrice,
    colourCommercialMessageNewLowerPriceRgb: $65e18d5b60454c7a$exports.colourCommercialMessageNewLowerPriceRgb,
    colourCommercialMessageIkeaFamily: $65e18d5b60454c7a$exports.colourCommercialMessageIkeaFamily,
    colourCommercialMessageIkeaFamilyRgb: $65e18d5b60454c7a$exports.colourCommercialMessageIkeaFamilyRgb,
    colourCommercialMessageBtiYellow: $65e18d5b60454c7a$exports.colourCommercialMessageBtiYellow,
    colourCommercialMessageBtiYellowRgb: $65e18d5b60454c7a$exports.colourCommercialMessageBtiYellowRgb,
    colourCommercialMessageBtiRed: $65e18d5b60454c7a$exports.colourCommercialMessageBtiRed,
    colourCommercialMessageBtiRedRgb: $65e18d5b60454c7a$exports.colourCommercialMessageBtiRedRgb,
    colourCampaignSustainability: $65e18d5b60454c7a$exports.colourCampaignSustainability,
    colourCampaignSustainabilityRgb: $65e18d5b60454c7a$exports.colourCampaignSustainabilityRgb
};



const $f0cd4f5955eeda77$export$c5b6f123b39cf573 = (0, $a40bd87bc05fc082$export$2e2bcd8739ae039).div`
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;




const $195cb77f2a25c277$var$CardContainer = (0, $a40bd87bc05fc082$export$2e2bcd8739ae039).div`
  margin: 8px 0 !important;
  span{
    span{ 
      display: none;
    }
  }
`;
const $195cb77f2a25c277$var$TextDescription = (0, $a40bd87bc05fc082$export$2e2bcd8739ae039).div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 220px;
  max-height: 220px;
`;
class $195cb77f2a25c277$var$TitleComp extends (0, $aXNcS.default).Component {
    render() {
        return /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)("a", {
            children: this.props.title
        });
    }
}
class $195cb77f2a25c277$var$CatComp extends (0, $aXNcS.default).Component {
    render() {
        return /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)("a", {
            children: this.props.category
        });
    }
}
// The conditional check for variant is used for A/B-test. 
const $195cb77f2a25c277$var$ArticleCard = ({ id: id, title: title, category: category, variant: variant, onClick: onClick, onKeyPress: onKeyPress, description: description })=>{
    return /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)($195cb77f2a25c277$var$CardContainer, {
        children: /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($f094668ecc4481a4$exports))), {
            label: category ? /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)($195cb77f2a25c277$var$CatComp, {
                category: category.substring(category.lastIndexOf("/") + 1)
            }) : '',
            body: description,
            id: id,
            title: /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)($195cb77f2a25c277$var$TitleComp, {
                title: title
            }),
            tabIndex: 0,
            backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($65e18d5b60454c7a$exports))).colourNeutral2,
            buttonVariant: "icon-primary-inverse",
            emphasised: true,
            onClick: onClick,
            onKeyPress: onKeyPress,
            ctaLabel: "open article",
            children: /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)((0, $fUX2S.Fragment), {
                children: /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)((0, $f0cd4f5955eeda77$export$c5b6f123b39cf573), {
                    children: 'press enter to open full article'
                })
            })
        })
    });
};
var $195cb77f2a25c277$export$2e2bcd8739ae039 = $195cb77f2a25c277$var$ArticleCard;




var $71265fa99aff43d1$exports = {};
var $ded606fa4987f091$exports = {};
function $ded606fa4987f091$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
$ded606fa4987f091$exports = $ded606fa4987f091$var$_arrayWithHoles, $ded606fa4987f091$exports.__esModule = true, $ded606fa4987f091$exports["default"] = $ded606fa4987f091$exports;


var $2b4ce45a87dce209$exports = {};
function $2b4ce45a87dce209$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$2b4ce45a87dce209$exports = $2b4ce45a87dce209$var$_iterableToArrayLimit, $2b4ce45a87dce209$exports.__esModule = true, $2b4ce45a87dce209$exports["default"] = $2b4ce45a87dce209$exports;


var $648e5413b667ecf3$exports = {};
var $0b18ad47f7945e3c$exports = {};
function $0b18ad47f7945e3c$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$0b18ad47f7945e3c$exports = $0b18ad47f7945e3c$var$_arrayLikeToArray, $0b18ad47f7945e3c$exports.__esModule = true, $0b18ad47f7945e3c$exports["default"] = $0b18ad47f7945e3c$exports;


function $648e5413b667ecf3$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $0b18ad47f7945e3c$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $0b18ad47f7945e3c$exports(r, a) : void 0;
    }
}
$648e5413b667ecf3$exports = $648e5413b667ecf3$var$_unsupportedIterableToArray, $648e5413b667ecf3$exports.__esModule = true, $648e5413b667ecf3$exports["default"] = $648e5413b667ecf3$exports;


var $9c44df681ac06bf2$exports = {};
function $9c44df681ac06bf2$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$9c44df681ac06bf2$exports = $9c44df681ac06bf2$var$_nonIterableRest, $9c44df681ac06bf2$exports.__esModule = true, $9c44df681ac06bf2$exports["default"] = $9c44df681ac06bf2$exports;


function $71265fa99aff43d1$var$_slicedToArray(r, e) {
    return $ded606fa4987f091$exports(r) || $2b4ce45a87dce209$exports(r, e) || $648e5413b667ecf3$exports(r, e) || $9c44df681ac06bf2$exports();
}
$71265fa99aff43d1$exports = $71265fa99aff43d1$var$_slicedToArray, $71265fa99aff43d1$exports.__esModule = true, $71265fa99aff43d1$exports["default"] = $71265fa99aff43d1$exports;


var $1f4740afd5c0e9da$exports = {};
var $78fc20b0505201d6$exports = {};
var $ee301111719d6f71$exports = {};
function $ee301111719d6f71$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ee301111719d6f71$exports = $ee301111719d6f71$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ee301111719d6f71$exports.__esModule = true, $ee301111719d6f71$exports["default"] = $ee301111719d6f71$exports, $ee301111719d6f71$var$_typeof(o);
}
$ee301111719d6f71$exports = $ee301111719d6f71$var$_typeof, $ee301111719d6f71$exports.__esModule = true, $ee301111719d6f71$exports["default"] = $ee301111719d6f71$exports;


var $78fc20b0505201d6$var$_typeof = $ee301111719d6f71$exports.default;
var $bc347fa0257de455$exports = {};

var $bc347fa0257de455$var$_typeof = $ee301111719d6f71$exports.default;
function $bc347fa0257de455$var$toPrimitive(t, r) {
    if ("object" != $bc347fa0257de455$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $bc347fa0257de455$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$bc347fa0257de455$exports = $bc347fa0257de455$var$toPrimitive, $bc347fa0257de455$exports.__esModule = true, $bc347fa0257de455$exports["default"] = $bc347fa0257de455$exports;


function $78fc20b0505201d6$var$toPropertyKey(t) {
    var i = $bc347fa0257de455$exports(t, "string");
    return "symbol" == $78fc20b0505201d6$var$_typeof(i) ? i : i + "";
}
$78fc20b0505201d6$exports = $78fc20b0505201d6$var$toPropertyKey, $78fc20b0505201d6$exports.__esModule = true, $78fc20b0505201d6$exports["default"] = $78fc20b0505201d6$exports;


function $1f4740afd5c0e9da$var$_defineProperty(e, r, t) {
    return (r = $78fc20b0505201d6$exports(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
$1f4740afd5c0e9da$exports = $1f4740afd5c0e9da$var$_defineProperty, $1f4740afd5c0e9da$exports.__esModule = true, $1f4740afd5c0e9da$exports["default"] = $1f4740afd5c0e9da$exports;


parcelRequire("aXNcS");
var $fqaWh = parcelRequire("fqaWh");
var $dd33cb24853a3969$exports = {};
function $dd33cb24853a3969$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
$dd33cb24853a3969$exports = $dd33cb24853a3969$var$_classCallCheck, $dd33cb24853a3969$exports.__esModule = true, $dd33cb24853a3969$exports["default"] = $dd33cb24853a3969$exports;


var $37cd463fd02d7812$exports = {};

function $37cd463fd02d7812$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $78fc20b0505201d6$exports(o.key), o);
    }
}
function $37cd463fd02d7812$var$_createClass(e, r, t) {
    return r && $37cd463fd02d7812$var$_defineProperties(e.prototype, r), t && $37cd463fd02d7812$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
$37cd463fd02d7812$exports = $37cd463fd02d7812$var$_createClass, $37cd463fd02d7812$exports.__esModule = true, $37cd463fd02d7812$exports["default"] = $37cd463fd02d7812$exports;




var $aXNcS = parcelRequire("aXNcS");
function $9d2df5ee7800c19d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9d2df5ee7800c19d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $9d2df5ee7800c19d$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($1f4740afd5c0e9da$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $9d2df5ee7800c19d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $9d2df5ee7800c19d$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true
};
var $9d2df5ee7800c19d$var$i18nInstance;
var $9d2df5ee7800c19d$export$5603ab5ced17ce64 = (0, $aXNcS.default).createContext();
function $9d2df5ee7800c19d$export$2e2366488d12e20d() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $9d2df5ee7800c19d$var$defaultOptions = $9d2df5ee7800c19d$var$_objectSpread($9d2df5ee7800c19d$var$_objectSpread({}, $9d2df5ee7800c19d$var$defaultOptions), options);
}
function $9d2df5ee7800c19d$export$212bb2fc580a90a8() {
    return $9d2df5ee7800c19d$var$defaultOptions;
}
var $9d2df5ee7800c19d$export$ea171b67e3820290 = function() {
    function ReportNamespaces() {
        (0, (/*@__PURE__*/$parcel$interopDefault($dd33cb24853a3969$exports)))(this, ReportNamespaces);
        this.usedNamespaces = {};
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($37cd463fd02d7812$exports)))(ReportNamespaces, [
        {
            key: "addUsedNamespaces",
            value: function addUsedNamespaces(namespaces) {
                var _this = this;
                namespaces.forEach(function(ns) {
                    if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
                });
            }
        },
        {
            key: "getUsedNamespaces",
            value: function getUsedNamespaces() {
                return Object.keys(this.usedNamespaces);
            }
        }
    ]);
    return ReportNamespaces;
}();
function $9d2df5ee7800c19d$export$a039134f2fc7e0(instance) {
    $9d2df5ee7800c19d$var$i18nInstance = instance;
}
function $9d2df5ee7800c19d$export$64af334f494c2f47() {
    return $9d2df5ee7800c19d$var$i18nInstance;
}
var $9d2df5ee7800c19d$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init: function init(instance) {
        $9d2df5ee7800c19d$export$2e2366488d12e20d(instance.options.react);
        $9d2df5ee7800c19d$export$a039134f2fc7e0(instance);
    }
};
function $9d2df5ee7800c19d$export$30ff0342ccf735a(ForComponent) {
    return function(ctx) {
        return new Promise(function(resolve) {
            var i18nInitialProps = $9d2df5ee7800c19d$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then(function(componentsInitialProps) {
                resolve($9d2df5ee7800c19d$var$_objectSpread($9d2df5ee7800c19d$var$_objectSpread({}, componentsInitialProps), i18nInitialProps));
            });
            else resolve(i18nInitialProps);
        });
    };
}
function $9d2df5ee7800c19d$export$704200e5d0b9e8f() {
    var i18n = $9d2df5ee7800c19d$export$64af334f494c2f47();
    var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    var ret = {};
    var initialI18nStore = {};
    i18n.languages.forEach(function(l) {
        initialI18nStore[l] = {};
        namespaces.forEach(function(ns) {
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}


function $2c40aa85a20a6fb5$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        var _console;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);
        (_console = console).warn.apply(_console, args);
    }
}
var $2c40aa85a20a6fb5$var$alreadyWarned = {};
function $2c40aa85a20a6fb5$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === 'string' && $2c40aa85a20a6fb5$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === 'string') $2c40aa85a20a6fb5$var$alreadyWarned[args[0]] = new Date();
    $2c40aa85a20a6fb5$export$c106dd0671a0fc2d.apply(void 0, args);
}
function $2c40aa85a20a6fb5$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, function() {
        if (i18n.isInitialized) cb();
        else {
            var initialized = function initialized() {
                setTimeout(function() {
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    });
}
function $2c40aa85a20a6fb5$export$93d9ee97c1ad3f31(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $2c40aa85a20a6fb5$export$5b28268982f175ba('i18n.languages were undefined or empty', i18n.languages);
        return true;
    }
    var lng = i18n.languages[0];
    var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    var lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === 'cimode') return true;
    var loadNotPending = function loadNotPending(l, n) {
        var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $2c40aa85a20a6fb5$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}


function $f4ab155f387ca43d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f4ab155f387ca43d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $f4ab155f387ca43d$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($1f4740afd5c0e9da$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $f4ab155f387ca43d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f4ab155f387ca43d$export$9fc83ad70ead8663(ns) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $fqaWh.useContext)((0, $9d2df5ee7800c19d$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref.i18n, defaultNSFromContext = _ref.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $9d2df5ee7800c19d$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $9d2df5ee7800c19d$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $2c40aa85a20a6fb5$export$5b28268982f175ba)('You will need to pass in an i18next instance by using initReactI18next');
        var notReadyT = function notReadyT(k) {
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        var retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $2c40aa85a20a6fb5$export$5b28268982f175ba)('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
    var i18nOptions = $f4ab155f387ca43d$var$_objectSpread($f4ab155f387ca43d$var$_objectSpread($f4ab155f387ca43d$var$_objectSpread({}, (0, $9d2df5ee7800c19d$export$212bb2fc580a90a8)()), i18n.options.react), props);
    var useSuspense = i18nOptions.useSuspense;
    var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === 'string' ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function(n) {
        return (0, $2c40aa85a20a6fb5$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions);
    });
    function getT() {
        return i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0]);
    }
    var _useState = (0, $fqaWh.useState)(getT), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($71265fa99aff43d1$exports)))(_useState, 2), t = _useState2[0], setT = _useState2[1];
    var isMounted = (0, $fqaWh.useRef)(true);
    (0, $fqaWh.useEffect)(function() {
        var bindI18n = i18nOptions.bindI18n, bindI18nStore = i18nOptions.bindI18nStore;
        isMounted.current = true;
        if (!ready && !useSuspense) (0, $2c40aa85a20a6fb5$export$83be934b53fff43b)(i18n, namespaces, function() {
            if (isMounted.current) setT(getT);
        });
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return function() {
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(' ').forEach(function(e) {
                return i18n.off(e, boundReset);
            });
            if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function(e) {
                return i18n.store.off(e, boundReset);
            });
        };
    }, [
        i18n,
        namespaces.join()
    ]);
    var isInitial = (0, $fqaWh.useRef)(true);
    (0, $fqaWh.useEffect)(function() {
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n
    ]);
    var ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise(function(resolve) {
        (0, $2c40aa85a20a6fb5$export$83be934b53fff43b)(i18n, namespaces, function() {
            resolve();
        });
    });
}



var $bOlkA = parcelRequire("bOlkA");


var $aXNcS = parcelRequire("aXNcS");


var $aXNcS = parcelRequire("aXNcS");

var $3LGzW = parcelRequire("3LGzW");

const $dbf2b2b7fc402033$export$6dd930cb699ce12e = ({ prefix: prefix = "", className: className, viewBox: viewBox = "0 0 24 24", ariaHidden: ariaHidden = true, children: children, ...other })=>{
    return /* @__PURE__ */ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)("svg", {
        viewBox: viewBox,
        focusable: "false",
        width: "24",
        height: "24",
        ...other,
        "aria-hidden": ariaHidden,
        className: `${prefix}svg-icon${className ? ` ${className}` : ""}`,
        children: children
    });
};


const $40d02841b07afed5$var$SSRIcon = (props)=>{
    const { prefix: prefix = "", viewBox: viewBox = "0 0 24 24", paths: paths, className: className, modifier: modifier, ariaHidden: ariaHidden = true, ...otherProps } = props;
    const cssStyles = (0, (/*@__PURE__*/$parcel$interopDefault($3LGzW)))(className, modifier && `${prefix}svg-icon--${modifier}`);
    return paths ? /* @__PURE__ */ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)((0, $dbf2b2b7fc402033$export$6dd930cb699ce12e), {
        viewBox: viewBox,
        prefix: prefix,
        ...otherProps,
        className: cssStyles,
        ariaHidden: ariaHidden,
        children: paths().map((path, id)=>{
            return (0, $aXNcS.default).cloneElement(path, {
                key: id
            });
        })
    }) : null;
};
var $40d02841b07afed5$export$2e2bcd8739ae039 = $40d02841b07afed5$var$SSRIcon;


var $e4ff9f689fddbc04$export$2e2bcd8739ae039 = (0, $40d02841b07afed5$export$2e2bcd8739ae039);



var $3LGzW = parcelRequire("3LGzW");
var $a7d469822a4d2e98$exports = {};
"use strict";
var $a7d469822a4d2e98$var$__create = Object.create;
var $a7d469822a4d2e98$var$__defProp = Object.defineProperty;
var $a7d469822a4d2e98$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $a7d469822a4d2e98$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $a7d469822a4d2e98$var$__getProtoOf = Object.getPrototypeOf;
var $a7d469822a4d2e98$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $a7d469822a4d2e98$var$__export = (target, all)=>{
    for(var name in all)$a7d469822a4d2e98$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $a7d469822a4d2e98$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $a7d469822a4d2e98$var$__getOwnPropNames(from))if (!$a7d469822a4d2e98$var$__hasOwnProp.call(to, key) && key !== except) $a7d469822a4d2e98$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $a7d469822a4d2e98$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $a7d469822a4d2e98$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $a7d469822a4d2e98$var$__create($a7d469822a4d2e98$var$__getProtoOf(mod)) : {}, $a7d469822a4d2e98$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $a7d469822a4d2e98$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var $a7d469822a4d2e98$var$__toCommonJS = (mod)=>$a7d469822a4d2e98$var$__copyProps($a7d469822a4d2e98$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $a7d469822a4d2e98$var$warning_triangle_exports = {};
$a7d469822a4d2e98$var$__export($a7d469822a4d2e98$var$warning_triangle_exports, {
    default: ()=>$a7d469822a4d2e98$var$warning_triangle_default
});
$a7d469822a4d2e98$exports = $a7d469822a4d2e98$var$__toCommonJS($a7d469822a4d2e98$var$warning_triangle_exports);

var $a7d469822a4d2e98$var$import_warning_triangle = $a7d469822a4d2e98$var$__toESM((parcelRequire("fg7Qi")));
var $37ab4b12dc44840d$exports = {};
"use strict";
var $37ab4b12dc44840d$var$__defProp = Object.defineProperty;
var $37ab4b12dc44840d$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $37ab4b12dc44840d$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $37ab4b12dc44840d$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $37ab4b12dc44840d$var$__export = (target, all)=>{
    for(var name in all)$37ab4b12dc44840d$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $37ab4b12dc44840d$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $37ab4b12dc44840d$var$__getOwnPropNames(from))if (!$37ab4b12dc44840d$var$__hasOwnProp.call(to, key) && key !== except) $37ab4b12dc44840d$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $37ab4b12dc44840d$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $37ab4b12dc44840d$var$__toCommonJS = (mod)=>$37ab4b12dc44840d$var$__copyProps($37ab4b12dc44840d$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $37ab4b12dc44840d$var$renderPaths_exports = {};
$37ab4b12dc44840d$var$__export($37ab4b12dc44840d$var$renderPaths_exports, {
    renderPaths: ()=>$37ab4b12dc44840d$var$renderPaths
});
$37ab4b12dc44840d$exports = $37ab4b12dc44840d$var$__toCommonJS($37ab4b12dc44840d$var$renderPaths_exports);
parcelRequire("aXNcS");
var $fUX2S = parcelRequire("fUX2S");
function $37ab4b12dc44840d$var$kebabToCamelCase(str) {
    return str.replace(/-([a-z])/g, (_, $1)=>$1.toUpperCase());
}
function $37ab4b12dc44840d$var$reactAttributes(obj) {
    return Object.entries(obj).reduce((acc, [key, value])=>{
        if (key === "style" && typeof value === "string") acc.style = value.split(";").reduce((styleAcc, item)=>{
            const [styleKey, styleValue] = item.split(":");
            if (styleKey && styleValue) styleAcc[$37ab4b12dc44840d$var$kebabToCamelCase(styleKey.trim())] = styleValue.trim();
            return styleAcc;
        }, {});
        else acc[$37ab4b12dc44840d$var$kebabToCamelCase(key)] = value;
        return acc;
    }, {});
}
function $37ab4b12dc44840d$var$renderPaths(nodes) {
    if (!nodes) return;
    return nodes.map((node)=>(0, $fUX2S.createElement)(node.tag, $37ab4b12dc44840d$var$reactAttributes(node.att), $37ab4b12dc44840d$var$renderPaths(node.nds)));
}


var $a7d469822a4d2e98$var$warning_triangle_default = ()=>(0, $37ab4b12dc44840d$exports.renderPaths)($a7d469822a4d2e98$var$import_warning_triangle.default);


"use client";
const $6a8d1ed1a7c31f50$var$inverseTypes = [
    "primary",
    "emphasised",
    "secondary",
    "tertiary"
];
const $6a8d1ed1a7c31f50$var$Button = (0, $aXNcS.forwardRef)((props, ref)=>{
    const { href: href = "", newWindow: newWindow = false, loadingSrText: loadingSrText = "Loading\u2026", ssrIcon: ssrIcon, iconOnly: iconOnly = false, prefix: prefix = "", htmlType: htmlType = "button", disabled: disabled = false, className: className = "", onClick: onClick, text: text = "", type: type = "secondary", expanding: expanding = false, loading: loading = false, iconPosition: iconPosition = "leading", fluid: fluid = false, inverseTheme: inverseTheme = false, children: children, expandedOnTouchDevice: expandedOnTouchDevice = false, size: size = "medium", staticColour: staticColour = false, ...others } = props;
    const onKeyUpHandler = (e)=>{
        if (disabled || loading || e.key !== " ") return;
        const target = e.target;
        target.click();
    };
    let btnType = type ? type : "secondary";
    if (iconOnly && ssrIcon) btnType = `icon-${btnType}`;
    if (inverseTheme && type !== "danger" && type !== "plain" && type !== "image-overlay" && $6a8d1ed1a7c31f50$var$inverseTypes.indexOf(type) > -1) btnType = `${btnType}-inverse`;
    const innerClasses = (0, (/*@__PURE__*/$parcel$interopDefault($3LGzW)))(`${prefix}btn__inner`);
    const iconClass = `${prefix}btn__icon`;
    const icon = type === "danger" ? (0, (/*@__PURE__*/$parcel$interopDefault($a7d469822a4d2e98$exports))) : ssrIcon;
    const iconTag = icon ? /* @__PURE__ */ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)((0, $e4ff9f689fddbc04$export$2e2bcd8739ae039), {
        className: iconClass,
        prefix: prefix,
        paths: icon
    }) : null;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($3LGzW)))(`${prefix}btn`, loading && `${prefix}btn--loading`, size !== "medium" && `${prefix}btn--${size}`, !iconOnly && icon && iconPosition && `${prefix}${iconPosition}-icon`, type && `${prefix}btn--${btnType}`, fluid && !iconOnly && `${prefix}btn--fluid`, expanding && `${prefix}btn--expanding`, expanding && expandedOnTouchDevice && `${prefix}btn--touch-device-expanded`, staticColour && `${prefix}btn--static-colour`, className);
    const handleClick = (ev)=>{
        if (loading || disabled) {
            ev.stopPropagation();
            return;
        }
        if (onClick && typeof onClick === "function") onClick(ev);
    };
    const buttonContent = /* @__PURE__ */ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)("span", {
        className: innerClasses,
        children: [
            iconTag,
            text && /* @__PURE__ */ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)("span", {
                className: `${prefix}btn__label`,
                children: text
            }) || null,
            !loading && children || null,
            loading && /* @__PURE__ */ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)("span", {
                className: `${prefix}btn__loader`,
                children: loadingSrText
            }) || null
        ]
    });
    if (href) return /* @__PURE__ */ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)("a", {
        ref: ref,
        className: classes,
        "aria-disabled": loading ? true : void 0,
        onClick: handleClick,
        onKeyUp: onKeyUpHandler,
        href: disabled ? void 0 : href,
        target: newWindow ? "_blank" : void 0,
        rel: newWindow ? "noreferrer" : void 0,
        ...others,
        children: buttonContent
    });
    return /* @__PURE__ */ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)("button", {
        ref: ref,
        className: classes,
        disabled: disabled,
        type: htmlType,
        onClick: handleClick,
        ...others,
        children: buttonContent
    });
});
$6a8d1ed1a7c31f50$var$Button.displayName = "Button";
var $6a8d1ed1a7c31f50$export$2e2bcd8739ae039 = $6a8d1ed1a7c31f50$var$Button;


var $1a7c5a491fc3d4f2$export$2e2bcd8739ae039 = (0, $6a8d1ed1a7c31f50$export$2e2bcd8739ae039);


parcelRequire("aXNcS");
var $fqaWh = parcelRequire("fqaWh");
const $581d016b301d0ace$var$useAnalytics = ()=>{
    const [loaded, setLoaded] = (0, $fqaWh.useState)(false);
    const consent = window.ikea?.cookieConsent?.hasConsent(2);
    (0, $fqaWh.useEffect)(()=>{
        if (!$581d016b301d0ace$var$canUseGA) // throw Error('Analytics library not loaded');
        console.warn('Analytics library not loaded: will not send analytics');
        else console.log('Analytics library loaded');
    }, [
        consent
    ]);
    const send = (0, $fqaWh.useCallback)((eventName)=>{
        if ($581d016b301d0ace$var$canUseGA || consent) send(eventName);
    }, [
        consent
    ]);
    return {
        loaded: loaded,
        send: send
    };
};
const $581d016b301d0ace$var$canUseGA = ()=>{
    if (window.ikea?.cookieConsent?.hasConsent(2)) return true;
    return false;
};
const $581d016b301d0ace$export$f42fbd1cc833b8f7 = ({ results: results, query: query, guid: guid, action: action, pos: pos, variant: variant, page: page, topArts: topArts, loadTimeMs: loadTimeMs, backend: backend, correlationId: correlationId, activity: activity, articlesDisplayed: articlesDisplayed, redirect: redirect })=>{
    if ($581d016b301d0ace$var$canUseGA()) {
        let analyticsObject = null;
        switch(action){
            //pass along a collection of id's of the first five articles.
            case 'search':
                analyticsObject = {
                    event_category: 'customer_service',
                    event_action: 'vetaInfoReq',
                    event_label: JSON.stringify({
                        component: 'search',
                        variant: variant,
                        results: results,
                        query: query,
                        load_time_ms: loadTimeMs,
                        backend: backend,
                        correlationId: correlationId,
                        activity: action,
                        redirect: redirect
                    })
                };
                break;
            case 'articleOpen':
                analyticsObject = {
                    event_category: 'customer_service',
                    event_action: 'vetaInfoReq',
                    event_label: JSON.stringify({
                        component: 'search',
                        guid: guid,
                        variant: variant,
                        pos: pos + 1,
                        query: query,
                        correlationId: correlationId,
                        activity: 'readMoreArticle'
                    })
                };
                break;
            default:
                break;
        }
        if (analyticsObject) window.sendEvent(analyticsObject);
    //@ts-ignore
    } else console.log('Unable to sent GA event');
};
const $581d016b301d0ace$export$a65d69dd22caceda = ({ reaction: reaction, docGuid: docGuid, variant: variant })=>{
    if ($581d016b301d0ace$var$canUseGA() && docGuid) {
        let analyticsObject = null;
        analyticsObject = {
            event_category: 'customer_service',
            event_action: 'feedback',
            event_label: JSON.stringify({
                component: 'search',
                guid: docGuid,
                variant: variant,
                reaction: reaction ? 'positive' : 'negative',
                message: ''
            })
        };
        if (analyticsObject) window.sendEvent(analyticsObject);
    //@ts-ignore
    } else console.log('not allowed ga event');
};
var $581d016b301d0ace$export$2e2bcd8739ae039 = $581d016b301d0ace$var$useAnalytics;










const $977e635bd4ac891c$export$a0dba7a0070b1588 = "search";
const $977e635bd4ac891c$export$64419dba853ac5 = (lang)=>{
    const langMap = {
        "nl-NL": "nl-NL",
        "nl-EN": "en-NL",
        "en-EN": "en-EN",
        "fr-FR": "fr-FR",
        "fr-EN": "en-FR",
        "ca-FR": "fr-CA",
        "ca-EN": "en-CA",
        "se-SV": "sv-SE",
        "se-EN": "en-SE",
        "ch-DE": "de-CH",
        "ch-FR": "fr-CH",
        "ch-IT": "it-CH",
        "ch-EN": "en-CH",
        "pl-PL": "pl-PL",
        "ro-RO": "ro-RO",
        "rs-SR": "sr-RS",
        "sk-SK": "sk-SK",
        "cz-CS": "cs-CZ",
        "cz-EN": "en-CZ",
        "hr-HR": "hr-HR",
        "si-SL": "sl-SI",
        "de-DE": "de-DE",
        "de-EN": "en-DE",
        "dk-DA": "da-DK",
        "dk-EN": "en-DK",
        "no-NO": "no-NO",
        "no-EN": "en-NO",
        "jp-JA": "ja-JP",
        "jp-EN": "en-JP",
        "fi-FI": "fi-FI",
        "fi-EN": "en-FI",
        "fi-SV": "sv-FI",
        "pt-PT": "pt-PT",
        "pt-EN": "en-PT",
        "at-DE": "de-AT",
        "at-EN": "en-AT",
        "it-IT": "it-IT",
        "kr-KO": "ko-KR",
        "kr-EN": "en-KR",
        "us-EN": "en-US",
        "us-ES": "es-US",
        "gb-EN": "en-GB",
        "au-EN": "en-AU",
        "in-EN": "en-IN",
        "ie-EN": "en-IE",
        "es-EN": "en-ES",
        "es-ES": "es-ES",
        "es-GL": "gl-ES",
        "es-EU": "eu-ES",
        "es-CA": "ca-ES",
        "be-FR": "fr-BE",
        "be-EN": "en-BE",
        "be-NL": "nl-BE",
        "ua-UK": "uk-UA",
        "hu-HU": "hu-HU",
        "ru-RU": "ru-RU",
        "re-RV": "rv-RE",
        "nz-EN": "en-NZ",
        "hr-EN": "en-HR"
    };
    if (lang in langMap) return langMap[lang];
    return lang;
};


const $e0c6ce23fe7600d5$var$LISA_SEARCH_PROD = "https://web-api.ikea.com/customer-service/knowledge/search-gql";
const $e0c6ce23fe7600d5$var$LISA_SEARCH_INT = "https://web-api.cte.ikeadt.com/customer-service/knowledge/search-gql";
const $e0c6ce23fe7600d5$var$LISA_DOC_PROD = "https://web-api.ikea.com/customer-service/knowledge/document-gql";
const $e0c6ce23fe7600d5$var$LISA_DOC_INT = "https://web-api.cte.ikeadt.com/customer-service/knowledge/document-gql";
const $e0c6ce23fe7600d5$var$CLIENT_ID_PROD = "dde333e7-6433-46a4-aef5-34532aec4a88";
const $e0c6ce23fe7600d5$var$CLIENT_ID_INT = "d00c771f-5d86-449f-bff9-e9bf42729e68";
const $e0c6ce23fe7600d5$export$7759221db3edc8c1 = async (params)=>{
    const start = new Date().getTime();
    params.setLoading(true);
    const lang = $e0c6ce23fe7600d5$var$getValFromLocale(params.locale, "lang");
    const cb = $e0c6ce23fe7600d5$var$getValFromLocale(params.locale, "cb");
    const data = JSON.stringify({
        "query": `query{search(query:"${params.query}",lang:"${lang}",categoryBranch:"${cb}", origin:"${(0, $977e635bd4ac891c$export$a0dba7a0070b1588)}"){ documents{ description, title, content, vetaGuid }}}`,
        "variables": null
    });
    await fetch(params.isProd ? $e0c6ce23fe7600d5$var$LISA_SEARCH_PROD : $e0c6ce23fe7600d5$var$LISA_SEARCH_INT, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'x-client-id': params.isProd ? $e0c6ce23fe7600d5$var$CLIENT_ID_PROD : $e0c6ce23fe7600d5$var$CLIENT_ID_INT
        },
        body: data
    }).then((response)=>{
        const elapsed = new Date().getTime() - start;
        if (response.status !== 200) return {
            error: true
        };
        response.json().then((data)=>{
            let res = $e0c6ce23fe7600d5$var$mapLisaToVetaBody(data);
            if (res !== undefined) {
                params.setReady(true);
                params.setLoading(false);
                params.setResults(res.entries);
                if (res.entries.length <= 0) params.setError(0);
                const serializedArray = JSON.stringify(res);
                sessionStorage.setItem('queryString', serializedArray);
            }
            const redirectPage = $e0c6ce23fe7600d5$var$redirect(params.query);
            if (redirectPage) {
                (0, $581d016b301d0ace$export$f42fbd1cc833b8f7)({
                    action: 'search',
                    query: params.query,
                    loadTimeMs: elapsed,
                    variant: params.variant,
                    backend: params.backend,
                    correlationId: params.correlationId,
                    redirect: redirectPage
                });
                params.setResults([]);
                params.setRedirect(true);
            } else (0, $581d016b301d0ace$export$f42fbd1cc833b8f7)({
                results: res === undefined ? 0 : res.entries.length,
                action: 'search',
                query: params.query,
                loadTimeMs: elapsed,
                variant: params.variant,
                backend: params.backend,
                correlationId: params.correlationId
            });
        });
    }).catch((err)=>{
        params.setLoading(false);
        params.setError(err.request?.status > 0 ? err.request.status : 500);
        params.setReady(true);
    });
};
const $e0c6ce23fe7600d5$export$647b0f0838f655fd = async (params)=>{
    const start = new Date().getTime();
    const lang = $e0c6ce23fe7600d5$var$getValFromLocale(params.locale, "lang");
    const data = JSON.stringify({
        "query": `query{GetDoc(vetaGuid:"${params.docGuid}",lang:"${lang}", origin:"${(0, $977e635bd4ac891c$export$a0dba7a0070b1588)}"){ description, title, content, docMetaData{changeDate, publishDate, categories{branch, branchText}}}}`,
        "variables": null
    });
    await fetch(params.isProd ? $e0c6ce23fe7600d5$var$LISA_DOC_PROD : $e0c6ce23fe7600d5$var$LISA_DOC_INT, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'x-client-id': params.isProd ? $e0c6ce23fe7600d5$var$CLIENT_ID_PROD : $e0c6ce23fe7600d5$var$CLIENT_ID_INT
        },
        body: data
    }).then((response)=>{
        const elapsed = new Date().getTime() - start;
        if (response.status !== 200) return {
            error: true
        };
        response.json().then((data)=>{
            if (data !== undefined) {
                const document = data.data?.GetDoc;
                params.setVetaDoc({
                    title: document.title,
                    description: document.description,
                    content: document.content
                });
            }
            (0, $581d016b301d0ace$export$f42fbd1cc833b8f7)({
                action: 'articleOpen',
                query: params.query,
                guid: params.docGuid,
                pos: params.pos,
                loadTimeMs: elapsed,
                variant: 'standard',
                backend: params.backend,
                correlationId: params.correlationId
            });
            params.setModalOpen(true);
        });
    }).catch((err)=>{});
};
const $e0c6ce23fe7600d5$var$getValFromLocale = (locale, val)=>{
    let startIdx = locale.indexOf(val) + val.length + 1;
    let endIdx = locale.indexOf("&", startIdx);
    let res = locale.substring(startIdx, endIdx);
    return res;
};
const $e0c6ce23fe7600d5$var$mapLisaToVetaBody = (lisaRes)=>{
    let res = {
        count: 0,
        entries: new Array()
    };
    if (lisaRes === undefined) return undefined;
    if (lisaRes.data === undefined) return undefined;
    if (lisaRes.data === null) return res;
    res.count = lisaRes?.data?.search?.documents?.length;
    lisaRes.data.search.documents.forEach((doc)=>{
        res.entries.push({
            content: doc.content,
            title: doc.title,
            description: doc.description,
            metadata: {
                docGUID: doc.vetaGuid
            }
        });
    });
    return res;
};
const $e0c6ce23fe7600d5$var$redirect = (query)=>{
    const productRegex = /(\d+\.\d+\.\d+)|\b\d{8}\b/g;
    const orderNumbRegex = /\b\d{9,10}\b/g;
    const sparePartRegex = /\b\d{6}\b/g;
    const productMatch = query.match(productRegex);
    const orderMatch = query.match(orderNumbRegex);
    const sparePartMatch = query.match(sparePartRegex);
    if (productMatch) return "productNumber";
    else if (orderMatch) return "orderNumber";
    else if (sparePartMatch) return "sparePartNumber";
};


var $5abe9f74f8937781$exports = {};
$5abe9f74f8937781$exports = JSON.parse('{"archived_Desc_Key":"Weitere Informationen findest du hier.","archived_Redirection_Key":"customer-service/contact-us/","archived_Title_Key":"Dieses Dokument wurde archiviert.","carousel_Text_Key":"War der Inhalt nicht hilfreich f\xfcr dich? Versuche eines der folgenden Dokumente.","clear_button_label_Text_Key":"Suchfeld leeren","click_prompt_Text_Key":"Klicke hier","close_Text_Key":"schlie\xdfen","customerService_Text_Key":"Kundenservice","error_Text_Key":"Irgendetwas ist schief gelaufen","faq":"Frequently asked questions","feedback_Option1_Text_Key":"Der Text ist verwirrend.","feedback_Option2_Text_Key":"Der Text ist f\xfcr meine Frage nicht von Bedeutung.","feedback_Option3_Text_Key":"Der Text ist relevant aber nicht hilfreich.","feedback_Option4_Text_Key":"Der Text ist zu lang oder zu kurz.","feedback_Question_1_Text_Key":"Welche Abschnitte unserer Antwort findest du mangelhaft oder nicht hilfreich?","feedback_Rec_Text_Key":"Danke f\xfcr dein Feedback!","feedback_Text_Key":"War das hilfreich?","here_Text_Key":"Hier","knowledge_Text_Key":"Wissensinhalte","link_prod_error_Text_Key":"https://ikea.marat.qd.je/de/de/customer-service/track-manage-order/","loading_Text_Key":"Laden...","market_Name_Key":"Deutschland","modal_button_Close_Text_Key":"Schlie\xdfen","negative_feedback_Text_Key":"Es tut uns leid, dass du nicht die Antwort bekommen hast, nach der du gesucht hast. M\xf6chtest du uns dabei helfen, uns zu verbessern?","no_results_Text_Key":"Wir haben keine Ergebnisse f\xfcr den Suchbegriff gefunden: {{query}}","product_error_Text_Key":"Leider wurden keine Ergebnisse gefunden. Wenn du Produktinformationen ben\xf6tigst nutze die Suchleiste weiter oben. Wenn du den Status deiner Bestellung \xfcberpr\xfcfen willst, klicke bitte hier.","read_more_button_Text_Key":"Read more","results_Text_Key":"Wir haben {{number}} Ergebnisse gefunden: {{query}}","retrieving_Text_Key":"Abrufen von","search_button_label_Text_Key":"Suche","searchbar_Text_Key":"Gib ein Stichwort oder Thema ein, um eine Antwort zu finden.","searching_Text_Key":"Suche...","showLess_Text_Key":"Weniger anzeigen","showMore_Text_Key":"Mehr anzeigen","spellcheck_Text_Key":"Versuche andere Begriffe oder \xfcberpr\xfcfe, ob du alles richtig geschrieben hast.","submit_Text_Key":"Absenden","try_again_Text_Key":"Versuche es bitte sp\xe4ter noch einmal."}');


var $89840dc4ed33255a$exports = {};
$89840dc4ed33255a$exports = JSON.parse('{"ai_generated_Text_Key":"Este art\xedculo contiene contenido generado por IA","archived_Desc_Key":"Puedes encontrar m\xe1s ayuda aqu\xed","archived_Redirection_Key":"atenci\xf3n al cliente/cont\xe1ctanos/","archived_Title_Key":"Este documento ha sido archivado","carousel_Text_Key":"\xbfEl art\xedculo no te ha resultado \xfatil? Prueba uno de los art\xedculos relacionados a continuaci\xf3n.","click_prompt_Text_Key":"aqu\xed","close_Text_Key":"Cerrar","customerService_Text_Key":"Atenci\xf3n al cliente","error_Text_Key":"Algo sali\xf3 mal","faq":"Preguntas frecuentes","feedback_Option1_Text_Key":"El texto es confuso de entender","feedback_Option2_Text_Key":"El texto no es relevante para mi pregunta","feedback_Option3_Text_Key":"El texto es relevante pero no \xfatil","feedback_Option4_Text_Key":"El texto es demasiado largo o demasiado corto ","feedback_Question_1_Text_Key":"\xbfQu\xe9 partes concretas de nuestros art\xedculos te parecen insatisfactorias o poco \xfatiles?","feedback_Rec_Text_Key":"\xa1Gracias por tu opini\xf3n!","feedback_Text_Key":"\xbfTe result\xf3 \xfatil?","here_Text_Key":"aqu\xed","knowledge_Text_Key":"Conocimientos","link_prod_error_Text_Key":"https://ikea.marat.qd.je/us/es/customer-service/track-manage-order","loading_Text_Key":"Cargando","market_Name_Key":"Reino Unido","modal_button_Close_Text_Key":"Cerrar","negative_feedback_Text_Key":"Sentimos que no hayas obtenido la respuesta que buscabas, \xbfte gustar\xeda ayudarnos a mejorar?","no_results_Text_Key":"No hay resultados para tu b\xfasqueda: {{query}}","product_error_Text_Key":"Lo sentimos, no hemos encontrado resultados. Este buscador solo permite una o m\xe1s palabras claves. Si deseas informaci\xf3n sobre nuestros productos, utiliza el buscador principal ubicado en la parte superior de la p\xe1gina. Si deseas consultar el estado de tu pedido, por favor, haz clic.","read_more_button_Text_Key":"M\xe1s informaci\xf3n","results_Text_Key":"Hemos encontrado {{number}} resultado(s) para: {{query}}","retrieving_Text_Key":"Recuperando datos","searchbar_Text_Key":"Escribe una palabra o frase, por ejemplo, pedido o modificar.","searching_Text_Key":"Buscando...","showLess_Text_Key":"Ver menos","showMore_Text_Key":"Ver m\xe1s","spellcheck_Text_Key":"Intenta revisar la ortograf\xeda o usar otras palabras.","submit_Text_Key":"Enviar","try_again_Text_Key":"Por favor, int\xe9ntalo de nuevo m\xe1s tarde"}');


var $048bbf39f6fce1af$exports = {};
$048bbf39f6fce1af$exports = JSON.parse('{"archived_Desc_Key":"Trobar\xe0 m\xe9s ajuda aqu\xed","archived_Title_Key":"Aquest document ha estat arxivat.","carousel_Text_Key":"No li ha resultat \xfatil aquest article? Provi amb un dels seg\xfcents articles relacionats.","click_prompt_Text_Key":"aqui","close_Text_Key":"Tanca","customerService_Text_Key":"Atenci\xf3 al client","error_Text_Key":"Alguna cosa ha anat malament","faq":"Preguntes freq\xfcents","feedback_Option1_Text_Key":"El text \xe9s conf\xfas d\'entendre","feedback_Option2_Text_Key":"El text no \xe9s rellevant per a la meva pregunta","feedback_Option3_Text_Key":"El text \xe9s rellevant per\xf2 no \xe9s \xfatil","feedback_Option4_Text_Key":"El text \xe9s massa llarg o massa curt ","feedback_Question_1_Text_Key":"Quines parts dels nostres articles trobes que no s\xf3n satisfact\xf2ries o no s\xf3n \xfatils?","feedback_Rec_Text_Key":"Gr\xe0cies per la teva opini\xf3!","feedback_Text_Key":"T\'ha resultat \xfatil?","here_Text_Key":"aqu\xed","knowledge_Text_Key":"Coneixement","link_prod_error_Text_Key":"https://ikea.marat.qd.je/es/ca/customer-service/track-manage-order/","loading_Text_Key":"S\xb4est\xe0 carregant","market_Name_Key":"Espanya","modal_button_Close_Text_Key":"Tanca","negative_feedback_Text_Key":"Lamentem que no hagis rebut la resposta que estaves buscant. Vols ajudar-nos a millorar?","no_results_Text_Key":"No s\xb4han trobat resultats per als termes de cerca que heu proporcionat: {{query}}","product_error_Text_Key":"Ho sentim, no hem trobat resultats. Aquest cercador nom\xe9s admet una o m\xe9s paraules claus. Si desitges informaci\xf3 sobre els nostres articles utilitza el cercador principal situat en la part superior de la web. Si desitges consultar l\xb4estat de la teva comanda, si us plau, fes clic","read_more_button_Text_Key":"Llegir m\xe9s","results_Text_Key":"Hem trobat {{number}} resultat(s) pera: {{query}}","retrieving_Text_Key":"Recuperaci\xf3","searchbar_Text_Key":"Escriu una paraula o frase, per exemple, comanda o modificar.","searching_Text_Key":"Cercant...","showLess_Text_Key":"Mostra\'n menys","showMore_Text_Key":"Mostra\'n m\xe9s","spellcheck_Text_Key":"Proveu de revisar l\xb4ortografia o d\xb4utilitzar paraules clau diferents","submit_Text_Key":"Envia\'l","try_again_Text_Key":"Si us plau, intenta-ho m\xe9s tard"}');


var $e14a51c5ef1fcbea$exports = {};
$e14a51c5ef1fcbea$exports = JSON.parse('{"archived_Desc_Key":"Dal\u0161\xed n\xe1pov\u011Bdu naleznete zde","archived_Title_Key":"Tento dokument byl archivov\xe1n.","carousel_Text_Key":"Nebyl tento \u010Dl\xe1nek dostate\u010Dn\u011B u\u017Eite\u010Dn\xfd? Vyzkou\u0161ejte podobn\xfd obsah zobrazen\xfd n\xed\u017Ee.","click_prompt_Text_Key":"Klikn\u011Bte zde","close_Text_Key":"Zav\u0159\xedt","customerService_Text_Key":"Z\xe1kaznicky servis","error_Text_Key":"N\u011Bco se nepovedlo","faq":"\u010Casto kladen\xe9 ot\xe1zky","feedback_Option1_Text_Key":"\u010Cl\xe1nek je napsan\xfd nesrozumiteln\u011B.","feedback_Option2_Text_Key":"\u010Cl\xe1nek neposkytuje relevantn\xed odpov\u011B\u010F na mou ot\xe1zku.","feedback_Option3_Text_Key":"\u010Cl\xe1nek odpov\xedd\xe1 na moji ot\xe1zku, ale nepomohl mi.","feedback_Option4_Text_Key":"\u010Cl\xe1nek je p\u0159\xedli\u0161 dlouh\xfd/kr\xe1tk\xfd.","feedback_Question_1_Text_Key":"Co p\u0159esn\u011B bylo v \u010Dl\xe1nku \u0161patn\u011B?","feedback_Rec_Text_Key":"D\u011Bkujeme za va\u0161i zp\u011Btnou vazbu","feedback_Text_Key":"Bylo to pro v\xe1s u\u017Eite\u010Dn\xe9?","here_Text_Key":"zde","knowledge_Text_Key":"Centrum znalost\xed","link_prod_error_Text_Key":"https://ikea.marat.qd.je/cz/cs/customer-service/track-manage-order/","loading_Text_Key":"Na\u010D\xedt\xe1m","market_Name_Key":"\u010Cesk\xe1 republika","modal_button_Close_Text_Key":"Zav\u0159\xedt","negative_feedback_Text_Key":"Je n\xe1m l\xedto, \u017Ee jste nedostali odpov\u011B\u010F, kterou jste hledali, chcete n\xe1m pomoci se zlep\u0161en\xedm?","no_results_Text_Key":"Pro hledan\xfd v\xfdraz nebyly nalezeny \u017E\xe1dn\xe9 v\xfdsledky: {{query}}","product_error_Text_Key":"Toto pole slou\u017E\xed pro vyhled\xe1v\xe1n\xed n\xe1pov\u011Bdy. Pokud chcete hledat v\xfdrobky na z\xe1klad\u011B jejich \u010D\xedsla, pou\u017Eijte hlavn\xed vyhled\xe1vac\xed pole na IKEA.cz.","read_more_button_Text_Key":"P\u0159e\u010Dt\u011Bte si v\xedce","results_Text_Key":"Na\u0161li jsme {{number}} v\xfdsledek/v\xfdsledk\u016F pro: {{query}}","retrieving_Text_Key":"Na\u010D\xedt\xe1m","searchbar_Text_Key":"Napi\u0161te, co hled\xe1te","searching_Text_Key":"Vyhled\xe1v\xe1m...","showLess_Text_Key":"Zobrazit m\xe9n\u011B","showMore_Text_Key":"Zobrazit v\xedce","spellcheck_Text_Key":"Zkuste zkontrolovat pravopis nebo pou\u017E\xedt jin\xe1 kl\xed\u010Dov\xe1 slova","submit_Text_Key":"Odeslat","try_again_Text_Key":"Pros\xedm zkuste to znovu pozd\u011Bji"}');


var $71a191848dee8658$exports = {};
$71a191848dee8658$exports = JSON.parse('{"archived_Desc_Key":"Yderligere hj\xe6lp kan findes her.","archived_Title_Key":"Dette dokument er blevet arkiveret.","carousel_Text_Key":"Fandt du ikke svar? Pr\xf8v en af relaterede artikler nedenfor.","click_prompt_Text_Key":"klik her","close_Text_Key":"Luk","customerService_Text_Key":"Kundeservice","error_Text_Key":"Noget gik galt","faq":"Ofte stillede sp\xf8rgsm\xe5l","feedback_Option1_Text_Key":"Teksten er forvirrende at forst\xe5","feedback_Option2_Text_Key":"Teksten er ikke relevant for mit sp\xf8rgsm\xe5l","feedback_Option3_Text_Key":"Teksten er relevant, men jeg fik ikke svar","feedback_Option4_Text_Key":"Teksten er for lang eller for kort ","feedback_Question_1_Text_Key":"Hvilke dele af artiklen, synes du, er uklare eller irrelevante?","feedback_Rec_Text_Key":"Tak for din feedback!","feedback_Text_Key":"Fandt du svar?","here_Text_Key":"her.","knowledge_Text_Key":"Information","link_prod_error_Text_Key":"https://ikea.marat.qd.je/dk/da/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"Danmark","modal_button_Close_Text_Key":"Luk","negative_feedback_Text_Key":"Vi er kede af, at du ikke fik det svar, du ledte efter. Vil du hj\xe6lpe os med at blive bedre?","no_results_Text_Key":"Der er ingen s\xf8gninger som matcher s\xf8gning p\xe5: {{query}}","product_error_Text_Key":"Dette s\xf8gefelt er kun til support. Ved artikelnumre, pr\xf8v at s\xf8ge i s\xf8gefeltet \xf8verst p\xe5 IKEA.dk i stedet. Hvis du s\xf8ger efter information om din ordre,","read_more_button_Text_Key":"L\xe6s mere","results_Text_Key":"Der blev fundet {{number}} resultat(er) for: {{query}}","retrieving_Text_Key":"Modtager","searchbar_Text_Key":"Skriv dit sp\xf8rgsm\xe5l her","searching_Text_Key":"S\xf8ger....","showLess_Text_Key":"Vis mindre","showMore_Text_Key":"Vis mere","spellcheck_Text_Key":"Tjek for stavefejl eller pr\xf8v andre s\xf8geord.","submit_Text_Key":"Indsende","try_again_Text_Key":"Pr\xf8v venligst igen"}');


var $54f2f61608f89b93$exports = {};
$54f2f61608f89b93$exports = JSON.parse('{"archived_Desc_Key":"Hier findest du weitere Hilfe.","archived_Title_Key":"Dieses Dokument wurde archiviert.","carousel_Text_Key":"Brauchst du eine andere Information? Bestimmt hilft dir das weiter:","click_prompt_Text_Key":"Klick hier","close_Text_Key":"Schlie\xdfen","customerService_Text_Key":"Kundenservice","error_Text_Key":"Da ist etwas schiefgelaufen..","faq":"H\xe4ufig Gestellte Fragen","feedback_Option1_Text_Key":"Der Text ist verwirrend zu verstehen","feedback_Option2_Text_Key":"Der Text ist f\xfcr meine Frage nicht relevant","feedback_Option3_Text_Key":"Der Text ist relevant, aber nicht hilfreich","feedback_Option4_Text_Key":"Der Text ist zu lang oder zu kurz ","feedback_Question_1_Text_Key":"Welche Abschnitte unserer Antwort findest du mangelhaft oder nicht hilfreich?","feedback_Rec_Text_Key":"Danke f\xfcr dein Feedback!","feedback_Text_Key":"War das hilfreich?","here_Text_Key":"Hier","knowledge_Text_Key":"IKEA Wissen","link_prod_error_Text_Key":"https://ikea.marat.qd.je/at/de/customer-service/track-manage-order/","loading_Text_Key":"Laden...","market_Name_Key":"\xd6sterreich","modal_button_Close_Text_Key":"Schlie\xdfen","negative_feedback_Text_Key":"Es tut uns leid, dass du nicht die Antwort bekommen hast, nach der du gesucht hast. M\xf6chtest du uns helfen, uns zu verbessern?","no_results_Text_Key":"Wir konnten keinen Treffer f\xfcr deine Suchanfrage finden: {{query}}","product_error_Text_Key":"Mit dieser Suchleiste kannst du Antworten auf Fragen finden. Produkte findest du \xfcber die Suchleiste oben. M\xf6chtest du deine Bestellung einsehen und bearbeiten?","read_more_button_Text_Key":"Mehr...","results_Text_Key":"Wir haben {{number}} Ergebnis(se) gefunden f\xfcr: {{query}}","retrieving_Text_Key":"Wir montieren dein Suchergebnis...","searchbar_Text_Key":"Suche","searching_Text_Key":"Suche...","showLess_Text_Key":"Weniger anzeigen","showMore_Text_Key":"Mehr anzeigen","spellcheck_Text_Key":"Versuch es mit anderen Suchbegriffen oder \xfcberpr\xfcfe, ob alles richtig geschrieben ist.","submit_Text_Key":"Absenden","try_again_Text_Key":"Bitte versuche es sp\xe4ter noch einmal."}');


var $a4e5b3249dd769a6$exports = {};
$a4e5b3249dd769a6$exports = JSON.parse('{"archived_Desc_Key":"Weitere Informationen findest du hier","archived_Title_Key":"Dieses Dokument wurde archiviert.","carousel_Text_Key":"War dieses Dokument nicht hilfreich f\xfcr dich? Probiere eines der folgenden Dokumente aus.","clear_button_label_Text_Key":"Suchfeld leeren","click_prompt_Text_Key":"hier","close_Text_Key":"Schliessen","customerService_Text_Key":"Kundenservice","error_Text_Key":"Etwas hat nicht funktioniert","faq":"H\xe4ufig gestellte Fragen","feedback_Option1_Text_Key":"Der Text ist verwirrend zu verstehen","feedback_Option2_Text_Key":"Der Text ist f\xfcr meine Frage nicht relevant","feedback_Option3_Text_Key":"Der Text ist relevant, aber nicht hilfreich","feedback_Option4_Text_Key":"Der Text ist zu lang oder zu kurz ","feedback_Question_1_Text_Key":"Welche Teile unserer Artikel findest du mangelhaft oder nicht hilfreich?","feedback_Rec_Text_Key":"Danke f\xfcr dein Feedback!","feedback_Text_Key":"War dieser Beitrag hilfreich?","here_Text_Key":"hier","knowledge_Text_Key":"Enzyklop\xe4die","link_prod_error_Text_Key":"https://ikea.marat.qd.je/ch/de/customer-service/track-manage-order/","loading_Text_Key":"L\xe4dt","market_Name_Key":"Schweiz","modal_button_Close_Text_Key":"Schliessen","negative_feedback_Text_Key":"Es tut uns leid, dass du nicht die Antwort bekommen hast, nach der du gesucht hast. M\xf6chtest du uns dabei helfen, uns zu verbessern?","no_results_Text_Key":"Es wurden keine Ergebnisse f\xfcr deine angegebenen Suchw\xf6rter gefunden: {{query}}","product_error_Text_Key":"Leider wurden keine Ergebnisse gefunden. Diese Suchmaschine unterst\xfctzt nur einen oder mehrere Suchbegriffe. Wenn du Informationen \xfcber unsere Produkte suchst, verwende die Suchfunktion im oberen Bereich der Website. Wenn du den Status deiner Bestellung \xfcberpr\xfcfen willst, klicke bitte hier.","read_more_button_Text_Key":"Mehr erfahren","results_Text_Key":"Wir haben {{number}} Ergebnisse f\xfcr {{query}} gefunden","retrieving_Text_Key":"Am Abrufen","search_button_label_Text_Key":"Suchen","searchbar_Text_Key":"z.B.: Lieferung, R\xfcckgabe (Keine Nummer)","searching_Text_Key":"Am Suchen...","showLess_Text_Key":"Weniger anzeigen","showMore_Text_Key":"Showing","spellcheck_Text_Key":"Probier mal, die Rechtschreibung zu \xfcberpr\xfcfen oder andere Schl\xfcsselw\xf6rter zu verwenden","submit_Text_Key":"Senden","try_again_Text_Key":"Bitte versuche es sp\xe4ter noch einmal"}');


var $fafed6996f6e2378$exports = {};
$fafed6996f6e2378$exports = JSON.parse('{"archived_Desc_Key":"Hier findest du weitere Hilfe.","archived_Title_Key":"Dieses Dokument wurde archiviert.","carousel_Text_Key":"Brauchst du eine andere Information? Bestimmt hilft dir das weiter:","clear_button_label_Text_Key":"Suchfeld leeren","click_prompt_Text_Key":"Klick hier","close_Text_Key":"Schlie\xdfen","customerService_Text_Key":"Kundenservice","error_Text_Key":"Da ist etwas schiefgelaufen..","faq":"H\xe4ufig gestellte Fragen","feedback_Option1_Text_Key":"Der Inhalt ist verwirrend.","feedback_Option2_Text_Key":"Der Inhalt beantwortet nicht meine Frage.","feedback_Option3_Text_Key":"Der Inhalt passt ist aber nicht hilfreich.","feedback_Option4_Text_Key":"Der Inhalt ist zu lang beziehungsweise zu kurz.","feedback_Question_1_Text_Key":"Welche speziellen Bereiche dieses Dokumentes sind f\xfcr dich nicht ausreichend oder nicht hilfreich?","feedback_Rec_Text_Key":"Danke f\xfcr dein Feedback!","feedback_Text_Key":"War das hilfreich?","here_Text_Key":"Hier","knowledge_Text_Key":"IKEA Wissen","link_prod_error_Text_Key":"https://ikea.marat.qd.je/de/de/customer-service/track-manage-order/","loading_Text_Key":"Laden...","market_Name_Key":"Deutschland","modal_button_Close_Text_Key":"Schlie\xdfen","negative_feedback_Text_Key":"Es tut uns leid, dass du nicht die Antwort bekommen hast, nach der du gesucht hast. M\xf6chtest du uns helfen, uns zu verbessern?","no_results_Text_Key":"Wir konnten keinen Treffer f\xfcr deine Suchanfrage finden: {{query}}","product_error_Text_Key":"Mit dieser Suchleiste kannst du Antworten auf Fragen finden. Produkte findest du \xfcber die Suchleiste oben. M\xf6chtest du deine Bestellung einsehen und bearbeiten?","read_more_button_Text_Key":"Mehr...","results_Text_Key":"Wir haben {{number}} Ergebnis(se) gefunden f\xfcr: {{query}}","retrieving_Text_Key":"Wir montieren dein Suchergebnis...","search_button_label_Text_Key":"Suche","searchbar_Text_Key":"Stichwort/Thema   Bei Fragen zu Produkten oder Angeboten nutze bitte die Suchleiste ganz oben auf der Seite.","searching_Text_Key":"Suche...","showLess_Text_Key":"Weniger anzeigen","showMore_Text_Key":"Mehr anzeigen","spellcheck_Text_Key":"Versuch es mit anderen Suchbegriffen oder \xfcberpr\xfcfe, ob alles richtig geschrieben ist.","submit_Text_Key":"Absenden","try_again_Text_Key":"Bitte versuche es sp\xe4ter noch einmal."}');


var $c48a158a0b2163e0$exports = {};
$c48a158a0b2163e0$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","click_prompt_Text_Key":"here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Something went wrong","faq":"Frequently Asked Questions","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our articles do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://ikea.marat.qd.je/at/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"Austria","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn\u2019t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any matches for results for search term: {{query}}","product_error_Text_Key":"Sorry, no results found. This search engine only supports one or more keywords. If you want information about our products, use the main search engine located at the top of the web. If you want to check the status of your order, please click.","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","searchbar_Text_Key":"Type a word or phrase, for example, order or modify.","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Sorry, no results found. This search engine only supports one or more keywords. If you want information about our products, use the main search engine located at the top of the web. If you want to check the status of your order, please click.","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $975b1f6f24f40d28$exports = {};
$975b1f6f24f40d28$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","click_prompt_Text_Key":"Here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Something went wrong","faq":"Frequently Asked Questions","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our articles do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://ikea.marat.qd.je/au/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"Australia","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn\u2019t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any matches for results for search term: {{query}}","product_error_Text_Key":"Sorry, no results found. This search engine only supports one or more keywords. If you want information about our products, use the main search engine located at the top of the web. If you want to check the status of your order, please click.","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","searchbar_Text_Key":"Find answers to your question here","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $aaecafd845e67a90$exports = {};
$aaecafd845e67a90$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","clear_button_label_Text_Key":"Clear search field","click_prompt_Text_Key":"Click here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Oops, something went wrong","faq":"Frequently Asked Questions","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our articles do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://ikea.marat.qd.je/be/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"Belgium","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn\u2019t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any results for: {{query}}","product_error_Text_Key":"This searchbar is for IKEA knowledge documents only. For products, try searching with the searchbar on top of IKEA.nl. Looking for information about your order?","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Loading","search_button_label_Text_Key":"Search","searchbar_Text_Key":"Search","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $bcefd1a7713d53fc$exports = {};
$bcefd1a7713d53fc$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","click_prompt_Text_Key":"here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Something went wrong","faq":"Frequently Asked Questions","feedback_Option1_Text_Key":"The text is confusing and hard to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our articles do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://ikea.marat.qd.je/ca/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"Canada","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn\u2019t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any matches for results for search term: {{query}}","product_error_Text_Key":"This search bar is only for information documents. For article numbers, please type them in the search bar at the top of the page. To track your order, please click","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","searchbar_Text_Key":"Enter your question here","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $353db662f9ea9c1b$exports = {};
$353db662f9ea9c1b$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the document not helpful? Try one of the related documents below.","clear_button_label_Text_Key":"Clear search field","click_prompt_Text_Key":"here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Something went wrong","faq":"Frequently asked questions","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our documents do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Encyclopedia","link_prod_error_Text_Key":"https://ikea.marat.qd.je/ch/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"Switzerland","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn\u2019t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any matches for results for search term: {{query}}","product_error_Text_Key":"Here you find encyclopedia documents only. For product search, please type the article number in the search bar at the top. For order search, please go to","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","search_button_label_Text_Key":"Search","searchbar_Text_Key":"Ex: delivery, return (no number)","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Send","try_again_Text_Key":"Please try again later"}');


var $a185a0fd067f9c7a$exports = {};
$a185a0fd067f9c7a$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","click_prompt_Text_Key":"here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Something went wrong","faq":"Frequently Asked Questions","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our articles do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://ikea.marat.qd.je/cz/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"Czech","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn\u2019t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any matches for results for search term: {{query}}","product_error_Text_Key":"Sorry, no results found. This search engine only supports one or more keywords. If you want information about our products, use the main search engine located at the top of the web. If you want to check the status of your order, please click.","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","searchbar_Text_Key":"Type a word or phrase, for example, order or modify.","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $f06407a12667808f$exports = {};
$f06407a12667808f$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","click_prompt_Text_Key":"here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Something went wrong","faq":"FAQ","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our articles do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://ikea.marat.qd.je/es/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"Spain","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn\u2019t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any matches for results for search term: {{query}}","product_error_Text_Key":"Sorry, no results found. This search engine only supports one or more keywords. If you want information about our products, use the main search engine located at the top of the web. If you want to check the status of your order, please click.","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","searchbar_Text_Key":"Type a word or phrase, for example, order or modify.","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $a41100faa5e99a70$exports = {};
$a41100faa5e99a70$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","click_prompt_Text_Key":"here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Something went wrong","faq":"Frequently Asked Questions","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our articles do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://ikea.marat.qd.je/fi/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"Finland","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn\u2019t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any matches for results for search term: {{query}}","product_error_Text_Key":"Sorry, no results found. This search engine only supports one or more keywords. If you want information about our products, use the main search engine located at the top of the web. If you want to check the status of your order, please click.","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","searchbar_Text_Key":"What do you need information about? Type for example exchange, order tracking.","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $d0d1c33a933bdfe2$exports = {};
$d0d1c33a933bdfe2$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","click_prompt_Text_Key":"here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Something went wrong","faq":"Frequently Asked Questions","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our answer do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://ikea.marat.qd.je/gb/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"United kingdom","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn\u2019t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any matches for results for search term: {{query}}","product_error_Text_Key":"Sorry, no results found. This search engine only supports one or more keywords. If you want information about our products, use the main search engine located at the top of the web. If you want to check the status of your order, please click.","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","searchbar_Text_Key":"Type a word or phrase, for example, order or modify.","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $7a4c03cac25ab07f$exports = {};
$7a4c03cac25ab07f$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","click_prompt_Text_Key":"Click here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Something went wrong","faq":"Frequently Asked Questions","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our answer do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://ikea.marat.qd.je/ie/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"Ireland","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn\u2019t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any matches for results for search term: {{query}}","product_error_Text_Key":"This searchbar is for IKEA knowledge documents only. For products, try searching with the searchbar on top of IKEA.nl. Looking for information about your order?","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","searchbar_Text_Key":"Find answers to your question here","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $b7e14e4c3f9884e9$exports = {};
$b7e14e4c3f9884e9$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","clear_button_label_Text_Key":"Clear search field","click_prompt_Text_Key":"here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Oops, something went wrong","faq":"Frequently Asked Questions","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our articles do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://ikea.marat.qd.je/in/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"India","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn\u2019t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any results for: {{query}}","product_error_Text_Key":"Sorry, no results found. This search engine only supports one or more keywords. If you want information about our products, use the main search engine located at the top of the web. If you want to check the status of your order, please click.","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","search_button_label_Text_Key":"Search","searchbar_Text_Key":"Need help! Try: track my order, self-service, book planning appointment...","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $aed33ccce9fe5e33$exports = {};
$aed33ccce9fe5e33$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","click_prompt_Text_Key":"Here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Oops, something went wrong","faq":"Frequently Asked Questions","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our articles do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"hhttps://ikea.marat.qd.je/jp/en/","loading_Text_Key":"Loading","market_Name_Key":"Japan","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn\u2019t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any results for: {{query}}","product_error_Text_Key":"If you want to search for product information, please use the search bar at the top of the IKEA website.","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","searchbar_Text_Key":"Search inquiry by keyword","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $8156366d2f5ecd63$exports = {};
$8156366d2f5ecd63$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","click_prompt_Text_Key":"Here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Oops, something went wrong","faq":"Frequently Asked Questions","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our articles do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://ikea.marat.qd.je/nl/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"Netherlands","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn\u2019t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any results for: {{query}}","product_error_Text_Key":"This searchbar is for IKEA knowledge documents only. For products, try searching with the searchbar on top of IKEA.nl. Looking for information about your order?","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} result(s) for: {{query}}","retrieving_Text_Key":"Loading","searchbar_Text_Key":"Search","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $4af600aee2efc2c3$exports = {};
$4af600aee2efc2c3$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","clear_button_label_Text_Key":"Clear search field","click_prompt_Text_Key":"here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Something went wrong","faq":"Frequently Asked Questions","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our articles do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://ikea.marat.qd.je/pt/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"Portugal","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn\u2019t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any matches for results for search term: {{query}}","product_error_Text_Key":"This searchbar is for IKEA knowledge documents only. For products, try searching with the searchbar on top of IKEA.nl. Looking for information about your order?","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","search_button_label_Text_Key":"Search","searchbar_Text_Key":"Try for example: return or click and collect","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $815b81bef1ef5409$exports = {};
$815b81bef1ef5409$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","click_prompt_Text_Key":"here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Something went wrong","faq":"Frequently Asked Questions","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our articles do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://ikea.marat.qd.je/se/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"Sweden","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn\u2019t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any matches for results for search term: {{query}}","product_error_Text_Key":"Sorry, no results found. This search engine only supports one or more keywords. If you want information about our products, use the main search engine located at the top of the web. If you want to check the status of your order, please click.","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","searchbar_Text_Key":"Type a word or phrase, for example, order or modify.","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $f86b4311e6e08dfe$exports = {};
$f86b4311e6e08dfe$exports = JSON.parse('{"ai_generated_Text_Key":"This article contains AI-generated content","archived_Desc_Key":"Further help can be found here","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","click_prompt_Text_Key":"here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Something went wrong","faq":"Frequently Asked Questions","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short","feedback_Question_1_Text_Key":"What particular parts of our articles do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://ikea.marat.qd.je/us/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"United States","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn\u2019t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any matches for results for search term: {{query}}","product_error_Text_Key":"If you are looking for information on products, please use the search bar at the top. If you want to track and manage your order click: ","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","searchbar_Text_Key":"Type your question here (no numbers)","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $fa06606bbc43238c$exports = {};
$fa06606bbc43238c$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Redirection_Key":"customer-service/contact-us/","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","click_prompt_Text_Key":"here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Something went wrong","faq":"Frequently Asked Questions","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our articles do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://ikea.marat.qd.je/no/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"Norway","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn\u2019t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any matches for results for search term: {{query}}","product_error_Text_Key":"Sorry, no results found. This search engine only supports one or more keywords. If you want information about our products, use the main search engine located at the top of the web. If you want to check the status of your order, please click.","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","searchbar_Text_Key":"Describe what you need help with, for example order status.","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more ","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $c0fdf5d00be69964$exports = {};
$c0fdf5d00be69964$exports = JSON.parse('{"archived_Desc_Key":"Puedes encontrar m\xe1s ayuda aqu\xed","archived_Title_Key":"Este documento ha sido archivado","carousel_Text_Key":"\xbfEl art\xedculo no te ha resultado \xfatil? Prueba alguno de los art\xedculos relacionados que aparecen a continuaci\xf3n.","click_prompt_Text_Key":"click aqu\xed","close_Text_Key":"Cerrar","customerService_Text_Key":"Atenci\xf3n al cliente","error_Text_Key":"Algo ha salido mal\u2026","faq":"Preguntas frecuentes","feedback_Option1_Text_Key":"La respuesta es confusa y dif\xedcil de entender","feedback_Option2_Text_Key":"La respuesta no es relevante para mi pregunta","feedback_Option3_Text_Key":"La respuesta es relevante pero no es \xfatil","feedback_Option4_Text_Key":"La respuesta es demasiado larga o demasiado corta ","feedback_Question_1_Text_Key":"\xbfQu\xe9 parte concreta de nuestra respuesta te ha resultado insatisfactoria o poco \xfatil?","feedback_Rec_Text_Key":"\xa1Gracias por tu opini\xf3n!","feedback_Text_Key":"\xbfTe ha resultado \xfatil?","here_Text_Key":"aqu\xed","knowledge_Text_Key":"Conocimientos","link_prod_error_Text_Key":"https://ikea.marat.qd.je/gb/en/customer-service/track-manage-order/","loading_Text_Key":"Cargando","market_Name_Key":"Espa\xf1a","modal_button_Close_Text_Key":"Cerrar","negative_feedback_Text_Key":"Sentimos que no hayas obtenido la respuesta que buscabas, \xbfquieres ayudarnos a mejorar?","no_results_Text_Key":"No hay resultados para tu busqueda: {{query}}","product_error_Text_Key":"Lo sentimos, no hemos encontrado resultados. Este buscador s\xf3lo admite una o m\xe1s palabras claves. Si deseas informaci\xf3n sobre nuestros art\xedculos utiliza el buscador principal ubicado en la parte superior de la web. Si deseas consultar el estado de tu pedido, por favor, haz ","read_more_button_Text_Key":"Leer m\xe1s","results_Text_Key":"Hemos encontrado {{number}} resultado (s) para: {{query}}","retrieving_Text_Key":"Recuperando","searchbar_Text_Key":"Escribe una palabra o frase, por ejemplo, pedido o modificar.","searching_Text_Key":"Buscando...","showLess_Text_Key":"Ver menos","showMore_Text_Key":"Ver m\xe1s","spellcheck_Text_Key":"Int\xe9ntalo de nuevo usado otras palabras.","submit_Text_Key":"Env\xeda","try_again_Text_Key":"Por favor, intentalo de nuevo un poco m\xe1s tarde"}');


var $8a0bb0eb9df691cd$exports = {};
$8a0bb0eb9df691cd$exports = JSON.parse("{\"archived_Desc_Key\":\"Laguntza gehiago aurkituko duzu hemen\",\"archived_Title_Key\":\"Dokumentu hau artxibatu egin da.\",\"carousel_Text_Key\":\"Artikulu hau ez al zaizu lagungarria izan? Saiatu erlazionatutako artikulu hauetako bat.\",\"click_prompt_Text_Key\":\"hemen klikatu mesedez\",\"close_Text_Key\":\"Itxi\",\"customerService_Text_Key\":\"Bezeroarentzako Arreta\",\"error_Text_Key\":\"Zerbitzua ez dago erabilgarri\",\"faq\":\"Ohiko galderak\",\"feedback_Option1_Text_Key\":\"Testua ez da ondo ulertzen\",\"feedback_Option2_Text_Key\":\"Testuak ez dio nire galderari erantzuten\",\"feedback_Option3_Text_Key\":\"Testua nire galderari erantzuten dio, baina ez da lagungarria\",\"feedback_Option4_Text_Key\":\"Testua luzeegia edo laburregia da \",\"feedback_Question_1_Text_Key\":\"Zure ustez, gure artikuluen zein zati dira desegokiak edo ez oso lagungarriak?\",\"feedback_Rec_Text_Key\":\"Eskerrik asko zure iritziagatik!\",\"feedback_Text_Key\":\"Baliagarria iruditu al zaizu?\",\"here_Text_Key\":\"hemen\",\"knowledge_Text_Key\":\"Ezagutza\",\"link_prod_error_Text_Key\":\"https://ikea.marat.qd.je/es/eu/customer-service/track-manage-order/\",\"loading_Text_Key\":\"Deskargatzen\",\"market_Name_Key\":\"Espainia\",\"modal_button_Close_Text_Key\":\"Itxi\",\"negative_feedback_Text_Key\":\"Sentitzen dugu bilatzen ari zinen erantzuna ez jaso izana, hobetzen lagundu nahi diguzu?\",\"no_results_Text_Key\":\"Ez da emaitzarik aurkitu eskatutako bilaketa terminoetarako: {{query}}\",\"product_error_Text_Key\":\"Ez dugu erresultadorik aurkitu, sentitzen dugu. Bilatzaite honek bat edo hainbeste hitz gakoak onartzen ditu. Gure artikuluei buruzko informazioa nahi baduzu, web-aren goialdean dagoen bilatzaile nagusia erabili ezazu. Zure eskariaren egoera kontsultatu nahi baduzu, \",\"read_more_button_Text_Key\":\"Irakurri gehiago\",\"results_Text_Key\":\"{{number}} emaitza aurkitu dugu honetarako: {{query}}\",\"retrieving_Text_Key\":\"Berreskuratzen\",\"searchbar_Text_Key\":\"Hitz edo esaldi bat idatzi ezazu, eskaria edo aldatu adibidez.\",\"searching_Text_Key\":\"Bilatzen\",\"showLess_Text_Key\":\"Gutxiago erakuts\",\"showMore_Text_Key\":\"Gehiago ikusi\",\"spellcheck_Text_Key\":\"Saiatu ortografia egiaztatzen edo gako-hitzak erabiltzen\",\"submit_Text_Key\":\"Bidali\",\"try_again_Text_Key\":\"Mesedez, saiatu berriro geroago\"}");


var $749b63fb65d6d15f$exports = {};
$749b63fb65d6d15f$exports = JSON.parse('{"archived_Desc_Key":"Lis\xe4apua l\xf6ytyy t\xe4\xe4lt\xe4","archived_Title_Key":"T\xe4m\xe4 asiakirja on arkistoitu.","carousel_Text_Key":"Eik\xf6 artikkelista ollut apua? Kokeile alla n\xe4kyvi\xe4 artikkeleita.","click_prompt_Text_Key":"t\xe4\xe4lt\xe4","close_Text_Key":"Sulje","customerService_Text_Key":"Asiakaspalvelu","error_Text_Key":"Jotakin meni pieleen","faq":"Usein kysytyt kysymykset","feedback_Option1_Text_Key":"Teksti\xe4 on vaikea ymm\xe4rt\xe4\xe4","feedback_Option2_Text_Key":"Sis\xe4lt\xf6 ei liity kysymykseeni","feedback_Option3_Text_Key":"Sis\xe4lt\xf6 liittyy asiaan, muttei vastaa kysymykseeni","feedback_Option4_Text_Key":"Sis\xe4lt\xf6 on liian pitk\xe4 tai liian lyhyt ","feedback_Question_1_Text_Key":"Mitk\xe4 osat sis\xe4ll\xf6ist\xe4 eiv\xe4t mielest\xe4si ole hy\xf6dyllisi\xe4 tai toimivia?","feedback_Rec_Text_Key":"Kiitos palautteestasi!","feedback_Text_Key":"Oliko t\xe4m\xe4 hy\xf6dyksesi?","here_Text_Key":"t\xe4ss\xe4","knowledge_Text_Key":"Tietoa","link_prod_error_Text_Key":"https://ikea.marat.qd.je/fi/fi/customer-service/track-manage-order/","loading_Text_Key":"Ladataan","market_Name_Key":"Suomi","modal_button_Close_Text_Key":"Sulje","negative_feedback_Text_Key":"Olemme pahoillamme, ettet saanut etsim\xe4\xe4si vastausta, haluaisitko auttaa meit\xe4 parantamaan?","no_results_Text_Key":"Hakutermille: {{query}} ei l\xf6ytynyt yht\xe4\xe4n tulosta","product_error_Text_Key":"T\xe4st\xe4 l\xf6yd\xe4t vastauksia usein kysyttyihin kysymyksiin. Tuotenumerolla hakeminen onnistuu ylimm\xe4st\xe4 hakukent\xe4st\xe4 ja tilausnumerolla voit hakea.","read_more_button_Text_Key":"Lue lis\xe4\xe4","results_Text_Key":"L\xf6ysimme {{number}} tulosta(s) haulle: {{query}}","retrieving_Text_Key":"Haetaan","searchbar_Text_Key":"Mist\xe4 kaipaat tietoa? Kirjoita esimerkiksi vaihtaminen, tilauksen seuranta.","searching_Text_Key":"Etsit\xe4\xe4n...","showLess_Text_Key":"N\xe4yt\xe4 v\xe4hemm\xe4n","showMore_Text_Key":"N\xe4yt\xe4 enemm\xe4n","spellcheck_Text_Key":"Ole hyv\xe4 ja tarkista oikeinkirjoitus tai kokeile toista hakusanaa. Tuotteen nimell\xe4/artikkelinumerolla voit hakea tietoa ylemm\xe4st\xe4 Mit\xe4 etsit? hakupalkista.","submit_Text_Key":"L\xe4het\xe4","try_again_Text_Key":"Ole hyv\xe4 ja yrit\xe4 my\xf6hemmin uudelleen"}');


var $b9c8a8caf31f5452$exports = {};
$b9c8a8caf31f5452$exports = JSON.parse('{"archived_Desc_Key":"Tu peux trouver plus d\u2019aide ici.","archived_Title_Key":"Ce document a \xe9t\xe9 archiv\xe9.","carousel_Text_Key":"Cet article ne t\'a pas aid\xe9 ? Jette un \u0153il aux articles similaires ci-dessous.","clear_button_label_Text_Key":"Effacer le champ de recherche","click_prompt_Text_Key":"cliquez ici","close_Text_Key":"Fermer","customerService_Text_Key":"Service client\xe8le","error_Text_Key":"Une erreur s\'est produite.","faq":"Foire aux questions","feedback_Option1_Text_Key":"Le texte manque de clart\xe9","feedback_Option2_Text_Key":"Le texte ne r\xe9pond pas \xe0 ma question","feedback_Option3_Text_Key":"Le texte est pertinent, mais ne m\'a pas \xe9t\xe9 utile","feedback_Option4_Text_Key":"Le texte est trop long ou trop court ","feedback_Question_1_Text_Key":"Quelles parties sp\xe9cifiques de nos articles trouvez-vous d\xe9cevantes ou inutiles\xa0?","feedback_Rec_Text_Key":"Merci pour ton feedback !","feedback_Text_Key":"Est-ce que cette information \xe9tait utile ?","here_Text_Key":"ici","knowledge_Text_Key":"Base de connaissance","link_prod_error_Text_Key":"https://ikea.marat.qd.je/be/fr/customer-service/track-manage-order/","loading_Text_Key":"Chargement en cours","market_Name_Key":"Belgique","modal_button_Close_Text_Key":"Fermer","negative_feedback_Text_Key":"Nous sommes d\xe9sol\xe9s que vous n\'ayez pas trouv\xe9 la r\xe9ponse \xe0 votre question. Souhaitez-vous nous aider \xe0 am\xe9liorer notre service ?","no_results_Text_Key":"Nous ne trouvons aucun r\xe9sultat pour: {{query}}","product_error_Text_Key":"Vous cherchez un produit ? Merci d\'utiliser le moteur de recherche situ\xe9 en haut de page. Si vous souhaitez suivre l\'\xe9tat d\'avancement de votre commande, c\'est par","read_more_button_Text_Key":"En savoir plus","results_Text_Key":"Nous avons trouv\xe9 {{number}} r\xe9sultats pour: {{query}}","retrieving_Text_Key":"R\xe9cup\xe9ration","search_button_label_Text_Key":"Rechercher","searchbar_Text_Key":"\xc9cris un mot ou une phrase, par exemple \\"commander\\" ou \\"modifier\\".","searching_Text_Key":"Recherche en cours\u2026","showLess_Text_Key":"Afficher moins","showMore_Text_Key":"Afficher plus","spellcheck_Text_Key":"Essayez avec une autre orthographe ou d\'autres mots-cl\xe9s.","submit_Text_Key":"Envoyer","try_again_Text_Key":"R\xe9essaie plus tard"}');


var $21d17c9f878e2044$exports = {};
$21d17c9f878e2044$exports = JSON.parse('{"archived_Desc_Key":"Vous trouverez plus d\'informations en cliquant ici.","archived_Title_Key":"Ce document a \xe9t\xe9 supprim\xe9.","carousel_Text_Key":"Cette information n\'\xe9tait pas utile? Essayez l\'un des documents ci-dessous","click_prompt_Text_Key":"cliquez ici","close_Text_Key":"Fermer","customerService_Text_Key":"Service \xe0 la client\xe8le","error_Text_Key":"Quelque chose ne va pas","faq":"Foire aux question","feedback_Option1_Text_Key":"Le texte est difficile \xe0 comprendre","feedback_Option2_Text_Key":"Le texte n\u2019est pas pertinent par rapport \xe0 ma question","feedback_Option3_Text_Key":"Le texte est pertinent, mais il n\u2019est pas utile","feedback_Option4_Text_Key":"Le texte est trop long ou trop court ","feedback_Question_1_Text_Key":"Quels \xe9l\xe9ments particuliers de nos articles trouvez-vous insatisfaisants ou inutiles\xa0?","feedback_Rec_Text_Key":"Merci pour votre retour","feedback_Text_Key":"Avez-vous trouv\xe9 cette information utile?","here_Text_Key":"ici.","knowledge_Text_Key":"Base de connaissance","link_prod_error_Text_Key":"https://ikea.marat.qd.je/ca/fr/customer-service/track-manage-order/","loading_Text_Key":"Chargement","market_Name_Key":"Canada","modal_button_Close_Text_Key":"Fermer","negative_feedback_Text_Key":"Nous sommes d\xe9sol\xe9s que vous n\u2019ayez pas obtenu la r\xe9ponse que vous cherchiez, souhaitez-vous nous aider \xe0 nous am\xe9liorer ?","no_results_Text_Key":"Aucun r\xe9sultat n\u2019a \xe9t\xe9 trouv\xe9 avec vos termes de recherche! {{query}}","product_error_Text_Key":"Cette barre de recherche sert uniquement aux documents d\'information. Pour les num\xe9ros d\'article, veuillez les taper dans la barre de recherche en haut de la page. Pour un suivi de votre commande,","read_more_button_Text_Key":"En savoir plus","results_Text_Key":"Nous avons trouv\xe9 {{number}} r\xe9sultat(s) pour: {{query}}","retrieving_Text_Key":"R\xe9cup\xe9ration","searchbar_Text_Key":"Posez votre question ici.","searching_Text_Key":"Recherche en cours de\u2026","showLess_Text_Key":"Afficher moins","showMore_Text_Key":"Afficher plus","spellcheck_Text_Key":"V\xe9rifiez l\u2019orthographe ou utilisez d\u2019autres mots clef","submit_Text_Key":"Envoyer","try_again_Text_Key":"Merci r\xe9essayer ult\xe9rieurement"}');


var $e80f410b841103f1$exports = {};
$e80f410b841103f1$exports = JSON.parse('{"archived_Desc_Key":"Plus d\'informations disponibles ici","archived_Title_Key":"Ce document a \xe9t\xe9 archiv\xe9.","carousel_Text_Key":"Ce document n\'a pas \xe9t\xe9 utile ? Tu peux essayer l\'un des documents ci-dessous.","clear_button_label_Text_Key":"Vider le champ de recherche","click_prompt_Text_Key":"ici","close_Text_Key":"Fermer","customerService_Text_Key":"Service client\xe8le","error_Text_Key":"Quelque chose n\'a pas fonctionn\xe9","faq":"Foire aux questions","feedback_Option1_Text_Key":"Le texte est difficile \xe0 comprendre","feedback_Option2_Text_Key":"Le texte ne correspond pas \xe0 ma question","feedback_Option3_Text_Key":"Le texte est pertinent mais inutile","feedback_Option4_Text_Key":"Le texte est trop long ou trop court ","feedback_Question_1_Text_Key":"Quelles parties de nos documents trouves-tu insatisfaisantes ou inutiles ?","feedback_Rec_Text_Key":"Merci pour ton opinion !","feedback_Text_Key":"Est-ce que cette information \xe9tait utile ?","here_Text_Key":"ici","knowledge_Text_Key":"Encyclop\xe9die","link_prod_error_Text_Key":"https://ikea.marat.qd.je/ch/fr/customer-service/track-manage-order/","loading_Text_Key":"Chargement en cours","market_Name_Key":"Suisse","modal_button_Close_Text_Key":"Fermer","negative_feedback_Text_Key":"Nous sommes d\xe9sol\xe9s que tu n\u2019aies pas obtenu la r\xe9ponse que tu cherchais. Veux-tu nous aider \xe0 nous am\xe9liorer?","no_results_Text_Key":"Nous n\u2019avons pas trouv\xe9 de r\xe9sultat pour: {{query}}","product_error_Text_Key":"Tu trouves ici seulement des informations venant de notre encyclop\xe9die. Pour des informations sur un produit, inscris le num\xe9ro d\'article dans la barre de recherche en-haut. Pour des informations sur ta commande, cherche-la dans","read_more_button_Text_Key":"En savoir plus","results_Text_Key":"Nous avons trouv\xe9 {{number}} r\xe9sultat(s) pour: {{query}}","retrieving_Text_Key":"R\xe9cup\xe9ration en cours","search_button_label_Text_Key":"Chercher","searchbar_Text_Key":"Ex.: livraison, retour (pas de num\xe9ro)","searching_Text_Key":"Recherche en cours\u2026","showLess_Text_Key":"Afficher moins","showMore_Text_Key":"Montrer plus","spellcheck_Text_Key":"V\xe9rifie l\u2019orthographe ou utilise d\u2019autres mots-cl\xe9s","submit_Text_Key":"Envoyer","try_again_Text_Key":"Merci de r\xe9essayer ult\xe9rieurement"}');


var $76679e1285069648$exports = {};
$76679e1285069648$exports = JSON.parse('{"archived_Desc_Key":"Vous trouverez plus d\'informations en cliquant ici.","archived_Title_Key":"Ce document a \xe9t\xe9 supprim\xe9.","carousel_Text_Key":"Cette information n\'\xe9tait pas utile? Essayez l\'un des documents ci-dessous","click_prompt_Text_Key":"ici","close_Text_Key":"Fermer","customerService_Text_Key":"Informations pratiques","error_Text_Key":"Quelque chose ne va pas","faq":"Foire aux questions","feedback_Option1_Text_Key":"Le texte est difficile \xe0 comprendre","feedback_Option2_Text_Key":"Le texte n\'est pas pertinent par rapport \xe0 ma question","feedback_Option3_Text_Key":"Le texte est pertinent, mais il n\'est pas utile","feedback_Option4_Text_Key":"Le texte est trop long ou trop court ","feedback_Question_1_Text_Key":"Quelles sont les parties de nos documents que nous pourrions am\xe9liorer ?","feedback_Rec_Text_Key":"Merci pour votre retour","feedback_Text_Key":"Avez-vous trouv\xe9 cette information utile?","here_Text_Key":"ici.","knowledge_Text_Key":"Base de connaissance","link_prod_error_Text_Key":"https://ikea.marat.qd.je/fr/fr/customer-service/track-manage-order/","loading_Text_Key":"Chargement","market_Name_Key":"France","modal_button_Close_Text_Key":"Fermer","negative_feedback_Text_Key":"Nous sommes d\xe9sol\xe9s que vous n\u2019ayez pas obtenu la r\xe9ponse que vous cherchiez, souhaitez-vous nous aider \xe0 nous am\xe9liorer ?","no_results_Text_Key":"Nous n\u2019avons pas trouv\xe9 de r\xe9sultat pour: {{query}}","product_error_Text_Key":"Vous cherchez un produit ? Merci d\'utiliser le moteur de recherche situ\xe9 en haut de page. Si vous souhaitez suivre l\'\xe9tat d\'avancement de votre commande, c\'est par","read_more_button_Text_Key":"En savoir plus","results_Text_Key":"Nous avons trouv\xe9 {{number}} r\xe9sultat(s) pour: {{query}}","retrieving_Text_Key":"R\xe9cup\xe9ration","searchbar_Text_Key":"Posez votre question ici","searching_Text_Key":"En cours de recherche\u2026","showLess_Text_Key":"Afficher moins","showMore_Text_Key":"Afficher plus","spellcheck_Text_Key":"V\xe9rifiez l\u2019orthographe ou utilisez d\u2019autres mots clef","submit_Text_Key":"Envoyer","try_again_Text_Key":"Merci de r\xe9essayer ult\xe9rieurement"}');


var $5df1784b47d24eeb$exports = {};
$5df1784b47d24eeb$exports = JSON.parse("{\"archived_Desc_Key\":\"Further help can be found here\",\"archived_Redirection_Key\":\"customer-service/contact-us/\",\"archived_Title_Key\":\"This document has been archived.\",\"carousel_Text_Key\":\"Was the article not helpful? Try one of the related articles below.\",\"clear_button_label_Text_Key\":\"Clear search field\",\"click_prompt_Text_Key\":\"here\",\"close_Text_Key\":\"Close\",\"customerService_Text_Key\":\"Customer Service\",\"error_Text_Key\":\"Something went wrong\",\"faq\":\"Frequently Asked Questions\",\"feedback_Option1_Text_Key\":\"The text is confusing to understand\",\"feedback_Option2_Text_Key\":\"The text is not relevant to my question\",\"feedback_Option3_Text_Key\":\"The text is relevant but not helpful\",\"feedback_Option4_Text_Key\":\"The text is too long or too short\",\"feedback_Question_1_Text_Key\":\"What particular parts of our articles do you find unsatisfactory or unhelpful?\",\"feedback_Rec_Text_Key\":\"Thank you for your feedback!\",\"feedback_Text_Key\":\"Did you find this useful?\",\"here_Text_Key\":\"here\",\"knowledge_Text_Key\":\"Knowledge\",\"link_prod_error_Text_Key\":\"https://ikea.marat.qd.je/gb/en/customer-service/track-manage-order/\",\"loading_Text_Key\":\"Loading\",\"market_Name_Key\":\"United kingdom\",\"modal_button_Close_Text_Key\":\"Close\",\"no_results_Text_Key\":\"We did not find any matches for results for search term: {{query}}\",\"product_error_Text_Key\":\"Sorry, no results found. This search engine only supports one or more keywords. If you want information about our products, use the main search engine located at the top of the web. If you want to check the status of your order, please click.\",\"read_more_button_Text_Key\":\"Read more\",\"results_Text_Key\":\"We found {{number}} results for: {{query}}\",\"retrieving_Text_Key\":\"Retrieving\",\"search_button_label_Text_Key\":\"Search\",\"searchbar_Text_Key\":\"Type a word or phrase, for example, order or modify.\",\"searching_Text_Key\":\"Searching...\",\"showLess_Text_Key\":\"Show less\",\"showMore_Text_Key\":\"Show more\",\"spellcheck_Text_Key\":\"Try checking the spelling or using different keywords\",\"submit_Text_Key\":\"Submit\",\"try_again_Text_Key\":\"Please try again later\"}");


var $46fad8e485f23084$exports = {};
$46fad8e485f23084$exports = JSON.parse('{"archived_Desc_Key":"Aqu\xed atopar\xe1 m\xe1is axuda","archived_Title_Key":"Este documento foi arquivado","carousel_Text_Key":"Non lle resultou \xfatil o artigo? Proba cun dos artigos relacionados a continuaci\xf3n","click_prompt_Text_Key":"aqu\xed","close_Text_Key":"Pechar","customerService_Text_Key":"Atenci\xf3n ao cliente","error_Text_Key":"Algo foi mal","faq":"Preguntas frecuentes","feedback_Option1_Text_Key":"O texto non se entende ben","feedback_Option2_Text_Key":"O texto non ten que ver coa mi\xf1a pregunta","feedback_Option3_Text_Key":"O texto ten que ver coa mi\xf1a pregunta pero non \xe9 \xfatil","feedback_Option4_Text_Key":"O texto \xe9 demasiado longo ou demasiado curto ","feedback_Question_1_Text_Key":"Exactamente, que partes dos nosos artigos consideras insatisfactorias ou pouco \xfatiles?","feedback_Rec_Text_Key":"Grazas pola t\xfaa opini\xf3n!","feedback_Text_Key":"Cres que foi \xfatil?","here_Text_Key":"aqu\xed","knowledge_Text_Key":"Co\xf1ecemento","link_prod_error_Text_Key":"https://ikea.marat.qd.je/es/gl/customer-service/track-manage-order/","loading_Text_Key":"En proceso de descarga","market_Name_Key":"Espa\xf1a","modal_button_Close_Text_Key":"Cerrar","negative_feedback_Text_Key":"Lamentamos que non obtiveses a resposta que buscabas, queres axudarnos a mellorar?","no_results_Text_Key":"Non atopamos ningunha coincidencia cos resultados da busca:  {{query}}","product_error_Text_Key":"Sent\xedmolo, non atopamos resultados. Este buscador s\xf3 admite unha ou mais plalabras claves. Se desexas informaci\xf3n sobre os nosos artigos utiliza o buscador principal ubicado na parte superior da web. Se desexas consultar o estado do teu pedido, por favor, fai click","read_more_button_Text_Key":"Ler m\xe1is","results_Text_Key":"Atopamos {{number}} resultado(s) para: {{query}}","retrieving_Text_Key":"Estamos a recuperar a informaci\xf3n","searchbar_Text_Key":"Escribe unha plabra ou frase, por exemplo, pedido ou modificar.","searching_Text_Key":"Buscando...","showLess_Text_Key":"Mostrar menos","showMore_Text_Key":"Mostrar m\xe1is","spellcheck_Text_Key":"Comproba a ortograf\xeda ou emprega diferentes palabras clave","submit_Text_Key":"Enviar","try_again_Text_Key":"Si us plau, intenta-ho m\xe9s tard"}');


var $639fe58a242dbf06$exports = {};
$639fe58a242dbf06$exports = JSON.parse('{"archived_Desc_Key":"Dodatnu pomo\u0107 mo\u017Ee\u0161 prona\u0107i ovdje.","archived_Title_Key":"Ovaj \u010Dlanak je arhiviran.","carousel_Text_Key":"Ovaj \u010Dlanak nije odgovorio na sva tvoja pitanja? Odgovore potra\u017Ei u jednom od povezanih \u010Dlanaka u nastavku.","click_prompt_Text_Key":"ovdje","close_Text_Key":"Zatvori","customerService_Text_Key":"Slu\u017Eba za kupce","error_Text_Key":"Do\u0161lo je do gre\u0161ke","faq":"\u010Cesto postavljana pitanja","feedback_Option1_Text_Key":"Tekst je zbunjuju\u0107i i te\u0161ko ga je razumjeti","feedback_Option2_Text_Key":"Tekst nije relevantan za moje pitanje","feedback_Option3_Text_Key":"Tekst je relevantan, ali nije koristan","feedback_Option4_Text_Key":"Tekst je preduga\u010Dak ili prekratak ","feedback_Question_1_Text_Key":"Koji dio na\u0161eg \u010Dlanaka nije zadovoljavaju\u0107i ili nije koristan?","feedback_Rec_Text_Key":"Hvala ti na povratnoj informaciji!","feedback_Text_Key":"Je li ti ovo bilo korisno?","here_Text_Key":"ovdje.","knowledge_Text_Key":"Baza znanja","link_prod_error_Text_Key":"https://ikea.marat.qd.je/hr/hr/customer-service/track-manage-order/","loading_Text_Key":"U\u010Ditavanje","market_Name_Key":"Hrvatska","modal_button_Close_Text_Key":"Zatvori","negative_feedback_Text_Key":"\u017Dao nam je \u0161to nisi dobio/la odgovor koji si \u017Eelio/\u017Eeljela. \u017Deli\u0161 li nam pomo\u0107i da se pobolj\u0161amo?","no_results_Text_Key":"Nismo prona\u0161li nijedan rezultat za tvoj unos: {{query}}","product_error_Text_Key":"Ako tra\u017Ei\u0161 proizvod, molimo te da upotrijebi\u0161 traku za pretra\u017Eivanje na vrhu stranice. Ako tra\u017Ei\u0161 informacije o svojoj narud\u017Ebi, molimo te da klikne\u0161","read_more_button_Text_Key":"Pro\u010Ditaj vi\u0161e","results_Text_Key":"Prona\u0161li smo {{number}} rezultat/a za: {{query}}","retrieving_Text_Key":"Prikupljanje","searchbar_Text_Key":"Poku\u0161aj upisati na primjer: dostava ili reklamacija","searching_Text_Key":"Pretra\u017Eivanje...","showLess_Text_Key":"Prika\u017Ei manje","showMore_Text_Key":"Prika\u017Ei vi\u0161e","spellcheck_Text_Key":"Provjeri je li unos ispravan ili koristi druge klju\u010Dne rije\u010Di","submit_Text_Key":"Po\u0161alji","try_again_Text_Key":"Poku\u0161aj ponovo kasnije"}');


var $bdbaa19545c42116$exports = {};
$bdbaa19545c42116$exports = JSON.parse('{"ai_generated_Text_Key":"A cikk mesters\xe9ges intelligencia \xe1ltal gener\xe1lt inform\xe1ci\xf3t tartalmaz.","archived_Desc_Key":"Tov\xe1bbi seg\xedts\xe9g itt tal\xe1lhat\xf3","archived_Title_Key":"Ezt a dokumentumot archiv\xe1ltuk.","carousel_Text_Key":"Nem volt hasznos a cikk? Pr\xf3b\xe1ld ki az al\xe1bbi kapcsol\xf3d\xf3 cikkek egyik\xe9t.","clear_button_label_Text_Key":"Keres\xe9si mez\u0151 t\xf6rl\xe9se","click_prompt_Text_Key":"itt","close_Text_Key":"Bez\xe1r\xe1s","customerService_Text_Key":"\xdcgyf\xe9lszolg\xe1lat","error_Text_Key":"Hupsz! Valami","faq":"Gyakran ism\xe9telt k\xe9rd\xe9sek","feedback_Option1_Text_Key":"A sz\xf6veg zavaros, nehezen \xe9rthet\u0151","feedback_Option2_Text_Key":"A sz\xf6veg nem relev\xe1ns a k\xe9rd\xe9sem szempontj\xe1b\xf3l","feedback_Option3_Text_Key":"A sz\xf6veg relev\xe1ns, de nem hasznos a k\xe9rd\xe9sem szempontj\xe1b\xf3l","feedback_Option4_Text_Key":"A sz\xf6veg t\xfal hossz\xfa vagy t\xfal r\xf6vid ","feedback_Question_1_Text_Key":"A cikk melyik r\xe9szeit nem tal\xe1lod megfelel\u0151nek vagy hasznosnak?","feedback_Rec_Text_Key":"K\xf6sz\xf6nj\xfck a visszajelz\xe9sedet!","feedback_Text_Key":"Hasznosnak tal\xe1ltad ezt a cikket?","here_Text_Key":"itt","knowledge_Text_Key":"Tud\xe1s","link_prod_error_Text_Key":"https://ikea.marat.qd.je/hu/hu/customer-service/","loading_Text_Key":"Bet\xf6lt\xe9s...","market_Name_Key":"Magyarorsz\xe1g","modal_button_Close_Text_Key":"Bez\xe1r\xe1s","negative_feedback_Text_Key":"Sajn\xe1ljuk, hogy nem kaptad meg a v\xe1laszt, amit kerest\xe9l \u2013 szeretn\xe9l seg\xedteni, hogy jobb\xe1 v\xe1ljunk?","no_results_Text_Key":"Nincs tal\xe1lat erre a keres\u0151sz\xf3ra: {{query}}","product_error_Text_Key":"Ez a keres\u0151 csak seg\xedt\u0151 inform\xe1ci\xf3k \xe9s cikkek megjelen\xedt\xe9s\xe9re szolg\xe1l. Term\xe9kinform\xe1ci\xf3\xe9rt k\xe9rj\xfck haszn\xe1ld a IKEA.com/hu f\u0151oldal\xe1n tal\xe1lhat\xf3 keres\u0151t.","read_more_button_Text_Key":"B\u0151vebben","results_Text_Key":"{{number}} tal\xe1lat ezekre a keres\u0151szavakra: {{query}}","retrieving_Text_Key":"Visszakeres\xe9s","search_button_label_Text_Key":"Keres\xe9s","searchbar_Text_Key":"Tal\xe1ld meg a v\xe1laszt a k\xe9rd\xe9seidre","searching_Text_Key":"Keres\xe9s...","showLess_Text_Key":"Mutass kevesebbet","showMore_Text_Key":"Mutass t\xf6bbet","spellcheck_Text_Key":"Ellen\u0151rizd az elg\xe9pel\xe9seket, vagy pr\xf3b\xe1lj meg m\xe1s keres\u0151sz\xf3t haszn\xe1lni.","submit_Text_Key":"Beny\xfajtja","try_again_Text_Key":"K\xe9rlek pr\xf3b\xe1ld \xfajra"}');


var $cb1000c6a325bfad$exports = {};
$cb1000c6a325bfad$exports = JSON.parse('{"archived_Desc_Key":"Per maggiori informazioni, clicca qui.","archived_Title_Key":"Questo documento \xe8 stato archiviato.","carousel_Text_Key":"L\'articolo non \xe8 stato utile? Prova a leggere uno dei documenti correlati qui sotto.","clear_button_label_Text_Key":"Libera il campo di ricerca","click_prompt_Text_Key":"qui","close_Text_Key":"Chiudere","customerService_Text_Key":"Servizio clienti","error_Text_Key":"Qualcosa non ha funzionato","faq":"Domande frequenti","feedback_Option1_Text_Key":"Il testo \xe8 difficile da capire","feedback_Option2_Text_Key":"Il testo non \xe8 pertinente alla mia domanda","feedback_Option3_Text_Key":"Il testo \xe8 pertinente ma non utile","feedback_Option4_Text_Key":"Il testo \xe8 troppo lungo o troppo corto ","feedback_Question_1_Text_Key":"Quali parti particolari dei nostri documenti trovi insoddisfacenti o poco utili?","feedback_Rec_Text_Key":"Grazie per il tuo feedback!","feedback_Text_Key":"Ti \xe8 stato utile?","here_Text_Key":"qui","knowledge_Text_Key":"Enciclopedia","link_prod_error_Text_Key":"https://ikea.marat.qd.je/ch/it/customer-service/track-manage-order/","loading_Text_Key":"Caricamento","market_Name_Key":"Svizzera","modal_button_Close_Text_Key":"Chiudere","negative_feedback_Text_Key":"Ci dispiace che tu non abbia trovato la risposta che cercavi, vuoi aiutarci a migliorare?","no_results_Text_Key":"Non \xe8 stato trovato nessun risultato di ricerca per il seguente termine: {{query}}","product_error_Text_Key":"Spiacente, non sono stati trovati risultati. Questo motore di ricerca supporta solo una o pi\xf9 parole chiave. Se desideri informazioni sui nostri prodotti, utilizza il motore di ricerca principale che si trova nella parte superiore del sito. Se vuoi controllare lo stato del tuo ordine, clicca qui.","read_more_button_Text_Key":"Per saperne di pi\xf9","results_Text_Key":"Abbiamo trovato {{number}} risultati per: {{query}}","retrieving_Text_Key":"Recuperare","search_button_label_Text_Key":"Cerca","searchbar_Text_Key":"Es.: consegna, reso (nessun numero)","searching_Text_Key":"Sta cercando...","showLess_Text_Key":"Mostra di meno","showMore_Text_Key":"Mostra di pi\xf9","spellcheck_Text_Key":"Prova a controllare l\'ortografia o a usare parole chiave diverse.","submit_Text_Key":"Invia","try_again_Text_Key":"Ti preghiamo di riprovare pi\xf9 tardi"}');


var $52e10ebac323958d$exports = {};
$52e10ebac323958d$exports = JSON.parse('{"archived_Desc_Key":"Clicca qui per trovare il supporto di cui hai bisogno.","archived_Redirection_Key":"customer-service/contact-us/","archived_Title_Key":"Il contenuto relativo alla tua richiesta non \xe8 pi\xf9 disponibile.","carousel_Text_Key":"Il documento non \xe8 stato utile? Scopri di pi\xf9 sullo stesso argomento qui sotto:","click_prompt_Text_Key":"Clicca qui Verifica la consegna del tuo ordine - IKEA IT","close_Text_Key":"Chiudi","customerService_Text_Key":"Servizio Clienti","error_Text_Key":"Ops! Qualcosa \xe8 andato storto!","faq":"Domande frequenti","feedback_Option1_Text_Key":"E\' difficile da capire","feedback_Option2_Text_Key":"Non risponde alla mia domanda","feedback_Option3_Text_Key":"Risponde alla domanda ma non \xe8 esauriente","feedback_Option4_Text_Key":"Il testo \xe8 troppo lungo o troppo corto ","feedback_Question_1_Text_Key":"In particolare, perch\xe9 non lo trovi utile?","feedback_Rec_Text_Key":"Grazie per il tuo feedback!","feedback_Text_Key":"Hai trovato questo documento utile?","here_Text_Key":"qui","knowledge_Text_Key":"Domande Frequenti","link_prod_error_Text_Key":"https://ikea.marat.qd.je/it/it/customer-service/track-manage-order/","loading_Text_Key":"Ricerca in corso...","market_Name_Key":"Italia","modal_button_Close_Text_Key":"Chiudere","negative_feedback_Text_Key":"Ci dispiace che tu non abbia trovato la risposta che cercavi, vuoi aiutarci a migliorare?","no_results_Text_Key":"Nessun risultato disponibile per: {{query}}","product_error_Text_Key":"Qui puoi esplorare le FAQ pensate per te. Se stai cercando un prodotto specifico, digita il codice in alto nella barra di ricerca del sito. Se vuoi tracciare o gestire il tuo ordine.","read_more_button_Text_Key":"Per saperne di pi\xf9","results_Text_Key":"Sono stati trovati {{number}} risultati per: {{query}}","retrieving_Text_Key":"Recupero","searchbar_Text_Key":"Scrivi qui la tua domanda","searching_Text_Key":"Ricerca in corso...","showLess_Text_Key":"Mostra di meno","showMore_Text_Key":"Mostra di pi\xf9","spellcheck_Text_Key":"Prova a riformulare la tua ricerca con altre parole o a scrivere una frase meno complessa. Ricorda di digitare i codici dei prodotti senza inserire . o ,","submit_Text_Key":"Invia","try_again_Text_Key":"Riprova pi\xf9 tardi"}');


var $58d318efc91f80b5$exports = {};
$58d318efc91f80b5$exports = JSON.parse('{"archived_Desc_Key":"\u3053\u306E\u4ED6\u306E\u30B5\u30DD\u30FC\u30C8\u306F\u3053\u3061\u3089\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002","archived_Title_Key":"\u304A\u63A2\u3057\u306E\u8CEA\u554F\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002","carousel_Text_Key":"\u304A\u5F79\u306B\u7ACB\u3061\u307E\u305B\u3093\u3067\u3057\u305F\u304B\uFF1F\u4EE5\u4E0B\u3082\u3054\u53C2\u8003\u304F\u3060\u3055\u3044\u3002","click_prompt_Text_Key":"Here","close_Text_Key":"\u9589\u3058\u308B","customerService_Text_Key":"\u30AB\u30B9\u30BF\u30DE\u30FC\u30B5\u30FC\u30D3\u30B9","error_Text_Key":"\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","faq":"\u3088\u304F\u3042\u308B\u8CEA\u554F","feedback_Option1_Text_Key":"\u6587\u7AE0\u304C\u308F\u304B\u308A\u306B\u304F\u3044","feedback_Option2_Text_Key":"\u63A2\u3057\u3066\u3044\u308B\u8CEA\u554F\u306B\u95A2\u9023\u3057\u3066\u3044\u306A\u3044","feedback_Option3_Text_Key":"\u63A2\u3057\u3066\u3044\u308B\u8CEA\u554F\u3060\u304C\u60C5\u5831\u304C\u8DB3\u308A\u306A\u3044","feedback_Option4_Text_Key":"\u6587\u7AE0\u304C\u9577\u3059\u304E\u308B\u3001\u307E\u305F\u306F\u77ED\u3059\u304E\u308B ","feedback_Question_1_Text_Key":"\u3088\u304F\u306A\u304B\u3063\u305F\u7406\u7531\u3092\u6559\u3048\u3066\u304F\u3060\u3055\u3044\u3002","feedback_Rec_Text_Key":"\u3054\u610F\u898B\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002","feedback_Text_Key":"\u304A\u5F79\u306B\u7ACB\u3061\u307E\u3057\u305F\u304B\uFF1F","here_Text_Key":"\u3053\u3061\u3089","knowledge_Text_Key":"\u3088\u304F\u3042\u308B\u8CEA\u554F","link_prod_error_Text_Key":"https://ikea.marat.qd.je/jp/ja/","loading_Text_Key":"Loading","market_Name_Key":"\u65E5\u672C","modal_button_Close_Text_Key":"\u9589\u3058\u308B","negative_feedback_Text_Key":"\u304A\u63A2\u3057\u306E\u56DE\u7B54\u304C\u5F97\u3089\u308C\u305A\u7533\u3057\u8A33\u3054\u3056\u3044\u307E\u305B\u3093\u3002\u6539\u5584\u306B\u3054\u5354\u529B\u3044\u305F\u3060\u3051\u307E\u3059\u304B\uFF1F","no_results_Text_Key":"{{query}} \u8A72\u5F53\u3059\u308B\u3082\u306E\u304C\u3042\u308A\u307E\u305B\u3093\u3002","product_error_Text_Key":"\u3053\u3053\u306E\u691C\u7D22\u30D0\u30FC\u306F\u3001\u3088\u304F\u3042\u308B\u8CEA\u554F\u5185\u3067\u306E\u691C\u7D22\u3068\u306A\u308A\u307E\u3059\u3002\u5546\u54C1\u756A\u53F7\u306F\u3001\u3053\u306E\u30A6\u30A7\u30D6\u30DA\u30FC\u30B8\u4E0A\u90E8\u306B\u3042\u308B\u691C\u7D22\u30D0\u30FC\u3067\u306E\u691C\u7D22\u3092\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","read_more_button_Text_Key":"\u3082\u3063\u3068\u898B\u308B","results_Text_Key":"{{query}} \u306E\u691C\u7D22\u7D50\u679C {{number}}\u4EF6","retrieving_Text_Key":"Loading","searchbar_Text_Key":"\u8CEA\u554F\u3092\u30AD\u30FC\u30EF\u30FC\u30C9\u3067\u691C\u7D22","searching_Text_Key":"\u691C\u7D22\u4E2D","showLess_Text_Key":"\u8868\u793A\u3092\u6E1B\u3089\u3059","showMore_Text_Key":"\u3082\u3063\u3068\u898B\u308B","spellcheck_Text_Key":"\u9055\u3046\u30AD\u30FC\u30EF\u30FC\u30C9\u3092\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","submit_Text_Key":"\u9001\u4FE1\u3059\u308B","try_again_Text_Key":"\u3057\u3070\u3089\u304F\u305F\u3063\u3066\u304B\u3089\u3001\u307E\u305F\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002"}');


var $b0224a930dfcbf32$exports = {};
$b0224a930dfcbf32$exports = JSON.parse('{"archived_Desc_Key":"\uACE0\uAC1D\uC9C0\uC6D0 \uD398\uC774\uC9C0\uC5D0\uC11C \uB354 \uB9CE\uC740 \uC815\uBCF4\uB97C \uD655\uC778\uD574\uBCF4\uC138\uC694.","archived_Title_Key":"\uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uB2E4\uB978 \uC815\uBCF4\uB97C \uD655\uC778\uD574\uC8FC\uC138\uC694.","carousel_Text_Key":"\uC6D0\uD558\uB294 \uC815\uBCF4\uB97C \uCC3E\uC9C0 \uBABB\uD558\uC168\uB2E4\uBA74 \uC544\uB798\uC5D0 \uC788\uB294 \uC5F0\uAD00 \uC815\uBCF4\uB4E4\uC744 \uD655\uC778\uD574\uBCF4\uC138\uC694.","clear_button_label_Text_Key":"\uAC80\uC0C9 \uD544\uB4DC \uC9C0\uC6B0\uAE30","click_prompt_Text_Key":"\uC8FC\uBB38 \uC870\uD68C \uBC0F \uAD00\uB9AC","close_Text_Key":"\uC885\uB8CC","customerService_Text_Key":"\uACE0\uAC1D\uC9C0\uC6D0","error_Text_Key":"\uC608\uAE30\uCE58 \uBABB\uD55C \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uB098\uC911\uC5D0 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.","faq":"\uC790\uC8FC \uBB3B\uB294 \uC9C8\uBB38","feedback_Option1_Text_Key":"\uC774 \uC815\uBCF4\uB294 \uC774\uD574\uD558\uAE30 \uC5B4\uB835\uC2B5\uB2C8\uB2E4","feedback_Option2_Text_Key":"\uC774 \uC815\uBCF4\uB294 \uC81C \uC9C8\uBB38\uACFC \uAD00\uB828\uC774 \uC5C6\uC2B5\uB2C8\uB2E4","feedback_Option3_Text_Key":"\uC774 \uB0B4\uC6A9\uC740 \uAD00\uB828\uC774 \uC788\uAE34 \uD558\uC9C0\uB9CC \uB3C4\uC6C0\uC774 \uB418\uC9C0\uB294 \uC54A\uC2B5\uB2C8\uB2E4.","feedback_Option4_Text_Key":"\uC774 \uC815\uBCF4\uB294 \uB108\uBB34 \uAE38\uAC70\uB098 \uB108\uBB34 \uC9E7\uC2B5\uB2C8\uB2E4 ","feedback_Question_1_Text_Key":"\uC774 \uC815\uBCF4\uC758 \uD2B9\uC815 \uBD80\uBD84\uC774 \uB9CC\uC871\uC2A4\uB7FD\uC9C0 \uC54A\uAC70\uB098 \uB3C4\uC6C0\uC774 \uB418\uC9C0 \uC54A\uC558\uB098\uC694?","feedback_Rec_Text_Key":"\uC18C\uC911\uD55C \uD53C\uB4DC\uBC31 \uAC10\uC0AC\uB4DC\uB824\uC694!","feedback_Text_Key":"\uC774 \uC815\uBCF4\uAC00 \uB3C4\uC6C0\uC774 \uB418\uC5C8\uB098\uC694?","here_Text_Key":"\uACE0\uAC1D\uC9C0\uC6D0 \uD398\uC774\uC9C0","knowledge_Text_Key":"\uBB38\uC758\uC0AC\uD56D","link_prod_error_Text_Key":"https://order.ikea.com/kr/ko/purchases/lookup/","loading_Text_Key":"\uCC98\uB9AC\uC911","market_Name_Key":"\uB300\uD55C\uBBFC\uAD6D","modal_button_Close_Text_Key":"\uC885\uB8CC","negative_feedback_Text_Key":"\uC6D0\uD558\uB294 \uB2F5\uBCC0\uC744 \uB4DC\uB9AC\uC9C0 \uBABB\uD574 \uC8C4\uC1A1\uD569\uB2C8\uB2E4. \uAC1C\uC120\uC744 \uC704\uD574 \uB3C4\uC640\uC8FC\uC2DC\uACA0\uC5B4\uC694?","no_results_Text_Key":"\uAC80\uC0C9 \uC870\uAC74\uC5D0 \uB9DE\uB294 \uACB0\uACFC\uB97C \uCC3E\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4.","product_error_Text_Key":"\uC81C\uD488 \uC815\uBCF4 \uAC80\uC0C9\uC744 \uC6D0\uD558\uC2E0\uB2E4\uBA74 IKEA \uC6F9\uC0AC\uC774\uD2B8 \uC0C1\uB2E8 \uAC80\uC0C9 \uBC14\uB97C \uC774\uC6A9\uD574\uC8FC\uC138\uC694.","read_more_button_Text_Key":"\uB354 \uBCF4\uAE30","results_Text_Key":"{{query}} \uC744(\uB97C) \uD1B5\uD574 {{number}} \uAC1C\uC758 \uACB0\uACFC\uB97C \uCC3E\uC558\uC2B5\uB2C8\uB2E4.","retrieving_Text_Key":"\uAC80\uC0C9","search_button_label_Text_Key":"\uAC80\uC0C9","searchbar_Text_Key":"\uAC80\uC0C9 \uC608\uC2DC : \uAD50\uD658\uD658\uBD88, \uBC30\uC1A1\uC57D\uAD00 \uB4F1","searching_Text_Key":"\uAC80\uC0C9\uC911","showLess_Text_Key":"\uAC04\uB7B5\uD788","showMore_Text_Key":"\uB354 \uBCF4\uAE30","spellcheck_Text_Key":"\uBA85\uCE6D\uC774 \uC62C\uBC14\uB978\uC9C0 \uD55C\uBC88 \uB354 \uD655\uC778\uD574\uC8FC\uC138\uC694.","submit_Text_Key":"\uC81C\uCD9C","try_again_Text_Key":"\uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694."}');


var $614267f6335b21b4$exports = {};
$614267f6335b21b4$exports = JSON.parse('{"archived_Desc_Key":"Du kan f\xe5 mer hjelp her.","archived_Title_Key":"Denne artikkelen er arkivert.","carousel_Text_Key":"Hjalp ikke denne artikkelen deg? Pr\xf8v en av de lignende artiklene under.","click_prompt_Text_Key":"Klikk her","close_Text_Key":"Lukk","customerService_Text_Key":"Kundeservice","error_Text_Key":"Oops! Noe gikk galt.","faq":"Ofte stilte sp\xf8rsm\xe5l","feedback_Option1_Text_Key":"Teksten er uklar og vanskelig \xe5 forst\xe5","feedback_Option2_Text_Key":"Teksten er ikke relevant for sp\xf8rsm\xe5let mitt","feedback_Option3_Text_Key":"Teksten er relevant, men ikke nyttig","feedback_Option4_Text_Key":"Teksten er for lang eller for kort ","feedback_Question_1_Text_Key":"Hva gjorde at artikkelen ikke var nyttig for deg?","feedback_Rec_Text_Key":"Takk for tilbakemeldingen!","feedback_Text_Key":"Var dette nyttig?","here_Text_Key":"her.","knowledge_Text_Key":"Informasjon","link_prod_error_Text_Key":"https://order.ikea.com/no/no/purchases/lookup/","loading_Text_Key":"Laster...","market_Name_Key":"Norge","modal_button_Close_Text_Key":"Lukk","negative_feedback_Text_Key":"Vi beklager at du ikke fikk svaret du lette etter. Vil du hjelpe oss med \xe5 forbedre oss?","no_results_Text_Key":"Vi fant ingen treff n\xe5r vi s\xf8kte p\xe5: {{query}}","product_error_Text_Key":"Ingen treff p\xe5: {{query}} Her finner du informasjon og svar p\xe5 sp\xf8rsm\xe5l. Bruk s\xf8kefeltet \xf8verst for \xe5 s\xf8ke etter produkter. Ser du etter informasjon om ordren din,","read_more_button_Text_Key":"Les mer","results_Text_Key":"Vi fant {{number}} resultat(er) for: {{query}}","retrieving_Text_Key":"Laster inn...","searchbar_Text_Key":"Fortell oss hva du trenger hjelp med...","searching_Text_Key":"Leter etter svar...","showLess_Text_Key":"Vis mindre","showMore_Text_Key":"Vis mer","spellcheck_Text_Key":"Sjekk stavingen eller fors\xf8k gjerne andre s\xf8keord.","submit_Text_Key":"Send inn","try_again_Text_Key":"Vennligst pr\xf8v igjen senere."}');


var $9ff154c1a8eb2ce8$exports = {};
$9ff154c1a8eb2ce8$exports = JSON.parse('{"archived_Desc_Key":"Meer hulp vind je hier.","archived_Title_Key":"Dit document is gearchiveerd.","carousel_Text_Key":"Was dit artikel niet wat je zocht? Probeer dan een van de onderstaande artikelen. ","clear_button_label_Text_Key":"Zoekveld wissen","click_prompt_Text_Key":"Klik hier","close_Text_Key":"Sluiten","customerService_Text_Key":"Klantendienst","error_Text_Key":"Er ging iets mis","faq":"Veelgestelde vragen","feedback_Option1_Text_Key":"De tekst is verwarrend om te begrijpen","feedback_Option2_Text_Key":"De tekst beantwoordt mijn vraag niet.","feedback_Option3_Text_Key":"De tekst is relevant maar niet nuttig voor mij","feedback_Option4_Text_Key":"De tekst is te lang of te kort ","feedback_Question_1_Text_Key":"Welke specifieke onderdelen van onze artikelen vind je onbevredigend of niet behulpzaam?","feedback_Rec_Text_Key":"Bedankt voor je feedback!","feedback_Text_Key":"Was deze informatie nuttig? ","here_Text_Key":"hier","knowledge_Text_Key":"Kennis database","link_prod_error_Text_Key":"https://ikea.marat.qd.je/be/nl/customer-service/track-manage-order/","loading_Text_Key":"Laden","market_Name_Key":"Belgi\xeb","modal_button_Close_Text_Key":"Sluiten","negative_feedback_Text_Key":"Het spijt ons dat je niet het antwoord hebt gekregen dat je zocht, wil je ons helpen om dit te verbeteren?","no_results_Text_Key":"We vonden geen resultaten voor {{query}}","product_error_Text_Key":"Op zoek naar een product? Gebruik dan de zoekfunctie bovenaan de pagina. Als je de status van je bestelling wilt volgen, klik dan hier.","read_more_button_Text_Key":"Lees meer","results_Text_Key":"We vonden {{number}} resultaten voor: {{query}}","retrieving_Text_Key":"Laden","search_button_label_Text_Key":"Zoeken","searchbar_Text_Key":"Typ een woord of zin, bijvoorbeeld \\"bestellen\\" of \\"aanpassen\\".","searching_Text_Key":"Aan het zoeken...","showLess_Text_Key":"Toon minder","showMore_Text_Key":"Lees meer","spellcheck_Text_Key":"Probeer het opnieuw met een andere spelling of trefwoorden","submit_Text_Key":"Stuur  in","try_again_Text_Key":"Probeer later opnieuw"}');


var $26836d97c71d7de8$exports = {};
$26836d97c71d7de8$exports = JSON.parse("{\"archived_Desc_Key\":\"We helpen je graag verder via deze pagina\",\"archived_Title_Key\":\"Dit document is gearchiveerd.\",\"carousel_Text_Key\":\"Kunnen we je verder helpen?\",\"click_prompt_Text_Key\":\"Kliek hier\",\"close_Text_Key\":\"Sluiten\",\"customerService_Text_Key\":\"Klantenservice\",\"error_Text_Key\":\"Oeps, er ging iets mis\",\"faq\":\"Veelgestelde vragen\",\"feedback_Option1_Text_Key\":\"Ik begrijp de tekst niet of deze is verwarrend\",\"feedback_Option2_Text_Key\":\"De tekst is niet relevant voor mijn vraag\",\"feedback_Option3_Text_Key\":\"De tekst is relevant, maar niet nuttig voor mij\",\"feedback_Option4_Text_Key\":\"De tekst is te lang of te kort \",\"feedback_Question_1_Text_Key\":\"Welke specifieke onderdelen van onze artikelen vind je niet nuttig of niet behulpzaam?\",\"feedback_Rec_Text_Key\":\"Bedankt for je feedback!\",\"feedback_Text_Key\":\"Vond je dit nuttig?\",\"here_Text_Key\":\"via deze pagina\",\"knowledge_Text_Key\":\"Kennis\",\"link_prod_error_Text_Key\":\"https://ikea.marat.qd.je/nl/nl/customer-service/track-manage-order/\",\"loading_Text_Key\":\"Laden\",\"market_Name_Key\":\"Nederland\",\"modal_button_Close_Text_Key\":\"Sluiten\",\"negative_feedback_Text_Key\":\"Het spijt ons dat je niet het antwoord hebt gekregen dat je zocht, wil je ons helpen om dit te verbeteren?\",\"no_results_Text_Key\":\"Geen resultaten gevonden voor: {{query}}\",\"product_error_Text_Key\":\"Deze zoekbalk is voor ondersteunende informatie. Voor artikelnummers, probeer te zoeken in de bovenste zoekbalk op IKEA.nl. Zoek je naar informatie over je bestelling?\",\"read_more_button_Text_Key\":\"Lees meer\",\"results_Text_Key\":\"{{number}} resultaat/resultaten gevonden voor: {{query}}\",\"retrieving_Text_Key\":\"Laden\",\"searchbar_Text_Key\":\"Zoek\",\"searching_Text_Key\":\"Zoeken...\",\"showLess_Text_Key\":\"Lees minder\",\"showMore_Text_Key\":\"Lees meer\",\"spellcheck_Text_Key\":\"Controleer de spelling of gebruik andere zoektermen\",\"submit_Text_Key\":\"Stuur  in\",\"try_again_Text_Key\":\"Probeer het later nog een keer\"}");


var $3983bd296339e183$exports = {};
$3983bd296339e183$exports = JSON.parse('{"archived_Desc_Key":"Dalsze wsparcie znajdziesz tutaj.","archived_Title_Key":"Ten dokument zosta\u0142 zarchiwizowany.","carousel_Text_Key":"Ten artyku\u0142 nie by\u0142 pomocny? Sprawd\u017A inne artyku\u0142y poni\u017Cej.","click_prompt_Text_Key":"kliknij tutaj","close_Text_Key":"Zamknij","customerService_Text_Key":"Obs\u0142uga klienta","error_Text_Key":"Co\u015B posz\u0142o nie tak","faq":"Najcz\u0119\u015Bciej zadawane pytania","feedback_Option1_Text_Key":"Tekst jest niezrozumia\u0142y","feedback_Option2_Text_Key":"Tekst nie ma zwi\u0105zku z moim pytaniem","feedback_Option3_Text_Key":"Tekst ma zwi\u0105zek, ale nie jest pomocny","feedback_Option4_Text_Key":"Tekst jest za d\u0142ugi lub za kr\xf3tki ","feedback_Question_1_Text_Key":"Kt\xf3re cz\u0119\u015Bci naszych artyku\u0142\xf3w uwa\u017Casz za niezadowalaj\u0105ce lub nieprzydatne?","feedback_Rec_Text_Key":"Dzi\u0119kujemy za Twoj\u0105 opini\u0119!","feedback_Text_Key":"Czy powy\u017Csza informacja okaza\u0142a si\u0119 by\u0107 pomocna?","here_Text_Key":"tutaj.","knowledge_Text_Key":"Wiedza","link_prod_error_Text_Key":"https://ikea.marat.qd.je/pl/pl/customer-service/track-manage-order/","loading_Text_Key":"\u0141adowanie","market_Name_Key":"Polska","modal_button_Close_Text_Key":"Zamknij","negative_feedback_Text_Key":"Przykro nam, \u017Ce nie otrzyma\u0142e\u015B odpowiedzi, kt\xf3rej szuka\u0142e\u015B. Czy chcesz nam pom\xf3c j\u0105 poprawi\u0107?","no_results_Text_Key":"Nie znale\u017Ali\u015Bmy wynik\xf3w dla zapytania: {{query}}","product_error_Text_Key":"Brak wynik\xf3w dla... \\b Ta wyszukiwarka s\u0142u\u017Cy jedynie do wyszukiwania artyku\u0142\xf3w pomocniczych. Je\u015Bli szukasz naszego produktu, wpisz je jego numer w g\xf3rnym pasku wyszukiwania na stronie IKEA.pl Je\u015Bli szukasz informacji o swoim zam\xf3wieniu,","read_more_button_Text_Key":"Wi\u0119cej","results_Text_Key":"Wyniki znalezione dla zapytania \\"{{query}}\\": {{number}}","retrieving_Text_Key":"Odzyskiwanie","searchbar_Text_Key":"Tu wpisz has\u0142o lub kr\xf3tkie pytanie","searching_Text_Key":"Wyszukiwanie...","showLess_Text_Key":"Poka\u017C mniej","showMore_Text_Key":"Poka\u017C wi\u0119cej","spellcheck_Text_Key":"Sprawd\u017A pisowni\u0119 lub spr\xf3buj u\u017Cy\u0107 innych s\u0142\xf3w.","submit_Text_Key":"Prze\u015Blij","try_again_Text_Key":"Spr\xf3buj ponownie p\xf3\u017Aniej"}');


var $46abcc1d466640c8$exports = {};
$46abcc1d466640c8$exports = JSON.parse('{"archived_Desc_Key":"Pode encontrar mais ajuda aqui","archived_Title_Key":"Este documento foi arquivado.","carousel_Text_Key":"O artigo n\xe3o foi \xfatil? Veja um dos artigos relacionados abaixo.","clear_button_label_Text_Key":"Limpar campo de pesquisa","click_prompt_Text_Key":"aqui","close_Text_Key":"Fechar","customerService_Text_Key":"Apoio ao Cliente","error_Text_Key":"Alguma coisa correu mal","faq":"Perguntas frequentes","feedback_Option1_Text_Key":"O texto \xe9 confuso","feedback_Option2_Text_Key":"O texto n\xe3o \xe9 relevante para a minha pergunta","feedback_Option3_Text_Key":"O texto \xe9 relevante, mas n\xe3o \xe9 \xfatil","feedback_Option4_Text_Key":"O texto \xe9 demasiado longo ou demasiado curto ","feedback_Question_1_Text_Key":"Que partes espec\xedficas dos nossos artigos considera pouco satisfat\xf3rias ou in\xfateis?","feedback_Rec_Text_Key":"Agradecemos a sua opini\xe3o!","feedback_Text_Key":"Esta informa\xe7\xe3o foi \xfatil?","here_Text_Key":"aqui","knowledge_Text_Key":"Saber mais","link_prod_error_Text_Key":"https://ikea.marat.qd.je/pt/pt/customer-service/","loading_Text_Key":"A carregar","market_Name_Key":"Portugal","modal_button_Close_Text_Key":"Fechar","negative_feedback_Text_Key":"Lamentamos que n\xe3o tenha obtido a resposta que procurava. Gostaria de nos ajudar a melhorar?","no_results_Text_Key":"N\xe3o encontr\xe1mos nenhum resultado para os termos da pesquisa: {{query}}","product_error_Text_Key":"Lamentamos, mas n\xe3o foram encontrados resultados. Este motor de pesquisa suporta apenas uma ou mais palavras-chave. Se quiser informa\xe7\xf5es sobre os nossos produtos, use o motor de busca principal localizado na parte superior da web. Se pretender verificar o estado da sua encomenda, clique.","read_more_button_Text_Key":"Ler mais","results_Text_Key":"Encontr\xe1mos {{number}} resultado(s) para: {{query}}","retrieving_Text_Key":"A obter informa\xe7\xe3o","search_button_label_Text_Key":"Pesquisa","searchbar_Text_Key":"Escreva uma palavra ou frase, exemplo encomendar ou alterar.","searching_Text_Key":"A pesquisar...","showLess_Text_Key":"Mostre menos","showMore_Text_Key":"Mostrar mais","spellcheck_Text_Key":"Verifique os termos da pesquisa ou, em alternativa para obter suporte, poder\xe1 contactar-nos atrav\xe9s do chat.","submit_Text_Key":"Enviar","try_again_Text_Key":"Por favor tente novamente mais tarde"}');


var $23da7764d65c0fb1$exports = {};
$23da7764d65c0fb1$exports = JSON.parse('{"archived_Desc_Key":"Pute\u021Bi g\u0103si aici ajutor suplimentar.","archived_Title_Key":"Acest document a fost arhivat.","carousel_Text_Key":"Articolul nu a fost util? \xcencearc\u0103 unul dintre articolele similare de mai jos.","click_prompt_Text_Key":"click aici","close_Text_Key":"\xcenchide","customerService_Text_Key":"Rela\u021Bii clien\u021Bi","error_Text_Key":"A ap\u0103rut o eroare","faq":"\xcentreb\u0103ri frecvente","feedback_Option1_Text_Key":"Textul este derutant","feedback_Option2_Text_Key":"Textul nu este relevant pentru \xeentrebarea mea","feedback_Option3_Text_Key":"Textul este relevant, dar nu este util","feedback_Option4_Text_Key":"Textul este prea lung sau prea scurt ","feedback_Question_1_Text_Key":"Ce p\u0103r\u021Bi ale articolului nostru \u021Bi se par nesatisf\u0103c\u0103toare sau nefolositoare?","feedback_Rec_Text_Key":"\xce\u021Bi mul\u021Bumim pentru feedback!","feedback_Text_Key":"\u021Ai s-a p\u0103rut util\u0103 informa\u021Bia?","here_Text_Key":"aici","knowledge_Text_Key":"Informa\u021Bii","link_prod_error_Text_Key":"https://ikea.marat.qd.je/ro/ro/customer-service/track-manage-order/","loading_Text_Key":"\xcenc\u0103rcare","market_Name_Key":"Rom\xe2nia","modal_button_Close_Text_Key":"\xcenchide","negative_feedback_Text_Key":"Ne pare r\u0103u c\u0103 nu ai primit r\u0103spunsul pe care \xeel c\u0103utai, dore\u0219ti s\u0103 ne aju\u021Bi s\u0103 ne \xeembun\u0103t\u0103\u021Bim?","no_results_Text_Key":"Nu am g\u0103sit niciun rezultat pentru termenul c\u0103utat: {{query}}","product_error_Text_Key":"Dac\u0103 \xeencerci s\u0103 g\u0103se\u0219ti un produs, te rog s\u0103 folose\u0219ti bara de c\u0103utare din partea de sus a paginii. Dac\u0103 dore\u0219ti s\u0103 afli informa\u021Bii despre comanda ta, te rog f\u0103","read_more_button_Text_Key":"Cite\u0219te mai mult","results_Text_Key":"Noi am g\u0103sit {{number}} rezultat pentru: {{query}}","retrieving_Text_Key":"Pridobivanje","searchbar_Text_Key":"Exemplu de c\u0103utare: livrare sau factur\u0103","searching_Text_Key":"C\u0103utare...","showLess_Text_Key":"Arat\u0103 mai pu\u021Bin","showMore_Text_Key":"Arat\u0103 mai mult","spellcheck_Text_Key":"Te rug\u0103m s\u0103 verifici c\u0103 ai scris corect sau s\u0103 \xeencerci alte cuvinte cheie","submit_Text_Key":"Trimite","try_again_Text_Key":"Te rug\u0103m s\u0103 \xeencerci din nou mai t\xe2rziu"}');


var $71d9e05e2b8e84e5$exports = {};
$71d9e05e2b8e84e5$exports = JSON.parse('{"archived_Desc_Key":"Dodatna pomo\u010D je na voljo tukaj","archived_Title_Key":"Ta dokument je bil arhiviran.","carousel_Text_Key":"Nebol tento \u010Dl\xe1nok dostato\u010Dne u\u017Eito\u010Dn\xfd? Vysk\xfa\u0161ajte pr\xedbuzn\xfd obsah zobrazen\xfd ni\u017E\u0161ie.","click_prompt_Text_Key":"Kliknite tu","close_Text_Key":"Zavrie\u0165","customerService_Text_Key":"Z\xe1kazn\xedcky servis","error_Text_Key":"Nie\u010Do sa nepodarilo","faq":"\u010Casto kladen\xe9 ot\xe1zky","feedback_Option1_Text_Key":"Text je m\xe4t\xfaci a\xa0nepochopite\u013En\xfd","feedback_Option2_Text_Key":"Text sa net\xfdka mojej ot\xe1zky","feedback_Option3_Text_Key":"Text sa t\xfdka mojej ot\xe1zky, ale nie je u\u017Eito\u010Dn\xfd","feedback_Option4_Text_Key":"Text je pr\xedli\u0161 dlh\xfd alebo pr\xedli\u0161 kr\xe1tky ","feedback_Question_1_Text_Key":"Ktor\xe9 konkr\xe9tne \u010Dasti na\u0161ich \u010Dl\xe1nkov pova\u017Eujete za neuspokojiv\xe9 alebo neu\u017Eito\u010Dn\xe9?","feedback_Rec_Text_Key":"\u010Eakujeme za va\u0161u sp\xe4tn\xfa v\xe4zbu!","feedback_Text_Key":"Bolo to pre v\xe1s u\u017Eito\u010Dn\xe9?","here_Text_Key":"tukaj","knowledge_Text_Key":"Centrum poznatkov","link_prod_error_Text_Key":"https://ikea.marat.qd.je/sk/sk/customer-service/track-manage-order/","loading_Text_Key":"Na\u010D\xedtavam","market_Name_Key":"Slovensk\xe1 republika","modal_button_Close_Text_Key":"Zatvori\u0165","negative_feedback_Text_Key":"Je n\xe1m \u013E\xfato, \u017Ee ste nedostali odpove\u010F, ktor\xfa ste h\u013Eadali, chcete n\xe1m pom\xf4c\u0165 zlep\u0161i\u0165 sa?","no_results_Text_Key":"Nena\u0161li sme \u017Eiadne zhody pre h\u013Eadan\xfd v\xfdraz: {{query}}","product_error_Text_Key":"Toto pole sl\xfa\u017Ei na vyh\u013Eadanie n\xe1povedy. Pokia\u013E chcete h\u013Eada\u0165 v\xfdrobky na z\xe1klade ich \u010D\xedsla, pou\u017Eite hlavn\xe9 vyh\u013Ead\xe1vacie pole na IKEA.sk","read_more_button_Text_Key":"Pre\u010D\xedta\u0165 viac","results_Text_Key":"Na\u0161li sme {{number}} v\xfdsledok/v\xfdsledky pre: {{query}}","retrieving_Text_Key":"Na\u010D\xedtavam","searchbar_Text_Key":"Sem nap\xed\u0161te, \u010Do h\u013Ead\xe1te.","searching_Text_Key":"Vyh\u013Ead\xe1vam...","showLess_Text_Key":"Zobrazi\u0165 menej","showMore_Text_Key":"Zobrazi\u0165 viac","spellcheck_Text_Key":"Sk\xfaste skontrolova\u0165 pravopis alebo pou\u017Eite in\xe9 k\u013E\xfa\u010Dov\xe9 slov\xe1","submit_Text_Key":"Odosla\u0165","try_again_Text_Key":"Sk\xfaste to znovu nesk\xf4r pros\xedm"}');


var $cbdec4b8bc702547$exports = {};
$cbdec4b8bc702547$exports = JSON.parse('{"archived_Desc_Key":"Pomo\u010D lahko najde\u0161 tukaj.","archived_Title_Key":"Ta dokument je arhiviran.","carousel_Text_Key":"Ali \u010Dlanek ni bil koristen? Poskusi z enim od povezanih \u010Dlankov spodaj.","click_prompt_Text_Key":"klikni tukaj","close_Text_Key":"Zapri","customerService_Text_Key":"Slu\u017Eba za pomo\u010D kupcem","error_Text_Key":"Pri\u0161lo je do napake","faq":"Pogosto zastavjena vpra\u0161anja","feedback_Option1_Text_Key":"Besedilo ni jasno razumljivo","feedback_Option2_Text_Key":"Besedilo ni povezano z mojim vpra\u0161anjem","feedback_Option3_Text_Key":"Besedilo je relevantno, vendar ni koristno","feedback_Option4_Text_Key":"Besedilo je predolgo ali prekratko ","feedback_Question_1_Text_Key":"Kaj na na\u0161em \u010Dlanku se ti zdi pomanjkljivo ali nekoristno?","feedback_Rec_Text_Key":"Hvala za povratne informacije!","feedback_Text_Key":"Je bilo to uporabno?","here_Text_Key":"tukaj.","knowledge_Text_Key":"Zbirka znanja","link_prod_error_Text_Key":"https://ikea.marat.qd.je/si/sl/customer-service/track-manage-order/","loading_Text_Key":"Nalaganje","market_Name_Key":"Slovenija","modal_button_Close_Text_Key":"Zapri","negative_feedback_Text_Key":"\u017Dal nam je, da nisi dobil/-a odgovora, ki si ga iskal/-a. Ali nam \u017Eeli\u0161 pomagati pri izbolj\u0161ivah?","no_results_Text_Key":"Ni bilo mogo\u010De najti ujemanj za iskalne izraze: {{query}}","product_error_Text_Key":"\u010Ce i\u0161\u010De\u0161 izdelek, uporabi brskalnik na vrhu spletne strani. \u010Ce i\u0161\u010De\u0161 informacije o svojem naro\u010Dilu,","read_more_button_Text_Key":"Preberi ve\u010D","results_Text_Key":"\u0160tevilo zadetkov za \\"{{query}}\\": {{number}}","retrieving_Text_Key":"Pridobivanje","searchbar_Text_Key":"Preizkusi na primer: dostava ali prevzem","searching_Text_Key":"Iskanje...","showLess_Text_Key":"Prika\u017Ei manj","showMore_Text_Key":"Prika\u017Ei ve\u010D","spellcheck_Text_Key":"Preveri zapis besede ali uporabi druge klju\u010Dne besede","submit_Text_Key":"Po\u0161lji","try_again_Text_Key":"Poku\u0161aj ponovo kasnije"}');


var $8c0446b1bd1ed1e5$exports = {};
$8c0446b1bd1ed1e5$exports = JSON.parse('{"archived_Desc_Key":"Dodatnu pomo\u0107 mo\u017Ee\u0161 prona\u0107i ovde.","archived_Title_Key":"Ovaj dokument je arhiviran.","carousel_Text_Key":"Ovaj \u010Dlanak ti nije bio od pomo\u0107i? Pogledaj jedan od sli\u010Dnih \u010Dlanaka u nastavku.","click_prompt_Text_Key":"klikni ovde","close_Text_Key":"Zatvori","customerService_Text_Key":"Slu\u017Eba za kupce","error_Text_Key":"Do\u0161lo je do gre\u0161ke","faq":"Naj\u010De\u0161\u0107a pitanja","feedback_Option1_Text_Key":"Tekst je zbunjuju\u0107i i te\u017Eak za razumevanje","feedback_Option2_Text_Key":"Tekst nije relevantan za moje pitanje","feedback_Option3_Text_Key":"Tekst je relevantan, ali nije od pomo\u0107i","feedback_Option4_Text_Key":"Tekst je preduga\u010Dak ili prekratak ","feedback_Question_1_Text_Key":"Koji deo na\u0161eg \u010Dlanka smatra\u0161 nezadovoljavaju\u0107im ili nije koristan?","feedback_Rec_Text_Key":"Hvala na povratnoj informaciji!","feedback_Text_Key":"Da li ti je ovo bilo korisno?","here_Text_Key":"ovde.","knowledge_Text_Key":"Baza znanja","link_prod_error_Text_Key":"https://ikea.marat.qd.je/rs/sr/customer-service/track-manage-order/","loading_Text_Key":"U\u010Ditavanje","market_Name_Key":"Srbija","modal_button_Close_Text_Key":"Zatvori","negative_feedback_Text_Key":"\u017Dao nam je \u0161to nisi dobio/la tra\u017Eeni odgovor, da li bi \u017Eeleo/la da nam pomogne\u0161 da se pobolj\u0161amo?","no_results_Text_Key":"Nismo prona\u0161li nijedan rezultat za tvoj unos: {{query}}","product_error_Text_Key":"Ako tra\u017Ei\u0161 neki proizvod, koristi polje za pretragu na vrhu stranice. Ukoliko ti je potrebna informacija u vezi s tvojom narud\u017Ebinom,","read_more_button_Text_Key":"Pro\u010Ditaj vi\u0161e","results_Text_Key":"Prona\u0161li smo {{number}} rezultat(a) za: {{query}}","retrieving_Text_Key":"Prikupljanje","searchbar_Text_Key":"Poku\u0161aj, recimo: isporuka ili radno vreme","searching_Text_Key":"Pretraga...","showLess_Text_Key":"Prika\u017Ei manje","showMore_Text_Key":"Prika\u017Ei vi\u0161e","spellcheck_Text_Key":"Proveri da li je unos ispravan ili koristi druge klju\u010Dne re\u010Di","submit_Text_Key":"Po\u0161alji","try_again_Text_Key":"Poku\u0161aj ponovo kasnije"}');


var $b950e4b02745ddf9$exports = {};
$b950e4b02745ddf9$exports = JSON.parse('{"archived_Desc_Key":"F\xf6r support, g\xe5 till ikea.se/kundservice","archived_Title_Key":"Det h\xe4r dokumentet \xe4r inte l\xe4ngre tillg\xe4ngligt.","carousel_Text_Key":"Hittade du inte det du s\xf6kte? Ta en titt p\xe5 en av artiklarna i listan.","click_prompt_Text_Key":"Klicka h\xe4r","close_Text_Key":"St\xe4ng","customerService_Text_Key":"Kundservice","error_Text_Key":"N\xe5got gick fel","faq":"Vanliga fr\xe5gor och svar","feedback_Option1_Text_Key":"Texten \xe4r f\xf6rvirrande och sv\xe5r att f\xf6rst\xe5","feedback_Option2_Text_Key":"Texten \xe4r inte relevant f\xf6r min fr\xe5ga","feedback_Option3_Text_Key":"Texten \xe4r relevant men inte till n\xe5gon hj\xe4lp","feedback_Option4_Text_Key":"Texten \xe4r f\xf6r l\xe5ng eller f\xf6r kort ","feedback_Question_1_Text_Key":"Vilken eller vilka delar av artikeln kan vi g\xf6ra b\xe4ttre?","feedback_Rec_Text_Key":"Tack f\xf6r din feedback!","feedback_Text_Key":"Hj\xe4lpte den h\xe4r artikeln dig?","here_Text_Key":"ikea.se/kundservice","knowledge_Text_Key":"Kunskapsportal","link_prod_error_Text_Key":"https://order.ikea.com/se/sv/purchases/lookup/","loading_Text_Key":"Letar efter svaret...","market_Name_Key":"Sverige","modal_button_Close_Text_Key":"St\xe4ng","negative_feedback_Text_Key":"Vi beklagar att du inte fick det svar du letade efter, vill du hj\xe4lpa oss att bli b\xe4ttre?","no_results_Text_Key":"Vi hittade inga resultat f\xf6r: {{query}}","product_error_Text_Key":"Anv\xe4nd ist\xe4llet s\xf6kf\xe4ltet h\xf6gst upp p\xe5 v\xe5r hemsida om du letar efter information om en specifik produkt. Vill du sp\xe5ra eller hantera din order,","read_more_button_Text_Key":"L\xe4s mer","results_Text_Key":"Vi hittade {{number}} resultat f\xf6r: {{query}}","retrieving_Text_Key":"Laddar...","searchbar_Text_Key":"Hur kan vi hj\xe4lpa dig? Skriv din fr\xe5ga h\xe4r","searching_Text_Key":"Letar efter svaret...","showLess_Text_Key":"Visa mindre","showMore_Text_Key":"Visa mer","spellcheck_Text_Key":"Testa att anv\xe4nda ett annat ord eller fras!","submit_Text_Key":"Skicka in","try_again_Text_Key":"Var sn\xe4ll och f\xf6rs\xf6k igen senare."}');


var $8e58ea47cb838caa$exports = {};
$8e58ea47cb838caa$exports = JSON.parse('{"archived_Desc_Key":"Ytterligare hj\xe4lp finns h\xe4r","archived_Redirection_Key":"kundservice/Kontakta oss/","archived_Title_Key":"Detta dokument har arkiverats.","carousel_Text_Key":"Var artikeln inte till hj\xe4lp? Prova n\xe5gon av de relaterade artiklarna nedan.","clear_button_label_Text_Key":"Rensa s\xf6kf\xe4ltet","click_prompt_Text_Key":"h\xe4r","close_Text_Key":"St\xe4ng","customerService_Text_Key":"Kundtj\xe4nst","error_Text_Key":"N\xe5got gick fel","faq":"Vanliga fr\xe5gor och svar","feedback_Option1_Text_Key":"Texten \xe4r sv\xe5r att f\xf6rst\xe5.","feedback_Option2_Text_Key":"Texten \xe4r inte relevant f\xf6r min fr\xe5ga.","feedback_Option3_Text_Key":"Texten \xe4r relevant men inte till n\xe5gon hj\xe4lp.","feedback_Option4_Text_Key":"Texten \xe4r f\xf6r l\xe5ng eller f\xf6r kort.","feedback_Question_1_Text_Key":"Vilka delar av v\xe5ra artiklar tycker du \xe4r otillfredsst\xe4llande eller oanv\xe4ndbara?","feedback_Rec_Text_Key":"Tack f\xf6r din feedback!","feedback_Text_Key":"Tyckte du att detta var anv\xe4ndbart?","here_Text_Key":"h\xe4r","knowledge_Text_Key":"Kunskap","link_prod_error_Text_Key":"https://ikea.marat.qd.je/gb/en/customer-service/track-manage-order/","loading_Text_Key":"Laddar","market_Name_Key":"Finland","modal_button_Close_Text_Key":"St\xe4ng","negative_feedback_Text_Key":"Vi beklagar att du inte fick det svar du s\xf6kte. Vill du hj\xe4lpa oss att f\xf6rb\xe4ttra oss?","no_results_Text_Key":"Vi hittade inga tr\xe4ffar f\xf6r s\xf6ktermen: {{query}}","product_error_Text_Key":"Tyv\xe4rr, inga resultat hittades. Denna s\xf6kmotor st\xf6der endast ett eller flera nyckelord. Om du vill ha information om v\xe5ra produkter, anv\xe4nd huvudsakliga s\xf6kmotorn som finns h\xf6gst upp p\xe5 webbplatsen. Om du vill kontrollera statusen f\xf6r din best\xe4llning, klicka h\xe4r.","read_more_button_Text_Key":"L\xe4s mer","results_Text_Key":"Vi hittade {{number}} resultat f\xf6r: {{query}}","retrieving_Text_Key":"H\xe4mta","search_button_label_Text_Key":"S\xf6k","searchbar_Text_Key":"Skriv ett ord eller en fras, till exempel best\xe4ll eller \xe4ndra.","searching_Text_Key":"S\xf6ker...","showLess_Text_Key":"Visa mindre","showMore_Text_Key":"Visa mer","spellcheck_Text_Key":"Kontrollera stavningen eller anv\xe4nd andra s\xf6kord.","submit_Text_Key":"Skicka","try_again_Text_Key":"F\xf6rs\xf6k igen senare"}');


var $cebae5d08f34d98d$exports = {};
$cebae5d08f34d98d$exports = JSON.parse('{"archived_Desc_Key":"\u0414\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0443 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0443 \u043C\u043E\u0436\u043D\u0430 \u0437\u043D\u0430\u0439\u0442\u0438 \u0442\u0443\u0442","archived_Title_Key":"\u0426\u0435\u0439 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u0431\u0443\u043B\u043E \u0430\u0440\u0445\u0456\u0432\u043E\u0432\u0430\u043D\u043E.","carousel_Text_Key":"\u0427\u0438 \u043D\u0435 \u0431\u0443\u043B\u0430 \u0441\u0442\u0430\u0442\u0442\u044F \u043A\u043E\u0440\u0438\u0441\u043D\u043E\u044E? \u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043E\u0434\u043D\u0443 \u0437\u0456 \u0441\u043F\u043E\u0440\u0456\u0434\u043D\u0435\u043D\u0438\u0445 \u0441\u0442\u0430\u0442\u0435\u0439 \u043D\u0438\u0436\u0447\u0435.","click_prompt_Text_Key":"\u0442\u0443\u0442","close_Text_Key":"\u0417\u0430\u043A\u0440\u0438\u0442\u0438","customerService_Text_Key":"\u0421\u043B\u0443\u0436\u0431\u0430 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438 \u043A\u043B\u0456\u0454\u043D\u0442\u0456\u0432","error_Text_Key":"\u0421\u0442\u0430\u043B\u0430\u0441\u044C \u043F\u043E\u043C\u0438\u043B\u043A\u0430","feedback_Option1_Text_Key":"\u0422\u0435\u043A\u0441\u0442 \u0432\u0430\u0436\u043A\u043E \u0437\u0440\u043E\u0437\u0443\u043C\u0456\u0442\u0438","feedback_Option2_Text_Key":"\u0422\u0435\u043A\u0441\u0442 \u043D\u0435 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u0454 \u043D\u0430 \u043C\u043E\u0454 \u043F\u0438\u0442\u0430\u043D\u043D\u044F","feedback_Option3_Text_Key":"\u0422\u0435\u043A\u0441\u0442 \u0434\u043E\u0440\u0435\u0447\u043D\u0438\u0439, \u0430\u043B\u0435 \u043D\u0435 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u0439","feedback_Option4_Text_Key":"\u0422\u0435\u043A\u0441\u0442 \u0437\u0430\u043D\u0430\u0434\u0442\u043E \u0434\u043E\u0432\u0433\u0438\u0439 \u0430\u0431\u043E \u0437\u0430\u043D\u0430\u0434\u0442\u043E \u043A\u043E\u0440\u043E\u0442\u043A\u0438\u0439 ","feedback_Question_1_Text_Key":"\u042F\u043A\u0443 \u0441\u0430\u043C\u0435 \u0447\u0430\u0441\u0442\u0438\u043D\u0443 \u043D\u0430\u0448\u043E\u0457 \u0441\u0442\u0430\u0442\u0442\u0456 \u0432\u0438 \u0432\u0432\u0430\u0436\u0430\u0454\u0442\u0435 \u043D\u0435\u0437\u0430\u0434\u043E\u0432\u0456\u043B\u044C\u043D\u043E\u044E \u0447\u0438 \u043D\u0435\u043A\u043E\u0440\u0438\u0441\u043D\u043E\u044E?","feedback_Rec_Text_Key":"\u0414\u044F\u043A\u0443\u0454\u043C\u043E \u0437\u0430 \u0432\u0430\u0448 \u0432\u0456\u0434\u0433\u0443\u043A!","feedback_Text_Key":"\u0427\u0438 \u0431\u0443\u043B\u0430 \u043A\u043E\u0440\u0438\u0441\u043D\u043E\u044E \u0446\u044F \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044F?","here_Text_Key":"\u0442\u0443\u0442","knowledge_Text_Key":"\u0417\u043D\u0430\u043D\u043D\u044F","link_prod_error_Text_Key":"https://ikea.marat.qd.je/ua/uk/customer-service/","loading_Text_Key":"\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F","market_Name_Key":"\u0423\u043A\u0440\u0430\u0457\u043D\u0430","modal_button_Close_Text_Key":"\u0417\u0430\u043A\u0440\u0438\u0442\u0438","negative_feedback_Text_Key":"\u041D\u0430\u043C \u0448\u043A\u043E\u0434\u0430, \u0449\u043E \u0432\u0438 \u043D\u0435 \u043E\u0442\u0440\u0438\u043C\u0430\u043B\u0438 \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E\u0457 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456, \u0447\u0438 \u043D\u0435 \u0445\u043E\u0442\u0456\u043B\u0438 \u0431 \u0432\u0438 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0442\u0438 \u043D\u0430\u043C \u0441\u0442\u0430\u0442\u0438 \u043A\u0440\u0430\u0449\u0435?","no_results_Text_Key":"\u041D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E \u0437\u0431\u0456\u0433\u0456\u0432 \u0437\u0430 \u0437\u0430\u043F\u0438\u0442\u043E\u043C: {{query}}","product_error_Text_Key":"\u041D\u0430 \u0436\u0430\u043B\u044C, \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E. \u0426\u044F \u043F\u043E\u0448\u0443\u043A\u043E\u0432\u0430 \u0441\u0438\u0441\u0442\u0435\u043C\u0430 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u0443\u0454 \u0442\u0456\u043B\u044C\u043A\u0438 \u043E\u0434\u043D\u0435 \u0430\u0431\u043E \u0431\u0456\u043B\u044C\u0448\u0435 \u043A\u043B\u044E\u0447\u043E\u0432\u0438\u0445 \u0441\u043B\u0456\u0432. \u042F\u043A\u0449\u043E \u0432\u0430\u043C \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u0430 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044F \u043F\u0440\u043E \u043D\u0430\u0448\u0456 \u0442\u043E\u0432\u0430\u0440\u0438, \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0439\u0442\u0435 \u043E\u0441\u043D\u043E\u0432\u043D\u0443 \u043F\u043E\u0448\u0443\u043A\u043E\u0432\u0443 \u0441\u0438\u0441\u0442\u0435\u043C\u0443, \u0440\u043E\u0437\u0442\u0430\u0448\u043E\u0432\u0430\u043D\u0443 \u0443 \u0432\u0435\u0440\u0445\u043D\u0456\u0439 \u0447\u0430\u0441\u0442\u0438\u043D\u0456 \u043C\u0435\u0440\u0435\u0436\u0456. \u042F\u043A\u0449\u043E \u0432\u0438 \u0445\u043E\u0447\u0435\u0442\u0435 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0438\u0442\u0438 \u0441\u0442\u0430\u043D \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F, \u043D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \u043A\u043D\u043E\u043F\u043A\u0443.","read_more_button_Text_Key":"\u0414\u043E\u043A\u043B\u0430\u0434\u043D\u0456\u0448\u0435","results_Text_Key":"\u041C\u0438 \u0437\u043D\u0430\u0439\u0448\u043B\u0438 {{number}} \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442(\u0456\u0432) \u0434\u043B\u044F: {{query}}","retrieving_Text_Key":"\u041E\u0431\u0440\u043E\u0431\u043A\u0430","searchbar_Text_Key":"\u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435, \u043D\u0430\u043F\u0440\u0438\u043A\u043B\u0430\u0434: \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430, \u0430\u0431\u043E \u043E\u043F\u043B\u0430\u0442\u0430","searching_Text_Key":"\u041F\u043E\u0448\u0443\u043A...","showLess_Text_Key":"\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u043C\u0435\u043D\u0448\u0435","showMore_Text_Key":"\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0431\u0456\u043B\u044C\u0448\u0435","spellcheck_Text_Key":"\u041F\u0435\u0440\u0435\u0432\u0456\u0440, \u0447\u0438 \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E \u043D\u0430\u043F\u0438\u0441\u0430\u043D\u0435 \u0441\u043B\u043E\u0432\u043E, \u0430\u0431\u043E \u0441\u043F\u0440\u043E\u0431\u0443\u0439 \u0432\u0432\u0435\u0441\u0442\u0438 \u0456\u043D\u0448\u0435","submit_Text_Key":"\u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0438\u0442\u0438","try_again_Text_Key":"\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0441\u043F\u0440\u043E\u0431\u0443\u0439 \u043F\u0456\u0437\u043D\u0456\u0448\u0435"}');


var $c15f795cecf68ace$exports = {};
$c15f795cecf68ace$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Redirection_Key":"customer-service/contact-us/","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","click_prompt_Text_Key":"Here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Something went wrong","faq":"Frequently Asked Questions","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our articles do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://ikea.marat.qd.je/nz/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"New Zealand","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn\u2019t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any matches for results for search term: {{query}}","product_error_Text_Key":"Sorry, no results found. This search engine only supports one or more keywords. If you want information about our products, use the main search engine located at the top of the web. If you want to check the status of your order, please click.","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","searchbar_Text_Key":"Find answers to your question here","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $1a6cb0e476e76e70$exports = {};
$1a6cb0e476e76e70$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Redirection_Key":"customer-service/contact-us/","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","clear_button_label_Text_Key":"Clear search field","click_prompt_Text_Key":"here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Something went wrong","faq":"Frequently Asked Questions","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short","feedback_Question_1_Text_Key":"What particular parts of our articles do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://ikea.marat.qd.je/gb/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"United kingdom","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn\u2019t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any matches for results for search term: {{query}}","product_error_Text_Key":"Sorry, no results found. This search engine only supports one or more keywords. If you want information about our products, use the main search engine located at the top of the web. If you want to check the status of your order, please click.","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","search_button_label_Text_Key":"Search","searchbar_Text_Key":"Type a word or phrase, for example, order or modify.","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $ddebaaceb149176f$exports = {};
$ddebaaceb149176f$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Redirection_Key":"customer-service/contact-us/","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","clear_button_label_Text_Key":"Clear search field","click_prompt_Text_Key":"here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Something went wrong","faq":"Frequently Asked Questions","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short","feedback_Question_1_Text_Key":"What particular parts of our articles do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://ikea.marat.qd.je/gb/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"United kingdom","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn\u2019t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any matches for results for search term: {{query}}","product_error_Text_Key":"Sorry, no results found. This search engine only supports one or more keywords. If you want information about our products, use the main search engine located at the top of the web. If you want to check the status of your order, please click.","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","search_button_label_Text_Key":"Search","searchbar_Text_Key":"Type a word or phrase, for example, order or modify.","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


const $1e4d69f93f9cf1b1$export$93e4534b7d0af9d4 = {
    'ca-ES': $048bbf39f6fce1af$exports,
    'cs-CZ': $e14a51c5ef1fcbea$exports,
    'da-DK': $71a191848dee8658$exports,
    'de-AT': $54f2f61608f89b93$exports,
    'de-CH': $a4e5b3249dd769a6$exports,
    'de-DE': $fafed6996f6e2378$exports,
    'en-AT': $c48a158a0b2163e0$exports,
    'en-AU': $975b1f6f24f40d28$exports,
    'en-BE': $aaecafd845e67a90$exports,
    'en-CA': $bcefd1a7713d53fc$exports,
    'en-CH': $353db662f9ea9c1b$exports,
    'en-CZ': $a185a0fd067f9c7a$exports,
    'en-DE': $5abe9f74f8937781$exports,
    'en-DK': $1a6cb0e476e76e70$exports,
    'en-ES': $f06407a12667808f$exports,
    'en-FI': $a41100faa5e99a70$exports,
    'en-FR': $5df1784b47d24eeb$exports,
    'en-GB': $d0d1c33a933bdfe2$exports,
    'en-HR': $ddebaaceb149176f$exports,
    'en-IE': $7a4c03cac25ab07f$exports,
    'en-IN': $b7e14e4c3f9884e9$exports,
    'en-JP': $aed33ccce9fe5e33$exports,
    'en-NL': $8156366d2f5ecd63$exports,
    'en-NO': $fa06606bbc43238c$exports,
    'en-NZ': $c15f795cecf68ace$exports,
    'en-PT': $4af600aee2efc2c3$exports,
    'en-SE': $815b81bef1ef5409$exports,
    'en-US': $f86b4311e6e08dfe$exports,
    'es-ES': $c0fdf5d00be69964$exports,
    'es-US': $89840dc4ed33255a$exports,
    'eu-ES': $8a0bb0eb9df691cd$exports,
    'fi-FI': $749b63fb65d6d15f$exports,
    'fr-BE': $b9c8a8caf31f5452$exports,
    'fr-CA': $21d17c9f878e2044$exports,
    'fr-CH': $e80f410b841103f1$exports,
    'fr-FR': $76679e1285069648$exports,
    'gl-ES': $46fad8e485f23084$exports,
    'hr-HR': $639fe58a242dbf06$exports,
    'hu-HU': $bdbaa19545c42116$exports,
    'it-CH': $cb1000c6a325bfad$exports,
    'it-IT': $52e10ebac323958d$exports,
    'ja-JP': $58d318efc91f80b5$exports,
    'ko-KR': $b0224a930dfcbf32$exports,
    'no-NO': $614267f6335b21b4$exports,
    'nl-BE': $9ff154c1a8eb2ce8$exports,
    'nl-NL': $26836d97c71d7de8$exports,
    'pl-PL': $3983bd296339e183$exports,
    'pt-PT': $46abcc1d466640c8$exports,
    'ro-RO': $23da7764d65c0fb1$exports,
    'sk-SK': $71d9e05e2b8e84e5$exports,
    'sl-SI': $cbdec4b8bc702547$exports,
    'sr-RS': $8c0446b1bd1ed1e5$exports,
    'sv-FI': $8e58ea47cb838caa$exports,
    'sv-SE': $b950e4b02745ddf9$exports,
    'uk-UA': $cebae5d08f34d98d$exports
};


const $d4b97166c3e1da52$var$Container = (0, $a40bd87bc05fc082$export$2e2bcd8739ae039).div`
  width: 100%;
  display: flex;
  flex-direction: column;
  @media (max-width: 480px) {
    display: flex;
    flex-direction: column;
    max-width: 400px;
  }

  span:hover {
    cursor: pointer;
  }

  h2:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;
const $d4b97166c3e1da52$var$OpenInNewWindow = (lang)=>{
    const articlePages = [
        "nl-NL",
        "en-NL",
        "fr-FR",
        "fr-CH",
        "it-CH",
        "de-CH",
        "en-CH",
        "fr-CA",
        "en-CA",
        "sv-SE",
        "en-SE",
        "pl-PL",
        "ro-RO",
        "sr-RS",
        "sk-SK",
        "cs-CZ",
        "en-CZ",
        "hr-HR",
        "en-HR",
        "sl-SI",
        "de-DE",
        "en-DE",
        "da-DK",
        "en-DK",
        "no-NO",
        "en-NO",
        "ja-JP",
        "en-JP",
        "fi-FI",
        "en-FI",
        "sv-FI",
        "pt-PT",
        "en-PT",
        "de-AT",
        "en-AT",
        "it-IT",
        "ko-KR",
        "en-KR",
        "en-GB",
        "en-AU",
        "en-US",
        "es-US",
        "en-IN",
        "en-IE",
        "en-ES",
        "es-ES",
        "ca-ES",
        "eu-ES",
        "gl-ES",
        "hu-HU",
        "fr-BE",
        "en-FR",
        "nl-BE",
        "en-BE",
        "uk-UA",
        "en-NZ"
    ];
    if (articlePages.indexOf(lang) > -1) return true;
    else return false;
};
const $d4b97166c3e1da52$var$ArticleList = ({ data: data, lang: lang, query: query, correlationId: correlationId, variant: variant })=>{
    const [modalOpen, setModalOpen] = (0, $fqaWh.useState)(false);
    const [docGuid, setDocGuid] = (0, $fqaWh.useState)(null);
    const [pos, setPos] = (0, $fqaWh.useState)(null);
    const [vetaDoc, setVetaDoc] = (0, $fqaWh.useState)({
        title: "",
        description: "",
        content: ""
    });
    const { t: t } = (0, $f4ab155f387ca43d$export$9fc83ad70ead8663)();
    const langKey = lang;
    const IsProduction = ()=>{
        const url = window.location.href;
        return url.includes("www.ikea.com");
    };
    (0, $fqaWh.useEffect)(()=>{
        async function retrieveDocs() {
            if (docGuid) (0, $e0c6ce23fe7600d5$export$647b0f0838f655fd)({
                locale: t("locale"),
                query: query,
                docGuid: docGuid,
                correlationId: correlationId,
                backend: "lisa",
                isProd: IsProduction(),
                pos: pos,
                setModalOpen: setModalOpen,
                setVetaDoc: setVetaDoc
            });
        }
        if (docGuid) retrieveDocs();
    }, [
        data.content,
        data.length,
        docGuid,
        lang,
        pos,
        query,
        t
    ]);
    const UrlExists = (url)=>{
        if (window.location.hostname === "www.cte.ikeadt.com" || window.location.hostname === "localhost") return true;
        var http = new XMLHttpRequest();
        http.open("HEAD", url, false);
        http.send();
        if (http.status != 404) return true;
        else return false;
    };
    const closeFunc = ()=>{
        setModalOpen(false);
        setDocGuid("");
        setPos(null);
    };
    const renderItems = ()=>{
        const mapRows = data.map((item, index)=>{
            return /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)((0, $fUX2S.Fragment), {
                children: /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)((0, $195cb77f2a25c277$export$2e2bcd8739ae039), {
                    id: item.metadata.docGUID,
                    title: item.title,
                    category: item?.metadata?.categoryPath,
                    variant: variant,
                    onClick: ()=>{
                        setPos(index);
                        const langCombo = lang.split("-");
                        const market = langCombo[1];
                        const mLang = langCombo[0];
                        if ($d4b97166c3e1da52$var$OpenInNewWindow(lang)) {
                            (0, $581d016b301d0ace$export$f42fbd1cc833b8f7)({
                                guid: `${item.metadata.docGUID}`,
                                action: "articleOpen",
                                query: query,
                                variant: variant,
                                pos: index,
                                correlationId: correlationId
                            });
                            window.location.href = `https://ikea.marat.qd.je/${market.toLowerCase()}/${mLang.toLowerCase()}/customer-service/knowledge/articles/${item.metadata.docGUID}.html`;
                        } else setDocGuid(item.metadata.docGUID);
                    },
                    onKeyPress: (e)=>{
                        if (e.key === "Enter") {
                            document.activeElement.blur();
                            setPos(index);
                            if ($d4b97166c3e1da52$var$OpenInNewWindow(lang)) {
                                (0, $581d016b301d0ace$export$f42fbd1cc833b8f7)({
                                    guid: `${item.metadata.docGUID}`,
                                    action: "articleOpen",
                                    query: query,
                                    variant: variant,
                                    pos: index,
                                    correlationId: correlationId
                                });
                                const langCombo = lang.split("-");
                                const market = langCombo[1];
                                const mLang = langCombo[0];
                                window.location.href = `https://ikea.marat.qd.je/${market.toLowerCase()}/${mLang.toLowerCase()}/customer-service/knowledge/articles/${item.metadata.docGUID}.html`;
                            } else setDocGuid(item.metadata.docGUID);
                        }
                    },
                    description: item.description
                })
            });
        });
        return mapRows;
    };
    return /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)($d4b97166c3e1da52$var$Container, {
        children: [
            /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($bOlkA))), {
                visible: modalOpen,
                handleCloseBtn: closeFunc,
                children: /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)((0, $bOlkA.Sheets), {
                    labelledById: vetaDoc.title,
                    alignment: "right",
                    preserveAlignment: false,
                    size: "medium",
                    header: /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)((0, $bOlkA.ModalHeader), {
                        titleId: vetaDoc.title,
                        title: vetaDoc.title,
                        backBtnClick: closeFunc,
                        floating: false
                    }),
                    footer: /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)((0, $bOlkA.ModalFooter), {
                        className: "veta-btn-alignment",
                        children: /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)((0, $1a7c5a491fc3d4f2$export$2e2bcd8739ae039), {
                            text: (0, $1e4d69f93f9cf1b1$export$93e4534b7d0af9d4)[langKey].close_Text_Key,
                            type: "primary",
                            onClick: closeFunc
                        })
                    }),
                    children: /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)((0, $bOlkA.ModalBody), {
                        children: [
                            /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)("p", {
                                children: vetaDoc.description
                            }),
                            /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: vetaDoc.content
                                }
                            })
                        ]
                    })
                })
            }),
            renderItems()
        ]
    });
};
var $d4b97166c3e1da52$export$2e2bcd8739ae039 = $d4b97166c3e1da52$var$ArticleList;





/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $fUX2S = parcelRequire("fUX2S");
parcelRequire("aXNcS");
var $fqaWh = parcelRequire("fqaWh");

'use strict';
function $9aee92b7abef0e18$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $ba6bcc07573c881a$var$toString } = Object.prototype;
const { getPrototypeOf: $ba6bcc07573c881a$var$getPrototypeOf } = Object;
const { iterator: $ba6bcc07573c881a$var$iterator, toStringTag: $ba6bcc07573c881a$var$toStringTag } = Symbol;
const $ba6bcc07573c881a$var$kindOf = ((cache)=>(thing)=>{
        const str = $ba6bcc07573c881a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $ba6bcc07573c881a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$ba6bcc07573c881a$var$kindOf(thing) === type;
};
const $ba6bcc07573c881a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $ba6bcc07573c881a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $ba6bcc07573c881a$var$isUndefined = $ba6bcc07573c881a$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $ba6bcc07573c881a$var$isBuffer(val) {
    return val !== null && !$ba6bcc07573c881a$var$isUndefined(val) && val.constructor !== null && !$ba6bcc07573c881a$var$isUndefined(val.constructor) && $ba6bcc07573c881a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $ba6bcc07573c881a$var$isArrayBuffer = $ba6bcc07573c881a$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $ba6bcc07573c881a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $ba6bcc07573c881a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $ba6bcc07573c881a$var$isString = $ba6bcc07573c881a$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $ba6bcc07573c881a$var$isFunction = $ba6bcc07573c881a$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $ba6bcc07573c881a$var$isNumber = $ba6bcc07573c881a$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $ba6bcc07573c881a$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $ba6bcc07573c881a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $ba6bcc07573c881a$var$isPlainObject = (val)=>{
    if ($ba6bcc07573c881a$var$kindOf(val) !== "object") return false;
    const prototype = $ba6bcc07573c881a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($ba6bcc07573c881a$var$toStringTag in val) && !($ba6bcc07573c881a$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $ba6bcc07573c881a$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$ba6bcc07573c881a$var$isObject(val) || $ba6bcc07573c881a$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $ba6bcc07573c881a$var$isDate = $ba6bcc07573c881a$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $ba6bcc07573c881a$var$isFile = $ba6bcc07573c881a$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $ba6bcc07573c881a$var$isBlob = $ba6bcc07573c881a$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $ba6bcc07573c881a$var$isFileList = $ba6bcc07573c881a$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $ba6bcc07573c881a$var$isStream = (val)=>$ba6bcc07573c881a$var$isObject(val) && $ba6bcc07573c881a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $ba6bcc07573c881a$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $ba6bcc07573c881a$var$isFunction(thing.append) && ((kind = $ba6bcc07573c881a$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $ba6bcc07573c881a$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $ba6bcc07573c881a$var$isURLSearchParams = $ba6bcc07573c881a$var$kindOfTest("URLSearchParams");
const [$ba6bcc07573c881a$var$isReadableStream, $ba6bcc07573c881a$var$isRequest, $ba6bcc07573c881a$var$isResponse, $ba6bcc07573c881a$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($ba6bcc07573c881a$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $ba6bcc07573c881a$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $ba6bcc07573c881a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($ba6bcc07573c881a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($ba6bcc07573c881a$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $ba6bcc07573c881a$var$findKey(obj, key) {
    if ($ba6bcc07573c881a$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $ba6bcc07573c881a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $ba6bcc07573c881a$var$isContextDefined = (context)=>!$ba6bcc07573c881a$var$isUndefined(context) && context !== $ba6bcc07573c881a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $ba6bcc07573c881a$var$merge() {
    const { caseless: caseless, skipUndefined: skipUndefined } = $ba6bcc07573c881a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === "__proto__" || key === "constructor" || key === "prototype") return;
        const targetKey = caseless && $ba6bcc07573c881a$var$findKey(result, key) || key;
        if ($ba6bcc07573c881a$var$isPlainObject(result[targetKey]) && $ba6bcc07573c881a$var$isPlainObject(val)) result[targetKey] = $ba6bcc07573c881a$var$merge(result[targetKey], val);
        else if ($ba6bcc07573c881a$var$isPlainObject(val)) result[targetKey] = $ba6bcc07573c881a$var$merge({}, val);
        else if ($ba6bcc07573c881a$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$ba6bcc07573c881a$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $ba6bcc07573c881a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $ba6bcc07573c881a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $ba6bcc07573c881a$var$forEach(b, (val, key)=>{
        if (thisArg && $ba6bcc07573c881a$var$isFunction(val)) Object.defineProperty(a, key, {
            value: (0, $9aee92b7abef0e18$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $ba6bcc07573c881a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $ba6bcc07573c881a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, "constructor", {
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $ba6bcc07573c881a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $ba6bcc07573c881a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $ba6bcc07573c881a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $ba6bcc07573c881a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($ba6bcc07573c881a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$ba6bcc07573c881a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $ba6bcc07573c881a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $ba6bcc07573c881a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $ba6bcc07573c881a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$ba6bcc07573c881a$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $ba6bcc07573c881a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $ba6bcc07573c881a$var$isHTMLForm = $ba6bcc07573c881a$var$kindOfTest("HTMLFormElement");
const $ba6bcc07573c881a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $ba6bcc07573c881a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $ba6bcc07573c881a$var$isRegExp = $ba6bcc07573c881a$var$kindOfTest("RegExp");
const $ba6bcc07573c881a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $ba6bcc07573c881a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $ba6bcc07573c881a$var$freezeMethods = (obj)=>{
    $ba6bcc07573c881a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($ba6bcc07573c881a$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$ba6bcc07573c881a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $ba6bcc07573c881a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $ba6bcc07573c881a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $ba6bcc07573c881a$var$noop = ()=>{};
const $ba6bcc07573c881a$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $ba6bcc07573c881a$var$isSpecCompliantForm(thing) {
    return !!(thing && $ba6bcc07573c881a$var$isFunction(thing.append) && thing[$ba6bcc07573c881a$var$toStringTag] === "FormData" && thing[$ba6bcc07573c881a$var$iterator]);
}
const $ba6bcc07573c881a$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($ba6bcc07573c881a$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            //Buffer check
            if ($ba6bcc07573c881a$var$isBuffer(source)) return source;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $ba6bcc07573c881a$var$isArray(source) ? [] : {};
                $ba6bcc07573c881a$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$ba6bcc07573c881a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $ba6bcc07573c881a$var$isAsyncFn = $ba6bcc07573c881a$var$kindOfTest("AsyncFunction");
const $ba6bcc07573c881a$var$isThenable = (thing)=>thing && ($ba6bcc07573c881a$var$isObject(thing) || $ba6bcc07573c881a$var$isFunction(thing)) && $ba6bcc07573c881a$var$isFunction(thing.then) && $ba6bcc07573c881a$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $ba6bcc07573c881a$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $ba6bcc07573c881a$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $ba6bcc07573c881a$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $ba6bcc07573c881a$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === "function", $ba6bcc07573c881a$var$isFunction($ba6bcc07573c881a$var$_global.postMessage));
const $ba6bcc07573c881a$var$asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind($ba6bcc07573c881a$var$_global) : $ba6bcc07573c881a$var$_setImmediate;
// *********************
const $ba6bcc07573c881a$var$isIterable = (thing)=>thing != null && $ba6bcc07573c881a$var$isFunction(thing[$ba6bcc07573c881a$var$iterator]);
var $ba6bcc07573c881a$export$2e2bcd8739ae039 = {
    isArray: $ba6bcc07573c881a$var$isArray,
    isArrayBuffer: $ba6bcc07573c881a$var$isArrayBuffer,
    isBuffer: $ba6bcc07573c881a$var$isBuffer,
    isFormData: $ba6bcc07573c881a$var$isFormData,
    isArrayBufferView: $ba6bcc07573c881a$var$isArrayBufferView,
    isString: $ba6bcc07573c881a$var$isString,
    isNumber: $ba6bcc07573c881a$var$isNumber,
    isBoolean: $ba6bcc07573c881a$var$isBoolean,
    isObject: $ba6bcc07573c881a$var$isObject,
    isPlainObject: $ba6bcc07573c881a$var$isPlainObject,
    isEmptyObject: $ba6bcc07573c881a$var$isEmptyObject,
    isReadableStream: $ba6bcc07573c881a$var$isReadableStream,
    isRequest: $ba6bcc07573c881a$var$isRequest,
    isResponse: $ba6bcc07573c881a$var$isResponse,
    isHeaders: $ba6bcc07573c881a$var$isHeaders,
    isUndefined: $ba6bcc07573c881a$var$isUndefined,
    isDate: $ba6bcc07573c881a$var$isDate,
    isFile: $ba6bcc07573c881a$var$isFile,
    isBlob: $ba6bcc07573c881a$var$isBlob,
    isRegExp: $ba6bcc07573c881a$var$isRegExp,
    isFunction: $ba6bcc07573c881a$var$isFunction,
    isStream: $ba6bcc07573c881a$var$isStream,
    isURLSearchParams: $ba6bcc07573c881a$var$isURLSearchParams,
    isTypedArray: $ba6bcc07573c881a$var$isTypedArray,
    isFileList: $ba6bcc07573c881a$var$isFileList,
    forEach: $ba6bcc07573c881a$var$forEach,
    merge: $ba6bcc07573c881a$var$merge,
    extend: $ba6bcc07573c881a$var$extend,
    trim: $ba6bcc07573c881a$var$trim,
    stripBOM: $ba6bcc07573c881a$var$stripBOM,
    inherits: $ba6bcc07573c881a$var$inherits,
    toFlatObject: $ba6bcc07573c881a$var$toFlatObject,
    kindOf: $ba6bcc07573c881a$var$kindOf,
    kindOfTest: $ba6bcc07573c881a$var$kindOfTest,
    endsWith: $ba6bcc07573c881a$var$endsWith,
    toArray: $ba6bcc07573c881a$var$toArray,
    forEachEntry: $ba6bcc07573c881a$var$forEachEntry,
    matchAll: $ba6bcc07573c881a$var$matchAll,
    isHTMLForm: $ba6bcc07573c881a$var$isHTMLForm,
    hasOwnProperty: $ba6bcc07573c881a$var$hasOwnProperty,
    hasOwnProp: $ba6bcc07573c881a$var$hasOwnProperty,
    reduceDescriptors: $ba6bcc07573c881a$var$reduceDescriptors,
    freezeMethods: $ba6bcc07573c881a$var$freezeMethods,
    toObjectSet: $ba6bcc07573c881a$var$toObjectSet,
    toCamelCase: $ba6bcc07573c881a$var$toCamelCase,
    noop: $ba6bcc07573c881a$var$noop,
    toFiniteNumber: $ba6bcc07573c881a$var$toFiniteNumber,
    findKey: $ba6bcc07573c881a$var$findKey,
    global: $ba6bcc07573c881a$var$_global,
    isContextDefined: $ba6bcc07573c881a$var$isContextDefined,
    isSpecCompliantForm: $ba6bcc07573c881a$var$isSpecCompliantForm,
    toJSONObject: $ba6bcc07573c881a$var$toJSONObject,
    isAsyncFn: $ba6bcc07573c881a$var$isAsyncFn,
    isThenable: $ba6bcc07573c881a$var$isThenable,
    setImmediate: $ba6bcc07573c881a$var$_setImmediate,
    asap: $ba6bcc07573c881a$var$asap,
    isIterable: $ba6bcc07573c881a$var$isIterable
};







'use strict';
class $3f7893131edded6a$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        const axiosError = new $3f7893131edded6a$var$AxiosError(error.message, code || error.code, config, request, response);
        axiosError.cause = error;
        axiosError.name = error.name;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
     * Create an Error with the specified message, config, error code, request and response.
     *
     * @param {string} message The error message.
     * @param {string} [code] The error code (for example, 'ECONNABORTED').
     * @param {Object} [config] The config.
     * @param {Object} [request] The request.
     * @param {Object} [response] The response.
     *
     * @returns {Error} The created error.
     */ constructor(message, code, config, request, response){
        super(message);
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$3f7893131edded6a$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$3f7893131edded6a$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$3f7893131edded6a$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$3f7893131edded6a$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$3f7893131edded6a$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$3f7893131edded6a$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$3f7893131edded6a$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$3f7893131edded6a$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$3f7893131edded6a$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$3f7893131edded6a$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$3f7893131edded6a$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$3f7893131edded6a$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
var $3f7893131edded6a$export$2e2bcd8739ae039 = $3f7893131edded6a$var$AxiosError;


// eslint-disable-next-line strict
var $08b0e4e9ba6e0113$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $0c89b4b4e3a03018$export$a143d493d941bafc;
var $0c89b4b4e3a03018$export$e4cf37d7f6fb9e0a;
var $0c89b4b4e3a03018$export$f99ded8fe4b79145;
var $0c89b4b4e3a03018$export$599f31c3813fae4d;
'use strict';
var $2f6be699f60557c3$export$a48f0734ac7c2329;
var $2f6be699f60557c3$export$d622b2ad8d90c771;
var $2f6be699f60557c3$export$6100ba28696e12de;
'use strict';
$2f6be699f60557c3$export$a48f0734ac7c2329 = $2f6be699f60557c3$var$byteLength;
$2f6be699f60557c3$export$d622b2ad8d90c771 = $2f6be699f60557c3$var$toByteArray;
$2f6be699f60557c3$export$6100ba28696e12de = $2f6be699f60557c3$var$fromByteArray;
var $2f6be699f60557c3$var$lookup = [];
var $2f6be699f60557c3$var$revLookup = [];
var $2f6be699f60557c3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $2f6be699f60557c3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $2f6be699f60557c3$var$i = 0, $2f6be699f60557c3$var$len = $2f6be699f60557c3$var$code.length; $2f6be699f60557c3$var$i < $2f6be699f60557c3$var$len; ++$2f6be699f60557c3$var$i){
    $2f6be699f60557c3$var$lookup[$2f6be699f60557c3$var$i] = $2f6be699f60557c3$var$code[$2f6be699f60557c3$var$i];
    $2f6be699f60557c3$var$revLookup[$2f6be699f60557c3$var$code.charCodeAt($2f6be699f60557c3$var$i)] = $2f6be699f60557c3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$2f6be699f60557c3$var$revLookup['-'.charCodeAt(0)] = 62;
$2f6be699f60557c3$var$revLookup['_'.charCodeAt(0)] = 63;
function $2f6be699f60557c3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $2f6be699f60557c3$var$byteLength(b64) {
    var lens = $2f6be699f60557c3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $2f6be699f60557c3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $2f6be699f60557c3$var$toByteArray(b64) {
    var tmp;
    var lens = $2f6be699f60557c3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $2f6be699f60557c3$var$Arr($2f6be699f60557c3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $2f6be699f60557c3$var$revLookup[b64.charCodeAt(i)] << 18 | $2f6be699f60557c3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $2f6be699f60557c3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $2f6be699f60557c3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $2f6be699f60557c3$var$revLookup[b64.charCodeAt(i)] << 2 | $2f6be699f60557c3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $2f6be699f60557c3$var$revLookup[b64.charCodeAt(i)] << 10 | $2f6be699f60557c3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $2f6be699f60557c3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $2f6be699f60557c3$var$tripletToBase64(num) {
    return $2f6be699f60557c3$var$lookup[num >> 18 & 0x3F] + $2f6be699f60557c3$var$lookup[num >> 12 & 0x3F] + $2f6be699f60557c3$var$lookup[num >> 6 & 0x3F] + $2f6be699f60557c3$var$lookup[num & 0x3F];
}
function $2f6be699f60557c3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($2f6be699f60557c3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $2f6be699f60557c3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($2f6be699f60557c3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($2f6be699f60557c3$var$lookup[tmp >> 2] + $2f6be699f60557c3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($2f6be699f60557c3$var$lookup[tmp >> 10] + $2f6be699f60557c3$var$lookup[tmp >> 4 & 0x3F] + $2f6be699f60557c3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $10e08df24d6ef04d$export$aafa59e2e03f2942;
var $10e08df24d6ef04d$export$68d8715fc104d294;
$10e08df24d6ef04d$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$10e08df24d6ef04d$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $0c89b4b4e3a03018$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$0c89b4b4e3a03018$export$a143d493d941bafc = $0c89b4b4e3a03018$var$Buffer;
$0c89b4b4e3a03018$export$e4cf37d7f6fb9e0a = $0c89b4b4e3a03018$var$SlowBuffer;
$0c89b4b4e3a03018$export$f99ded8fe4b79145 = 50;
const $0c89b4b4e3a03018$var$K_MAX_LENGTH = 0x7fffffff;
$0c89b4b4e3a03018$export$599f31c3813fae4d = $0c89b4b4e3a03018$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $0c89b4b4e3a03018$var$Buffer.TYPED_ARRAY_SUPPORT = $0c89b4b4e3a03018$var$typedArraySupport();
if (!$0c89b4b4e3a03018$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $0c89b4b4e3a03018$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($0c89b4b4e3a03018$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$0c89b4b4e3a03018$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($0c89b4b4e3a03018$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$0c89b4b4e3a03018$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $0c89b4b4e3a03018$var$createBuffer(length) {
    if (length > $0c89b4b4e3a03018$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $0c89b4b4e3a03018$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $0c89b4b4e3a03018$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $0c89b4b4e3a03018$var$allocUnsafe(arg);
    }
    return $0c89b4b4e3a03018$var$from(arg, encodingOrOffset, length);
}
$0c89b4b4e3a03018$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $0c89b4b4e3a03018$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $0c89b4b4e3a03018$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $0c89b4b4e3a03018$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($0c89b4b4e3a03018$var$isInstance(value, ArrayBuffer) || value && $0c89b4b4e3a03018$var$isInstance(value.buffer, ArrayBuffer)) return $0c89b4b4e3a03018$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($0c89b4b4e3a03018$var$isInstance(value, SharedArrayBuffer) || value && $0c89b4b4e3a03018$var$isInstance(value.buffer, SharedArrayBuffer))) return $0c89b4b4e3a03018$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $0c89b4b4e3a03018$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $0c89b4b4e3a03018$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $0c89b4b4e3a03018$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $0c89b4b4e3a03018$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $0c89b4b4e3a03018$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($0c89b4b4e3a03018$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($0c89b4b4e3a03018$var$Buffer, Uint8Array);
function $0c89b4b4e3a03018$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $0c89b4b4e3a03018$var$alloc(size, fill, encoding) {
    $0c89b4b4e3a03018$var$assertSize(size);
    if (size <= 0) return $0c89b4b4e3a03018$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $0c89b4b4e3a03018$var$createBuffer(size).fill(fill, encoding) : $0c89b4b4e3a03018$var$createBuffer(size).fill(fill);
    return $0c89b4b4e3a03018$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $0c89b4b4e3a03018$var$Buffer.alloc = function(size, fill, encoding) {
    return $0c89b4b4e3a03018$var$alloc(size, fill, encoding);
};
function $0c89b4b4e3a03018$var$allocUnsafe(size) {
    $0c89b4b4e3a03018$var$assertSize(size);
    return $0c89b4b4e3a03018$var$createBuffer(size < 0 ? 0 : $0c89b4b4e3a03018$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $0c89b4b4e3a03018$var$Buffer.allocUnsafe = function(size) {
    return $0c89b4b4e3a03018$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $0c89b4b4e3a03018$var$Buffer.allocUnsafeSlow = function(size) {
    return $0c89b4b4e3a03018$var$allocUnsafe(size);
};
function $0c89b4b4e3a03018$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$0c89b4b4e3a03018$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $0c89b4b4e3a03018$var$byteLength(string, encoding) | 0;
    let buf = $0c89b4b4e3a03018$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $0c89b4b4e3a03018$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $0c89b4b4e3a03018$var$checked(array.length) | 0;
    const buf = $0c89b4b4e3a03018$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $0c89b4b4e3a03018$var$fromArrayView(arrayView) {
    if ($0c89b4b4e3a03018$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $0c89b4b4e3a03018$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $0c89b4b4e3a03018$var$fromArrayLike(arrayView);
}
function $0c89b4b4e3a03018$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $0c89b4b4e3a03018$var$Buffer.prototype);
    return buf;
}
function $0c89b4b4e3a03018$var$fromObject(obj) {
    if ($0c89b4b4e3a03018$var$Buffer.isBuffer(obj)) {
        const len = $0c89b4b4e3a03018$var$checked(obj.length) | 0;
        const buf = $0c89b4b4e3a03018$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $0c89b4b4e3a03018$var$numberIsNaN(obj.length)) return $0c89b4b4e3a03018$var$createBuffer(0);
        return $0c89b4b4e3a03018$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $0c89b4b4e3a03018$var$fromArrayLike(obj.data);
}
function $0c89b4b4e3a03018$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $0c89b4b4e3a03018$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $0c89b4b4e3a03018$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $0c89b4b4e3a03018$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $0c89b4b4e3a03018$var$Buffer.alloc(+length);
}
$0c89b4b4e3a03018$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $0c89b4b4e3a03018$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$0c89b4b4e3a03018$var$Buffer.compare = function compare(a, b) {
    if ($0c89b4b4e3a03018$var$isInstance(a, Uint8Array)) a = $0c89b4b4e3a03018$var$Buffer.from(a, a.offset, a.byteLength);
    if ($0c89b4b4e3a03018$var$isInstance(b, Uint8Array)) b = $0c89b4b4e3a03018$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$0c89b4b4e3a03018$var$Buffer.isBuffer(a) || !$0c89b4b4e3a03018$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$0c89b4b4e3a03018$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$0c89b4b4e3a03018$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $0c89b4b4e3a03018$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $0c89b4b4e3a03018$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($0c89b4b4e3a03018$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$0c89b4b4e3a03018$var$Buffer.isBuffer(buf)) buf = $0c89b4b4e3a03018$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$0c89b4b4e3a03018$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $0c89b4b4e3a03018$var$byteLength(string, encoding) {
    if ($0c89b4b4e3a03018$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $0c89b4b4e3a03018$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $0c89b4b4e3a03018$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $0c89b4b4e3a03018$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $0c89b4b4e3a03018$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$0c89b4b4e3a03018$var$Buffer.byteLength = $0c89b4b4e3a03018$var$byteLength;
function $0c89b4b4e3a03018$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $0c89b4b4e3a03018$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $0c89b4b4e3a03018$var$utf8Slice(this, start, end);
        case 'ascii':
            return $0c89b4b4e3a03018$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $0c89b4b4e3a03018$var$latin1Slice(this, start, end);
        case 'base64':
            return $0c89b4b4e3a03018$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0c89b4b4e3a03018$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$0c89b4b4e3a03018$var$Buffer.prototype._isBuffer = true;
function $0c89b4b4e3a03018$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$0c89b4b4e3a03018$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$0c89b4b4e3a03018$var$swap(this, i, i + 1);
    return this;
};
$0c89b4b4e3a03018$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $0c89b4b4e3a03018$var$swap(this, i, i + 3);
        $0c89b4b4e3a03018$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$0c89b4b4e3a03018$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $0c89b4b4e3a03018$var$swap(this, i, i + 7);
        $0c89b4b4e3a03018$var$swap(this, i + 1, i + 6);
        $0c89b4b4e3a03018$var$swap(this, i + 2, i + 5);
        $0c89b4b4e3a03018$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$0c89b4b4e3a03018$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $0c89b4b4e3a03018$var$utf8Slice(this, 0, length);
    return $0c89b4b4e3a03018$var$slowToString.apply(this, arguments);
};
$0c89b4b4e3a03018$var$Buffer.prototype.toLocaleString = $0c89b4b4e3a03018$var$Buffer.prototype.toString;
$0c89b4b4e3a03018$var$Buffer.prototype.equals = function equals(b) {
    if (!$0c89b4b4e3a03018$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $0c89b4b4e3a03018$var$Buffer.compare(this, b) === 0;
};
$0c89b4b4e3a03018$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $0c89b4b4e3a03018$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($0c89b4b4e3a03018$var$customInspectSymbol) $0c89b4b4e3a03018$var$Buffer.prototype[$0c89b4b4e3a03018$var$customInspectSymbol] = $0c89b4b4e3a03018$var$Buffer.prototype.inspect;
$0c89b4b4e3a03018$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($0c89b4b4e3a03018$var$isInstance(target, Uint8Array)) target = $0c89b4b4e3a03018$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$0c89b4b4e3a03018$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $0c89b4b4e3a03018$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($0c89b4b4e3a03018$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $0c89b4b4e3a03018$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($0c89b4b4e3a03018$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $0c89b4b4e3a03018$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $0c89b4b4e3a03018$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $0c89b4b4e3a03018$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$0c89b4b4e3a03018$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$0c89b4b4e3a03018$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $0c89b4b4e3a03018$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$0c89b4b4e3a03018$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $0c89b4b4e3a03018$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $0c89b4b4e3a03018$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($0c89b4b4e3a03018$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $0c89b4b4e3a03018$var$utf8Write(buf, string, offset, length) {
    return $0c89b4b4e3a03018$var$blitBuffer($0c89b4b4e3a03018$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $0c89b4b4e3a03018$var$asciiWrite(buf, string, offset, length) {
    return $0c89b4b4e3a03018$var$blitBuffer($0c89b4b4e3a03018$var$asciiToBytes(string), buf, offset, length);
}
function $0c89b4b4e3a03018$var$base64Write(buf, string, offset, length) {
    return $0c89b4b4e3a03018$var$blitBuffer($0c89b4b4e3a03018$var$base64ToBytes(string), buf, offset, length);
}
function $0c89b4b4e3a03018$var$ucs2Write(buf, string, offset, length) {
    return $0c89b4b4e3a03018$var$blitBuffer($0c89b4b4e3a03018$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$0c89b4b4e3a03018$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $0c89b4b4e3a03018$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $0c89b4b4e3a03018$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $0c89b4b4e3a03018$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $0c89b4b4e3a03018$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0c89b4b4e3a03018$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$0c89b4b4e3a03018$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $0c89b4b4e3a03018$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $2f6be699f60557c3$export$6100ba28696e12de(buf);
    else return $2f6be699f60557c3$export$6100ba28696e12de(buf.slice(start, end));
}
function $0c89b4b4e3a03018$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $0c89b4b4e3a03018$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $0c89b4b4e3a03018$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $0c89b4b4e3a03018$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $0c89b4b4e3a03018$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $0c89b4b4e3a03018$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $0c89b4b4e3a03018$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $0c89b4b4e3a03018$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $0c89b4b4e3a03018$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $0c89b4b4e3a03018$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $0c89b4b4e3a03018$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$0c89b4b4e3a03018$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $0c89b4b4e3a03018$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $0c89b4b4e3a03018$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$0c89b4b4e3a03018$var$Buffer.prototype.readUintLE = $0c89b4b4e3a03018$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0c89b4b4e3a03018$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$0c89b4b4e3a03018$var$Buffer.prototype.readUintBE = $0c89b4b4e3a03018$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0c89b4b4e3a03018$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$0c89b4b4e3a03018$var$Buffer.prototype.readUint8 = $0c89b4b4e3a03018$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0c89b4b4e3a03018$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$0c89b4b4e3a03018$var$Buffer.prototype.readUint16LE = $0c89b4b4e3a03018$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0c89b4b4e3a03018$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$0c89b4b4e3a03018$var$Buffer.prototype.readUint16BE = $0c89b4b4e3a03018$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0c89b4b4e3a03018$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$0c89b4b4e3a03018$var$Buffer.prototype.readUint32LE = $0c89b4b4e3a03018$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0c89b4b4e3a03018$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$0c89b4b4e3a03018$var$Buffer.prototype.readUint32BE = $0c89b4b4e3a03018$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0c89b4b4e3a03018$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$0c89b4b4e3a03018$var$Buffer.prototype.readBigUInt64LE = $0c89b4b4e3a03018$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $0c89b4b4e3a03018$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0c89b4b4e3a03018$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$0c89b4b4e3a03018$var$Buffer.prototype.readBigUInt64BE = $0c89b4b4e3a03018$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $0c89b4b4e3a03018$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0c89b4b4e3a03018$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$0c89b4b4e3a03018$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0c89b4b4e3a03018$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0c89b4b4e3a03018$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0c89b4b4e3a03018$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0c89b4b4e3a03018$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0c89b4b4e3a03018$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$0c89b4b4e3a03018$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0c89b4b4e3a03018$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0c89b4b4e3a03018$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0c89b4b4e3a03018$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0c89b4b4e3a03018$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0c89b4b4e3a03018$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$0c89b4b4e3a03018$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0c89b4b4e3a03018$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$0c89b4b4e3a03018$var$Buffer.prototype.readBigInt64LE = $0c89b4b4e3a03018$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $0c89b4b4e3a03018$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0c89b4b4e3a03018$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$0c89b4b4e3a03018$var$Buffer.prototype.readBigInt64BE = $0c89b4b4e3a03018$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $0c89b4b4e3a03018$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0c89b4b4e3a03018$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$0c89b4b4e3a03018$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0c89b4b4e3a03018$var$checkOffset(offset, 4, this.length);
    return $10e08df24d6ef04d$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$0c89b4b4e3a03018$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0c89b4b4e3a03018$var$checkOffset(offset, 4, this.length);
    return $10e08df24d6ef04d$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$0c89b4b4e3a03018$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0c89b4b4e3a03018$var$checkOffset(offset, 8, this.length);
    return $10e08df24d6ef04d$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$0c89b4b4e3a03018$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0c89b4b4e3a03018$var$checkOffset(offset, 8, this.length);
    return $10e08df24d6ef04d$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $0c89b4b4e3a03018$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$0c89b4b4e3a03018$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$0c89b4b4e3a03018$var$Buffer.prototype.writeUintLE = $0c89b4b4e3a03018$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0c89b4b4e3a03018$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0c89b4b4e3a03018$var$Buffer.prototype.writeUintBE = $0c89b4b4e3a03018$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0c89b4b4e3a03018$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0c89b4b4e3a03018$var$Buffer.prototype.writeUint8 = $0c89b4b4e3a03018$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0c89b4b4e3a03018$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$0c89b4b4e3a03018$var$Buffer.prototype.writeUint16LE = $0c89b4b4e3a03018$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0c89b4b4e3a03018$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0c89b4b4e3a03018$var$Buffer.prototype.writeUint16BE = $0c89b4b4e3a03018$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0c89b4b4e3a03018$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0c89b4b4e3a03018$var$Buffer.prototype.writeUint32LE = $0c89b4b4e3a03018$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0c89b4b4e3a03018$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$0c89b4b4e3a03018$var$Buffer.prototype.writeUint32BE = $0c89b4b4e3a03018$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0c89b4b4e3a03018$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $0c89b4b4e3a03018$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $0c89b4b4e3a03018$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $0c89b4b4e3a03018$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $0c89b4b4e3a03018$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$0c89b4b4e3a03018$var$Buffer.prototype.writeBigUInt64LE = $0c89b4b4e3a03018$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $0c89b4b4e3a03018$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0c89b4b4e3a03018$var$Buffer.prototype.writeBigUInt64BE = $0c89b4b4e3a03018$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $0c89b4b4e3a03018$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0c89b4b4e3a03018$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0c89b4b4e3a03018$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0c89b4b4e3a03018$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0c89b4b4e3a03018$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0c89b4b4e3a03018$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0c89b4b4e3a03018$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$0c89b4b4e3a03018$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0c89b4b4e3a03018$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0c89b4b4e3a03018$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0c89b4b4e3a03018$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0c89b4b4e3a03018$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0c89b4b4e3a03018$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$0c89b4b4e3a03018$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0c89b4b4e3a03018$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$0c89b4b4e3a03018$var$Buffer.prototype.writeBigInt64LE = $0c89b4b4e3a03018$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $0c89b4b4e3a03018$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$0c89b4b4e3a03018$var$Buffer.prototype.writeBigInt64BE = $0c89b4b4e3a03018$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $0c89b4b4e3a03018$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $0c89b4b4e3a03018$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $0c89b4b4e3a03018$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0c89b4b4e3a03018$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $10e08df24d6ef04d$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$0c89b4b4e3a03018$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $0c89b4b4e3a03018$var$writeFloat(this, value, offset, true, noAssert);
};
$0c89b4b4e3a03018$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $0c89b4b4e3a03018$var$writeFloat(this, value, offset, false, noAssert);
};
function $0c89b4b4e3a03018$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0c89b4b4e3a03018$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $10e08df24d6ef04d$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$0c89b4b4e3a03018$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $0c89b4b4e3a03018$var$writeDouble(this, value, offset, true, noAssert);
};
$0c89b4b4e3a03018$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $0c89b4b4e3a03018$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$0c89b4b4e3a03018$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$0c89b4b4e3a03018$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$0c89b4b4e3a03018$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$0c89b4b4e3a03018$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $0c89b4b4e3a03018$var$Buffer.isBuffer(val) ? val : $0c89b4b4e3a03018$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $0c89b4b4e3a03018$var$errors = {};
function $0c89b4b4e3a03018$var$E(sym, getMessage, Base) {
    $0c89b4b4e3a03018$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$0c89b4b4e3a03018$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$0c89b4b4e3a03018$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$0c89b4b4e3a03018$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $0c89b4b4e3a03018$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $0c89b4b4e3a03018$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $0c89b4b4e3a03018$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $0c89b4b4e3a03018$var$checkBounds(buf, offset, byteLength) {
    $0c89b4b4e3a03018$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $0c89b4b4e3a03018$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $0c89b4b4e3a03018$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $0c89b4b4e3a03018$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $0c89b4b4e3a03018$var$checkBounds(buf, offset, byteLength);
}
function $0c89b4b4e3a03018$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $0c89b4b4e3a03018$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $0c89b4b4e3a03018$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $0c89b4b4e3a03018$var$validateNumber(value, type);
        throw new $0c89b4b4e3a03018$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $0c89b4b4e3a03018$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $0c89b4b4e3a03018$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $0c89b4b4e3a03018$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $0c89b4b4e3a03018$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($0c89b4b4e3a03018$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $0c89b4b4e3a03018$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $0c89b4b4e3a03018$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $0c89b4b4e3a03018$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $0c89b4b4e3a03018$var$base64ToBytes(str) {
    return $2f6be699f60557c3$export$d622b2ad8d90c771($0c89b4b4e3a03018$var$base64clean(str));
}
function $0c89b4b4e3a03018$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $0c89b4b4e3a03018$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $0c89b4b4e3a03018$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $0c89b4b4e3a03018$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $0c89b4b4e3a03018$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $0c89b4b4e3a03018$var$BufferBigIntNotDefined : fn;
}
function $0c89b4b4e3a03018$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $d7dffbee6f17734c$require$Buffer = $0c89b4b4e3a03018$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $d7dffbee6f17734c$var$isVisitable(thing) {
    return (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $d7dffbee6f17734c$var$removeBrackets(key) {
    return (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $d7dffbee6f17734c$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $d7dffbee6f17734c$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $d7dffbee6f17734c$var$isFlatArray(arr) {
    return (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isArray(arr) && !arr.some($d7dffbee6f17734c$var$isVisitable);
}
const $d7dffbee6f17734c$var$predicates = (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).toFlatObject((0, $ba6bcc07573c881a$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $d7dffbee6f17734c$var$toFormData(obj, formData, options) {
    if (!(0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $08b0e4e9ba6e0113$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $3f7893131edded6a$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $d7dffbee6f17734c$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isArray(value) && $d7dffbee6f17734c$var$isFlatArray(value) || ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isFileList(value) || (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $d7dffbee6f17734c$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $d7dffbee6f17734c$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($d7dffbee6f17734c$var$isVisitable(value)) return true;
        formData.append($d7dffbee6f17734c$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($d7dffbee6f17734c$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $d7dffbee6f17734c$var$isVisitable
    });
    function build(value, path) {
        if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $d7dffbee6f17734c$export$2e2bcd8739ae039 = $d7dffbee6f17734c$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $7ac78dfc4f7fdd07$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $7ac78dfc4f7fdd07$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $d7dffbee6f17734c$export$2e2bcd8739ae039)(params, this, options);
}
const $7ac78dfc4f7fdd07$var$prototype = $7ac78dfc4f7fdd07$var$AxiosURLSearchParams.prototype;
$7ac78dfc4f7fdd07$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$7ac78dfc4f7fdd07$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $7ac78dfc4f7fdd07$var$encode);
    } : $7ac78dfc4f7fdd07$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $7ac78dfc4f7fdd07$export$2e2bcd8739ae039 = $7ac78dfc4f7fdd07$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $6f08e102d8ac4fd9$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $6f08e102d8ac4fd9$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    const _encode = options && options.encode || $6f08e102d8ac4fd9$var$encode;
    const _options = (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    const serializeFn = _options && _options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $7ac78dfc4f7fdd07$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $a24f52ea391204b7$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $a24f52ea391204b7$export$2e2bcd8739ae039 = $a24f52ea391204b7$var$InterceptorManager;





'use strict';
var $125d51b784c0c2b3$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true
};






'use strict';
var $23cc4ae04fe96c10$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $7ac78dfc4f7fdd07$export$2e2bcd8739ae039);


'use strict';
var $2062a8ea9f2ecc00$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $0de0ba64863d5b0d$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $407733f1723182a6$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $23cc4ae04fe96c10$export$2e2bcd8739ae039,
        FormData: $2062a8ea9f2ecc00$export$2e2bcd8739ae039,
        Blob: $0de0ba64863d5b0d$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $bea8cf5469686d23$exports = {};

$parcel$export($bea8cf5469686d23$exports, "hasBrowserEnv", () => $bea8cf5469686d23$export$c4996c4b7b93b0bf);
$parcel$export($bea8cf5469686d23$exports, "navigator", () => $bea8cf5469686d23$export$ec7c8efa7f5790ae);
$parcel$export($bea8cf5469686d23$exports, "hasStandardBrowserEnv", () => $bea8cf5469686d23$export$c0bcc9250309d66);
$parcel$export($bea8cf5469686d23$exports, "hasStandardBrowserWebWorkerEnv", () => $bea8cf5469686d23$export$c81692cf5af97dac);
$parcel$export($bea8cf5469686d23$exports, "origin", () => $bea8cf5469686d23$export$f710a83a91838a36);
const $bea8cf5469686d23$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $bea8cf5469686d23$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $bea8cf5469686d23$export$c0bcc9250309d66 = $bea8cf5469686d23$export$c4996c4b7b93b0bf && (!$bea8cf5469686d23$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($bea8cf5469686d23$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $bea8cf5469686d23$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $bea8cf5469686d23$export$f710a83a91838a36 = $bea8cf5469686d23$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $543f49874ef67a7d$export$2e2bcd8739ae039 = {
    ...$bea8cf5469686d23$exports,
    ...(0, $407733f1723182a6$export$2e2bcd8739ae039)
};


'use strict';
function $012975bbfdf66050$export$2e2bcd8739ae039(data, options) {
    return (0, $d7dffbee6f17734c$export$2e2bcd8739ae039)(data, new (0, $543f49874ef67a7d$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $543f49874ef67a7d$export$2e2bcd8739ae039).isNode && (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $c1fdba7e3e78540d$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $c1fdba7e3e78540d$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $c1fdba7e3e78540d$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $c1fdba7e3e78540d$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isFormData(formData) && (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($c1fdba7e3e78540d$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $c1fdba7e3e78540d$export$2e2bcd8739ae039 = $c1fdba7e3e78540d$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $cc340daf8494761e$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $cc340daf8494761e$var$defaults = {
    transitional: (0, $125d51b784c0c2b3$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $c1fdba7e3e78540d$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isBuffer(data) || (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isStream(data) || (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isFile(data) || (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isBlob(data) || (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $012975bbfdf66050$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $d7dffbee6f17734c$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $cc340daf8494761e$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $cc340daf8494761e$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isResponse(data) || (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, this.parseReviver);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $3f7893131edded6a$export$2e2bcd8739ae039).from(e, (0, $3f7893131edded6a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $543f49874ef67a7d$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $543f49874ef67a7d$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $ba6bcc07573c881a$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $cc340daf8494761e$var$defaults.headers[method] = {};
});
var $cc340daf8494761e$export$2e2bcd8739ae039 = $cc340daf8494761e$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $a7a1b6131708b8a0$var$ignoreDuplicateOf = (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $a7a1b6131708b8a0$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $a7a1b6131708b8a0$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $2f2559df99c503d1$var$$internals = Symbol('internals');
function $2f2559df99c503d1$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $2f2559df99c503d1$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isArray(value) ? value.map($2f2559df99c503d1$var$normalizeValue) : String(value);
}
function $2f2559df99c503d1$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $2f2559df99c503d1$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $2f2559df99c503d1$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $2f2559df99c503d1$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $2f2559df99c503d1$var$buildAccessors(obj, header) {
    const accessorName = (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $2f2559df99c503d1$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $2f2559df99c503d1$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $2f2559df99c503d1$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $ba6bcc07573c881a$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$2f2559df99c503d1$var$isValidHeaderName(header)) setHeaders((0, $a7a1b6131708b8a0$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isObject(header) && (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $2f2559df99c503d1$var$normalizeHeader(header);
        if (header) {
            const key = (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $2f2559df99c503d1$var$parseTokens(value);
                if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $2f2559df99c503d1$var$normalizeHeader(header);
        if (header) {
            const key = (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $2f2559df99c503d1$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $2f2559df99c503d1$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $2f2559df99c503d1$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $2f2559df99c503d1$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $2f2559df99c503d1$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $2f2559df99c503d1$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $2f2559df99c503d1$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get("set-cookie") || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$2f2559df99c503d1$var$$internals] = this[$2f2559df99c503d1$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $2f2559df99c503d1$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $2f2559df99c503d1$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$2f2559df99c503d1$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $ba6bcc07573c881a$export$2e2bcd8739ae039).reduceDescriptors($2f2559df99c503d1$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $ba6bcc07573c881a$export$2e2bcd8739ae039).freezeMethods($2f2559df99c503d1$var$AxiosHeaders);
var $2f2559df99c503d1$export$2e2bcd8739ae039 = $2f2559df99c503d1$var$AxiosHeaders;


'use strict';
function $5a14c80a9abf5896$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $cc340daf8494761e$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $2f2559df99c503d1$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $35a935baa57a3e1d$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




'use strict';
class $62778dc0c3970db3$var$CanceledError extends (0, $3f7893131edded6a$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $3f7893131edded6a$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $62778dc0c3970db3$export$2e2bcd8739ae039 = $62778dc0c3970db3$var$CanceledError;







'use strict';
function $26ed2a864bc9eaae$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $3f7893131edded6a$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $3f7893131edded6a$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $3f7893131edded6a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $f182c5f5eca9aa7b$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $a26e219c1c3fad95$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $a26e219c1c3fad95$export$2e2bcd8739ae039 = $a26e219c1c3fad95$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $17f00db6d1107691$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $17f00db6d1107691$export$2e2bcd8739ae039 = $17f00db6d1107691$var$throttle;



const $5167b763b29631b0$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $a26e219c1c3fad95$export$2e2bcd8739ae039)(50, 250);
    return (0, $17f00db6d1107691$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $5167b763b29631b0$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $5167b763b29631b0$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $ba6bcc07573c881a$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $c11eabd360cb3ba8$export$2e2bcd8739ae039 = (0, $543f49874ef67a7d$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $543f49874ef67a7d$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $543f49874ef67a7d$export$2e2bcd8739ae039).origin), (0, $543f49874ef67a7d$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $543f49874ef67a7d$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $d65754a790e325ff$export$2e2bcd8739ae039 = (0, $543f49874ef67a7d$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $fd0d2abfde0b7ba9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $2fb9ea05a27d0271$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $373df03de5acb28b$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $fd0d2abfde0b7ba9$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $2fb9ea05a27d0271$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
const $4f4403c3661d9da0$var$headersToObject = (thing)=>thing instanceof (0, $2f2559df99c503d1$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $4f4403c3661d9da0$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isPlainObject(target) && (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($4f4403c3661d9da0$var$headersToObject(a), $4f4403c3661d9da0$var$headersToObject(b), prop, true)
    };
    (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === "__proto__" || prop === "constructor" || prop === "prototype") return;
        const merge = (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $9b5f6d610f85f5a8$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $4f4403c3661d9da0$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $2f2559df99c503d1$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $6f08e102d8ac4fd9$export$2e2bcd8739ae039)((0, $373df03de5acb28b$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $543f49874ef67a7d$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $543f49874ef67a7d$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isFunction(data.getHeaders)) {
            // Node.js FormData (like form-data package)
            const formHeaders = data.getHeaders();
            // Only set safe headers to avoid overwriting security headers
            const allowedHeaders = [
                'content-type',
                'content-length'
            ];
            Object.entries(formHeaders).forEach(([key, val])=>{
                if (allowedHeaders.includes(key.toLowerCase())) headers.set(key, val);
            });
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $543f49874ef67a7d$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $c11eabd360cb3ba8$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $d65754a790e325ff$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $41329f2a8f20ce15$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $41329f2a8f20ce15$export$2e2bcd8739ae039 = $41329f2a8f20ce15$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $9b5f6d610f85f5a8$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $2f2559df99c503d1$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $2f2559df99c503d1$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $26ed2a864bc9eaae$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $3f7893131edded6a$export$2e2bcd8739ae039)('Request aborted', (0, $3f7893131edded6a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $3f7893131edded6a$export$2e2bcd8739ae039)(msg, (0, $3f7893131edded6a$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $125d51b784c0c2b3$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $3f7893131edded6a$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $3f7893131edded6a$export$2e2bcd8739ae039).ETIMEDOUT : (0, $3f7893131edded6a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $5167b763b29631b0$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $5167b763b29631b0$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $62778dc0c3970db3$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $f182c5f5eca9aa7b$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $543f49874ef67a7d$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $3f7893131edded6a$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $3f7893131edded6a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $ed306451abc4cf90$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $3f7893131edded6a$export$2e2bcd8739ae039) ? err : new (0, $62778dc0c3970db3$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $3f7893131edded6a$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $3f7893131edded6a$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $ba6bcc07573c881a$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $ed306451abc4cf90$export$2e2bcd8739ae039 = $ed306451abc4cf90$var$composeSignals;


const $12e5268619108e0e$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $12e5268619108e0e$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $12e5268619108e0e$var$readStream(iterable))yield* $12e5268619108e0e$export$71b051935044bd5d(chunk, chunkSize);
};
const $12e5268619108e0e$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $12e5268619108e0e$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $12e5268619108e0e$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $41937dd998954bce$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $41937dd998954bce$var$isFunction } = (0, $ba6bcc07573c881a$export$2e2bcd8739ae039);
const $41937dd998954bce$var$globalFetchAPI = (({ Request: Request, Response: Response })=>({
        Request: Request,
        Response: Response
    }))((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).global);
const { ReadableStream: $41937dd998954bce$var$ReadableStream, TextEncoder: $41937dd998954bce$var$TextEncoder } = (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).global;
const $41937dd998954bce$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $41937dd998954bce$var$factory = (env)=>{
    env = (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, $41937dd998954bce$var$globalFetchAPI, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $41937dd998954bce$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $41937dd998954bce$var$isFunction(Request);
    const isResponseSupported = $41937dd998954bce$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $41937dd998954bce$var$isFunction($41937dd998954bce$var$ReadableStream);
    const encodeText = isFetchSupported && (typeof $41937dd998954bce$var$TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new $41937dd998954bce$var$TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $41937dd998954bce$var$test(()=>{
        let duplexAccessed = false;
        const hasContentType = new Request((0, $543f49874ef67a7d$export$2e2bcd8739ae039).origin, {
            body: new $41937dd998954bce$var$ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        }).headers.has('Content-Type');
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $41937dd998954bce$var$test(()=>(0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $3f7893131edded6a$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $3f7893131edded6a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $543f49874ef67a7d$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $9b5f6d610f85f5a8$export$2e2bcd8739ae039)(config);
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $ed306451abc4cf90$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: "half"
                });
                let contentTypeHeader;
                if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, $5167b763b29631b0$export$d9fadd12586c18d6)(requestContentLength, (0, $5167b763b29631b0$export$c1b28109d46c3592)((0, $5167b763b29631b0$export$5d35863c355a22a9)(onUploadProgress)));
                    data = (0, $12e5268619108e0e$export$b0119225647bd83)(_request.body, $41937dd998954bce$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && "credentials" in Request.prototype;
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: headers.normalize().toJSON(),
                body: data,
                duplex: "half",
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, $5167b763b29631b0$export$d9fadd12586c18d6)(responseContentLength, (0, $5167b763b29631b0$export$c1b28109d46c3592)((0, $5167b763b29631b0$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                response = new Response((0, $12e5268619108e0e$export$b0119225647bd83)(response.body, $41937dd998954bce$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $ba6bcc07573c881a$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $26ed2a864bc9eaae$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $2f2559df99c503d1$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $3f7893131edded6a$export$2e2bcd8739ae039)('Network Error', (0, $3f7893131edded6a$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response), {
                cause: err.cause || err
            });
            throw (0, $3f7893131edded6a$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $41937dd998954bce$var$seedCache = new Map();
const $41937dd998954bce$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $41937dd998954bce$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $41937dd998954bce$var$factory(env));
        map = target;
    }
    return target;
};
const $41937dd998954bce$var$adapter = $41937dd998954bce$export$3105c6651375d4fa();
var $41937dd998954bce$export$2e2bcd8739ae039 = $41937dd998954bce$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 * 
 * @type {Object<string, Function|Object>}
 */ const $d019ee5520515593$var$knownAdapters = {
    http: (0, $08b0e4e9ba6e0113$export$2e2bcd8739ae039),
    xhr: (0, $41329f2a8f20ce15$export$2e2bcd8739ae039),
    fetch: {
        get: $41937dd998954bce$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $ba6bcc07573c881a$export$2e2bcd8739ae039).forEach($d019ee5520515593$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 * 
 * @param {string} reason
 * @returns {string}
 */ const $d019ee5520515593$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 * 
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $d019ee5520515593$var$isResolvedHandle = (adapter)=>(0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 * 
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $d019ee5520515593$var$getAdapter(adapters, config) {
    adapters = (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$d019ee5520515593$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $d019ee5520515593$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $3f7893131edded6a$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($d019ee5520515593$var$renderReason).join('\n') : ' ' + $d019ee5520515593$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $3f7893131edded6a$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $d019ee5520515593$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $d019ee5520515593$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $d019ee5520515593$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $6cbe39b69235faed$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $62778dc0c3970db3$export$2e2bcd8739ae039)(null, config);
}
function $6cbe39b69235faed$export$2e2bcd8739ae039(config) {
    $6cbe39b69235faed$var$throwIfCancellationRequested(config);
    config.headers = (0, $2f2559df99c503d1$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $5a14c80a9abf5896$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $d019ee5520515593$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $cc340daf8494761e$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $6cbe39b69235faed$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $5a14c80a9abf5896$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $2f2559df99c503d1$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $35a935baa57a3e1d$export$2e2bcd8739ae039)(reason)) {
            $6cbe39b69235faed$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $5a14c80a9abf5896$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $2f2559df99c503d1$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $9b327396330aaa82$export$a4ad2735b021c132 = "1.13.5";



'use strict';
const $f3cf7ddb853ce624$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $f3cf7ddb853ce624$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $f3cf7ddb853ce624$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $f3cf7ddb853ce624$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $9b327396330aaa82$export$a4ad2735b021c132) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $3f7893131edded6a$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $3f7893131edded6a$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$f3cf7ddb853ce624$var$deprecatedWarnings[opt]) {
            $f3cf7ddb853ce624$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$f3cf7ddb853ce624$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $f3cf7ddb853ce624$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $3f7893131edded6a$export$2e2bcd8739ae039)('options must be an object', (0, $3f7893131edded6a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $3f7893131edded6a$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $3f7893131edded6a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $3f7893131edded6a$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $3f7893131edded6a$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $f3cf7ddb853ce624$export$2e2bcd8739ae039 = {
    assertOptions: $f3cf7ddb853ce624$var$assertOptions,
    validators: $f3cf7ddb853ce624$var$validators
};




'use strict';
const $7af5ff94fc11a425$var$validators = (0, $f3cf7ddb853ce624$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $7af5ff94fc11a425$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $a24f52ea391204b7$export$2e2bcd8739ae039)(),
            response: new (0, $a24f52ea391204b7$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $4f4403c3661d9da0$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $f3cf7ddb853ce624$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $7af5ff94fc11a425$var$validators.transitional($7af5ff94fc11a425$var$validators.boolean),
            forcedJSONParsing: $7af5ff94fc11a425$var$validators.transitional($7af5ff94fc11a425$var$validators.boolean),
            clarifyTimeoutError: $7af5ff94fc11a425$var$validators.transitional($7af5ff94fc11a425$var$validators.boolean),
            legacyInterceptorReqResOrdering: $7af5ff94fc11a425$var$validators.transitional($7af5ff94fc11a425$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $f3cf7ddb853ce624$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $7af5ff94fc11a425$var$validators.function,
                serialize: $7af5ff94fc11a425$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $f3cf7ddb853ce624$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $7af5ff94fc11a425$var$validators.spelling('baseURL'),
            withXsrfToken: $7af5ff94fc11a425$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $2f2559df99c503d1$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $125d51b784c0c2b3$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $6cbe39b69235faed$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $6cbe39b69235faed$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $4f4403c3661d9da0$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $373df03de5acb28b$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $6f08e102d8ac4fd9$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $ba6bcc07573c881a$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $7af5ff94fc11a425$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $4f4403c3661d9da0$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $ba6bcc07573c881a$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $4f4403c3661d9da0$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $7af5ff94fc11a425$var$Axios.prototype[method] = generateHTTPMethod();
    $7af5ff94fc11a425$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $7af5ff94fc11a425$export$2e2bcd8739ae039 = $7af5ff94fc11a425$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $e88fa4793a9fc8d2$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $62778dc0c3970db3$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $e88fa4793a9fc8d2$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $e88fa4793a9fc8d2$export$2e2bcd8739ae039 = $e88fa4793a9fc8d2$var$CancelToken;






'use strict';
function $dcdaea9b2ba3a5f5$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $6386173eaa28cda9$export$2e2bcd8739ae039(payload) {
    return (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $56c0047ae6552697$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($56c0047ae6552697$var$HttpStatusCode).forEach(([key, value])=>{
    $56c0047ae6552697$var$HttpStatusCode[value] = key;
});
var $56c0047ae6552697$export$2e2bcd8739ae039 = $56c0047ae6552697$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $691a483fd8b5b759$var$createInstance(defaultConfig) {
    const context = new (0, $7af5ff94fc11a425$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $9aee92b7abef0e18$export$2e2bcd8739ae039)((0, $7af5ff94fc11a425$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).extend(instance, (0, $7af5ff94fc11a425$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $ba6bcc07573c881a$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $691a483fd8b5b759$var$createInstance((0, $4f4403c3661d9da0$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $691a483fd8b5b759$var$axios = $691a483fd8b5b759$var$createInstance((0, $cc340daf8494761e$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$691a483fd8b5b759$var$axios.Axios = (0, $7af5ff94fc11a425$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$691a483fd8b5b759$var$axios.CanceledError = (0, $62778dc0c3970db3$export$2e2bcd8739ae039);
$691a483fd8b5b759$var$axios.CancelToken = (0, $e88fa4793a9fc8d2$export$2e2bcd8739ae039);
$691a483fd8b5b759$var$axios.isCancel = (0, $35a935baa57a3e1d$export$2e2bcd8739ae039);
$691a483fd8b5b759$var$axios.VERSION = (0, $9b327396330aaa82$export$a4ad2735b021c132);
$691a483fd8b5b759$var$axios.toFormData = (0, $d7dffbee6f17734c$export$2e2bcd8739ae039);
// Expose AxiosError class
$691a483fd8b5b759$var$axios.AxiosError = (0, $3f7893131edded6a$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$691a483fd8b5b759$var$axios.Cancel = $691a483fd8b5b759$var$axios.CanceledError;
// Expose all/spread
$691a483fd8b5b759$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$691a483fd8b5b759$var$axios.spread = (0, $dcdaea9b2ba3a5f5$export$2e2bcd8739ae039);
// Expose isAxiosError
$691a483fd8b5b759$var$axios.isAxiosError = (0, $6386173eaa28cda9$export$2e2bcd8739ae039);
// Expose mergeConfig
$691a483fd8b5b759$var$axios.mergeConfig = (0, $4f4403c3661d9da0$export$2e2bcd8739ae039);
$691a483fd8b5b759$var$axios.AxiosHeaders = (0, $2f2559df99c503d1$export$2e2bcd8739ae039);
$691a483fd8b5b759$var$axios.formToJSON = (thing)=>(0, $c1fdba7e3e78540d$export$2e2bcd8739ae039)((0, $ba6bcc07573c881a$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$691a483fd8b5b759$var$axios.getAdapter = (0, $d019ee5520515593$export$2e2bcd8739ae039).getAdapter;
$691a483fd8b5b759$var$axios.HttpStatusCode = (0, $56c0047ae6552697$export$2e2bcd8739ae039);
$691a483fd8b5b759$var$axios.default = $691a483fd8b5b759$var$axios;
var // this module should only have a default export
$691a483fd8b5b759$export$2e2bcd8739ae039 = $691a483fd8b5b759$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $cde35abffeda876c$export$1c00760e9e5a4e95, AxiosError: $cde35abffeda876c$export$c1fbed17c2f6a328, CanceledError: $cde35abffeda876c$export$1ab0c6b20d94fa14, isCancel: $cde35abffeda876c$export$3b22524397b493c6, CancelToken: $cde35abffeda876c$export$fd08e3cb425f0d61, VERSION: $cde35abffeda876c$export$a4ad2735b021c132, all: $cde35abffeda876c$export$84bf76cd7afc7469, Cancel: $cde35abffeda876c$export$848c9b7ead0df967, isAxiosError: $cde35abffeda876c$export$fbafdbe06a5b5a9a, spread: $cde35abffeda876c$export$3ae0fd4797ed47c8, toFormData: $cde35abffeda876c$export$10ae0d317ea97f8b, AxiosHeaders: $cde35abffeda876c$export$4e7d6ff0f3e6520, HttpStatusCode: $cde35abffeda876c$export$a972f69c851492b3, formToJSON: $cde35abffeda876c$export$86d7c59254d6a2c9, getAdapter: $cde35abffeda876c$export$17ddc20a97d669e2, mergeConfig: $cde35abffeda876c$export$7ec1ebcfa9d8bd6a } = (0, $691a483fd8b5b759$export$2e2bcd8739ae039);




var $dfe2ea2eed4d79a6$exports = {};
"use strict";
Object.defineProperty($dfe2ea2eed4d79a6$exports, "__esModule", {
    value: true
});
Object.defineProperty($dfe2ea2eed4d79a6$exports, "LoadingBall", {
    enumerable: true,
    get: function() {
        return $dfe2ea2eed4d79a6$var$_LoadingBall.default;
    }
});
Object.defineProperty($dfe2ea2eed4d79a6$exports, "LoadingLinear", {
    enumerable: true,
    get: function() {
        return $dfe2ea2eed4d79a6$var$_LoadingLinear.default;
    }
});
Object.defineProperty($dfe2ea2eed4d79a6$exports, "default", {
    enumerable: true,
    get: function() {
        return $dfe2ea2eed4d79a6$var$_Loading.default;
    }
});

var $dfe2ea2eed4d79a6$var$_Loading = $dfe2ea2eed4d79a6$var$_interopRequireDefault((parcelRequire("ipMmU")));

var $dfe2ea2eed4d79a6$var$_LoadingBall = $dfe2ea2eed4d79a6$var$_interopRequireDefault((parcelRequire("bJ5nJ")));

var $dfe2ea2eed4d79a6$var$_LoadingLinear = $dfe2ea2eed4d79a6$var$_interopRequireDefault((parcelRequire("8afao")));
function $dfe2ea2eed4d79a6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}


var $649a1eb77fde347f$export$1e511d4a378977f5;
var $649a1eb77fde347f$export$f6d5d4774149a3bf;
"use strict";
$649a1eb77fde347f$export$1e511d4a378977f5 = true;
var $649a1eb77fde347f$var$Guid = /** @class */ function() {
    function Guid(guid) {
        if (!guid) throw new TypeError("Invalid argument; `value` has no value.");
        this.value = Guid.EMPTY;
        if (guid && Guid.isGuid(guid)) this.value = guid;
    }
    Guid.isGuid = function(guid) {
        var value = guid.toString();
        return guid && (guid instanceof Guid || Guid.validator.test(value));
    };
    Guid.create = function() {
        return new Guid([
            Guid.gen(2),
            Guid.gen(1),
            Guid.gen(1),
            Guid.gen(1),
            Guid.gen(3)
        ].join("-"));
    };
    Guid.createEmpty = function() {
        return new Guid("emptyguid");
    };
    Guid.parse = function(guid) {
        return new Guid(guid);
    };
    Guid.raw = function() {
        return [
            Guid.gen(2),
            Guid.gen(1),
            Guid.gen(1),
            Guid.gen(1),
            Guid.gen(3)
        ].join("-");
    };
    Guid.gen = function(count) {
        var out = "";
        for(var i = 0; i < count; i++)// tslint:disable-next-line:no-bitwise
        out += ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
        return out;
    };
    Guid.prototype.equals = function(other) {
        // Comparing string `value` against provided `guid` will auto-call
        // toString on `guid` for comparison
        return Guid.isGuid(other) && this.value === other.toString();
    };
    Guid.prototype.isEmpty = function() {
        return this.value === Guid.EMPTY;
    };
    Guid.prototype.toString = function() {
        return this.value;
    };
    Guid.prototype.toJSON = function() {
        return {
            value: this.value
        };
    };
    Guid.validator = new RegExp("^[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}$", "i");
    Guid.EMPTY = "00000000-0000-0000-0000-000000000000";
    return Guid;
}();
$649a1eb77fde347f$export$f6d5d4774149a3bf = $649a1eb77fde347f$var$Guid;










var $71633f14175fd379$exports = {};
"use strict";
Object.defineProperty($71633f14175fd379$exports, "__esModule", {
    value: true
});
$71633f14175fd379$exports.default = void 0;

var $71633f14175fd379$var$_Search = $71633f14175fd379$var$_interopRequireDefault((parcelRequire("5DXRG")));
function $71633f14175fd379$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $71633f14175fd379$var$_default = $71633f14175fd379$var$_Search.default;
$71633f14175fd379$exports.default = $71633f14175fd379$var$_default;



(0, $691a483fd8b5b759$export$2e2bcd8739ae039).defaults.timeout = 5000;
const $b4a270996085b34b$var$Container = (0, $a40bd87bc05fc082$export$2e2bcd8739ae039).div`
  width: 100%;
  font-family: Noto IKEA, Noto Sans, Roboto, Open Sans, sans-serif;
  font-style: normal;
  font-weight: 400;

  justify-content: center;

  @media (max-width: 480px) {
    font-size: 15px;
  }

  @media (max-width: 375px) {
    font-size: 15px;
  }

  @media (max-width: 320px) {
    font-size: 15px;
  }
`;
const $b4a270996085b34b$var$SearchBarContainer = (0, $a40bd87bc05fc082$export$2e2bcd8739ae039).div`
  width: 100%;
  min-width: inherit;
  margin-bottom: 1rem;

  input {
    font-family: Noto IKEA, Noto Sans, Roboto, Open Sans, sans-serif;
  }

  @media screen and (max-width: 480px) {
    font-size: 15px;
    min-width: unset;
  }

  @media (max-width: 320px) {
    font-size: 15px;
    min-width: unset;
  }
  .search__clear {
    position: absolute !important;
  }
  .search__input::placeholder {
    color: rgb(var(--colour-text-and-icon-2, 72, 72, 72))
  }
`;
const $b4a270996085b34b$var$ResultsContainer = (0, $a40bd87bc05fc082$export$2e2bcd8739ae039).div`
  width: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  @media screen and (max-width: 480px) {
    width: 357px;
  }
`;
const $b4a270996085b34b$var$SearchResultContainer = (0, $a40bd87bc05fc082$export$2e2bcd8739ae039).div`
  display: flex;
  flex: 1;
  flex-direction: row;
  margin-top: 8px;
  margin-left: 16px;
  margin-bottom: 24px;

  @media screen and (max-width: 480px) {
    margin-left: 0px;
    max-width: 358px;
  }
`;
const $b4a270996085b34b$var$LoadingContainer = (0, $a40bd87bc05fc082$export$2e2bcd8739ae039).div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: center;
  margin-top: 8px;
  margin-left: 16px;
  margin-bottom: 24px;
`;
const $b4a270996085b34b$var$CenteredButton = (0, $a40bd87bc05fc082$export$2e2bcd8739ae039)((0, $1a7c5a491fc3d4f2$export$2e2bcd8739ae039))`
  align-self: center;
`;
const $b4a270996085b34b$var$maxSearchResult = 15;
const $b4a270996085b34b$var$minSearchResult = 5;
const $b4a270996085b34b$var$iterateNumArticles = 5;
const $b4a270996085b34b$var$KnowledgeComponent = ({ lang: lang, variant: variant })=>{
    const langKey = lang;
    const IsProduction = ()=>{
        const url = window.location.href;
        return url.includes("www.ikea.com");
    };
    const queryString = JSON.parse(sessionStorage.getItem("queryString"));
    const storedResult = queryString ? queryString.entries : [];
    const [query, setQuery] = (0, $fqaWh.useState)("");
    const [results, setResults] = (0, $fqaWh.useState)(storedResult ? storedResult : []);
    const [resultsShown, setResultsShown] = (0, $fqaWh.useState)($b4a270996085b34b$var$minSearchResult);
    const [ready, setReady] = (0, $fqaWh.useState)(false);
    const [redirect, setRedirect] = (0, $fqaWh.useState)(false);
    const [loading, setLoading] = (0, $fqaWh.useState)(false);
    const [error, setError] = (0, $fqaWh.useState)(undefined);
    const [regExError, setRegexError] = (0, $fqaWh.useState)(false);
    const [numberRegex, setNumberRegex] = (0, $fqaWh.useState)(false);
    // state for holding scope.
    const [correlationId, setCorrelationId] = (0, $fqaWh.useState)("");
    const { i18n: i18n, t: t } = (0, $f4ab155f387ca43d$export$9fc83ad70ead8663)();
    const [language, market] = langKey.split("-");
    const invalidCharRegex = /[()"{}\=\\]/;
    const productRegex = /(\d+(\.\d+)?\.\d+\.\d+)|\b\d{8}\b/g;
    const orderNumbRegex = /\b\d{9,10}\b/g;
    const sparePartRegex = /\b\d{6}\b/g;
    (0, $fqaWh.useEffect)(()=>{
        setRedirect(false);
        setResultsShown($b4a270996085b34b$var$minSearchResult);
        let backend = "lisa";
        async function runSearch() {
            setRegexError(false);
            if (query) await (0, $e0c6ce23fe7600d5$export$7759221db3edc8c1)({
                correlationId: correlationId,
                query: query,
                backend: backend,
                variant: variant,
                locale: t("locale"),
                isProd: IsProduction(),
                setResults: setResults,
                setLoading: setLoading,
                setError: setError,
                setReady: setReady,
                setRedirect: setRedirect
            });
        }
        runSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        query
    ]);
    (0, $fqaWh.useEffect)(()=>{
        openRedirect(query);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        redirect
    ]);
    setTimeout(()=>{
        sessionStorage.removeItem("queryString");
    }, 60000);
    const searchFunc = async (e, data)=>{
        checkRedirect(data.value);
        if (invalidCharRegex.test(data.value)) setRegexError(true);
        setQuery(data.value);
    };
    const openRedirect = (query)=>{
        const productMatch = query.match(productRegex);
        const orderMatch = query.match(orderNumbRegex);
        const sparePartMatch = query.match(sparePartRegex);
        if (productMatch && redirect) window.location.href = `https://ikea.marat.qd.je/${market.toLowerCase()}/${language.toLowerCase()}/search/?q=${productMatch[0]}`;
        else if (orderMatch && redirect) window.location.href = `https://ikea.marat.qd.je/${market.toLowerCase()}/${language.toLocaleLowerCase()}/purchases/lookup/${orderMatch[0]}/`;
        else if (sparePartMatch && redirect) window.location.href = `https://ikea.marat.qd.je/${market.toLowerCase()}/${language.toLocaleLowerCase()}/customer-service/returns-claims/spareparts/`;
    };
    const checkRedirect = (query)=>{
        const productRegex = /(\d+\.\d+\.\d+)|\b\d{8}\b/g;
        const orderNumbRegex = /\b\d{9,10}\b/g;
        const sparePartRegex = /\b\d{6}\b/g;
        const productMatch = query.match(productRegex);
        const orderMatch = query.match(orderNumbRegex);
        const sparePartMatch = query.match(sparePartRegex);
        if (productMatch || orderMatch || sparePartMatch) setNumberRegex(true);
    };
    const showMoreArticles = async (data)=>{
        const articleResult = setNumberOfArticles();
        setResultsShown(data.target.textContent === (0, $1e4d69f93f9cf1b1$export$93e4534b7d0af9d4)[langKey]?.showMore_Text_Key ? articleResult : $b4a270996085b34b$var$minSearchResult);
    };
    const setLabelOnBtn = ()=>{
        return resultsShown >= results.length ? (0, $1e4d69f93f9cf1b1$export$93e4534b7d0af9d4)[langKey]?.showLess_Text_Key : (0, $1e4d69f93f9cf1b1$export$93e4534b7d0af9d4)[langKey]?.showMore_Text_Key;
    };
    const setNumberOfArticles = ()=>{
        const articleResult = resultsShown + $b4a270996085b34b$var$iterateNumArticles;
        return articleResult > results.length ? results.length : articleResult;
    };
    const canShowButton = ()=>{
        if (results.length > $b4a270996085b34b$var$minSearchResult) return true;
    };
    const articleToDisplay = ()=>{
        return results.slice(0, resultsShown);
    };
    (0, $fqaWh.useEffect)(()=>{
        setCorrelationId((0, $649a1eb77fde347f$export$f6d5d4774149a3bf).create().toString());
        i18n.changeLanguage(lang);
    }, [
        i18n,
        lang
    ]);
    return /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)($b4a270996085b34b$var$Container, {
        children: [
            /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)($b4a270996085b34b$var$SearchBarContainer, {
                children: /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($71633f14175fd379$exports))), {
                    className: "searchBar",
                    id: "search",
                    "aria-label": "Search",
                    placeholder: (0, $1e4d69f93f9cf1b1$export$93e4534b7d0af9d4)[langKey]?.searchbar_Text_Key,
                    onSearch: searchFunc,
                    clearBtnText: (0, $1e4d69f93f9cf1b1$export$93e4534b7d0af9d4)[langKey]?.clear_button_label_Text_Key,
                    submitBtnText: (0, $1e4d69f93f9cf1b1$export$93e4534b7d0af9d4)[langKey]?.search_button_label_Text_Key,
                    onClear: ()=>{
                        setQuery("");
                        setReady(false);
                        setResults([]);
                    }
                })
            }),
            /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)($b4a270996085b34b$var$SearchResultContainer, {
                "aria-live": "assertive",
                children: regExError ? /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)((0, $f67c8cc462b3ef3f$export$2e2bcd8739ae039), {
                    lang: lang,
                    message: ""
                }) : query !== "" && query && lang !== "" && !loading ? /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)((0, $fUX2S.Fragment), {
                    children: ready && error ? /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)((0, $f67c8cc462b3ef3f$export$2e2bcd8739ae039), {
                        lang: lang,
                        errorCode: error,
                        message: (0, $1e4d69f93f9cf1b1$export$93e4534b7d0af9d4)[langKey]?.try_again_Text_Key
                    }) : ready && results.length > 0 ? /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)((0, $fUX2S.Fragment), {
                        children: (0, $1e4d69f93f9cf1b1$export$93e4534b7d0af9d4)[langKey]?.results_Text_Key.replace("{{number}}", results.length > $b4a270996085b34b$var$maxSearchResult ? $b4a270996085b34b$var$maxSearchResult : results.length).replace("{{query}}", query)
                    }) : ready && !numberRegex ? /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)((0, $f67c8cc462b3ef3f$export$2e2bcd8739ae039), {
                        lang: lang,
                        message: `${(0, $1e4d69f93f9cf1b1$export$93e4534b7d0af9d4)[langKey]?.no_results_Text_Key?.replace("{{query}}", query)}`
                    }) : null
                }) : loading ? /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)($b4a270996085b34b$var$LoadingContainer, {
                    children: /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($dfe2ea2eed4d79a6$exports))), {
                        labelTransitions: true,
                        text: (0, $1e4d69f93f9cf1b1$export$93e4534b7d0af9d4)[langKey]?.loading_Text_Key,
                        children: /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)((0, $dfe2ea2eed4d79a6$exports.LoadingBall), {})
                    })
                }) : ""
            }),
            /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)($b4a270996085b34b$var$ResultsContainer, {
                children: results && lang !== "" && /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)((0, $fUX2S.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)((0, $d4b97166c3e1da52$export$2e2bcd8739ae039), {
                            data: articleToDisplay(),
                            lang: lang,
                            query: query,
                            variant: variant,
                            correlationId: correlationId
                        }),
                        canShowButton() && /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)($b4a270996085b34b$var$CenteredButton, {
                            iconPosition: "leading",
                            onClick: (e)=>{
                                showMoreArticles(e);
                            },
                            text: setLabelOnBtn(),
                            type: "secondary",
                            fluid: false,
                            size: "medium"
                        })
                    ]
                })
            })
        ]
    });
};
var $b4a270996085b34b$export$2e2bcd8739ae039 = $b4a270996085b34b$var$KnowledgeComponent;





parcelRequire("aXNcS");
var $82dc69f6c4d3f015$exports = {};
"use strict";
Object.defineProperty($82dc69f6c4d3f015$exports, "__esModule", {
    value: true
});
$82dc69f6c4d3f015$exports.default = void 0;

var $82dc69f6c4d3f015$var$_InlineMessage = $82dc69f6c4d3f015$var$_interopRequireDefault((parcelRequire("7HtFQ")));
function $82dc69f6c4d3f015$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $82dc69f6c4d3f015$var$_default = $82dc69f6c4d3f015$var$_InlineMessage.default;
$82dc69f6c4d3f015$exports.default = $82dc69f6c4d3f015$var$_default;








const $f67c8cc462b3ef3f$var$CalculateVariant = (errorCode)=>{
    let firstChar = errorCode.toString();
    firstChar = firstChar.substr(0, 1);
    firstChar = parseInt(firstChar);
    if (firstChar === 5 || firstChar === 4) return 'negative';
    else return 'cautionary';
};
const $f67c8cc462b3ef3f$var$ErrorCard = ({ message: message = '', errorCode: errorCode = 0, lang: lang = 'en_NL' })=>{
    const { t: t } = (0, $f4ab155f387ca43d$export$9fc83ad70ead8663)();
    const renderFunc = (errorCode)=>{
        const langKey = lang;
        if (errorCode && errorCode > 0 && errorCode !== 22) return /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($82dc69f6c4d3f015$exports))), {
            variant: $f67c8cc462b3ef3f$var$CalculateVariant(errorCode),
            title: (0, $1e4d69f93f9cf1b1$export$93e4534b7d0af9d4)[langKey].error_Text_Key,
            body: message
        });
        else if (errorCode && errorCode === 22) return /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($82dc69f6c4d3f015$exports))), {
            variant: "cautionary",
            title: (0, $1e4d69f93f9cf1b1$export$93e4534b7d0af9d4)[langKey].product_error_Text_Key,
            linkLabel: (0, $1e4d69f93f9cf1b1$export$93e4534b7d0af9d4)[langKey].click_prompt_Text_Key,
            link: (0, $1e4d69f93f9cf1b1$export$93e4534b7d0af9d4)[langKey].link_prod_error_Text_Key
        });
        else return /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($82dc69f6c4d3f015$exports))), {
            variant: "cautionary",
            title: message,
            body: (0, $1e4d69f93f9cf1b1$export$93e4534b7d0af9d4)[langKey].spellcheck_Text_Key
        });
    };
    return renderFunc(errorCode);
};
var $f67c8cc462b3ef3f$export$2e2bcd8739ae039 = $f67c8cc462b3ef3f$var$ErrorCard;







var $fUX2S = parcelRequire("fUX2S");
function $c1f5565b80956abe$var$r() {
    return ($c1f5565b80956abe$var$r = Object.assign || function(t) {
        for(var e = 1; e < arguments.length; e++){
            var n = arguments[e];
            for(var o in n)Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
        }
        return t;
    }).apply(this, arguments);
}
function $c1f5565b80956abe$var$i(t) {
    this.getChildContext = function() {
        return t.context;
    };
    var e = t.children, n = function(t, e) {
        if (null == t) return {};
        var n, o, r = {}, i = Object.keys(t);
        for(o = 0; o < i.length; o++)e.indexOf(n = i[o]) >= 0 || (r[n] = t[n]);
        return r;
    }(t, [
        "context",
        "children"
    ]);
    return (0, $fUX2S.cloneElement)(e, n);
}
function $c1f5565b80956abe$var$a() {
    var o = new CustomEvent("_preact", {
        detail: {},
        bubbles: !0,
        cancelable: !0
    });
    this.dispatchEvent(o), this._vdom = (0, $fUX2S.h)($c1f5565b80956abe$var$i, $c1f5565b80956abe$var$r({}, this._props, {
        context: o.detail.context
    }), function e(n, o) {
        if (3 === n.nodeType) return n.data;
        if (1 !== n.nodeType) return null;
        var r = [], i = {}, a = 0, c = n.attributes, l = n.childNodes;
        for(a = c.length; a--;)"slot" !== c[a].name && (i[c[a].name] = c[a].value, i[$c1f5565b80956abe$var$s(c[a].name)] = c[a].value);
        for(a = l.length; a--;){
            var p = e(l[a], null), d = l[a].slot;
            d ? i[d] = (0, $fUX2S.h)($c1f5565b80956abe$var$u, {
                name: d
            }, p) : r[a] = p;
        }
        var h = o ? (0, $fUX2S.h)($c1f5565b80956abe$var$u, null, r) : r;
        return (0, $fUX2S.h)(o || n.nodeName.toLowerCase(), i, h);
    }(this, this._vdomComponent)), (this.hasAttribute("hydrate") ? (0, $fUX2S.hydrate) : (0, $fUX2S.render))(this._vdom, this._root);
}
function $c1f5565b80956abe$var$s(t) {
    return t.replace(/-(\w)/g, function(t, e) {
        return e ? e.toUpperCase() : "";
    });
}
function $c1f5565b80956abe$var$c(t, e, r) {
    if (this._vdom) {
        var i = {};
        i[t] = r = null == r ? void 0 : r, i[$c1f5565b80956abe$var$s(t)] = r, this._vdom = (0, $fUX2S.cloneElement)(this._vdom, i), (0, $fUX2S.render)(this._vdom, this._root);
    }
}
function $c1f5565b80956abe$var$l() {
    (0, $fUX2S.render)(this._vdom = null, this._root);
}
function $c1f5565b80956abe$var$u(e, n) {
    var o = this;
    return (0, $fUX2S.h)("slot", $c1f5565b80956abe$var$r({}, e, {
        ref: function(t) {
            t ? (o.ref = t, o._listener || (o._listener = function(t) {
                t.stopPropagation(), t.detail.context = n;
            }, t.addEventListener("_preact", o._listener))) : o.ref.removeEventListener("_preact", o._listener);
        }
    }));
}
function $c1f5565b80956abe$export$2e2bcd8739ae039(t, e, n, o) {
    function r() {
        var e = Reflect.construct(HTMLElement, [], r);
        return e._vdomComponent = t, e._root = o && o.shadow ? e.attachShadow({
            mode: "open"
        }) : e, e;
    }
    return (r.prototype = Object.create(HTMLElement.prototype)).constructor = r, r.prototype.connectedCallback = $c1f5565b80956abe$var$a, r.prototype.attributeChangedCallback = $c1f5565b80956abe$var$c, r.prototype.disconnectedCallback = $c1f5565b80956abe$var$l, n = n || t.observedAttributes || Object.keys(t.propTypes || {}), r.observedAttributes = n, n.forEach(function(t) {
        Object.defineProperty(r.prototype, t, {
            get: function() {
                return this._vdom.props[t];
            },
            set: function(e) {
                this._vdom ? this.attributeChangedCallback(t, null, e) : (this._props || (this._props = {}), this._props[t] = e, this.connectedCallback());
                var n = typeof e;
                null != e && "string" !== n && "boolean" !== n && "number" !== n || this.setAttribute(t, e);
            }
        });
    }), customElements.define(e || t.tagName || t.displayName || t.name, r);
}



var $lo7DV = parcelRequire("lo7DV");

var $7QZoe = parcelRequire("7QZoe");
function $cd3c4f1b8d1b875e$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), o.forEach(function(r) {
            (0, $7QZoe.default)(e, r, t[r]);
        });
    }
    return e;
}


function $4693e6b1076bc055$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



var $d2O01 = parcelRequire("d2O01");
function $763097cbd79a3e0d$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $d2O01.default)(o.key), o);
    }
}
function $763097cbd79a3e0d$export$2e2bcd8739ae039(e, r, t) {
    return r && $763097cbd79a3e0d$var$_defineProperties(e.prototype, r), t && $763097cbd79a3e0d$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}



var $lo7DV = parcelRequire("lo7DV");
function $3dcef9283da65ae2$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $4e0276c2d8340071$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $lo7DV.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $3dcef9283da65ae2$export$2e2bcd8739ae039)(t);
}


function $60051a8e2455c2da$export$2e2bcd8739ae039(t) {
    return $60051a8e2455c2da$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $60051a8e2455c2da$export$2e2bcd8739ae039(t);
}




var $e5t8D = parcelRequire("e5t8D");
function $5423356470eccb54$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $e5t8D.default)(t, e);
}


var $d3afb0019d2e6e2a$var$consoleLogger = {
    type: 'logger',
    log: function log(args) {
        this.output('log', args);
    },
    warn: function warn(args) {
        this.output('warn', args);
    },
    error: function error(args) {
        this.output('error', args);
    },
    output: function output(type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
var $d3afb0019d2e6e2a$var$Logger = function() {
    function Logger(concreteLogger) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $4693e6b1076bc055$export$2e2bcd8739ae039)(this, Logger);
        this.init(concreteLogger, options);
    }
    (0, $763097cbd79a3e0d$export$2e2bcd8739ae039)(Logger, [
        {
            key: "init",
            value: function init(concreteLogger) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                this.prefix = options.prefix || 'i18next:';
                this.logger = concreteLogger || $d3afb0019d2e6e2a$var$consoleLogger;
                this.options = options;
                this.debug = options.debug;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(bool) {
                this.debug = bool;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return this.forward(args, 'log', '', true);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return this.forward(args, 'warn', '', true);
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                return this.forward(args, 'error', '');
            }
        },
        {
            key: "deprecate",
            value: function deprecate() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
            }
        },
        {
            key: "forward",
            value: function forward(args, lvl, prefix, debugOnly) {
                if (debugOnly && !this.debug) return null;
                if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
                return this.logger[lvl](args);
            }
        },
        {
            key: "create",
            value: function create(moduleName) {
                return new Logger(this.logger, (0, $cd3c4f1b8d1b875e$export$2e2bcd8739ae039)({}, {
                    prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
                }, this.options));
            }
        }
    ]);
    return Logger;
}();
var $d3afb0019d2e6e2a$var$baseLogger = new $d3afb0019d2e6e2a$var$Logger();
var $d3afb0019d2e6e2a$var$EventEmitter = function() {
    function EventEmitter() {
        (0, $4693e6b1076bc055$export$2e2bcd8739ae039)(this, EventEmitter);
        this.observers = {};
    }
    (0, $763097cbd79a3e0d$export$2e2bcd8739ae039)(EventEmitter, [
        {
            key: "on",
            value: function on(events, listener) {
                var _this = this;
                events.split(' ').forEach(function(event) {
                    _this.observers[event] = _this.observers[event] || [];
                    _this.observers[event].push(listener);
                });
                return this;
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                if (!this.observers[event]) return;
                if (!listener) {
                    delete this.observers[event];
                    return;
                }
                this.observers[event] = this.observers[event].filter(function(l) {
                    return l !== listener;
                });
            }
        },
        {
            key: "emit",
            value: function emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (this.observers[event]) {
                    var cloned = [].concat(this.observers[event]);
                    cloned.forEach(function(observer) {
                        observer.apply(void 0, args);
                    });
                }
                if (this.observers['*']) {
                    var _cloned = [].concat(this.observers['*']);
                    _cloned.forEach(function(observer) {
                        observer.apply(observer, [
                            event
                        ].concat(args));
                    });
                }
            }
        }
    ]);
    return EventEmitter;
}();
function $d3afb0019d2e6e2a$var$defer() {
    var res;
    var rej;
    var promise = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $d3afb0019d2e6e2a$var$makeString(object) {
    if (object == null) return '';
    return '' + object;
}
function $d3afb0019d2e6e2a$var$copy(a, s, t) {
    a.forEach(function(m) {
        if (s[m]) t[m] = s[m];
    });
}
function $d3afb0019d2e6e2a$var$getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === 'string';
    }
    var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        var key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function $d3afb0019d2e6e2a$var$setPath(object, path, newValue) {
    var _getLastOfPath = $d3afb0019d2e6e2a$var$getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    obj[k] = newValue;
}
function $d3afb0019d2e6e2a$var$pushPath(object, path, newValue, concat) {
    var _getLastOfPath2 = $d3afb0019d2e6e2a$var$getLastOfPath(object, path, Object), obj = _getLastOfPath2.obj, k = _getLastOfPath2.k;
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function $d3afb0019d2e6e2a$var$getPath(object, path) {
    var _getLastOfPath3 = $d3afb0019d2e6e2a$var$getLastOfPath(object, path), obj = _getLastOfPath3.obj, k = _getLastOfPath3.k;
    if (!obj) return undefined;
    return obj[k];
}
function $d3afb0019d2e6e2a$var$getPathWithDefaults(data, defaultData, key) {
    var value = $d3afb0019d2e6e2a$var$getPath(data, key);
    if (value !== undefined) return value;
    return $d3afb0019d2e6e2a$var$getPath(defaultData, key);
}
function $d3afb0019d2e6e2a$var$deepExtend(target, source, overwrite) {
    for(var prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $d3afb0019d2e6e2a$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function $d3afb0019d2e6e2a$var$regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var $d3afb0019d2e6e2a$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
function $d3afb0019d2e6e2a$var$escape(data) {
    if (typeof data === 'string') return data.replace(/[&<>"'\/]/g, function(s) {
        return $d3afb0019d2e6e2a$var$_entityMap[s];
    });
    return data;
}
var $d3afb0019d2e6e2a$var$isIE10 = typeof window !== 'undefined' && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;
var $d3afb0019d2e6e2a$var$ResourceStore = function(_EventEmitter) {
    (0, $5423356470eccb54$export$2e2bcd8739ae039)(ResourceStore, _EventEmitter);
    function ResourceStore(data) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                'translation'
            ],
            defaultNS: 'translation'
        };
        (0, $4693e6b1076bc055$export$2e2bcd8739ae039)(this, ResourceStore);
        _this = (0, $4e0276c2d8340071$export$2e2bcd8739ae039)(this, (0, $60051a8e2455c2da$export$2e2bcd8739ae039)(ResourceStore).call(this));
        if ($d3afb0019d2e6e2a$var$isIE10) $d3afb0019d2e6e2a$var$EventEmitter.call((0, $3dcef9283da65ae2$export$2e2bcd8739ae039)(_this));
        _this.data = data || {};
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = '.';
        return _this;
    }
    (0, $763097cbd79a3e0d$export$2e2bcd8739ae039)(ResourceStore, [
        {
            key: "addNamespaces",
            value: function addNamespaces(ns) {
                if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
            }
        },
        {
            key: "removeNamespaces",
            value: function removeNamespaces(ns) {
                var index = this.options.ns.indexOf(ns);
                if (index > -1) this.options.ns.splice(index, 1);
            }
        },
        {
            key: "getResource",
            value: function getResource(lng, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var path = [
                    lng,
                    ns
                ];
                if (key && typeof key !== 'string') path = path.concat(key);
                if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf('.') > -1) path = lng.split('.');
                return $d3afb0019d2e6e2a$var$getPath(this.data, path);
            }
        },
        {
            key: "addResource",
            value: function addResource(lng, ns, key, value) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
                    silent: false
                };
                var keySeparator = this.options.keySeparator;
                if (keySeparator === undefined) keySeparator = '.';
                var path = [
                    lng,
                    ns
                ];
                if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf('.') > -1) {
                    path = lng.split('.');
                    value = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                $d3afb0019d2e6e2a$var$setPath(this.data, path, value);
                if (!options.silent) this.emit('added', lng, ns, key, value);
            }
        },
        {
            key: "addResources",
            value: function addResources(lng, ns, resources) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                    silent: false
                };
                for(var m in resources)if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
                    silent: true
                });
                if (!options.silent) this.emit('added', lng, ns, resources);
            }
        },
        {
            key: "addResourceBundle",
            value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
                    silent: false
                };
                var path = [
                    lng,
                    ns
                ];
                if (lng.indexOf('.') > -1) {
                    path = lng.split('.');
                    deep = resources;
                    resources = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                var pack = $d3afb0019d2e6e2a$var$getPath(this.data, path) || {};
                if (deep) $d3afb0019d2e6e2a$var$deepExtend(pack, resources, overwrite);
                else pack = (0, $cd3c4f1b8d1b875e$export$2e2bcd8739ae039)({}, pack, resources);
                $d3afb0019d2e6e2a$var$setPath(this.data, path, pack);
                if (!options.silent) this.emit('added', lng, ns, resources);
            }
        },
        {
            key: "removeResourceBundle",
            value: function removeResourceBundle(lng, ns) {
                if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
                this.removeNamespaces(ns);
                this.emit('removed', lng, ns);
            }
        },
        {
            key: "hasResourceBundle",
            value: function hasResourceBundle(lng, ns) {
                return this.getResource(lng, ns) !== undefined;
            }
        },
        {
            key: "getResourceBundle",
            value: function getResourceBundle(lng, ns) {
                if (!ns) ns = this.options.defaultNS;
                if (this.options.compatibilityAPI === 'v1') return (0, $cd3c4f1b8d1b875e$export$2e2bcd8739ae039)({}, {}, this.getResource(lng, ns));
                return this.getResource(lng, ns);
            }
        },
        {
            key: "getDataByLanguage",
            value: function getDataByLanguage(lng) {
                return this.data[lng];
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.data;
            }
        }
    ]);
    return ResourceStore;
}($d3afb0019d2e6e2a$var$EventEmitter);
var $d3afb0019d2e6e2a$var$postProcessor = {
    processors: {},
    addPostProcessor: function addPostProcessor(module) {
        this.processors[module.name] = module;
    },
    handle: function handle(processors, value, key, options, translator) {
        var _this = this;
        processors.forEach(function(processor) {
            if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
var $d3afb0019d2e6e2a$var$checkedLoadedFor = {};
var $d3afb0019d2e6e2a$var$Translator = function(_EventEmitter) {
    (0, $5423356470eccb54$export$2e2bcd8739ae039)(Translator, _EventEmitter);
    function Translator(services) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $4693e6b1076bc055$export$2e2bcd8739ae039)(this, Translator);
        _this = (0, $4e0276c2d8340071$export$2e2bcd8739ae039)(this, (0, $60051a8e2455c2da$export$2e2bcd8739ae039)(Translator).call(this));
        if ($d3afb0019d2e6e2a$var$isIE10) $d3afb0019d2e6e2a$var$EventEmitter.call((0, $3dcef9283da65ae2$export$2e2bcd8739ae039)(_this));
        $d3afb0019d2e6e2a$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, (0, $3dcef9283da65ae2$export$2e2bcd8739ae039)(_this));
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = '.';
        _this.logger = $d3afb0019d2e6e2a$var$baseLogger.create('translator');
        return _this;
    }
    (0, $763097cbd79a3e0d$export$2e2bcd8739ae039)(Translator, [
        {
            key: "changeLanguage",
            value: function changeLanguage(lng) {
                if (lng) this.language = lng;
            }
        },
        {
            key: "exists",
            value: function exists(key) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                var resolved = this.resolve(key, options);
                return resolved && resolved.res !== undefined;
            }
        },
        {
            key: "extractFromKey",
            value: function extractFromKey(key, options) {
                var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
                if (nsSeparator === undefined) nsSeparator = ':';
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var namespaces = options.ns || this.options.defaultNS;
                if (nsSeparator && key.indexOf(nsSeparator) > -1) {
                    var m = key.match(this.interpolator.nestingRegexp);
                    if (m && m.length > 0) return {
                        key: key,
                        namespaces: namespaces
                    };
                    var parts = key.split(nsSeparator);
                    if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
                    key = parts.join(keySeparator);
                }
                if (typeof namespaces === 'string') namespaces = [
                    namespaces
                ];
                return {
                    key: key,
                    namespaces: namespaces
                };
            }
        },
        {
            key: "translate",
            value: function translate(keys, options, lastKey) {
                var _this2 = this;
                if ((0, $lo7DV.default)(options) !== 'object' && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
                if (!options) options = {};
                if (keys === undefined || keys === null) return '';
                if (!Array.isArray(keys)) keys = [
                    String(keys)
                ];
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options), key = _this$extractFromKey.key, namespaces = _this$extractFromKey.namespaces;
                var namespace = namespaces[namespaces.length - 1];
                var lng = options.lng || this.language;
                var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
                if (lng && lng.toLowerCase() === 'cimode') {
                    if (appendNamespaceToCIMode) {
                        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
                        return namespace + nsSeparator + key;
                    }
                    return key;
                }
                var resolved = this.resolve(keys, options);
                var res = resolved && resolved.res;
                var resUsedKey = resolved && resolved.usedKey || key;
                var resExactUsedKey = resolved && resolved.exactUsedKey || key;
                var resType = Object.prototype.toString.apply(res);
                var noObject = [
                    '[object Number]',
                    '[object Function]',
                    '[object RegExp]'
                ];
                var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
                var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
                var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
                if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
                    if (!options.returnObjects && !this.options.returnObjects) {
                        this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                        return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, options) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
                    }
                    if (keySeparator) {
                        var resTypeIsArray = resType === '[object Array]';
                        var copy = resTypeIsArray ? [] : {};
                        var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                        for(var m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                            var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
                            copy[m] = this.translate(deepKey, (0, $cd3c4f1b8d1b875e$export$2e2bcd8739ae039)({}, options, {
                                joinArrays: false,
                                ns: namespaces
                            }));
                            if (copy[m] === deepKey) copy[m] = res[m];
                        }
                        res = copy;
                    }
                } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
                    res = res.join(joinArrays);
                    if (res) res = this.extendTranslation(res, keys, options, lastKey);
                } else {
                    var usedDefault = false;
                    var usedKey = false;
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
                    var hasDefaultValue = Translator.hasDefaultValue(options);
                    var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count) : '';
                    var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
                    if (!this.isValidLookup(res) && hasDefaultValue) {
                        usedDefault = true;
                        res = defaultValue;
                    }
                    if (!this.isValidLookup(res)) {
                        usedKey = true;
                        res = key;
                    }
                    var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
                    if (usedKey || usedDefault || updateMissing) {
                        this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                        if (keySeparator) {
                            var fk = this.resolve(key, (0, $cd3c4f1b8d1b875e$export$2e2bcd8739ae039)({}, options, {
                                keySeparator: false
                            }));
                            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                        }
                        var lngs = [];
                        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(var i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                        else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                        else lngs.push(options.lng || this.language);
                        var send = function send(l, k, fallbackValue) {
                            if (_this2.options.missingKeyHandler) _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? fallbackValue : res, updateMissing, options);
                            else if (_this2.backendConnector && _this2.backendConnector.saveMissing) _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? fallbackValue : res, updateMissing, options);
                            _this2.emit('missingKey', l, namespace, k, res);
                        };
                        if (this.options.saveMissing) {
                            if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach(function(language) {
                                _this2.pluralResolver.getSuffixes(language).forEach(function(suffix) {
                                    send([
                                        language
                                    ], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                                });
                            });
                            else send(lngs, key, defaultValue);
                        }
                    }
                    res = this.extendTranslation(res, keys, options, resolved, lastKey);
                    if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
                    if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
                }
                return res;
            }
        },
        {
            key: "extendTranslation",
            value: function extendTranslation(res, key, options, resolved, lastKey) {
                var _this3 = this;
                if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
                    resolved: resolved
                });
                else if (!options.skipInterpolation) {
                    if (options.interpolation) this.interpolator.init((0, $cd3c4f1b8d1b875e$export$2e2bcd8739ae039)({}, options, {
                        interpolation: (0, $cd3c4f1b8d1b875e$export$2e2bcd8739ae039)({}, this.options.interpolation, options.interpolation)
                    }));
                    var skipOnVariables = options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
                    var nestBef;
                    if (skipOnVariables) {
                        var nb = res.match(this.interpolator.nestingRegexp);
                        nestBef = nb && nb.length;
                    }
                    var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
                    if (this.options.interpolation.defaultVariables) data = (0, $cd3c4f1b8d1b875e$export$2e2bcd8739ae039)({}, this.options.interpolation.defaultVariables, data);
                    res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
                    if (skipOnVariables) {
                        var na = res.match(this.interpolator.nestingRegexp);
                        var nestAft = na && na.length;
                        if (nestBef < nestAft) options.nest = false;
                    }
                    if (options.nest !== false) res = this.interpolator.nest(res, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        if (lastKey && lastKey[0] === args[0] && !options.context) {
                            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
                            return null;
                        }
                        return _this3.translate.apply(_this3, args.concat([
                            key
                        ]));
                    }, options);
                    if (options.interpolation) this.interpolator.reset();
                }
                var postProcess = options.postProcess || this.options.postProcess;
                var postProcessorNames = typeof postProcess === 'string' ? [
                    postProcess
                ] : postProcess;
                if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $d3afb0019d2e6e2a$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? (0, $cd3c4f1b8d1b875e$export$2e2bcd8739ae039)({
                    i18nResolved: resolved
                }, options) : options, this);
                return res;
            }
        },
        {
            key: "resolve",
            value: function resolve(keys) {
                var _this4 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var found;
                var usedKey;
                var exactUsedKey;
                var usedLng;
                var usedNS;
                if (typeof keys === 'string') keys = [
                    keys
                ];
                keys.forEach(function(k) {
                    if (_this4.isValidLookup(found)) return;
                    var extracted = _this4.extractFromKey(k, options);
                    var key = extracted.key;
                    usedKey = key;
                    var namespaces = extracted.namespaces;
                    if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
                    var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';
                    var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
                    namespaces.forEach(function(ns) {
                        if (_this4.isValidLookup(found)) return;
                        usedNS = ns;
                        if (!$d3afb0019d2e6e2a$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
                            $d3afb0019d2e6e2a$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
                            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                        }
                        codes.forEach(function(code) {
                            if (_this4.isValidLookup(found)) return;
                            usedLng = code;
                            var finalKey = key;
                            var finalKeys = [
                                finalKey
                            ];
                            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                            else {
                                var pluralSuffix;
                                if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count);
                                if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);
                                if (needsContextHandling) finalKeys.push(finalKey += "".concat(_this4.options.contextSeparator).concat(options.context));
                                if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
                            }
                            var possibleKey;
                            while(possibleKey = finalKeys.pop())if (!_this4.isValidLookup(found)) {
                                exactUsedKey = possibleKey;
                                found = _this4.getResource(code, ns, possibleKey, options);
                            }
                        });
                    });
                });
                return {
                    res: found,
                    usedKey: usedKey,
                    exactUsedKey: exactUsedKey,
                    usedLng: usedLng,
                    usedNS: usedNS
                };
            }
        },
        {
            key: "isValidLookup",
            value: function isValidLookup(res) {
                return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
            }
        },
        {
            key: "getResource",
            value: function getResource(code, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
                return this.resourceStore.getResource(code, ns, key, options);
            }
        }
    ], [
        {
            key: "hasDefaultValue",
            value: function hasDefaultValue(options) {
                var prefix = 'defaultValue';
                for(var option in options){
                    if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
                }
                return false;
            }
        }
    ]);
    return Translator;
}($d3afb0019d2e6e2a$var$EventEmitter);
function $d3afb0019d2e6e2a$var$capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var $d3afb0019d2e6e2a$var$LanguageUtil = function() {
    function LanguageUtil(options) {
        (0, $4693e6b1076bc055$export$2e2bcd8739ae039)(this, LanguageUtil);
        this.options = options;
        this.whitelist = this.options.supportedLngs || false;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $d3afb0019d2e6e2a$var$baseLogger.create('languageUtils');
    }
    (0, $763097cbd79a3e0d$export$2e2bcd8739ae039)(LanguageUtil, [
        {
            key: "getScriptPartFromCode",
            value: function getScriptPartFromCode(code) {
                if (!code || code.indexOf('-') < 0) return null;
                var p = code.split('-');
                if (p.length === 2) return null;
                p.pop();
                if (p[p.length - 1].toLowerCase() === 'x') return null;
                return this.formatLanguageCode(p.join('-'));
            }
        },
        {
            key: "getLanguagePartFromCode",
            value: function getLanguagePartFromCode(code) {
                if (!code || code.indexOf('-') < 0) return code;
                var p = code.split('-');
                return this.formatLanguageCode(p[0]);
            }
        },
        {
            key: "formatLanguageCode",
            value: function formatLanguageCode(code) {
                if (typeof code === 'string' && code.indexOf('-') > -1) {
                    var specialCases = [
                        'hans',
                        'hant',
                        'latn',
                        'cyrl',
                        'cans',
                        'mong',
                        'arab'
                    ];
                    var p = code.split('-');
                    if (this.options.lowerCaseLng) p = p.map(function(part) {
                        return part.toLowerCase();
                    });
                    else if (p.length === 2) {
                        p[0] = p[0].toLowerCase();
                        p[1] = p[1].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $d3afb0019d2e6e2a$var$capitalize(p[1].toLowerCase());
                    } else if (p.length === 3) {
                        p[0] = p[0].toLowerCase();
                        if (p[1].length === 2) p[1] = p[1].toUpperCase();
                        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $d3afb0019d2e6e2a$var$capitalize(p[1].toLowerCase());
                        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $d3afb0019d2e6e2a$var$capitalize(p[2].toLowerCase());
                    }
                    return p.join('-');
                }
                return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
            }
        },
        {
            key: "isWhitelisted",
            value: function isWhitelisted(code) {
                this.logger.deprecate('languageUtils.isWhitelisted', 'function "isWhitelisted" will be renamed to "isSupportedCode" in the next major - please make sure to rename it\'s usage asap.');
                return this.isSupportedCode(code);
            }
        },
        {
            key: "isSupportedCode",
            value: function isSupportedCode(code) {
                if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
                return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
            }
        },
        {
            key: "getBestMatchFromCodes",
            value: function getBestMatchFromCodes(codes) {
                var _this = this;
                if (!codes) return null;
                var found;
                codes.forEach(function(code) {
                    if (found) return;
                    var cleanedLng = _this.formatLanguageCode(code);
                    if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
                });
                if (!found && this.options.supportedLngs) codes.forEach(function(code) {
                    if (found) return;
                    var lngOnly = _this.getLanguagePartFromCode(code);
                    if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
                    found = _this.options.supportedLngs.find(function(supportedLng) {
                        if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
                    });
                });
                if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
                return found;
            }
        },
        {
            key: "getFallbackCodes",
            value: function getFallbackCodes(fallbacks, code) {
                if (!fallbacks) return [];
                if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
                if (typeof fallbacks === 'string') fallbacks = [
                    fallbacks
                ];
                if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
                if (!code) return fallbacks["default"] || [];
                var found = fallbacks[code];
                if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
                if (!found) found = fallbacks[this.formatLanguageCode(code)];
                if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
                if (!found) found = fallbacks["default"];
                return found || [];
            }
        },
        {
            key: "toResolveHierarchy",
            value: function toResolveHierarchy(code, fallbackCode) {
                var _this2 = this;
                var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
                var codes = [];
                var addCode = function addCode(c) {
                    if (!c) return;
                    if (_this2.isSupportedCode(c)) codes.push(c);
                    else _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
                };
                if (typeof code === 'string' && code.indexOf('-') > -1) {
                    if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
                    if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
                    if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
                } else if (typeof code === 'string') addCode(this.formatLanguageCode(code));
                fallbackCodes.forEach(function(fc) {
                    if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
                });
                return codes;
            }
        }
    ]);
    return LanguageUtil;
}();
var $d3afb0019d2e6e2a$var$sets = [
    {
        lngs: [
            'ach',
            'ak',
            'am',
            'arn',
            'br',
            'fil',
            'gun',
            'ln',
            'mfe',
            'mg',
            'mi',
            'oc',
            'pt',
            'pt-BR',
            'tg',
            'tl',
            'ti',
            'tr',
            'uz',
            'wa'
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            'af',
            'an',
            'ast',
            'az',
            'bg',
            'bn',
            'ca',
            'da',
            'de',
            'dev',
            'el',
            'en',
            'eo',
            'es',
            'et',
            'eu',
            'fi',
            'fo',
            'fur',
            'fy',
            'gl',
            'gu',
            'ha',
            'hi',
            'hu',
            'hy',
            'ia',
            'it',
            'kn',
            'ku',
            'lb',
            'mai',
            'ml',
            'mn',
            'mr',
            'nah',
            'nap',
            'nb',
            'ne',
            'nl',
            'nn',
            'no',
            'nso',
            'pa',
            'pap',
            'pms',
            'ps',
            'pt-PT',
            'rm',
            'sco',
            'se',
            'si',
            'so',
            'son',
            'sq',
            'sv',
            'sw',
            'ta',
            'te',
            'tk',
            'ur',
            'yo'
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            'ay',
            'bo',
            'cgg',
            'fa',
            'ht',
            'id',
            'ja',
            'jbo',
            'ka',
            'kk',
            'km',
            'ko',
            'ky',
            'lo',
            'ms',
            'sah',
            'su',
            'th',
            'tt',
            'ug',
            'vi',
            'wo',
            'zh'
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            'be',
            'bs',
            'cnr',
            'dz',
            'hr',
            'ru',
            'sr',
            'uk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            'ar'
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            'cs',
            'sk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            'csb',
            'pl'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            'cy'
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            'fr'
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            'ga'
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            'gd'
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            'is'
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            'jv'
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            'kw'
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            'lt'
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            'lv'
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            'mk'
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            'mnk'
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            'mt'
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            'or'
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            'ro'
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            'sl'
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            'he',
            'iw'
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
var $d3afb0019d2e6e2a$var$_rulesPluralsTypes = {
    1: function _(n) {
        return Number(n > 1);
    },
    2: function _(n) {
        return Number(n != 1);
    },
    3: function _(n) {
        return 0;
    },
    4: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function _(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function _(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function _(n) {
        return Number(n >= 2);
    },
    10: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function _(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function _(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function _(n) {
        return Number(n !== 0);
    },
    14: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function _(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function _(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
function $d3afb0019d2e6e2a$var$createRules() {
    var rules = {};
    $d3afb0019d2e6e2a$var$sets.forEach(function(set) {
        set.lngs.forEach(function(l) {
            rules[l] = {
                numbers: set.nr,
                plurals: $d3afb0019d2e6e2a$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
var $d3afb0019d2e6e2a$var$PluralResolver = function() {
    function PluralResolver(languageUtils) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $4693e6b1076bc055$export$2e2bcd8739ae039)(this, PluralResolver);
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $d3afb0019d2e6e2a$var$baseLogger.create('pluralResolver');
        this.rules = $d3afb0019d2e6e2a$var$createRules();
    }
    (0, $763097cbd79a3e0d$export$2e2bcd8739ae039)(PluralResolver, [
        {
            key: "addRule",
            value: function addRule(lng, obj) {
                this.rules[lng] = obj;
            }
        },
        {
            key: "getRule",
            value: function getRule(code) {
                return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
            }
        },
        {
            key: "needsPlural",
            value: function needsPlural(code) {
                var rule = this.getRule(code);
                return rule && rule.numbers.length > 1;
            }
        },
        {
            key: "getPluralFormsOfKey",
            value: function getPluralFormsOfKey(code, key) {
                return this.getSuffixes(code).map(function(suffix) {
                    return key + suffix;
                });
            }
        },
        {
            key: "getSuffixes",
            value: function getSuffixes(code) {
                var _this = this;
                var rule = this.getRule(code);
                if (!rule) return [];
                return rule.numbers.map(function(number) {
                    return _this.getSuffix(code, number);
                });
            }
        },
        {
            key: "getSuffix",
            value: function getSuffix(code, count) {
                var _this2 = this;
                var rule = this.getRule(code);
                if (rule) {
                    var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
                    var suffix = rule.numbers[idx];
                    if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
                        if (suffix === 2) suffix = 'plural';
                        else if (suffix === 1) suffix = '';
                    }
                    var returnSuffix = function returnSuffix() {
                        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
                    };
                    if (this.options.compatibilityJSON === 'v1') {
                        if (suffix === 1) return '';
                        if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
                        return returnSuffix();
                    } else if (this.options.compatibilityJSON === 'v2') return returnSuffix();
                    else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
                    return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
                }
                this.logger.warn("no plural rule found for: ".concat(code));
                return '';
            }
        }
    ]);
    return PluralResolver;
}();
var $d3afb0019d2e6e2a$var$Interpolator = function() {
    function Interpolator() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $4693e6b1076bc055$export$2e2bcd8739ae039)(this, Interpolator);
        this.logger = $d3afb0019d2e6e2a$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || function(value) {
            return value;
        };
        this.init(options);
    }
    (0, $763097cbd79a3e0d$export$2e2bcd8739ae039)(Interpolator, [
        {
            key: "init",
            value: function init() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!options.interpolation) options.interpolation = {
                    escapeValue: true
                };
                var iOpts = options.interpolation;
                this.escape = iOpts.escape !== undefined ? iOpts.escape : $d3afb0019d2e6e2a$var$escape;
                this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
                this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
                this.prefix = iOpts.prefix ? $d3afb0019d2e6e2a$var$regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
                this.suffix = iOpts.suffix ? $d3afb0019d2e6e2a$var$regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
                this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
                this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
                this.nestingPrefix = iOpts.nestingPrefix ? $d3afb0019d2e6e2a$var$regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || $d3afb0019d2e6e2a$var$regexEscape('$t(');
                this.nestingSuffix = iOpts.nestingSuffix ? $d3afb0019d2e6e2a$var$regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || $d3afb0019d2e6e2a$var$regexEscape(')');
                this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
                this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
                this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
                this.resetRegExp();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.options) this.init(this.options);
            }
        },
        {
            key: "resetRegExp",
            value: function resetRegExp() {
                var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
                this.regexp = new RegExp(regexpStr, 'g');
                var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
                this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
                var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
                this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
            }
        },
        {
            key: "interpolate",
            value: function interpolate(str, data, lng, options) {
                var _this = this;
                var match;
                var value;
                var replaces;
                var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
                function regexSafe(val) {
                    return val.replace(/\$/g, '$$$$');
                }
                var handleFormat = function handleFormat(key) {
                    if (key.indexOf(_this.formatSeparator) < 0) {
                        var path = $d3afb0019d2e6e2a$var$getPathWithDefaults(data, defaultData, key);
                        return _this.alwaysFormat ? _this.format(path, undefined, lng) : path;
                    }
                    var p = key.split(_this.formatSeparator);
                    var k = p.shift().trim();
                    var f = p.join(_this.formatSeparator).trim();
                    return _this.format($d3afb0019d2e6e2a$var$getPathWithDefaults(data, defaultData, k), f, lng, options);
                };
                this.resetRegExp();
                var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
                var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
                var todos = [
                    {
                        regex: this.regexpUnescape,
                        safeValue: function safeValue(val) {
                            return regexSafe(val);
                        }
                    },
                    {
                        regex: this.regexp,
                        safeValue: function safeValue(val) {
                            return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
                        }
                    }
                ];
                todos.forEach(function(todo) {
                    replaces = 0;
                    while(match = todo.regex.exec(str)){
                        value = handleFormat(match[1].trim());
                        if (value === undefined) {
                            if (typeof missingInterpolationHandler === 'function') {
                                var temp = missingInterpolationHandler(str, match, options);
                                value = typeof temp === 'string' ? temp : '';
                            } else if (skipOnVariables) {
                                value = match[0];
                                continue;
                            } else {
                                _this.logger.warn("missed to pass in variable ".concat(match[1], " for interpolating ").concat(str));
                                value = '';
                            }
                        } else if (typeof value !== 'string' && !_this.useRawValueToEscape) value = $d3afb0019d2e6e2a$var$makeString(value);
                        str = str.replace(match[0], todo.safeValue(value));
                        todo.regex.lastIndex = 0;
                        replaces++;
                        if (replaces >= _this.maxReplaces) break;
                    }
                });
                return str;
            }
        },
        {
            key: "nest",
            value: function nest(str, fc) {
                var _this2 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var match;
                var value;
                var clonedOptions = (0, $cd3c4f1b8d1b875e$export$2e2bcd8739ae039)({}, options);
                clonedOptions.applyPostProcessor = false;
                delete clonedOptions.defaultValue;
                function handleHasOptions(key, inheritedOptions) {
                    var sep = this.nestingOptionsSeparator;
                    if (key.indexOf(sep) < 0) return key;
                    var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
                    var optionsString = "{".concat(c[1]);
                    key = c[0];
                    optionsString = this.interpolate(optionsString, clonedOptions);
                    optionsString = optionsString.replace(/'/g, '"');
                    try {
                        clonedOptions = JSON.parse(optionsString);
                        if (inheritedOptions) clonedOptions = (0, $cd3c4f1b8d1b875e$export$2e2bcd8739ae039)({}, inheritedOptions, clonedOptions);
                    } catch (e) {
                        this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
                        return "".concat(key).concat(sep).concat(optionsString);
                    }
                    delete clonedOptions.defaultValue;
                    return key;
                }
                while(match = this.nestingRegexp.exec(str)){
                    var formatters = [];
                    var doReduce = false;
                    if (match[0].includes(this.formatSeparator) && !/{.*}/.test(match[1])) {
                        var r = match[1].split(this.formatSeparator).map(function(elem) {
                            return elem.trim();
                        });
                        match[1] = r.shift();
                        formatters = r;
                        doReduce = true;
                    }
                    value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
                    if (value && match[0] === str && typeof value !== 'string') return value;
                    if (typeof value !== 'string') value = $d3afb0019d2e6e2a$var$makeString(value);
                    if (!value) {
                        this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
                        value = '';
                    }
                    if (doReduce) value = formatters.reduce(function(v, f) {
                        return _this2.format(v, f, options.lng, options);
                    }, value.trim());
                    str = str.replace(match[0], value);
                    this.regexp.lastIndex = 0;
                }
                return str;
            }
        }
    ]);
    return Interpolator;
}();
function $d3afb0019d2e6e2a$var$remove(arr, what) {
    var found = arr.indexOf(what);
    while(found !== -1){
        arr.splice(found, 1);
        found = arr.indexOf(what);
    }
}
var $d3afb0019d2e6e2a$var$Connector = function(_EventEmitter) {
    (0, $5423356470eccb54$export$2e2bcd8739ae039)(Connector, _EventEmitter);
    function Connector(backend, store, services) {
        var _this;
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        (0, $4693e6b1076bc055$export$2e2bcd8739ae039)(this, Connector);
        _this = (0, $4e0276c2d8340071$export$2e2bcd8739ae039)(this, (0, $60051a8e2455c2da$export$2e2bcd8739ae039)(Connector).call(this));
        if ($d3afb0019d2e6e2a$var$isIE10) $d3afb0019d2e6e2a$var$EventEmitter.call((0, $3dcef9283da65ae2$export$2e2bcd8739ae039)(_this));
        _this.backend = backend;
        _this.store = store;
        _this.services = services;
        _this.languageUtils = services.languageUtils;
        _this.options = options;
        _this.logger = $d3afb0019d2e6e2a$var$baseLogger.create('backendConnector');
        _this.state = {};
        _this.queue = [];
        if (_this.backend && _this.backend.init) _this.backend.init(services, options.backend, options);
        return _this;
    }
    (0, $763097cbd79a3e0d$export$2e2bcd8739ae039)(Connector, [
        {
            key: "queueLoad",
            value: function queueLoad(languages, namespaces, options, callback) {
                var _this2 = this;
                var toLoad = [];
                var pending = [];
                var toLoadLanguages = [];
                var toLoadNamespaces = [];
                languages.forEach(function(lng) {
                    var hasAllNamespaces = true;
                    namespaces.forEach(function(ns) {
                        var name = "".concat(lng, "|").concat(ns);
                        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) _this2.state[name] = 2;
                        else if (_this2.state[name] < 0) ;
                        else if (_this2.state[name] === 1) {
                            if (pending.indexOf(name) < 0) pending.push(name);
                        } else {
                            _this2.state[name] = 1;
                            hasAllNamespaces = false;
                            if (pending.indexOf(name) < 0) pending.push(name);
                            if (toLoad.indexOf(name) < 0) toLoad.push(name);
                            if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
                        }
                    });
                    if (!hasAllNamespaces) toLoadLanguages.push(lng);
                });
                if (toLoad.length || pending.length) this.queue.push({
                    pending: pending,
                    loaded: {},
                    errors: [],
                    callback: callback
                });
                return {
                    toLoad: toLoad,
                    pending: pending,
                    toLoadLanguages: toLoadLanguages,
                    toLoadNamespaces: toLoadNamespaces
                };
            }
        },
        {
            key: "loaded",
            value: function loaded(name, err, data) {
                var s = name.split('|');
                var lng = s[0];
                var ns = s[1];
                if (err) this.emit('failedLoading', lng, ns, err);
                if (data) this.store.addResourceBundle(lng, ns, data);
                this.state[name] = err ? -1 : 2;
                var loaded = {};
                this.queue.forEach(function(q) {
                    $d3afb0019d2e6e2a$var$pushPath(q.loaded, [
                        lng
                    ], ns);
                    $d3afb0019d2e6e2a$var$remove(q.pending, name);
                    if (err) q.errors.push(err);
                    if (q.pending.length === 0 && !q.done) {
                        Object.keys(q.loaded).forEach(function(l) {
                            if (!loaded[l]) loaded[l] = [];
                            if (q.loaded[l].length) q.loaded[l].forEach(function(ns) {
                                if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
                            });
                        });
                        q.done = true;
                        if (q.errors.length) q.callback(q.errors);
                        else q.callback();
                    }
                });
                this.emit('loaded', loaded);
                this.queue = this.queue.filter(function(q) {
                    return !q.done;
                });
            }
        },
        {
            key: "read",
            value: function read(lng, ns, fcName) {
                var _this3 = this;
                var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 350;
                var callback = arguments.length > 5 ? arguments[5] : undefined;
                if (!lng.length) return callback(null, {});
                return this.backend[fcName](lng, ns, function(err, data) {
                    if (err && data && tried < 5) {
                        setTimeout(function() {
                            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
                        }, wait);
                        return;
                    }
                    callback(err, data);
                });
            }
        },
        {
            key: "prepareLoading",
            value: function prepareLoading(languages, namespaces) {
                var _this4 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var callback = arguments.length > 3 ? arguments[3] : undefined;
                if (!this.backend) {
                    this.logger.warn('No backend was added via i18next.use. Will not load resources.');
                    return callback && callback();
                }
                if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
                if (typeof namespaces === 'string') namespaces = [
                    namespaces
                ];
                var toLoad = this.queueLoad(languages, namespaces, options, callback);
                if (!toLoad.toLoad.length) {
                    if (!toLoad.pending.length) callback();
                    return null;
                }
                toLoad.toLoad.forEach(function(name) {
                    _this4.loadOne(name);
                });
            }
        },
        {
            key: "load",
            value: function load(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {}, callback);
            }
        },
        {
            key: "reload",
            value: function reload(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {
                    reload: true
                }, callback);
            }
        },
        {
            key: "loadOne",
            value: function loadOne(name) {
                var _this5 = this;
                var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                var s = name.split('|');
                var lng = s[0];
                var ns = s[1];
                this.read(lng, ns, 'read', undefined, undefined, function(err, data) {
                    if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
                    if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
                    _this5.loaded(name, err, data);
                });
            }
        },
        {
            key: "saveMissing",
            value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
                    this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                    return;
                }
                if (key === undefined || key === null || key === '') return;
                if (this.backend && this.backend.create) this.backend.create(languages, namespace, key, fallbackValue, null, (0, $cd3c4f1b8d1b875e$export$2e2bcd8739ae039)({}, options, {
                    isUpdate: isUpdate
                }));
                if (!languages || !languages[0]) return;
                this.store.addResource(languages[0], namespace, key, fallbackValue);
            }
        }
    ]);
    return Connector;
}($d3afb0019d2e6e2a$var$EventEmitter);
function $d3afb0019d2e6e2a$var$get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        whitelist: false,
        nonExplicitWhitelist: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: true,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            var ret = {};
            if ((0, $lo7DV.default)(args[1]) === 'object') ret = args[1];
            if (typeof args[1] === 'string') ret.defaultValue = args[1];
            if (typeof args[2] === 'string') ret.tDescription = args[2];
            if ((0, $lo7DV.default)(args[2]) === 'object' || (0, $lo7DV.default)(args[3]) === 'object') {
                var options = args[3] || args[2];
                Object.keys(options).forEach(function(key) {
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: function format(value, _format, lng, options) {
                return value;
            },
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: false
        }
    };
}
function $d3afb0019d2e6e2a$var$transformOptions(options) {
    if (typeof options.ns === 'string') options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === 'string') options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === 'string') options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.whitelist) {
        if (options.whitelist && options.whitelist.indexOf('cimode') < 0) options.whitelist = options.whitelist.concat([
            'cimode'
        ]);
        options.supportedLngs = options.whitelist;
    }
    if (options.nonExplicitWhitelist) options.nonExplicitSupportedLngs = options.nonExplicitWhitelist;
    if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    return options;
}
function $d3afb0019d2e6e2a$var$noop() {}
var $d3afb0019d2e6e2a$var$I18n = function(_EventEmitter) {
    (0, $5423356470eccb54$export$2e2bcd8739ae039)(I18n, _EventEmitter);
    function I18n() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callback = arguments.length > 1 ? arguments[1] : undefined;
        (0, $4693e6b1076bc055$export$2e2bcd8739ae039)(this, I18n);
        _this = (0, $4e0276c2d8340071$export$2e2bcd8739ae039)(this, (0, $60051a8e2455c2da$export$2e2bcd8739ae039)(I18n).call(this));
        if ($d3afb0019d2e6e2a$var$isIE10) $d3afb0019d2e6e2a$var$EventEmitter.call((0, $3dcef9283da65ae2$export$2e2bcd8739ae039)(_this));
        _this.options = $d3afb0019d2e6e2a$var$transformOptions(options);
        _this.services = {};
        _this.logger = $d3afb0019d2e6e2a$var$baseLogger;
        _this.modules = {
            external: []
        };
        if (callback && !_this.isInitialized && !options.isClone) {
            if (!_this.options.initImmediate) {
                _this.init(options, callback);
                return (0, $4e0276c2d8340071$export$2e2bcd8739ae039)(_this, (0, $3dcef9283da65ae2$export$2e2bcd8739ae039)(_this));
            }
            setTimeout(function() {
                _this.init(options, callback);
            }, 0);
        }
        return _this;
    }
    (0, $763097cbd79a3e0d$export$2e2bcd8739ae039)(I18n, [
        {
            key: "init",
            value: function init() {
                var _this2 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                if (typeof options === 'function') {
                    callback = options;
                    options = {};
                }
                if (options.whitelist && !options.supportedLngs) this.logger.deprecate('whitelist', 'option "whitelist" will be renamed to "supportedLngs" in the next major - please make sure to rename this option asap.');
                if (options.nonExplicitWhitelist && !options.nonExplicitSupportedLngs) this.logger.deprecate('whitelist', 'options "nonExplicitWhitelist" will be renamed to "nonExplicitSupportedLngs" in the next major - please make sure to rename this option asap.');
                this.options = (0, $cd3c4f1b8d1b875e$export$2e2bcd8739ae039)({}, $d3afb0019d2e6e2a$var$get(), this.options, $d3afb0019d2e6e2a$var$transformOptions(options));
                this.format = this.options.interpolation.format;
                if (!callback) callback = $d3afb0019d2e6e2a$var$noop;
                function createClassOnDemand(ClassOrObject) {
                    if (!ClassOrObject) return null;
                    if (typeof ClassOrObject === 'function') return new ClassOrObject();
                    return ClassOrObject;
                }
                if (!this.options.isClone) {
                    if (this.modules.logger) $d3afb0019d2e6e2a$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
                    else $d3afb0019d2e6e2a$var$baseLogger.init(null, this.options);
                    var lu = new $d3afb0019d2e6e2a$var$LanguageUtil(this.options);
                    this.store = new $d3afb0019d2e6e2a$var$ResourceStore(this.options.resources, this.options);
                    var s = this.services;
                    s.logger = $d3afb0019d2e6e2a$var$baseLogger;
                    s.resourceStore = this.store;
                    s.languageUtils = lu;
                    s.pluralResolver = new $d3afb0019d2e6e2a$var$PluralResolver(lu, {
                        prepend: this.options.pluralSeparator,
                        compatibilityJSON: this.options.compatibilityJSON,
                        simplifyPluralSuffix: this.options.simplifyPluralSuffix
                    });
                    s.interpolator = new $d3afb0019d2e6e2a$var$Interpolator(this.options);
                    s.utils = {
                        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
                    };
                    s.backendConnector = new $d3afb0019d2e6e2a$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
                    s.backendConnector.on('*', function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    if (this.modules.languageDetector) {
                        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                        s.languageDetector.init(s, this.options.detection, this.options);
                    }
                    if (this.modules.i18nFormat) {
                        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                        if (s.i18nFormat.init) s.i18nFormat.init(this);
                    }
                    this.translator = new $d3afb0019d2e6e2a$var$Translator(this.services, this.options);
                    this.translator.on('*', function(event) {
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    this.modules.external.forEach(function(m) {
                        if (m.init) m.init(_this2);
                    });
                }
                if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
                    var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                    if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
                }
                if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
                var storeApi = [
                    'getResource',
                    'hasResourceBundle',
                    'getResourceBundle',
                    'getDataByLanguage'
                ];
                storeApi.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store;
                        return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
                    };
                });
                var storeApiChained = [
                    'addResource',
                    'addResources',
                    'addResourceBundle',
                    'removeResourceBundle'
                ];
                storeApiChained.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store2;
                        (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
                        return _this2;
                    };
                });
                var deferred = $d3afb0019d2e6e2a$var$defer();
                var load = function load() {
                    var finish = function finish(err, t) {
                        if (_this2.isInitialized) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
                        _this2.isInitialized = true;
                        if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);
                        _this2.emit('initialized', _this2.options);
                        deferred.resolve(t);
                        callback(err, t);
                    };
                    if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
                    _this2.changeLanguage(_this2.options.lng, finish);
                };
                if (this.options.resources || !this.options.initImmediate) load();
                else setTimeout(load, 0);
                return deferred;
            }
        },
        {
            key: "loadResources",
            value: function loadResources(language) {
                var _this3 = this;
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $d3afb0019d2e6e2a$var$noop;
                var usedCallback = callback;
                var usedLng = typeof language === 'string' ? language : this.language;
                if (typeof language === 'function') usedCallback = language;
                if (!this.options.resources || this.options.partialBundledLanguages) {
                    if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
                    var toLoad = [];
                    var append = function append(lng) {
                        if (!lng) return;
                        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
                        lngs.forEach(function(l) {
                            if (toLoad.indexOf(l) < 0) toLoad.push(l);
                        });
                    };
                    if (!usedLng) {
                        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                        fallbacks.forEach(function(l) {
                            return append(l);
                        });
                    } else append(usedLng);
                    if (this.options.preload) this.options.preload.forEach(function(l) {
                        return append(l);
                    });
                    this.services.backendConnector.load(toLoad, this.options.ns, usedCallback);
                } else usedCallback(null);
            }
        },
        {
            key: "reloadResources",
            value: function reloadResources(lngs, ns, callback) {
                var deferred = $d3afb0019d2e6e2a$var$defer();
                if (!lngs) lngs = this.languages;
                if (!ns) ns = this.options.ns;
                if (!callback) callback = $d3afb0019d2e6e2a$var$noop;
                this.services.backendConnector.reload(lngs, ns, function(err) {
                    deferred.resolve();
                    callback(err);
                });
                return deferred;
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
                if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
                if (module.type === 'backend') this.modules.backend = module;
                if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
                if (module.type === 'languageDetector') this.modules.languageDetector = module;
                if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
                if (module.type === 'postProcessor') $d3afb0019d2e6e2a$var$postProcessor.addPostProcessor(module);
                if (module.type === '3rdParty') this.modules.external.push(module);
                return this;
            }
        },
        {
            key: "changeLanguage",
            value: function changeLanguage(lng, callback) {
                var _this4 = this;
                this.isLanguageChangingTo = lng;
                var deferred = $d3afb0019d2e6e2a$var$defer();
                this.emit('languageChanging', lng);
                var done = function done(err, l) {
                    if (l) {
                        _this4.language = l;
                        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                        _this4.translator.changeLanguage(l);
                        _this4.isLanguageChangingTo = undefined;
                        _this4.emit('languageChanged', l);
                        _this4.logger.log('languageChanged', l);
                    } else _this4.isLanguageChangingTo = undefined;
                    deferred.resolve(function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                    if (callback) callback(err, function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                };
                var setLng = function setLng(lngs) {
                    var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
                    if (l) {
                        if (!_this4.language) {
                            _this4.language = l;
                            _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                        }
                        if (!_this4.translator.language) _this4.translator.changeLanguage(l);
                        if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
                    }
                    _this4.loadResources(l, function(err) {
                        done(err, l);
                    });
                };
                if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
                else if (!lng && this.services.languageDetector && this.services.languageDetector.async) this.services.languageDetector.detect(setLng);
                else setLng(lng);
                return deferred;
            }
        },
        {
            key: "getFixedT",
            value: function getFixedT(lng, ns) {
                var _this5 = this;
                var fixedT = function fixedT(key, opts) {
                    var options;
                    if ((0, $lo7DV.default)(opts) !== 'object') {
                        for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                        options = _this5.options.overloadTranslationOptionHandler([
                            key,
                            opts
                        ].concat(rest));
                    } else options = (0, $cd3c4f1b8d1b875e$export$2e2bcd8739ae039)({}, opts);
                    options.lng = options.lng || fixedT.lng;
                    options.lngs = options.lngs || fixedT.lngs;
                    options.ns = options.ns || fixedT.ns;
                    return _this5.t(key, options);
                };
                if (typeof lng === 'string') fixedT.lng = lng;
                else fixedT.lngs = lng;
                fixedT.ns = ns;
                return fixedT;
            }
        },
        {
            key: "t",
            value: function t() {
                var _this$translator;
                return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
            }
        },
        {
            key: "exists",
            value: function exists() {
                var _this$translator2;
                return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
            }
        },
        {
            key: "setDefaultNamespace",
            value: function setDefaultNamespace(ns) {
                this.options.defaultNS = ns;
            }
        },
        {
            key: "hasLoadedNamespace",
            value: function hasLoadedNamespace(ns) {
                var _this6 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (!this.isInitialized) {
                    this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
                    return false;
                }
                if (!this.languages || !this.languages.length) {
                    this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
                    return false;
                }
                var lng = this.languages[0];
                var fallbackLng = this.options ? this.options.fallbackLng : false;
                var lastLng = this.languages[this.languages.length - 1];
                if (lng.toLowerCase() === 'cimode') return true;
                var loadNotPending = function loadNotPending(l, n) {
                    var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
                    return loadState === -1 || loadState === 2;
                };
                if (options.precheck) {
                    var preResult = options.precheck(this, loadNotPending);
                    if (preResult !== undefined) return preResult;
                }
                if (this.hasResourceBundle(lng, ns)) return true;
                if (!this.services.backendConnector.backend) return true;
                if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
                return false;
            }
        },
        {
            key: "loadNamespaces",
            value: function loadNamespaces(ns, callback) {
                var _this7 = this;
                var deferred = $d3afb0019d2e6e2a$var$defer();
                if (!this.options.ns) {
                    callback && callback();
                    return Promise.resolve();
                }
                if (typeof ns === 'string') ns = [
                    ns
                ];
                ns.forEach(function(n) {
                    if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
                });
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "loadLanguages",
            value: function loadLanguages(lngs, callback) {
                var deferred = $d3afb0019d2e6e2a$var$defer();
                if (typeof lngs === 'string') lngs = [
                    lngs
                ];
                var preloaded = this.options.preload || [];
                var newLngs = lngs.filter(function(lng) {
                    return preloaded.indexOf(lng) < 0;
                });
                if (!newLngs.length) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                this.options.preload = preloaded.concat(newLngs);
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "dir",
            value: function dir(lng) {
                if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
                if (!lng) return 'rtl';
                var rtlLngs = [
                    'ar',
                    'shu',
                    'sqr',
                    'ssh',
                    'xaa',
                    'yhd',
                    'yud',
                    'aao',
                    'abh',
                    'abv',
                    'acm',
                    'acq',
                    'acw',
                    'acx',
                    'acy',
                    'adf',
                    'ads',
                    'aeb',
                    'aec',
                    'afb',
                    'ajp',
                    'apc',
                    'apd',
                    'arb',
                    'arq',
                    'ars',
                    'ary',
                    'arz',
                    'auz',
                    'avl',
                    'ayh',
                    'ayl',
                    'ayn',
                    'ayp',
                    'bbz',
                    'pga',
                    'he',
                    'iw',
                    'ps',
                    'pbt',
                    'pbu',
                    'pst',
                    'prp',
                    'prd',
                    'ug',
                    'ur',
                    'ydd',
                    'yds',
                    'yih',
                    'ji',
                    'yi',
                    'hbo',
                    'men',
                    'xmn',
                    'fa',
                    'jpr',
                    'peo',
                    'pes',
                    'prs',
                    'dv',
                    'sam'
                ];
                return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
            }
        },
        {
            key: "createInstance",
            value: function createInstance() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                return new I18n(options, callback);
            }
        },
        {
            key: "cloneInstance",
            value: function cloneInstance() {
                var _this8 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $d3afb0019d2e6e2a$var$noop;
                var mergedOptions = (0, $cd3c4f1b8d1b875e$export$2e2bcd8739ae039)({}, this.options, options, {
                    isClone: true
                });
                var clone = new I18n(mergedOptions);
                var membersToCopy = [
                    'store',
                    'services',
                    'language'
                ];
                membersToCopy.forEach(function(m) {
                    clone[m] = _this8[m];
                });
                clone.services = (0, $cd3c4f1b8d1b875e$export$2e2bcd8739ae039)({}, this.services);
                clone.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                clone.translator = new $d3afb0019d2e6e2a$var$Translator(clone.services, clone.options);
                clone.translator.on('*', function(event) {
                    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
                    clone.emit.apply(clone, [
                        event
                    ].concat(args));
                });
                clone.init(mergedOptions, callback);
                clone.translator.options = clone.options;
                clone.translator.backendConnector.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                return clone;
            }
        }
    ]);
    return I18n;
}($d3afb0019d2e6e2a$var$EventEmitter);
var $d3afb0019d2e6e2a$var$i18next = new $d3afb0019d2e6e2a$var$I18n();
var $d3afb0019d2e6e2a$export$2e2bcd8739ae039 = $d3afb0019d2e6e2a$var$i18next;



const $c4d69bc8475bfdac$var$API_URL_DOC_EN = 'https://veta.ingka.com/serviceconnector/swagger/../services/rest/documents';
const $c4d69bc8475bfdac$var$API_URL_DOC_EN_INT = 'https://veta-int.kcenter.usu.com/serviceconnector/swagger/../services/rest/documents';
const $c4d69bc8475bfdac$var$API_LOCALE_EN_ES = '&cb=1_88&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_HU = '&cb=1_899&lang=hu&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_PT = '&cb=1_246&lang=pt&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_EN_PT = '&cb=1_246&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_CZ = '&cb=1_951&lang=cs&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_SK = '&cb=1_847&lang=sk&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_NO = '&cb=1_1003&lang=no&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_EN_NO = '&cb=1_1003&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_EN_GB = '&cb=1_390&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_EN_AU = '&cb=1_2127&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_EN_IE = '&cb=1_766&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_IT = '&cb=1_342&lang=it&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
// Note Lang should be sv but due to USU bug it's se
const $c4d69bc8475bfdac$var$API_LOCALE_SE = '&cb=1_628&lang=sv&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_EN_SE = '&cb=1_628&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_AT = '&cb=1_1559&lang=de&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_EN_AT = '&cb=1_1559&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_BE = '&cb=1_571&lang=nl&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_FR_BE = '&cb=1_571&lang=fr&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_EN_BE = '&cb=1_571&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_DK = '&cb=1_294&lang=da&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_PL = '&cb=1_517&lang=pl&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_DE = '&cb=1_1423&lang=de&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_EN_DE = '&cb=1_1423&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_FI = '&cb=1_1055&lang=fi&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_EN_FI = '&cb=1_1055&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_SV_FI = '&cb=1_1055&lang=sv&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_FR = '&cb=1_1107&lang=fr&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_EN_FR = '&cb=1_1107&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_FR_CA = '&cb=1_147&lang=fr&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_EN_CA = '&cb=1_147&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_RS = '&cb=1_1180&lang=sr&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_SI = '&cb=1_1475&lang=sl&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_UA = '&cb=1_1333&lang=uk&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_HR = '&cb=1_1282&lang=hr&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_RO = '&cb=1_1231&lang=ro&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_DE_CH = '&cb=1_716&lang=de&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_FR_CH = '&cb=1_716&lang=fr&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_US = '&cb=1_1654&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_ES_US = '&cb=1_1654&lang=es&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_EN_CH = '&cb=1_716&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_IT_CH = '&cb=1_716&lang=it&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_URL_SEARCH = 'https://veta.ingka.com/serviceconnector/swagger/../services/rest/content/search';
const $c4d69bc8475bfdac$var$API_URL_SEARCH_INT = 'https://veta-int.kcenter.usu.com/serviceconnector/swagger/../services/rest/content/search';
const $c4d69bc8475bfdac$var$API_URL_CATS_EN = 'https://veta.ingka.com/serviceconnector/swagger/../services/rest/content/categories?';
const $c4d69bc8475bfdac$var$API_URL_DOC = 'https://veta.ingka.com/serviceconnector/swagger/../services/rest/documents';
const $c4d69bc8475bfdac$var$API_LOCALE_ES = '&cb=1_88&lang=es&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_EU_ES = '&cb=1_88&lang=eu&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_GL_ES = '&cb=1_88&lang=gl&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_CA_ES = '&cb=1_88&lang=ca&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_NL = '&cb=1_438&lang=nl&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_EN_NL = '&cb=1_438&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_RU = '&cb=1_1867&lang=ru&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_KR = '&cb=1_2016&lang=ko&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_EN_KR = '&cb=1_2016&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_JP = '&cb=1_1810&lang=ja&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_EN_JP = '&cb=1_1810&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_EN_IN = '&cb=1_1941&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
const $c4d69bc8475bfdac$var$API_LOCALE_EN_NZ = '&cb=1_3198&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8';
(0, $d3afb0019d2e6e2a$export$2e2bcd8739ae039).use((0, $9d2df5ee7800c19d$export$ae7e14d40d89f296)).init({
    fallbackLng: 'en-ES',
    interpolation: {
        escapeValue: false
    },
    detection: {
        order: [
            'htmlTag',
            'navigator',
            'querystring',
            'cookie',
            'localStorage',
            'sessionStorage',
            'path',
            'subdomain'
        ]
    },
    resources: {
        'en-ES': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-cats': $c4d69bc8475bfdac$var$API_URL_CATS_EN,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC_EN,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_EN_ES
            }
        },
        'it-IT': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_IT
            }
        },
        'en-GB': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_EN_GB
            }
        },
        'en-IE': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_EN_IE
            }
        },
        'cs-CZ': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_CZ
            }
        },
        'sk-SK': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_SK
            }
        },
        'es-ES': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_ES
            }
        },
        'eu-ES': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-cats': $c4d69bc8475bfdac$var$API_URL_CATS_EN,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC_EN,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_EU_ES
            }
        },
        'ca-ES': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-cats': $c4d69bc8475bfdac$var$API_URL_CATS_EN,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC_EN,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_CA_ES
            }
        },
        'gl-ES': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-cats': $c4d69bc8475bfdac$var$API_URL_CATS_EN,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC_EN,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_GL_ES
            }
        },
        'nl-NL': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_NL
            }
        },
        'en-NL': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_EN_NL
            }
        },
        'fr-FR': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_FR
            }
        },
        'en-FR': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_EN_FR
            }
        },
        'fr-CH': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_FR_CH
            }
        },
        'en-CH': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_EN_CH
            }
        },
        'it-CH': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_IT_CH
            }
        },
        'de-CH': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_DE_CH
            }
        },
        'sr-RS': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_RS
            }
        },
        'hr-HR': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_HR
            }
        },
        'sl-SI': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_SI
            }
        },
        'ro-RO': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_RO
            }
        },
        'uk-UA': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_UA
            }
        },
        'de-DE': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_DE
            }
        },
        'en-DE': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_EN_DE
            }
        },
        'en-CA': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_EN_CA
            }
        },
        'fr-CA': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_FR_CA
            }
        },
        'fi-FI': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_FI
            }
        },
        'en-FI': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_EN_FI
            }
        },
        'sv-FI': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_SV_FI
            }
        },
        'da-DK': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_DK
            }
        },
        'pl-PL': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_PL
            }
        },
        'de-AT': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_AT
            }
        },
        'en-AT': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-cats': $c4d69bc8475bfdac$var$API_URL_CATS_EN,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC_EN,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_EN_AT
            }
        },
        'fr-BE': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_FR_BE
            }
        },
        'nl-BE': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_BE
            }
        },
        'en-BE': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_EN_BE
            }
        },
        'no-NO': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_NO
            }
        },
        'en-NO': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_EN_NO
            }
        },
        'sv-SE': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_SE
            }
        },
        'en-SE': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_EN_SE
            }
        },
        'hu-HU': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_HU
            }
        },
        'pt-PT': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_PT
            }
        },
        'en-PT': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_EN_PT
            }
        },
        'en-US': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_US
            }
        },
        'es-US': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_ES_US
            }
        },
        'ru-RU': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_RU
            }
        },
        'en-KR': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_EN_KR
            }
        },
        'ko-KR': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_KR
            }
        },
        'ja-JP': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_JP
            }
        },
        'en-JP': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_EN_JP
            }
        },
        'en-IN': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_EN_IN
            }
        },
        'en-AU': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_EN_AU
            }
        },
        'rv-RE': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_EN_AU,
                searching: 'Searching...',
                search: 'Find answers to your question here',
                loading: 'Loading',
                'no-results': 'We did not find any matches for results for search term: {{query}}',
                'try-again': 'Please try again later',
                results: 'We found {{number}} results for: {{query}}',
                error: 'Something went wrong',
                'spell-check': 'Try checking the spelling or using different keywords.',
                close: 'Close',
                showMore: 'Show more',
                showLess: 'Show less',
                retrieving: 'Retrieving',
                'feedback-first': 'Did you find this useful?',
                'feedback-second': 'Thank you for your feedback!',
                'not-available': '	Service is currently not available, please try again later.'
            }
        },
        'en-NZ': {
            translation: {
                'url-search': $c4d69bc8475bfdac$var$API_URL_SEARCH,
                'url-doc': $c4d69bc8475bfdac$var$API_URL_DOC,
                locale: $c4d69bc8475bfdac$var$API_LOCALE_EN_NZ
            }
        }
    }
});
var $c4d69bc8475bfdac$export$2e2bcd8739ae039 = (0, $d3afb0019d2e6e2a$export$2e2bcd8739ae039);


var $adc4e3594f14b849$exports = {};
(function(global, factory) {
    factory();
})($adc4e3594f14b849$exports, function() {
    'use strict';
    /**
   * Applies the :focus-visible polyfill at the given scope.
   * A scope in this case is either the top-level Document or a Shadow Root.
   *
   * @param {(Document|ShadowRoot)} scope
   * @see https://github.com/WICG/focus-visible
   */ function applyFocusVisiblePolyfill(scope) {
        var hadKeyboardEvent = true;
        var hadFocusVisibleRecently = false;
        var hadFocusVisibleRecentlyTimeout = null;
        var inputTypesAllowlist = {
            text: true,
            search: true,
            url: true,
            tel: true,
            email: true,
            password: true,
            number: true,
            date: true,
            month: true,
            week: true,
            time: true,
            datetime: true,
            'datetime-local': true
        };
        /**
     * Helper function for legacy browsers and iframes which sometimes focus
     * elements like document, body, and non-interactive SVG.
     * @param {Element} el
     */ function isValidFocusTarget(el) {
            if (el && el !== document && el.nodeName !== 'HTML' && el.nodeName !== 'BODY' && 'classList' in el && 'contains' in el.classList) return true;
            return false;
        }
        /**
     * Computes whether the given element should automatically trigger the
     * `focus-visible` class being added, i.e. whether it should always match
     * `:focus-visible` when focused.
     * @param {Element} el
     * @return {boolean}
     */ function focusTriggersKeyboardModality(el) {
            var type = el.type;
            var tagName = el.tagName;
            if (tagName === 'INPUT' && inputTypesAllowlist[type] && !el.readOnly) return true;
            if (tagName === 'TEXTAREA' && !el.readOnly) return true;
            if (el.isContentEditable) return true;
            return false;
        }
        /**
     * Add the `focus-visible` class to the given element if it was not added by
     * the author.
     * @param {Element} el
     */ function addFocusVisibleClass(el) {
            if (el.classList.contains('focus-visible')) return;
            el.classList.add('focus-visible');
            el.setAttribute('data-focus-visible-added', '');
        }
        /**
     * Remove the `focus-visible` class from the given element if it was not
     * originally added by the author.
     * @param {Element} el
     */ function removeFocusVisibleClass(el) {
            if (!el.hasAttribute('data-focus-visible-added')) return;
            el.classList.remove('focus-visible');
            el.removeAttribute('data-focus-visible-added');
        }
        /**
     * If the most recent user interaction was via the keyboard;
     * and the key press did not include a meta, alt/option, or control key;
     * then the modality is keyboard. Otherwise, the modality is not keyboard.
     * Apply `focus-visible` to any current active element and keep track
     * of our keyboard modality state with `hadKeyboardEvent`.
     * @param {KeyboardEvent} e
     */ function onKeyDown(e) {
            if (e.metaKey || e.altKey || e.ctrlKey) return;
            if (isValidFocusTarget(scope.activeElement)) addFocusVisibleClass(scope.activeElement);
            hadKeyboardEvent = true;
        }
        /**
     * If at any point a user clicks with a pointing device, ensure that we change
     * the modality away from keyboard.
     * This avoids the situation where a user presses a key on an already focused
     * element, and then clicks on a different element, focusing it with a
     * pointing device, while we still think we're in keyboard modality.
     * @param {Event} e
     */ function onPointerDown(e) {
            hadKeyboardEvent = false;
        }
        /**
     * On `focus`, add the `focus-visible` class to the target if:
     * - the target received focus as a result of keyboard navigation, or
     * - the event target is an element that will likely require interaction
     *   via the keyboard (e.g. a text box)
     * @param {Event} e
     */ function onFocus(e) {
            // Prevent IE from focusing the document or HTML element.
            if (!isValidFocusTarget(e.target)) return;
            if (hadKeyboardEvent || focusTriggersKeyboardModality(e.target)) addFocusVisibleClass(e.target);
        }
        /**
     * On `blur`, remove the `focus-visible` class from the target.
     * @param {Event} e
     */ function onBlur(e) {
            if (!isValidFocusTarget(e.target)) return;
            if (e.target.classList.contains('focus-visible') || e.target.hasAttribute('data-focus-visible-added')) {
                // To detect a tab/window switch, we look for a blur event followed
                // rapidly by a visibility change.
                // If we don't see a visibility change within 100ms, it's probably a
                // regular focus change.
                hadFocusVisibleRecently = true;
                window.clearTimeout(hadFocusVisibleRecentlyTimeout);
                hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
                    hadFocusVisibleRecently = false;
                }, 100);
                removeFocusVisibleClass(e.target);
            }
        }
        /**
     * If the user changes tabs, keep track of whether or not the previously
     * focused element had .focus-visible.
     * @param {Event} e
     */ function onVisibilityChange(e) {
            if (document.visibilityState === 'hidden') {
                // If the tab becomes active again, the browser will handle calling focus
                // on the element (Safari actually calls it twice).
                // If this tab change caused a blur on an element with focus-visible,
                // re-apply the class when the user switches back to the tab.
                if (hadFocusVisibleRecently) hadKeyboardEvent = true;
                addInitialPointerMoveListeners();
            }
        }
        /**
     * Add a group of listeners to detect usage of any pointing devices.
     * These listeners will be added when the polyfill first loads, and anytime
     * the window is blurred, so that they are active when the window regains
     * focus.
     */ function addInitialPointerMoveListeners() {
            document.addEventListener('mousemove', onInitialPointerMove);
            document.addEventListener('mousedown', onInitialPointerMove);
            document.addEventListener('mouseup', onInitialPointerMove);
            document.addEventListener('pointermove', onInitialPointerMove);
            document.addEventListener('pointerdown', onInitialPointerMove);
            document.addEventListener('pointerup', onInitialPointerMove);
            document.addEventListener('touchmove', onInitialPointerMove);
            document.addEventListener('touchstart', onInitialPointerMove);
            document.addEventListener('touchend', onInitialPointerMove);
        }
        function removeInitialPointerMoveListeners() {
            document.removeEventListener('mousemove', onInitialPointerMove);
            document.removeEventListener('mousedown', onInitialPointerMove);
            document.removeEventListener('mouseup', onInitialPointerMove);
            document.removeEventListener('pointermove', onInitialPointerMove);
            document.removeEventListener('pointerdown', onInitialPointerMove);
            document.removeEventListener('pointerup', onInitialPointerMove);
            document.removeEventListener('touchmove', onInitialPointerMove);
            document.removeEventListener('touchstart', onInitialPointerMove);
            document.removeEventListener('touchend', onInitialPointerMove);
        }
        /**
     * When the polfyill first loads, assume the user is in keyboard modality.
     * If any event is received from a pointing device (e.g. mouse, pointer,
     * touch), turn off keyboard modality.
     * This accounts for situations where focus enters the page from the URL bar.
     * @param {Event} e
     */ function onInitialPointerMove(e) {
            // Work around a Safari quirk that fires a mousemove on <html> whenever the
            // window blurs, even if you're tabbing out of the page. ¯\_(ツ)_/¯
            if (e.target.nodeName && e.target.nodeName.toLowerCase() === 'html') return;
            hadKeyboardEvent = false;
            removeInitialPointerMoveListeners();
        }
        // For some kinds of state, we are interested in changes at the global scope
        // only. For example, global pointer input, global key presses and global
        // visibility change should affect the state at every scope:
        document.addEventListener('keydown', onKeyDown, true);
        document.addEventListener('mousedown', onPointerDown, true);
        document.addEventListener('pointerdown', onPointerDown, true);
        document.addEventListener('touchstart', onPointerDown, true);
        document.addEventListener('visibilitychange', onVisibilityChange, true);
        addInitialPointerMoveListeners();
        // For focus and blur, we specifically care about state changes in the local
        // scope. This is because focus / blur events that originate from within a
        // shadow root are not re-dispatched from the host element if it was already
        // the active element in its own scope:
        scope.addEventListener('focus', onFocus, true);
        scope.addEventListener('blur', onBlur, true);
        // We detect that a node is a ShadowRoot by ensuring that it is a
        // DocumentFragment and also has a host property. This check covers native
        // implementation and polyfill implementation transparently. If we only cared
        // about the native implementation, we could just check if the scope was
        // an instance of a ShadowRoot.
        if (scope.nodeType === Node.DOCUMENT_FRAGMENT_NODE && scope.host) // Since a ShadowRoot is a special kind of DocumentFragment, it does not
        // have a root element to add a class to. So, we add this attribute to the
        // host element instead:
        scope.host.setAttribute('data-js-focus-visible', '');
        else if (scope.nodeType === Node.DOCUMENT_NODE) {
            document.documentElement.classList.add('js-focus-visible');
            document.documentElement.setAttribute('data-js-focus-visible', '');
        }
    }
    // It is important to wrap all references to global window and document in
    // these checks to support server-side rendering use cases
    // @see https://github.com/WICG/focus-visible/issues/199
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        // Make the polyfill helper globally available. This can be used as a signal
        // to interested libraries that wish to coordinate with the polyfill for e.g.,
        // applying the polyfill to a shadow root:
        window.applyFocusVisiblePolyfill = applyFocusVisiblePolyfill;
        // Notify interested libraries of the polyfill's presence, in case the
        // polyfill was loaded lazily:
        var event;
        try {
            event = new CustomEvent('focus-visible-polyfill-ready');
        } catch (error) {
            // IE11 does not support using CustomEvent as a constructor directly:
            event = document.createEvent('CustomEvent');
            event.initCustomEvent('focus-visible-polyfill-ready', false, false, {});
        }
        window.dispatchEvent(event);
    }
    if (typeof document !== 'undefined') // Apply the polyfill to the global document, so that no JavaScript
    // coordination is required to use the polyfill in the top-level document:
    applyFocusVisiblePolyfill(document);
});



const $e06067fd0560714c$var$App = ({ lang: lang })=>{
    lang = (0, $977e635bd4ac891c$export$64419dba853ac5)(lang);
    return /*#__PURE__*/ (0, $2ae486c44b6dfbc4$export$34b9dba7ce09269b)((0, $b4a270996085b34b$export$2e2bcd8739ae039), {
        lang: lang,
        variant: "standard"
    });
//Keep below code for future A/B-tests
//
// let rand = Math.floor(Math.random() * 101);
// if(rand >= 50){
//   //@ts-ignore
//   return <KnowledgeComponent lang={lang} variant="standard"/>;
// }else{
//   return <KnowledgeComponent lang={lang} variant="standard"/>;
// } 
};
(0, $c1f5565b80956abe$export$2e2bcd8739ae039)($e06067fd0560714c$var$App, 'km-search-integration', [
    'lang'
], {
    shadow: false
});

})();
//# sourceMappingURL=searchBundle.js.map
